//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface IMapClient {

    getPoisGET(): Promise<BasePoI[]>;

    getPoisPOST(query: POIQuery): Promise<BasePoI[]>;
}

export class MapClient implements IMapClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getPoisGET(): Promise<BasePoI[]> {
        let url_ = this.baseUrl + "/api/Map/pois";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPoisGET(_response);
        });
    }

    protected processGetPoisGET(response: Response): Promise<BasePoI[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = BaseResultOfErrorResult.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultDatadefault)) {
                resultdefault = [] as any;
                for (let item of resultDatadefault)
                    resultdefault!.push(BasePoI.fromJS(item));
            }
            else {
                resultdefault = null as any;
            }
            return resultdefault;
            });
        }
    }

    getPoisPOST(query: POIQuery): Promise<BasePoI[]> {
        let url_ = this.baseUrl + "/api/Map/pois";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPoisPOST(_response);
        });
    }

    protected processGetPoisPOST(response: Response): Promise<BasePoI[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = BaseResultOfErrorResult.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultDatadefault)) {
                resultdefault = [] as any;
                for (let item of resultDatadefault)
                    resultdefault!.push(BasePoI.fromJS(item));
            }
            else {
                resultdefault = null as any;
            }
            return resultdefault;
            });
        }
    }
}

export interface IAdminApiClient {

    getAccountList(): Promise<FileResponse>;

    getAccountListCsv(searchStr: string | null | undefined): Promise<FileResponse>;

    getRoleListCsv(): Promise<FileResponse>;

    getUserList(): Promise<FileResponse>;
}

export class AdminApiClient implements IAdminApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAccountList(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AdminApi";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccountList(_response);
        });
    }

    protected processGetAccountList(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAccountListCsv(searchStr: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AdminApi/GetAccountListCsv?";
        if (searchStr !== undefined && searchStr !== null)
            url_ += "searchStr=" + encodeURIComponent("" + searchStr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccountListCsv(_response);
        });
    }

    protected processGetAccountListCsv(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getRoleListCsv(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AdminApi/GetRoleListCsv";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRoleListCsv(_response);
        });
    }

    protected processGetRoleListCsv(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getUserList(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AdminApi/GetUserList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserList(_response);
        });
    }

    protected processGetUserList(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ISettingsApiUiClient {

    list(): Promise<SettingItem[]>;

    insert(collection: SettingItem): Promise<SettingItem>;

    update(collection: SettingItem[]): Promise<SettingItem>;

    listListSettingUser(): Promise<SettingItemUser[]>;

    updateUserSetting(collection: SettingItemUser[]): Promise<SettingItemUser>;

    /**
     * Uploads an image for a specific setting item using the MediaUploadModel pattern
     * @param internalId (optional) The internal ID of the setting (from query string)
     * @param id (optional) 
     * @param parentId (optional) 
     * @param uploads (optional) 
     * @return Image upload response with media ID and URL
     */
    uploadImage(internalId: string | undefined, id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<ImageUploadResponse>;

    /**
     * Deletes an image associated with a setting item
     */
    deleteImage(internalId: string, mediaId: string): Promise<void>;

    /**
     * Gets the media for a setting item
     */
    getMedia(internalId: string): Promise<string>;

    /**
     * Imports an Excel file for a specific setting item using the MediaUploadModel pattern
     * @param internalId (optional) 
     * @param id (optional) 
     * @param parentId (optional) 
     * @param uploads (optional) 
     */
    importExcel(internalId: string | undefined, id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<void>;
}

export class SettingsApiUiClient implements ISettingsApiUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<SettingItem[]> {
        let url_ = this.baseUrl + "/api/v1/settings/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<SettingItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SettingItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SettingItem[]>(null as any);
    }

    insert(collection: SettingItem): Promise<SettingItem> {
        let url_ = this.baseUrl + "/api/v1/settings/insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(collection);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: Response): Promise<SettingItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = SettingItem.fromJS(resultData201);
            return result201;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SettingItem>(null as any);
    }

    update(collection: SettingItem[]): Promise<SettingItem> {
        let url_ = this.baseUrl + "/api/v1/settings/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(collection);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<SettingItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = SettingItem.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SettingItem>(null as any);
    }

    listListSettingUser(): Promise<SettingItemUser[]> {
        let url_ = this.baseUrl + "/api/v1/settings/listListSettingUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListListSettingUser(_response);
        });
    }

    protected processListListSettingUser(response: Response): Promise<SettingItemUser[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SettingItemUser.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SettingItemUser[]>(null as any);
    }

    updateUserSetting(collection: SettingItemUser[]): Promise<SettingItemUser> {
        let url_ = this.baseUrl + "/api/v1/settings/updateUserSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(collection);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserSetting(_response);
        });
    }

    protected processUpdateUserSetting(response: Response): Promise<SettingItemUser> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = SettingItemUser.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SettingItemUser>(null as any);
    }

    /**
     * Uploads an image for a specific setting item using the MediaUploadModel pattern
     * @param internalId (optional) The internal ID of the setting (from query string)
     * @param id (optional) 
     * @param parentId (optional) 
     * @param uploads (optional) 
     * @return Image upload response with media ID and URL
     */
    uploadImage(internalId: string | undefined, id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<ImageUploadResponse> {
        let url_ = this.baseUrl + "/api/v1/settings/upload?";
        if (internalId === null)
            throw new globalThis.Error("The parameter 'internalId' cannot be null.");
        else if (internalId !== undefined)
            url_ += "internalId=" + encodeURIComponent("" + internalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (parentId !== null && parentId !== undefined)
            content_.append("ParentId", parentId.toString());
        if (uploads !== null && uploads !== undefined)
            uploads.forEach(item_ => content_.append("Uploads", item_.data, item_.fileName ? item_.fileName : "Uploads") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadImage(_response);
        });
    }

    protected processUploadImage(response: Response): Promise<ImageUploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageUploadResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImageUploadResponse>(null as any);
    }

    /**
     * Deletes an image associated with a setting item
     */
    deleteImage(internalId: string, mediaId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/settings/image/{internalId}/{mediaId}";
        if (internalId === undefined || internalId === null)
            throw new globalThis.Error("The parameter 'internalId' must be defined.");
        url_ = url_.replace("{internalId}", encodeURIComponent("" + internalId));
        if (mediaId === undefined || mediaId === null)
            throw new globalThis.Error("The parameter 'mediaId' must be defined.");
        url_ = url_.replace("{mediaId}", encodeURIComponent("" + mediaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteImage(_response);
        });
    }

    protected processDeleteImage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the media for a setting item
     */
    getMedia(internalId: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/settings/media/{internalId}";
        if (internalId === undefined || internalId === null)
            throw new globalThis.Error("The parameter 'internalId' must be defined.");
        url_ = url_.replace("{internalId}", encodeURIComponent("" + internalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMedia(_response);
        });
    }

    protected processGetMedia(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Imports an Excel file for a specific setting item using the MediaUploadModel pattern
     * @param internalId (optional) 
     * @param id (optional) 
     * @param parentId (optional) 
     * @param uploads (optional) 
     */
    importExcel(internalId: string | undefined, id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/settings/import?";
        if (internalId === null)
            throw new globalThis.Error("The parameter 'internalId' cannot be null.");
        else if (internalId !== undefined)
            url_ += "internalId=" + encodeURIComponent("" + internalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (parentId !== null && parentId !== undefined)
            content_.append("ParentId", parentId.toString());
        if (uploads !== null && uploads !== undefined)
            uploads.forEach(item_ => content_.append("Uploads", item_.data, item_.fileName ? item_.fileName : "Uploads") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportExcel(_response);
        });
    }

    protected processImportExcel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ISettingsSwaggerDummyClient {

    activityColumns(ac: ActivityColumns): Promise<FileResponse>;

    activityColumns2(ac: ActivitySettings): Promise<FileResponse>;

    cellSettings(ct: CellSettings): Promise<FileResponse>;

    kanbanSettings(ks: KanbanSettings): Promise<FileResponse>;

    chartwizardTemplates(ct: ChartwizardTemplates): Promise<FileResponse>;

    generalUserSettings(ct: GeneralUserSettings): Promise<FileResponse>;

    overview2DSettings(ct: Overview2DSettings): Promise<FileResponse>;

    pqtConfig(ct: PqtConfig): Promise<FileResponse>;

    createMqttFromVisitorManagementResultParam(ct: CreateMqttFromVisitorManagementResultParam): Promise<FileResponse>;
}

export class SettingsSwaggerDummyClient implements ISettingsSwaggerDummyClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    activityColumns(ac: ActivityColumns): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/SettingsSwaggerDummy/ActivityColumns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ac);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityColumns(_response);
        });
    }

    protected processActivityColumns(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    activityColumns2(ac: ActivitySettings): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/SettingsSwaggerDummy/ActivitySettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ac);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityColumns2(_response);
        });
    }

    protected processActivityColumns2(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    cellSettings(ct: CellSettings): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/SettingsSwaggerDummy/CellSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ct);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCellSettings(_response);
        });
    }

    protected processCellSettings(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    kanbanSettings(ks: KanbanSettings): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/SettingsSwaggerDummy/KanbanSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ks);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKanbanSettings(_response);
        });
    }

    protected processKanbanSettings(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    chartwizardTemplates(ct: ChartwizardTemplates): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/SettingsSwaggerDummy/ChartwizardTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ct);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChartwizardTemplates(_response);
        });
    }

    protected processChartwizardTemplates(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    generalUserSettings(ct: GeneralUserSettings): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/SettingsSwaggerDummy/GeneralUserSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ct);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeneralUserSettings(_response);
        });
    }

    protected processGeneralUserSettings(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    overview2DSettings(ct: Overview2DSettings): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/SettingsSwaggerDummy/Overview2DSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ct);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOverview2DSettings(_response);
        });
    }

    protected processOverview2DSettings(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    pqtConfig(ct: PqtConfig): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/SettingsSwaggerDummy/PqtConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ct);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPqtConfig(_response);
        });
    }

    protected processPqtConfig(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createMqttFromVisitorManagementResultParam(ct: CreateMqttFromVisitorManagementResultParam): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/SettingsSwaggerDummy/CreateMqttFromVisitorManagementResultParam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ct);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateMqttFromVisitorManagementResultParam(_response);
        });
    }

    protected processCreateMqttFromVisitorManagementResultParam(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IUserLimitClient {

    userLimitReached(): Promise<BaseResultOfBoolean>;
}

export class UserLimitClient implements IUserLimitClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    userLimitReached(): Promise<BaseResultOfBoolean> {
        let url_ = this.baseUrl + "/reached";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserLimitReached(_response);
        });
    }

    protected processUserLimitReached(response: Response): Promise<BaseResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfBoolean.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }
}

export interface IApplicationConfigControllerUIClient {

    getAppConfig(dto: ConfigDto): Promise<BaseResultOfAppConfig>;

    getAppUiConfig(): Promise<AppUiConfigResponse>;

    getAppSettingConfig(): Promise<AppSettingConfigResponse>;

    getTranslations(): Promise<FileResponse>;
}

export class ApplicationConfigControllerUIClient implements IApplicationConfigControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAppConfig(dto: ConfigDto): Promise<BaseResultOfAppConfig> {
        let url_ = this.baseUrl + "/api/v1/config/config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppConfig(_response);
        });
    }

    protected processGetAppConfig(response: Response): Promise<BaseResultOfAppConfig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfAppConfig.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfAppConfig>(null as any);
    }

    getAppUiConfig(): Promise<AppUiConfigResponse> {
        let url_ = this.baseUrl + "/api/v1/config/appuiconfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppUiConfig(_response);
        });
    }

    protected processGetAppUiConfig(response: Response): Promise<AppUiConfigResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppUiConfigResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppUiConfigResponse>(null as any);
    }

    getAppSettingConfig(): Promise<AppSettingConfigResponse> {
        let url_ = this.baseUrl + "/api/v1/config/appsettingconfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppSettingConfig(_response);
        });
    }

    protected processGetAppSettingConfig(response: Response): Promise<AppSettingConfigResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingConfigResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppSettingConfigResponse>(null as any);
    }

    getTranslations(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTranslations(_response);
        });
    }

    protected processGetTranslations(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IGroupUiClient {

    list(): Promise<Group[]>;

    create(vm: Group): Promise<Group>;

    update(vm: Group): Promise<Group>;

    listUsers(): Promise<ListItem[]>;

    delete(id: string): Promise<void>;

    parseUsers(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<GroupUserExternal[]>;

    listGroupUserExternal(groupId: string): Promise<FileResponse>;
}

export class GroupUiClient implements IGroupUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<Group[]> {
        let url_ = this.baseUrl + "/api/v1/group";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<Group[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Group.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Group[]>(null as any);
    }

    create(vm: Group): Promise<Group> {
        let url_ = this.baseUrl + "/api/v1/group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<Group> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Group.fromJS(resultData201);
            return result201;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Group>(null as any);
    }

    update(vm: Group): Promise<Group> {
        let url_ = this.baseUrl + "/api/v1/group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<Group> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Group.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Group>(null as any);
    }

    listUsers(): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/v1/group/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListUsers(_response);
        });
    }

    protected processListUsers(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/group/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    parseUsers(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<GroupUserExternal[]> {
        let url_ = this.baseUrl + "/api/v1/group/parseUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (parentId !== null && parentId !== undefined)
            content_.append("ParentId", parentId.toString());
        if (uploads !== null && uploads !== undefined)
            uploads.forEach(item_ => content_.append("Uploads", item_.data, item_.fileName ? item_.fileName : "Uploads") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processParseUsers(_response);
        });
    }

    protected processParseUsers(response: Response): Promise<GroupUserExternal[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupUserExternal.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupUserExternal[]>(null as any);
    }

    listGroupUserExternal(groupId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/group/{groupId}/downloadGroupUsersExternal";
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListGroupUserExternal(_response);
        });
    }

    protected processListGroupUserExternal(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IPivotClient {

    index(refresh: boolean | undefined): Promise<FileResponse>;

    pivotTableHtml(pvtReportCfg: PivotTableReportConfig): Promise<FileResponse>;

    exportFile(format: string | null | undefined, pvtConfigJson: string | null | undefined): Promise<FileResponse>;

    exportFile2(format: string | null | undefined, pvtConfigJson: string | null | undefined): Promise<FileResponse>;

    extraModels(templates: PivotTemplates): Promise<FileResponse>;
}

export class PivotClient implements IPivotClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    index(refresh: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Pivot?";
        if (refresh === null)
            throw new globalThis.Error("The parameter 'refresh' cannot be null.");
        else if (refresh !== undefined)
            url_ += "refresh=" + encodeURIComponent("" + refresh) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    pivotTableHtml(pvtReportCfg: PivotTableReportConfig): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Pivot/PivotTableHtml";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pvtReportCfg);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPivotTableHtml(_response);
        });
    }

    protected processPivotTableHtml(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportFile(format: string | null | undefined, pvtConfigJson: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Pivot/ExportFile?";
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        if (pvtConfigJson !== undefined && pvtConfigJson !== null)
            url_ += "pvtConfigJson=" + encodeURIComponent("" + pvtConfigJson) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportFile(_response);
        });
    }

    protected processExportFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportFile2(format: string | null | undefined, pvtConfigJson: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Pivot/Export?";
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        if (pvtConfigJson !== undefined && pvtConfigJson !== null)
            url_ += "pvtConfigJson=" + encodeURIComponent("" + pvtConfigJson) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportFile2(_response);
        });
    }

    protected processExportFile2(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    extraModels(templates: PivotTemplates): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Pivot/_exta-models";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(templates);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExtraModels(_response);
        });
    }

    protected processExtraModels(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IPivotSettingsClient {

    shared(): Promise<PivotTemplates>;

    saveTemplateInSubAccounts(request: SaveTemplateInSubAccountsRequest): Promise<void>;
}

export class PivotSettingsClient implements IPivotSettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    shared(): Promise<PivotTemplates> {
        let url_ = this.baseUrl + "/PivotSettings/Shared";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processShared(_response);
        });
    }

    protected processShared(response: Response): Promise<PivotTemplates> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PivotTemplates.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PivotTemplates>(null as any);
    }

    saveTemplateInSubAccounts(request: SaveTemplateInSubAccountsRequest): Promise<void> {
        let url_ = this.baseUrl + "/PivotSettings/saveTemplateInSubAccounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveTemplateInSubAccounts(_response);
        });
    }

    protected processSaveTemplateInSubAccounts(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IGroupSurveyExtensionUiClient {

    create(vm: GroupSurveyExtension): Promise<GroupSurveyExtension>;

    list(filter: string | null | undefined, order: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined): Promise<GroupSurveyExtension[]>;

    update(vm: GroupSurveyExtension): Promise<GroupSurveyExtension>;

    getById(id: string): Promise<GroupSurveyExtension>;

    delete(groupSurveyExtensionId: string): Promise<void>;

    getMostRecentResults(groupSurveyExtensionId: string): Promise<SurveyResultMeta[]>;

    previewUserMail(groupSurveyExtensionId: string, request: PreviewUserMailRequest): Promise<TitleAndContent>;

    previewExternalUserMail(groupSurveyExtensionId: string, request: PreviewExternalUserMailRequest): Promise<TitleAndContent>;

    sendUserMail(groupSurveyExtensionId: string, request: SendUserMailRequest): Promise<void>;

    sendExternalUserMail(groupSurveyExtensionId: string, request: SendExternalUserMailRequest): Promise<void>;

    presenceStart(groupSurveyExtensionId: string, request: PresenceStartRequest): Promise<GroupSurveyUserPresence>;

    presenceEnd(groupSurveyExtensionId: string, request: PresenceEndRequest): Promise<GroupSurveyUserPresence>;

    listGroupsWithMetaInfo(pagination_Page: number | undefined, pagination_PerPage: number | undefined, filter: FilterOption[] | undefined, sort: SortOption[] | undefined, search: string | null | undefined): Promise<GroupWithMetaInfo[]>;
}

export class GroupSurveyExtensionUiClient implements IGroupSurveyExtensionUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    create(vm: GroupSurveyExtension): Promise<GroupSurveyExtension> {
        let url_ = this.baseUrl + "/api/v1/survey/group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<GroupSurveyExtension> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = GroupSurveyExtension.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupSurveyExtension>(null as any);
    }

    list(filter: string | null | undefined, order: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined): Promise<GroupSurveyExtension[]> {
        let url_ = this.baseUrl + "/api/v1/survey/group?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (order !== undefined && order !== null)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<GroupSurveyExtension[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupSurveyExtension.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupSurveyExtension[]>(null as any);
    }

    update(vm: GroupSurveyExtension): Promise<GroupSurveyExtension> {
        let url_ = this.baseUrl + "/api/v1/survey/group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<GroupSurveyExtension> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupSurveyExtension.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupSurveyExtension>(null as any);
    }

    getById(id: string): Promise<GroupSurveyExtension> {
        let url_ = this.baseUrl + "/api/v1/survey/group/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<GroupSurveyExtension> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupSurveyExtension.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupSurveyExtension>(null as any);
    }

    delete(groupSurveyExtensionId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/survey/group/{groupSurveyExtensionId}";
        if (groupSurveyExtensionId === undefined || groupSurveyExtensionId === null)
            throw new globalThis.Error("The parameter 'groupSurveyExtensionId' must be defined.");
        url_ = url_.replace("{groupSurveyExtensionId}", encodeURIComponent("" + groupSurveyExtensionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getMostRecentResults(groupSurveyExtensionId: string): Promise<SurveyResultMeta[]> {
        let url_ = this.baseUrl + "/api/v1/survey/group/{groupSurveyExtensionId}/results/mostRecent";
        if (groupSurveyExtensionId === undefined || groupSurveyExtensionId === null)
            throw new globalThis.Error("The parameter 'groupSurveyExtensionId' must be defined.");
        url_ = url_.replace("{groupSurveyExtensionId}", encodeURIComponent("" + groupSurveyExtensionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMostRecentResults(_response);
        });
    }

    protected processGetMostRecentResults(response: Response): Promise<SurveyResultMeta[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyResultMeta.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyResultMeta[]>(null as any);
    }

    previewUserMail(groupSurveyExtensionId: string, request: PreviewUserMailRequest): Promise<TitleAndContent> {
        let url_ = this.baseUrl + "/api/v1/survey/group/{groupSurveyExtensionId}/mail/user/preview";
        if (groupSurveyExtensionId === undefined || groupSurveyExtensionId === null)
            throw new globalThis.Error("The parameter 'groupSurveyExtensionId' must be defined.");
        url_ = url_.replace("{groupSurveyExtensionId}", encodeURIComponent("" + groupSurveyExtensionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPreviewUserMail(_response);
        });
    }

    protected processPreviewUserMail(response: Response): Promise<TitleAndContent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TitleAndContent.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TitleAndContent>(null as any);
    }

    previewExternalUserMail(groupSurveyExtensionId: string, request: PreviewExternalUserMailRequest): Promise<TitleAndContent> {
        let url_ = this.baseUrl + "/api/v1/survey/group/{groupSurveyExtensionId}/mail/externalUser/preview";
        if (groupSurveyExtensionId === undefined || groupSurveyExtensionId === null)
            throw new globalThis.Error("The parameter 'groupSurveyExtensionId' must be defined.");
        url_ = url_.replace("{groupSurveyExtensionId}", encodeURIComponent("" + groupSurveyExtensionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPreviewExternalUserMail(_response);
        });
    }

    protected processPreviewExternalUserMail(response: Response): Promise<TitleAndContent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TitleAndContent.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TitleAndContent>(null as any);
    }

    sendUserMail(groupSurveyExtensionId: string, request: SendUserMailRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/survey/group/{groupSurveyExtensionId}/mail/user";
        if (groupSurveyExtensionId === undefined || groupSurveyExtensionId === null)
            throw new globalThis.Error("The parameter 'groupSurveyExtensionId' must be defined.");
        url_ = url_.replace("{groupSurveyExtensionId}", encodeURIComponent("" + groupSurveyExtensionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendUserMail(_response);
        });
    }

    protected processSendUserMail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sendExternalUserMail(groupSurveyExtensionId: string, request: SendExternalUserMailRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/survey/group/{groupSurveyExtensionId}/mail/externalUser";
        if (groupSurveyExtensionId === undefined || groupSurveyExtensionId === null)
            throw new globalThis.Error("The parameter 'groupSurveyExtensionId' must be defined.");
        url_ = url_.replace("{groupSurveyExtensionId}", encodeURIComponent("" + groupSurveyExtensionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendExternalUserMail(_response);
        });
    }

    protected processSendExternalUserMail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    presenceStart(groupSurveyExtensionId: string, request: PresenceStartRequest): Promise<GroupSurveyUserPresence> {
        let url_ = this.baseUrl + "/api/v1/survey/group/{groupSurveyExtensionId}/presence/start";
        if (groupSurveyExtensionId === undefined || groupSurveyExtensionId === null)
            throw new globalThis.Error("The parameter 'groupSurveyExtensionId' must be defined.");
        url_ = url_.replace("{groupSurveyExtensionId}", encodeURIComponent("" + groupSurveyExtensionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPresenceStart(_response);
        });
    }

    protected processPresenceStart(response: Response): Promise<GroupSurveyUserPresence> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupSurveyUserPresence.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupSurveyUserPresence>(null as any);
    }

    presenceEnd(groupSurveyExtensionId: string, request: PresenceEndRequest): Promise<GroupSurveyUserPresence> {
        let url_ = this.baseUrl + "/api/v1/survey/group/{groupSurveyExtensionId}/presence/end";
        if (groupSurveyExtensionId === undefined || groupSurveyExtensionId === null)
            throw new globalThis.Error("The parameter 'groupSurveyExtensionId' must be defined.");
        url_ = url_.replace("{groupSurveyExtensionId}", encodeURIComponent("" + groupSurveyExtensionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPresenceEnd(_response);
        });
    }

    protected processPresenceEnd(response: Response): Promise<GroupSurveyUserPresence> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupSurveyUserPresence.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupSurveyUserPresence>(null as any);
    }

    listGroupsWithMetaInfo(pagination_Page: number | undefined, pagination_PerPage: number | undefined, filter: FilterOption[] | undefined, sort: SortOption[] | undefined, search: string | null | undefined): Promise<GroupWithMetaInfo[]> {
        let url_ = this.baseUrl + "/api/v1/survey/group/groupsWithMeta?";
        if (pagination_Page === null)
            throw new globalThis.Error("The parameter 'pagination_Page' cannot be null.");
        else if (pagination_Page !== undefined)
            url_ += "Pagination.Page=" + encodeURIComponent("" + pagination_Page) + "&";
        if (pagination_PerPage === null)
            throw new globalThis.Error("The parameter 'pagination_PerPage' cannot be null.");
        else if (pagination_PerPage !== undefined)
            url_ += "Pagination.PerPage=" + encodeURIComponent("" + pagination_PerPage) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            filter && filter.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filter[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (sort === null)
            throw new globalThis.Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Sort[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListGroupsWithMetaInfo(_response);
        });
    }

    protected processListGroupsWithMetaInfo(response: Response): Promise<GroupWithMetaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupWithMetaInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupWithMetaInfo[]>(null as any);
    }
}

export interface ISurveyCodeUiClient {

    getUser(): Promise<GroupUserExternal>;

    getSurveysResultMeta(): Promise<SurveyCodeStatusResponse>;

    getCodeImage(): Promise<SurveyCodeImageResponse>;

    authenticate(request: SurveyCodeAuthenticationRequest): Promise<void>;

    deauthenticate(): Promise<void>;
}

export class SurveyCodeUiClient implements ISurveyCodeUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getUser(): Promise<GroupUserExternal> {
        let url_ = this.baseUrl + "/api/v1/surveys/code/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: Response): Promise<GroupUserExternal> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupUserExternal.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupUserExternal>(null as any);
    }

    getSurveysResultMeta(): Promise<SurveyCodeStatusResponse> {
        let url_ = this.baseUrl + "/api/v1/surveys/code/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSurveysResultMeta(_response);
        });
    }

    protected processGetSurveysResultMeta(response: Response): Promise<SurveyCodeStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyCodeStatusResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyCodeStatusResponse>(null as any);
    }

    getCodeImage(): Promise<SurveyCodeImageResponse> {
        let url_ = this.baseUrl + "/api/v1/surveys/code/codeimage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCodeImage(_response);
        });
    }

    protected processGetCodeImage(response: Response): Promise<SurveyCodeImageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyCodeImageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyCodeImageResponse>(null as any);
    }

    authenticate(request: SurveyCodeAuthenticationRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/surveys/code/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deauthenticate(): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/surveys/code/deauthenticate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeauthenticate(_response);
        });
    }

    protected processDeauthenticate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ISurveyJsUiClient {

    list(): Promise<SurveyView[]>;

    create(vm: SurveyView): Promise<SurveyView>;

    update(vm: SurveyView): Promise<SurveyView>;

    createMedia(surveyId: string, isResultMedia: boolean | undefined, upload: FileParameter | null | undefined): Promise<Media>;

    getSurvey(id: string): Promise<SurveyView>;

    delete(id: string): Promise<void>;

    copyTo(req: CopyToRequest): Promise<void>;

    listResult(surveyId: string, pagination_Page: number | undefined, pagination_PerPage: number | undefined, filter: FilterOption[] | undefined, sort: SortOption[] | undefined, search: string | null | undefined): Promise<VueGoodTableListOfSurveyResultView>;

    deleteResultOfSurvey(surveyId: string): Promise<void>;

    saveResult(surveyId: string, vm: SurveyResultView): Promise<SurveyResultView>;

    listResultCombined(groupId: string, pagination_Page: number | undefined, pagination_PerPage: number | undefined, filter: FilterOption[] | undefined, sort: SortOption[] | undefined, search: string | null | undefined): Promise<VueGoodTableListOfSurveyResultView>;

    getAnswers(surveyId: string, resultId: number): Promise<SurveyAnswers>;

    getAnswersPdf(surveyId: string, resultId: number): Promise<FileResponse>;

    getResultCertificate(surveyId: string, resultId: number): Promise<FileResponse>;

    setEndDate(surveyId: string, resultId: number): Promise<SurveyResultView>;

    setExtraProperties(surveyId: string, resultId: number, surveyResultView: SurveyResultView): Promise<SurveyResultView>;

    checkResultValid(surveyId: string, req: SurveyResultValidityCheck): Promise<boolean>;

    updateResultEnd(vm: SurveyUpdateRequest): Promise<void>;

    getQrCode(surveyId: string): Promise<FileResponse>;

    import(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<ConvertReturn>;

    deleteMedia(surveyId: string, mediaId: string): Promise<void>;
}

export class SurveyJsUiClient implements ISurveyJsUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<SurveyView[]> {
        let url_ = this.baseUrl + "/api/v1/surveys";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<SurveyView[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyView.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyView[]>(null as any);
    }

    create(vm: SurveyView): Promise<SurveyView> {
        let url_ = this.baseUrl + "/api/v1/surveys";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<SurveyView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = SurveyView.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyView>(null as any);
    }

    update(vm: SurveyView): Promise<SurveyView> {
        let url_ = this.baseUrl + "/api/v1/surveys";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<SurveyView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyView.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyView>(null as any);
    }

    createMedia(surveyId: string, isResultMedia: boolean | undefined, upload: FileParameter | null | undefined): Promise<Media> {
        let url_ = this.baseUrl + "/api/v1/surveys/{surveyId}/media";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (isResultMedia === null || isResultMedia === undefined)
            throw new globalThis.Error("The parameter 'isResultMedia' cannot be null.");
        else
            content_.append("IsResultMedia", isResultMedia.toString());
        if (upload !== null && upload !== undefined)
            content_.append("Upload", upload.data, upload.fileName ? upload.fileName : "Upload");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateMedia(_response);
        });
    }

    protected processCreateMedia(response: Response): Promise<Media> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Media.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 413) {
            return response.text().then((_responseText) => {
            let result413: any = null;
            let resultData413 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result413 = ProblemDetails.fromJS(resultData413);
            return throwException("A server side error occurred.", status, _responseText, _headers, result413);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Media>(null as any);
    }

    getSurvey(id: string): Promise<SurveyView> {
        let url_ = this.baseUrl + "/api/v1/surveys/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSurvey(_response);
        });
    }

    protected processGetSurvey(response: Response): Promise<SurveyView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyView.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyView>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/surveys/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    copyTo(req: CopyToRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/surveys/copyTo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCopyTo(_response);
        });
    }

    protected processCopyTo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    listResult(surveyId: string, pagination_Page: number | undefined, pagination_PerPage: number | undefined, filter: FilterOption[] | undefined, sort: SortOption[] | undefined, search: string | null | undefined): Promise<VueGoodTableListOfSurveyResultView> {
        let url_ = this.baseUrl + "/api/v1/surveys/{surveyId}/results?";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (pagination_Page === null)
            throw new globalThis.Error("The parameter 'pagination_Page' cannot be null.");
        else if (pagination_Page !== undefined)
            url_ += "Pagination.Page=" + encodeURIComponent("" + pagination_Page) + "&";
        if (pagination_PerPage === null)
            throw new globalThis.Error("The parameter 'pagination_PerPage' cannot be null.");
        else if (pagination_PerPage !== undefined)
            url_ += "Pagination.PerPage=" + encodeURIComponent("" + pagination_PerPage) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            filter && filter.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filter[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (sort === null)
            throw new globalThis.Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Sort[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListResult(_response);
        });
    }

    protected processListResult(response: Response): Promise<VueGoodTableListOfSurveyResultView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VueGoodTableListOfSurveyResultView.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VueGoodTableListOfSurveyResultView>(null as any);
    }

    deleteResultOfSurvey(surveyId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/surveys/{surveyId}/results";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteResultOfSurvey(_response);
        });
    }

    protected processDeleteResultOfSurvey(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    saveResult(surveyId: string, vm: SurveyResultView): Promise<SurveyResultView> {
        let url_ = this.baseUrl + "/api/v1/surveys/{surveyId}/results";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveResult(_response);
        });
    }

    protected processSaveResult(response: Response): Promise<SurveyResultView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyResultView.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyResultView>(null as any);
    }

    listResultCombined(groupId: string, pagination_Page: number | undefined, pagination_PerPage: number | undefined, filter: FilterOption[] | undefined, sort: SortOption[] | undefined, search: string | null | undefined): Promise<VueGoodTableListOfSurveyResultView> {
        let url_ = this.baseUrl + "/api/v1/surveys/groups/{groupId}/resultsCombined?";
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (pagination_Page === null)
            throw new globalThis.Error("The parameter 'pagination_Page' cannot be null.");
        else if (pagination_Page !== undefined)
            url_ += "Pagination.Page=" + encodeURIComponent("" + pagination_Page) + "&";
        if (pagination_PerPage === null)
            throw new globalThis.Error("The parameter 'pagination_PerPage' cannot be null.");
        else if (pagination_PerPage !== undefined)
            url_ += "Pagination.PerPage=" + encodeURIComponent("" + pagination_PerPage) + "&";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            filter && filter.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filter[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (sort === null)
            throw new globalThis.Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Sort[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListResultCombined(_response);
        });
    }

    protected processListResultCombined(response: Response): Promise<VueGoodTableListOfSurveyResultView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VueGoodTableListOfSurveyResultView.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VueGoodTableListOfSurveyResultView>(null as any);
    }

    getAnswers(surveyId: string, resultId: number): Promise<SurveyAnswers> {
        let url_ = this.baseUrl + "/api/v1/surveys/{surveyId}/results/{resultId}/answers";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (resultId === undefined || resultId === null)
            throw new globalThis.Error("The parameter 'resultId' must be defined.");
        url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAnswers(_response);
        });
    }

    protected processGetAnswers(response: Response): Promise<SurveyAnswers> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyAnswers.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyAnswers>(null as any);
    }

    getAnswersPdf(surveyId: string, resultId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/surveys/{surveyId}/results/{resultId}/answers/pdf";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (resultId === undefined || resultId === null)
            throw new globalThis.Error("The parameter 'resultId' must be defined.");
        url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAnswersPdf(_response);
        });
    }

    protected processGetAnswersPdf(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getResultCertificate(surveyId: string, resultId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/surveys/{surveyId}/results/{resultId}/certificate";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (resultId === undefined || resultId === null)
            throw new globalThis.Error("The parameter 'resultId' must be defined.");
        url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetResultCertificate(_response);
        });
    }

    protected processGetResultCertificate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    setEndDate(surveyId: string, resultId: number): Promise<SurveyResultView> {
        let url_ = this.baseUrl + "/api/v1/surveys/{surveyId}/results/{resultId}/setEndDate";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (resultId === undefined || resultId === null)
            throw new globalThis.Error("The parameter 'resultId' must be defined.");
        url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetEndDate(_response);
        });
    }

    protected processSetEndDate(response: Response): Promise<SurveyResultView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyResultView.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyResultView>(null as any);
    }

    setExtraProperties(surveyId: string, resultId: number, surveyResultView: SurveyResultView): Promise<SurveyResultView> {
        let url_ = this.baseUrl + "/api/v1/surveys/{surveyId}/results/{resultId}/setExtraProperties";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (resultId === undefined || resultId === null)
            throw new globalThis.Error("The parameter 'resultId' must be defined.");
        url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyResultView);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetExtraProperties(_response);
        });
    }

    protected processSetExtraProperties(response: Response): Promise<SurveyResultView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyResultView.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyResultView>(null as any);
    }

    checkResultValid(surveyId: string, req: SurveyResultValidityCheck): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/surveys/{surveyId}/results/checkValid";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckResultValid(_response);
        });
    }

    protected processCheckResultValid(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateResultEnd(vm: SurveyUpdateRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/surveys/resultend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateResultEnd(_response);
        });
    }

    protected processUpdateResultEnd(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getQrCode(surveyId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/surveys/{surveyId}/qr";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQrCode(_response);
        });
    }

    protected processGetQrCode(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    import(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<ConvertReturn> {
        let url_ = this.baseUrl + "/api/v1/surveys/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (parentId !== null && parentId !== undefined)
            content_.append("ParentId", parentId.toString());
        if (uploads !== null && uploads !== undefined)
            uploads.forEach(item_ => content_.append("Uploads", item_.data, item_.fileName ? item_.fileName : "Uploads") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: Response): Promise<ConvertReturn> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConvertReturn.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConvertReturn>(null as any);
    }

    deleteMedia(surveyId: string, mediaId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/surveys/{surveyId}/media/{mediaId}";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (mediaId === undefined || mediaId === null)
            throw new globalThis.Error("The parameter 'mediaId' must be defined.");
        url_ = url_.replace("{mediaId}", encodeURIComponent("" + mediaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteMedia(_response);
        });
    }

    protected processDeleteMedia(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ISurveyOverviewUiClient {

    getSurveysResultMeta(): Promise<SurveyResultMeta[]>;
}

export class SurveyOverviewUiClient implements ISurveyOverviewUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getSurveysResultMeta(): Promise<SurveyResultMeta[]> {
        let url_ = this.baseUrl + "/api/v1/surveys/overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSurveysResultMeta(_response);
        });
    }

    protected processGetSurveysResultMeta(response: Response): Promise<SurveyResultMeta[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyResultMeta.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyResultMeta[]>(null as any);
    }
}

export interface IVisitorManagementUiClient {

    presenceViaQr(request: PresenceViaQrRequest): Promise<PresenceViaQrResponse>;

    getApprovalGroups(): Promise<Group[]>;

    getVisitorGroups(): Promise<GroupSurveyExtension[]>;

    generateApiKey(): Promise<string>;

    createExternalUserFromSurveyResult(request: ExternalUserFromSurveyResultRequest): Promise<GroupUserExternal>;

    printBadge(groupSurveyExtensionId: string, externalUserId: string): Promise<FileResponse>;

    generateKioskBadge(request: PresenceViaQrRequest): Promise<string>;

    advanceRegistrationApproval(req: VisitorManagementApprovalRequest): Promise<VisitorManagementApprovalCompleted>;

    getCockpit(from: Date | undefined, to: Date | undefined, filter: string | null | undefined, order: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined): Promise<VmCockpitRow[]>;

    getCockpitStats(from: Date | undefined, to: Date | undefined): Promise<CockpitStats[]>;

    getInformationGroups(): Promise<Group[]>;
}

export class VisitorManagementUiClient implements IVisitorManagementUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    presenceViaQr(request: PresenceViaQrRequest): Promise<PresenceViaQrResponse> {
        let url_ = this.baseUrl + "/api/v1/visitorManagement/presence/qr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPresenceViaQr(_response);
        });
    }

    protected processPresenceViaQr(response: Response): Promise<PresenceViaQrResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PresenceViaQrResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PresenceViaQrResponse>(null as any);
    }

    getApprovalGroups(): Promise<Group[]> {
        let url_ = this.baseUrl + "/api/v1/visitorManagement/advanceRegistration/approvalGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApprovalGroups(_response);
        });
    }

    protected processGetApprovalGroups(response: Response): Promise<Group[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Group.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Group[]>(null as any);
    }

    getVisitorGroups(): Promise<GroupSurveyExtension[]> {
        let url_ = this.baseUrl + "/api/v1/visitorManagement/advanceRegistration/visitorGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVisitorGroups(_response);
        });
    }

    protected processGetVisitorGroups(response: Response): Promise<GroupSurveyExtension[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupSurveyExtension.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupSurveyExtension[]>(null as any);
    }

    generateApiKey(): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/visitorManagement/generateApiKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateApiKey(_response);
        });
    }

    protected processGenerateApiKey(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    createExternalUserFromSurveyResult(request: ExternalUserFromSurveyResultRequest): Promise<GroupUserExternal> {
        let url_ = this.baseUrl + "/api/v1/visitorManagement/externalUserFromSurveyResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateExternalUserFromSurveyResult(_response);
        });
    }

    protected processCreateExternalUserFromSurveyResult(response: Response): Promise<GroupUserExternal> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupUserExternal.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupUserExternal>(null as any);
    }

    printBadge(groupSurveyExtensionId: string, externalUserId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/visitorManagement/group/{groupSurveyExtensionId}/externalUsers/{externalUserId}/badge/pdf";
        if (groupSurveyExtensionId === undefined || groupSurveyExtensionId === null)
            throw new globalThis.Error("The parameter 'groupSurveyExtensionId' must be defined.");
        url_ = url_.replace("{groupSurveyExtensionId}", encodeURIComponent("" + groupSurveyExtensionId));
        if (externalUserId === undefined || externalUserId === null)
            throw new globalThis.Error("The parameter 'externalUserId' must be defined.");
        url_ = url_.replace("{externalUserId}", encodeURIComponent("" + externalUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrintBadge(_response);
        });
    }

    protected processPrintBadge(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    generateKioskBadge(request: PresenceViaQrRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/visitorManagement/kioskBadge/printerCommands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateKioskBadge(_response);
        });
    }

    protected processGenerateKioskBadge(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    advanceRegistrationApproval(req: VisitorManagementApprovalRequest): Promise<VisitorManagementApprovalCompleted> {
        let url_ = this.baseUrl + "/api/v1/visitorManagement/advanceRegistration/approval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdvanceRegistrationApproval(_response);
        });
    }

    protected processAdvanceRegistrationApproval(response: Response): Promise<VisitorManagementApprovalCompleted> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VisitorManagementApprovalCompleted.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VisitorManagementApprovalCompleted>(null as any);
    }

    getCockpit(from: Date | undefined, to: Date | undefined, filter: string | null | undefined, order: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined): Promise<VmCockpitRow[]> {
        let url_ = this.baseUrl + "/api/v1/visitorManagement/advanceRegistration/cockpit?";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (order !== undefined && order !== null)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCockpit(_response);
        });
    }

    protected processGetCockpit(response: Response): Promise<VmCockpitRow[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VmCockpitRow.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VmCockpitRow[]>(null as any);
    }

    getCockpitStats(from: Date | undefined, to: Date | undefined): Promise<CockpitStats[]> {
        let url_ = this.baseUrl + "/api/v1/visitorManagement/advanceRegistration/cockpit/stats?";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCockpitStats(_response);
        });
    }

    protected processGetCockpitStats(response: Response): Promise<CockpitStats[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CockpitStats.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CockpitStats[]>(null as any);
    }

    getInformationGroups(): Promise<Group[]> {
        let url_ = this.baseUrl + "/api/v1/visitorManagement/advanceRegistration/informationGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInformationGroups(_response);
        });
    }

    protected processGetInformationGroups(response: Response): Promise<Group[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Group.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Group[]>(null as any);
    }
}

export interface ILocalizationApiUiClient {

    selectedAccount(): Promise<LanguageAndResourcesVmV1[]>;

    inherited(): Promise<LanguageAndResourcesVmV1[]>;

    insertLanguage(language: Language): Promise<Language>;

    update(translations: LocaleStringResource[]): Promise<LocaleStringResource[]>;
}

export class LocalizationApiUiClient implements ILocalizationApiUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    selectedAccount(): Promise<LanguageAndResourcesVmV1[]> {
        let url_ = this.baseUrl + "/api/v1/localization/selectedAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSelectedAccount(_response);
        });
    }

    protected processSelectedAccount(response: Response): Promise<LanguageAndResourcesVmV1[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LanguageAndResourcesVmV1.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LanguageAndResourcesVmV1[]>(null as any);
    }

    inherited(): Promise<LanguageAndResourcesVmV1[]> {
        let url_ = this.baseUrl + "/api/v1/localization/inherited";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInherited(_response);
        });
    }

    protected processInherited(response: Response): Promise<LanguageAndResourcesVmV1[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LanguageAndResourcesVmV1.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LanguageAndResourcesVmV1[]>(null as any);
    }

    insertLanguage(language: Language): Promise<Language> {
        let url_ = this.baseUrl + "/api/v1/localization/language";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(language);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertLanguage(_response);
        });
    }

    protected processInsertLanguage(response: Response): Promise<Language> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Language.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Language>(null as any);
    }

    update(translations: LocaleStringResource[]): Promise<LocaleStringResource[]> {
        let url_ = this.baseUrl + "/api/v1/localization/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(translations);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<LocaleStringResource[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocaleStringResource.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocaleStringResource[]>(null as any);
    }
}

export interface IUserAPIClient {

    /**
     * Gets the list model.
     * @param userId (optional) 
     * @param token (optional) 
     * @return The list model
     */
    confirmEmail(userId: string | null | undefined, token: string | null | undefined): Promise<FileResponse>;
}

export class UserAPIClient implements IUserAPIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets the list model.
     * @param userId (optional) 
     * @param token (optional) 
     * @return The list model
     */
    confirmEmail(userId: string | null | undefined, token: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/manager/api/user/ConfirmEmail?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmEmail(_response);
        });
    }

    protected processConfirmEmail(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IAccountApiClient {

    /**
     * Gets the list model.
     * @return The list model
     */
    getAccountEdit(accountId: number): Promise<AccountEdit>;

    /**
     * Gets the list model.
     * @return The list model
     */
    saveAccountEdit(accountEdit: AccountEdit): Promise<AccountEdit>;

    /**
     * Gets the list model.
     * @param id (optional) 
     * @return The list model
     */
    getAccountSelect(id: number | undefined): Promise<AccountSelect>;

    /**
     * Sets the user view account
     * @return The list model
     */
    saveAccountSelect(accountSelect: AccountSelect): Promise<FileResponse>;
}

export class AccountApiClient implements IAccountApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets the list model.
     * @return The list model
     */
    getAccountEdit(accountId: number): Promise<AccountEdit> {
        let url_ = this.baseUrl + "/manager/api/account/GetAccountEdit/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccountEdit(_response);
        });
    }

    protected processGetAccountEdit(response: Response): Promise<AccountEdit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountEdit.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountEdit>(null as any);
    }

    /**
     * Gets the list model.
     * @return The list model
     */
    saveAccountEdit(accountEdit: AccountEdit): Promise<AccountEdit> {
        let url_ = this.baseUrl + "/manager/api/account/SaveAccountEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountEdit);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveAccountEdit(_response);
        });
    }

    protected processSaveAccountEdit(response: Response): Promise<AccountEdit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AccountEdit.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountEdit>(null as any);
    }

    /**
     * Gets the list model.
     * @param id (optional) 
     * @return The list model
     */
    getAccountSelect(id: number | undefined): Promise<AccountSelect> {
        let url_ = this.baseUrl + "/manager/api/account/GetAccountSelect?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccountSelect(_response);
        });
    }

    protected processGetAccountSelect(response: Response): Promise<AccountSelect> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountSelect.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountSelect>(null as any);
    }

    /**
     * Sets the user view account
     * @return The list model
     */
    saveAccountSelect(accountSelect: AccountSelect): Promise<FileResponse> {
        let url_ = this.baseUrl + "/manager/api/account/SaveAccountSelect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountSelect);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveAccountSelect(_response);
        });
    }

    protected processSaveAccountSelect(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IContactsUiClient {

    list(page: number | null | undefined, pageSize: number | null | undefined): Promise<Contact[]>;

    create(contact: Contact): Promise<Contact>;

    getById(id: string): Promise<Contact[]>;

    update(id: string, contact: Contact): Promise<Contact>;

    patch(id: string, patch: Operation[]): Promise<Contact>;

    delete(id: string): Promise<void>;

    /**
     * Upload an Excel file (.xlsx) and import/update contacts.
     * @param id (optional) 
     * @param parentId (optional) 
     * @param uploads (optional) 
     */
    upload(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<void>;
}

export class ContactsUiClient implements IContactsUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(page: number | null | undefined, pageSize: number | null | undefined): Promise<Contact[]> {
        let url_ = this.baseUrl + "/api/v1/contacts?";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<Contact[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Contact.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Contact[]>(null as any);
    }

    create(contact: Contact): Promise<Contact> {
        let url_ = this.baseUrl + "/api/v1/contacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contact);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<Contact> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Contact.fromJS(resultData201);
            return result201;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Contact>(null as any);
    }

    getById(id: string): Promise<Contact[]> {
        let url_ = this.baseUrl + "/api/v1/contacts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<Contact[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Contact.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Contact[]>(null as any);
    }

    update(id: string, contact: Contact): Promise<Contact> {
        let url_ = this.baseUrl + "/api/v1/contacts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contact);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<Contact> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Contact.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Contact>(null as any);
    }

    patch(id: string, patch: Operation[]): Promise<Contact> {
        let url_ = this.baseUrl + "/api/v1/contacts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<Contact> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Contact.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Contact>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/contacts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Upload an Excel file (.xlsx) and import/update contacts.
     * @param id (optional) 
     * @param parentId (optional) 
     * @param uploads (optional) 
     */
    upload(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/contacts/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (parentId !== null && parentId !== undefined)
            content_.append("ParentId", parentId.toString());
        if (uploads !== null && uploads !== undefined)
            uploads.forEach(item_ => content_.append("Uploads", item_.data, item_.fileName ? item_.fileName : "Uploads") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IMediaApiControllerUIClient {

    /**
     * Gets single media
     * @return The list model
     */
    get(id: string): Promise<MediaItem>;

    /**
     * Gets the image url for the specified dimensions.
     * @param id The unqie id
     * @param width The optional width
     * @param height The optional height
     */
    getUrl(id: string, width: number | null, height: number | null): Promise<void>;

    /**
     * Gets the list model.
     * @param filter (optional) 
     * @param width (optional) 
     * @param height (optional) 
     * @param mediafilter (optional) 
     * @return The list model
     */
    list(folderId: string | null, filter: MediaType | undefined, width: number | null | undefined, height: number | null | undefined, mediafilter: MediaFilter | undefined): Promise<MediaListModel>;

    /**
     * Saves the meta information for the given media asset.
     * @param model The media model
     */
    saveMeta(model: MediaItem): Promise<StatusMessage>;

    saveFolder(filter: MediaType | undefined, model: MediaFolderModel): Promise<MediaListModel>;

    deleteFolder(id: string): Promise<MediaListModel>;

    /**
     * Adds a new media upload.
     * @param id (optional) 
     * @param parentId (optional) 
     * @param uploads (optional) 
     */
    upload(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<FileStatusMessage>;

    move(mediaId: string, folderId: string | null): Promise<StatusMessage>;

    delete(id: string): Promise<MediaListModel>;
}

export class MediaApiControllerUIClient implements IMediaApiControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets single media
     * @return The list model
     */
    get(id: string): Promise<MediaItem> {
        let url_ = this.baseUrl + "/manager/api/media/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<MediaItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaItem.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MediaItem>(null as any);
    }

    /**
     * Gets the image url for the specified dimensions.
     * @param id The unqie id
     * @param width The optional width
     * @param height The optional height
     */
    getUrl(id: string, width: number | null, height: number | null): Promise<void> {
        let url_ = this.baseUrl + "/manager/api/media/url/{id}/{width}/{height}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (width === undefined || width === null)
            throw new globalThis.Error("The parameter 'width' must be defined.");
        url_ = url_.replace("{width}", encodeURIComponent("" + width));
        if (height === undefined || height === null)
            throw new globalThis.Error("The parameter 'height' must be defined.");
        url_ = url_.replace("{height}", encodeURIComponent("" + height));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUrl(_response);
        });
    }

    protected processGetUrl(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 302) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the list model.
     * @param filter (optional) 
     * @param width (optional) 
     * @param height (optional) 
     * @param mediafilter (optional) 
     * @return The list model
     */
    list(folderId: string | null, filter: MediaType | undefined, width: number | null | undefined, height: number | null | undefined, mediafilter: MediaFilter | undefined): Promise<MediaListModel> {
        let url_ = this.baseUrl + "/manager/api/media/list/{folderId}?";
        if (folderId === undefined || folderId === null)
            throw new globalThis.Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (width !== undefined && width !== null)
            url_ += "width=" + encodeURIComponent("" + width) + "&";
        if (height !== undefined && height !== null)
            url_ += "height=" + encodeURIComponent("" + height) + "&";
        if (mediafilter === null)
            throw new globalThis.Error("The parameter 'mediafilter' cannot be null.");
        else if (mediafilter !== undefined)
            url_ += "mediafilter=" + encodeURIComponent("" + mediafilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<MediaListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaListModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MediaListModel>(null as any);
    }

    /**
     * Saves the meta information for the given media asset.
     * @param model The media model
     */
    saveMeta(model: MediaItem): Promise<StatusMessage> {
        let url_ = this.baseUrl + "/manager/api/media/meta/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveMeta(_response);
        });
    }

    protected processSaveMeta(response: Response): Promise<StatusMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatusMessage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusMessage>(null as any);
    }

    saveFolder(filter: MediaType | undefined, model: MediaFolderModel): Promise<MediaListModel> {
        let url_ = this.baseUrl + "/manager/api/media/folder/save?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveFolder(_response);
        });
    }

    protected processSaveFolder(response: Response): Promise<MediaListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaListModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = MediaListModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MediaListModel>(null as any);
    }

    deleteFolder(id: string): Promise<MediaListModel> {
        let url_ = this.baseUrl + "/manager/api/media/folder/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteFolder(_response);
        });
    }

    protected processDeleteFolder(response: Response): Promise<MediaListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaListModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = MediaListModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MediaListModel>(null as any);
    }

    /**
     * Adds a new media upload.
     * @param id (optional) 
     * @param parentId (optional) 
     * @param uploads (optional) 
     */
    upload(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<FileStatusMessage> {
        let url_ = this.baseUrl + "/manager/api/media/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (parentId !== null && parentId !== undefined)
            content_.append("ParentId", parentId.toString());
        if (uploads !== null && uploads !== undefined)
            uploads.forEach(item_ => content_.append("Uploads", item_.data, item_.fileName ? item_.fileName : "Uploads") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<FileStatusMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileStatusMessage.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = StatusMessage.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 413) {
            return response.text().then((_responseText) => {
            let result413: any = null;
            let resultData413 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result413 = StatusMessage.fromJS(resultData413);
            return throwException("A server side error occurred.", status, _responseText, _headers, result413);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileStatusMessage>(null as any);
    }

    move(mediaId: string, folderId: string | null): Promise<StatusMessage> {
        let url_ = this.baseUrl + "/manager/api/media/move/{mediaId}/{folderId}";
        if (mediaId === undefined || mediaId === null)
            throw new globalThis.Error("The parameter 'mediaId' must be defined.");
        url_ = url_.replace("{mediaId}", encodeURIComponent("" + mediaId));
        if (folderId === undefined || folderId === null)
            throw new globalThis.Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMove(_response);
        });
    }

    protected processMove(response: Response): Promise<StatusMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatusMessage.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = StatusMessage.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusMessage>(null as any);
    }

    delete(id: string): Promise<MediaListModel> {
        let url_ = this.baseUrl + "/manager/api/media/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<MediaListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaListModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = MediaListModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MediaListModel>(null as any);
    }
}

export interface IModuleApiClient {

    /**
     * Gets the list model.
     * @return The list model
     */
    list(): Promise<ModuleListModel>;
}

export class ModuleApiClient implements IModuleApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets the list model.
     * @return The list model
     */
    list(): Promise<ModuleListModel> {
        let url_ = this.baseUrl + "/manager/api/module/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<ModuleListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModuleListModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModuleListModel>(null as any);
    }
}

export interface ISettingsApiControllerUIClient {

    get(name: string, shared: boolean, useSelectedAccount: boolean | undefined): Promise<BaseResultOfISettings>;

    update(name: string, shared: boolean, useSelectedAccount: boolean | undefined, json: string): Promise<BaseResultOfObject>;

    getSystemSetting(name: string): Promise<BaseResultOfObject>;
}

export class SettingsApiControllerUIClient implements ISettingsApiControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(name: string, shared: boolean, useSelectedAccount: boolean | undefined): Promise<BaseResultOfISettings> {
        let url_ = this.baseUrl + "/api/v1/SettingsApiControllerUI/get/{name}/{shared}?";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (shared === undefined || shared === null)
            throw new globalThis.Error("The parameter 'shared' must be defined.");
        url_ = url_.replace("{shared}", encodeURIComponent("" + shared));
        if (useSelectedAccount === null)
            throw new globalThis.Error("The parameter 'useSelectedAccount' cannot be null.");
        else if (useSelectedAccount !== undefined)
            url_ += "useSelectedAccount=" + encodeURIComponent("" + useSelectedAccount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<BaseResultOfISettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfISettings.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfISettings>(null as any);
    }

    update(name: string, shared: boolean, useSelectedAccount: boolean | undefined, json: string): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/SettingsApiControllerUI/update/{name}/{shared}?";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (shared === undefined || shared === null)
            throw new globalThis.Error("The parameter 'shared' must be defined.");
        url_ = url_.replace("{shared}", encodeURIComponent("" + shared));
        if (useSelectedAccount === null)
            throw new globalThis.Error("The parameter 'useSelectedAccount' cannot be null.");
        else if (useSelectedAccount !== undefined)
            url_ += "useSelectedAccount=" + encodeURIComponent("" + useSelectedAccount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(json);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfObject.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfObject>(null as any);
    }

    getSystemSetting(name: string): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/SettingsApiControllerUI/getsys/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSystemSetting(_response);
        });
    }

    protected processGetSystemSetting(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfObject.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfObject>(null as any);
    }
}

export interface IUserUiClient {

    current(): Promise<ListItem>;

    changePassword(oldPassword: string | null | undefined, newPassword: string | null | undefined): Promise<void>;

    getHqAccount(userId: string): Promise<TreeNode>;

    setHqAccount(userId: string, accountId: number | undefined): Promise<void>;

    getAllUsers(filter: string | null | undefined, order: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined): Promise<ListItem[]>;
}

export class UserUiClient implements IUserUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    current(): Promise<ListItem> {
        let url_ = this.baseUrl + "/api/v1/user/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCurrent(_response);
        });
    }

    protected processCurrent(response: Response): Promise<ListItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem>(null as any);
    }

    changePassword(oldPassword: string | null | undefined, newPassword: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/user/changePassword?";
        if (oldPassword !== undefined && oldPassword !== null)
            url_ += "oldPassword=" + encodeURIComponent("" + oldPassword) + "&";
        if (newPassword !== undefined && newPassword !== null)
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getHqAccount(userId: string): Promise<TreeNode> {
        let url_ = this.baseUrl + "/api/v1/user/{userId}/hqAccount";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHqAccount(_response);
        });
    }

    protected processGetHqAccount(response: Response): Promise<TreeNode> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreeNode.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeNode>(null as any);
    }

    setHqAccount(userId: string, accountId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/user/{userId}/hqAccount";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (accountId === null || accountId === undefined)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else
            content_.append("accountId", accountId.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetHqAccount(_response);
        });
    }

    protected processSetHqAccount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAllUsers(filter: string | null | undefined, order: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/v1/user?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (order !== undefined && order !== null)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllUsers(_response);
        });
    }

    protected processGetAllUsers(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }
}

export interface ITranslationApiUiClient {

    translate(translationRequest: TranslationRequest): Promise<TranslationResult>;
}

export class TranslationApiUiClient implements ITranslationApiUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    translate(translationRequest: TranslationRequest): Promise<TranslationResult> {
        let url_ = this.baseUrl + "/api/v1/translation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(translationRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTranslate(_response);
        });
    }

    protected processTranslate(response: Response): Promise<TranslationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TranslationResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TranslationResult>(null as any);
    }
}

export interface IAiSearchClient {

    search(req: SearchRequest): Promise<SearchResponse>;

    answerJobFacts(req: EmailServiceRequest): Promise<SearchResponse>;

    getQuestions(req: QuestionGenerationRequest): Promise<QuestionResponse>;
}

export class AiSearchClient implements IAiSearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    search(req: SearchRequest): Promise<SearchResponse> {
        let url_ = this.baseUrl + "/api/AiSearch/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<SearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchResponse>(null as any);
    }

    answerJobFacts(req: EmailServiceRequest): Promise<SearchResponse> {
        let url_ = this.baseUrl + "/api/AiSearch/jobs/answer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnswerJobFacts(_response);
        });
    }

    protected processAnswerJobFacts(response: Response): Promise<SearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchResponse>(null as any);
    }

    getQuestions(req: QuestionGenerationRequest): Promise<QuestionResponse> {
        let url_ = this.baseUrl + "/api/AiSearch/questions/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestions(_response);
        });
    }

    protected processGetQuestions(response: Response): Promise<QuestionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionResponse>(null as any);
    }
}

export interface IAiDocumentsClient {

    upload(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined, tag: string | null | undefined, isShared: boolean | null | undefined): Promise<FileResponse>;

    media(model: ReqCellMediaEnqueue): Promise<SearchResponse>;

    list(): Promise<AiDocument[]>;
}

export class AiDocumentsClient implements IAiDocumentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    upload(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined, tag: string | null | undefined, isShared: boolean | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AiDocuments/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (parentId !== null && parentId !== undefined)
            content_.append("ParentId", parentId.toString());
        if (uploads !== null && uploads !== undefined)
            uploads.forEach(item_ => content_.append("Uploads", item_.data, item_.fileName ? item_.fileName : "Uploads") );
        if (tag !== null && tag !== undefined)
            content_.append("tag", tag.toString());
        if (isShared !== null && isShared !== undefined)
            content_.append("isShared", isShared.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    media(model: ReqCellMediaEnqueue): Promise<SearchResponse> {
        let url_ = this.baseUrl + "/api/AiDocuments/media";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedia(_response);
        });
    }

    protected processMedia(response: Response): Promise<SearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = SearchResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchResponse>(null as any);
    }

    list(): Promise<AiDocument[]> {
        let url_ = this.baseUrl + "/api/AiDocuments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<AiDocument[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AiDocument.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AiDocument[]>(null as any);
    }
}

export interface IAiPromptsClient {

    getPrompts(): Promise<string[]>;

    getTags(): Promise<string[]>;
}

export class AiPromptsClient implements IAiPromptsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getPrompts(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/AiPrompts/prompts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPrompts(_response);
        });
    }

    protected processGetPrompts(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getTags(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/AiPrompts/tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTags(_response);
        });
    }

    protected processGetTags(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export interface IActionsApiUiClient {

    list(): Promise<ActionDefinition[]>;

    insert(definition: ActionDefinition): Promise<ActionDefinition>;

    update(definition: ActionDefinition): Promise<ActionDefinition>;

    getById(id: string): Promise<ActionDefinition>;

    delete(id: string): Promise<void>;

    trigger(request: TriggerActionRequest): Promise<void>;
}

export class ActionsApiUiClient implements IActionsApiUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<ActionDefinition[]> {
        let url_ = this.baseUrl + "/api/v1/actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<ActionDefinition[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActionDefinition.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActionDefinition[]>(null as any);
    }

    insert(definition: ActionDefinition): Promise<ActionDefinition> {
        let url_ = this.baseUrl + "/api/v1/actions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(definition);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: Response): Promise<ActionDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ActionDefinition.fromJS(resultData201);
            return result201;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActionDefinition>(null as any);
    }

    update(definition: ActionDefinition): Promise<ActionDefinition> {
        let url_ = this.baseUrl + "/api/v1/actions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(definition);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ActionDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActionDefinition.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActionDefinition>(null as any);
    }

    getById(id: string): Promise<ActionDefinition> {
        let url_ = this.baseUrl + "/api/v1/actions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<ActionDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActionDefinition.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActionDefinition>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/actions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    trigger(request: TriggerActionRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/actions/trigger";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTrigger(_response);
        });
    }

    protected processTrigger(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IAndonAPIClient {

    list(): Promise<BaseResultOfAndonSettingOf>;

    update(setting: AndonSetting): Promise<BaseResultOfObject>;
}

export class AndonAPIClient implements IAndonAPIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<BaseResultOfAndonSettingOf> {
        let url_ = this.baseUrl + "/api/v1/AndonAPI/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<BaseResultOfAndonSettingOf> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfAndonSettingOf.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    update(setting: AndonSetting): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/AndonAPI/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setting);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfObject.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }
}

export interface IChartwizardApiClient {

    getTables(): Promise<BaseResultOfTableOf>;

    getData(sel: Selection): Promise<BaseResultOfDataPointOf>;
}

export class ChartwizardApiClient implements IChartwizardApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getTables(): Promise<BaseResultOfTableOf> {
        let url_ = this.baseUrl + "/api/v1/chartwizard/tables";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTables(_response);
        });
    }

    protected processGetTables(response: Response): Promise<BaseResultOfTableOf> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = BaseResultOfErrorResult.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfTableOf.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    getData(sel: Selection): Promise<BaseResultOfDataPointOf> {
        let url_ = this.baseUrl + "/api/v1/chartwizard/data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetData(_response);
        });
    }

    protected processGetData(response: Response): Promise<BaseResultOfDataPointOf> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = BaseResultOfErrorResult.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfDataPointOf.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }
}

export interface IChartwizardTranslationClient {

    list(): Promise<BaseResultOfChartwizardTranslationOf>;
}

export class ChartwizardTranslationClient implements IChartwizardTranslationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<BaseResultOfChartwizardTranslationOf> {
        let url_ = this.baseUrl + "/api/v1/chartwizard/translations/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<BaseResultOfChartwizardTranslationOf> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = BaseResultOfErrorResult.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfChartwizardTranslationOf.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }
}

export interface IChartwizardUnitClient {

    list(): Promise<BaseResultOfChartwizardUnitOf>;
}

export class ChartwizardUnitClient implements IChartwizardUnitClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<BaseResultOfChartwizardUnitOf> {
        let url_ = this.baseUrl + "/api/v1/chartwizard/units/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<BaseResultOfChartwizardUnitOf> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = BaseResultOfErrorResult.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfChartwizardUnitOf.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }
}

export interface IDashboardApiUiClient {

    getByAccountIdAndName(accountId: number, name: string): Promise<Dashboard>;

    getDataByName(name: string): Promise<any>;

    swaggerModels(models: SwaggerModels): Promise<void>;
}

export class DashboardApiUiClient implements IDashboardApiUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getByAccountIdAndName(accountId: number, name: string): Promise<Dashboard> {
        let url_ = this.baseUrl + "/api/v1/dashboard/{accountId}/{name}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByAccountIdAndName(_response);
        });
    }

    protected processGetByAccountIdAndName(response: Response): Promise<Dashboard> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Dashboard.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Dashboard>(null as any);
    }

    getDataByName(name: string): Promise<any> {
        let url_ = this.baseUrl + "/api/v1/dashboard/data/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDataByName(_response);
        });
    }

    protected processGetDataByName(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    swaggerModels(models: SwaggerModels): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/dashboard/_models";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(models);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSwaggerModels(_response);
        });
    }

    protected processSwaggerModels(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IApprovalsApiV2UiClient {

    openMine(): Promise<WorkflowApproval[]>;

    requestApproval(approval: WorkflowApproval): Promise<WorkflowApproval>;

    approve(request: WorkflowApprovalApproveRequest): Promise<WorkflowApproval[]>;
}

export class ApprovalsApiV2UiClient implements IApprovalsApiV2UiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    openMine(): Promise<WorkflowApproval[]> {
        let url_ = this.baseUrl + "/api/v1/kanban/approval/open/mine";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOpenMine(_response);
        });
    }

    protected processOpenMine(response: Response): Promise<WorkflowApproval[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkflowApproval.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkflowApproval[]>(null as any);
    }

    requestApproval(approval: WorkflowApproval): Promise<WorkflowApproval> {
        let url_ = this.baseUrl + "/api/v1/kanban/approval/request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(approval);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRequestApproval(_response);
        });
    }

    protected processRequestApproval(response: Response): Promise<WorkflowApproval> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowApproval.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkflowApproval>(null as any);
    }

    approve(request: WorkflowApprovalApproveRequest): Promise<WorkflowApproval[]> {
        let url_ = this.baseUrl + "/api/v1/kanban/approval/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApprove(_response);
        });
    }

    protected processApprove(response: Response): Promise<WorkflowApproval[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultDatadefault)) {
                resultdefault = [] as any;
                for (let item of resultDatadefault)
                    resultdefault!.push(WorkflowApproval.fromJS(item));
            }
            else {
                resultdefault = null as any;
            }
            return resultdefault;
            });
        }
    }
}

export interface ITemplatesApiV2UiClient {

    templates(): Promise<Board[]>;

    createBoardFromTemplate(request: KanbanCreateBoardFromTemplateRequest): Promise<Board>;

    createTemplateFromBoard(request: KanbanCreateTemplateFromBoardRequest): Promise<Board>;
}

export class TemplatesApiV2UiClient implements ITemplatesApiV2UiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    templates(): Promise<Board[]> {
        let url_ = this.baseUrl + "/api/v2/kanban/templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTemplates(_response);
        });
    }

    protected processTemplates(response: Response): Promise<Board[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Board.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Board[]>(null as any);
    }

    createBoardFromTemplate(request: KanbanCreateBoardFromTemplateRequest): Promise<Board> {
        let url_ = this.baseUrl + "/api/v2/kanban/templates/board-from-template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBoardFromTemplate(_response);
        });
    }

    protected processCreateBoardFromTemplate(response: Response): Promise<Board> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Board.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Board>(null as any);
    }

    createTemplateFromBoard(request: KanbanCreateTemplateFromBoardRequest): Promise<Board> {
        let url_ = this.baseUrl + "/api/v2/kanban/templates/template-from-board";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTemplateFromBoard(_response);
        });
    }

    protected processCreateTemplateFromBoard(response: Response): Promise<Board> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Board.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Board>(null as any);
    }
}

export interface ITimeTrackingApiV2UiClient {

    list(): Promise<TimeTracker[]>;

    update(tracker: TimeTracker): Promise<CardDuration>;

    start(request: KanbanTimeTrackingStartRequest): Promise<TimeTracker>;

    stop(request: KanbanTimeTrackingStopRequest): Promise<CardDuration>;
}

export class TimeTrackingApiV2UiClient implements ITimeTrackingApiV2UiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<TimeTracker[]> {
        let url_ = this.baseUrl + "/api/v2/kanban/time-tracking";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<TimeTracker[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeTracker.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeTracker[]>(null as any);
    }

    update(tracker: TimeTracker): Promise<CardDuration> {
        let url_ = this.baseUrl + "/api/v2/kanban/time-tracking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tracker);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<CardDuration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardDuration.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CardDuration>(null as any);
    }

    start(request: KanbanTimeTrackingStartRequest): Promise<TimeTracker> {
        let url_ = this.baseUrl + "/api/v2/kanban/time-tracking/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStart(_response);
        });
    }

    protected processStart(response: Response): Promise<TimeTracker> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeTracker.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeTracker>(null as any);
    }

    stop(request: KanbanTimeTrackingStopRequest): Promise<CardDuration> {
        let url_ = this.baseUrl + "/api/v2/kanban/time-tracking/stop";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStop(_response);
        });
    }

    protected processStop(response: Response): Promise<CardDuration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardDuration.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CardDuration>(null as any);
    }
}

export interface IAccountsAPIControllerUIClient {

    list(): Promise<BaseResultOfAccountSelect>;
}

export class AccountsAPIControllerUIClient implements IAccountsAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<BaseResultOfAccountSelect> {
        let url_ = this.baseUrl + "/api/v1/kanban/AccountsAPIControllerUI/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<BaseResultOfAccountSelect> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfAccountSelect.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }
}

export interface IAttachmentsAPIControllerUIClient {

    create(cardId: string | undefined, upload: FileParameter | null | undefined): Promise<BaseResultOfAttachment>;

    delete(id: number | undefined, cardId: string | undefined): Promise<BaseResultOfObject>;

    getAttachmentMedias(cardId: string | undefined): Promise<BaseResultOfMediaOf>;

    linkAttachment(req: LinkAttachmentRequest): Promise<Attachment>;

    getAttachmentByMediaPublicUrl(publicUrl: string | null | undefined, cardId: string | undefined): Promise<Attachment>;

    downloadFileByGuid(id: string | undefined): Promise<FileResponse>;
}

export class AttachmentsAPIControllerUIClient implements IAttachmentsAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    create(cardId: string | undefined, upload: FileParameter | null | undefined): Promise<BaseResultOfAttachment> {
        let url_ = this.baseUrl + "/api/v1/kanban/AttachmentsAPIControllerUI/create?";
        if (cardId === null)
            throw new globalThis.Error("The parameter 'cardId' cannot be null.");
        else if (cardId !== undefined)
            url_ += "cardId=" + encodeURIComponent("" + cardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (upload !== null && upload !== undefined)
            content_.append("upload", upload.data, upload.fileName ? upload.fileName : "upload");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<BaseResultOfAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 413) {
            return response.text().then((_responseText) => {
            let result413: any = null;
            let resultData413 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result413 = BaseResultOfErrorResult.fromJS(resultData413);
            return throwException("A server side error occurred.", status, _responseText, _headers, result413);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfAttachment.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    delete(id: number | undefined, cardId: string | undefined): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/kanban/AttachmentsAPIControllerUI/detete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (cardId === null)
            throw new globalThis.Error("The parameter 'cardId' cannot be null.");
        else if (cardId !== undefined)
            url_ += "cardId=" + encodeURIComponent("" + cardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfObject.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    getAttachmentMedias(cardId: string | undefined): Promise<BaseResultOfMediaOf> {
        let url_ = this.baseUrl + "/api/v1/kanban/AttachmentsAPIControllerUI/getAttachmentMedias?";
        if (cardId === null)
            throw new globalThis.Error("The parameter 'cardId' cannot be null.");
        else if (cardId !== undefined)
            url_ += "cardId=" + encodeURIComponent("" + cardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAttachmentMedias(_response);
        });
    }

    protected processGetAttachmentMedias(response: Response): Promise<BaseResultOfMediaOf> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfMediaOf.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    linkAttachment(req: LinkAttachmentRequest): Promise<Attachment> {
        let url_ = this.baseUrl + "/api/v1/kanban/AttachmentsAPIControllerUI/link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLinkAttachment(_response);
        });
    }

    protected processLinkAttachment(response: Response): Promise<Attachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Attachment.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Attachment>(null as any);
    }

    getAttachmentByMediaPublicUrl(publicUrl: string | null | undefined, cardId: string | undefined): Promise<Attachment> {
        let url_ = this.baseUrl + "/api/v1/kanban/AttachmentsAPIControllerUI/mediaPublicUrl?";
        if (publicUrl !== undefined && publicUrl !== null)
            url_ += "publicUrl=" + encodeURIComponent("" + publicUrl) + "&";
        if (cardId === null)
            throw new globalThis.Error("The parameter 'cardId' cannot be null.");
        else if (cardId !== undefined)
            url_ += "cardId=" + encodeURIComponent("" + cardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAttachmentByMediaPublicUrl(_response);
        });
    }

    protected processGetAttachmentByMediaPublicUrl(response: Response): Promise<Attachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Attachment.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Attachment>(null as any);
    }

    downloadFileByGuid(id: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/kanban/AttachmentsAPIControllerUI?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadFileByGuid(_response);
        });
    }

    protected processDownloadFileByGuid(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IAttributeDefinitionsAPIControllerUIClient {

    create(attr: CardAttributeDefinition): Promise<BaseResultOfCardAttributeDefinition>;

    update(attr: CardAttributeDefinition): Promise<BaseResultOfCardAttributeDefinition>;

    delete(id: number): Promise<BaseResultOfObject>;
}

export class AttributeDefinitionsAPIControllerUIClient implements IAttributeDefinitionsAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    create(attr: CardAttributeDefinition): Promise<BaseResultOfCardAttributeDefinition> {
        let url_ = this.baseUrl + "/api/v1/kanban/AttributeDefinitionsAPIControllerUI/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attr);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<BaseResultOfCardAttributeDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfCardAttributeDefinition.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    update(attr: CardAttributeDefinition): Promise<BaseResultOfCardAttributeDefinition> {
        let url_ = this.baseUrl + "/api/v1/kanban/AttributeDefinitionsAPIControllerUI/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attr);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResultOfCardAttributeDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfCardAttributeDefinition.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    delete(id: number): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/kanban/AttributeDefinitionsAPIControllerUI/detete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfObject.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }
}

export interface IBoardsAPIControllerUIClient {

    list(archived: boolean | undefined, alwaysShowMyBoards: boolean | undefined): Promise<BaseResultOfBoardOf>;

    create(board: Board): Promise<BaseResultOfBoard>;

    update(board: Board): Promise<BaseResultOfBoard>;

    updateLogging(boardId: number | undefined, enabled: boolean | undefined): Promise<BaseResultOfObject>;

    updateReadConfirmations(boardId: number | undefined, enabled: boolean | undefined): Promise<BaseResultOfBoard>;

    updateLockdownDelay(boardId: number | undefined, delaySeconds: number | undefined): Promise<BaseResultOfObject>;

    updateOnlyTimeTrackingForOthers(boardId: number | undefined, onlyTimeTrackingForOthers: boolean | undefined): Promise<void>;

    updateOnlyShowAssignedCardsToOthers(boardId: number | undefined, onlyShowAssignedCardsToOthers: boolean | undefined): Promise<void>;

    delete(id: number): Promise<BaseResultOfObject>;

    updateOwner(request: ChangeBoardOwnerRequest): Promise<void>;
}

export class BoardsAPIControllerUIClient implements IBoardsAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(archived: boolean | undefined, alwaysShowMyBoards: boolean | undefined): Promise<BaseResultOfBoardOf> {
        let url_ = this.baseUrl + "/api/v1/kanban/BoardsAPIControllerUI/list?";
        if (archived === null)
            throw new globalThis.Error("The parameter 'archived' cannot be null.");
        else if (archived !== undefined)
            url_ += "archived=" + encodeURIComponent("" + archived) + "&";
        if (alwaysShowMyBoards === null)
            throw new globalThis.Error("The parameter 'alwaysShowMyBoards' cannot be null.");
        else if (alwaysShowMyBoards !== undefined)
            url_ += "alwaysShowMyBoards=" + encodeURIComponent("" + alwaysShowMyBoards) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<BaseResultOfBoardOf> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfBoardOf.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    create(board: Board): Promise<BaseResultOfBoard> {
        let url_ = this.baseUrl + "/api/v1/kanban/BoardsAPIControllerUI/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(board);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<BaseResultOfBoard> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfBoard.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    update(board: Board): Promise<BaseResultOfBoard> {
        let url_ = this.baseUrl + "/api/v1/kanban/BoardsAPIControllerUI/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(board);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResultOfBoard> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfBoard.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    updateLogging(boardId: number | undefined, enabled: boolean | undefined): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/kanban/BoardsAPIControllerUI/update-logging?";
        if (boardId === null)
            throw new globalThis.Error("The parameter 'boardId' cannot be null.");
        else if (boardId !== undefined)
            url_ += "boardId=" + encodeURIComponent("" + boardId) + "&";
        if (enabled === null)
            throw new globalThis.Error("The parameter 'enabled' cannot be null.");
        else if (enabled !== undefined)
            url_ += "enabled=" + encodeURIComponent("" + enabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateLogging(_response);
        });
    }

    protected processUpdateLogging(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfObject.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    updateReadConfirmations(boardId: number | undefined, enabled: boolean | undefined): Promise<BaseResultOfBoard> {
        let url_ = this.baseUrl + "/api/v1/kanban/BoardsAPIControllerUI/update-read-confirmations?";
        if (boardId === null)
            throw new globalThis.Error("The parameter 'boardId' cannot be null.");
        else if (boardId !== undefined)
            url_ += "boardId=" + encodeURIComponent("" + boardId) + "&";
        if (enabled === null)
            throw new globalThis.Error("The parameter 'enabled' cannot be null.");
        else if (enabled !== undefined)
            url_ += "enabled=" + encodeURIComponent("" + enabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateReadConfirmations(_response);
        });
    }

    protected processUpdateReadConfirmations(response: Response): Promise<BaseResultOfBoard> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfBoard.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    updateLockdownDelay(boardId: number | undefined, delaySeconds: number | undefined): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/kanban/BoardsAPIControllerUI/update-lockdowndelay?";
        if (boardId === null)
            throw new globalThis.Error("The parameter 'boardId' cannot be null.");
        else if (boardId !== undefined)
            url_ += "boardId=" + encodeURIComponent("" + boardId) + "&";
        if (delaySeconds === null)
            throw new globalThis.Error("The parameter 'delaySeconds' cannot be null.");
        else if (delaySeconds !== undefined)
            url_ += "delaySeconds=" + encodeURIComponent("" + delaySeconds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateLockdownDelay(_response);
        });
    }

    protected processUpdateLockdownDelay(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfObject.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    updateOnlyTimeTrackingForOthers(boardId: number | undefined, onlyTimeTrackingForOthers: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/kanban/BoardsAPIControllerUI/update-onlyTimeTrackingForOthers?";
        if (boardId === null)
            throw new globalThis.Error("The parameter 'boardId' cannot be null.");
        else if (boardId !== undefined)
            url_ += "boardId=" + encodeURIComponent("" + boardId) + "&";
        if (onlyTimeTrackingForOthers === null)
            throw new globalThis.Error("The parameter 'onlyTimeTrackingForOthers' cannot be null.");
        else if (onlyTimeTrackingForOthers !== undefined)
            url_ += "onlyTimeTrackingForOthers=" + encodeURIComponent("" + onlyTimeTrackingForOthers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateOnlyTimeTrackingForOthers(_response);
        });
    }

    protected processUpdateOnlyTimeTrackingForOthers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateOnlyShowAssignedCardsToOthers(boardId: number | undefined, onlyShowAssignedCardsToOthers: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/kanban/BoardsAPIControllerUI/update-onlyShowAssignedCardsToOthers?";
        if (boardId === null)
            throw new globalThis.Error("The parameter 'boardId' cannot be null.");
        else if (boardId !== undefined)
            url_ += "boardId=" + encodeURIComponent("" + boardId) + "&";
        if (onlyShowAssignedCardsToOthers === null)
            throw new globalThis.Error("The parameter 'onlyShowAssignedCardsToOthers' cannot be null.");
        else if (onlyShowAssignedCardsToOthers !== undefined)
            url_ += "onlyShowAssignedCardsToOthers=" + encodeURIComponent("" + onlyShowAssignedCardsToOthers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateOnlyShowAssignedCardsToOthers(_response);
        });
    }

    protected processUpdateOnlyShowAssignedCardsToOthers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(id: number): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/kanban/BoardsAPIControllerUI/detete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfObject.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    updateOwner(request: ChangeBoardOwnerRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/kanban/BoardsAPIControllerUI/changeOwner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateOwner(_response);
        });
    }

    protected processUpdateOwner(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICardsAPIControllerUIClient {

    public(cardId: string): Promise<BaseResultOfCardCompound>;

    create(card: CardFix): Promise<BaseResultOfCard>;

    updatePosition(data: CardsPositionRequest): Promise<BaseResultOfCardOf>;

    updateDueDate(card: CardFix): Promise<BaseResultOfCard>;

    updateDescription(card: CardFix): Promise<BaseResultOfCard>;

    updateCardName(card: CardFix): Promise<BaseResultOfCard>;

    updateResponsible(req: ResponsibleRequest): Promise<BaseResultOfObject>;

    updateLabel(req: LabelRequest): Promise<BaseResultOfObject>;

    updatePublic(req: PublicRequest): Promise<BaseResultOfObject>;

    updateAttributes(req: AttributesRequest): Promise<BaseResultOfObject>;

    updateVueFormAttribute(req: AttributeRequest): Promise<void>;

    updateSystemAttributes(req: SystemAttributesRequest): Promise<BaseResultOfObject>;

    updateReadConfirmation(cardId: string | undefined): Promise<CardReadConfirmation>;

    move2Board(boardId: number, flowId: number | null | undefined, card: CardFix): Promise<BaseResultOfCard>;

    archive(card: CardFix): Promise<BaseResultOfCard>;

    delete(cardId: string): Promise<BaseResultOfObject>;

    addDuration(dur: CardDuration): Promise<BaseResultOfCardDuration>;

    duplicate(cardId: string): Promise<Card>;

    moveForward(cardId: string): Promise<void>;
}

export class CardsAPIControllerUIClient implements ICardsAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    public(cardId: string): Promise<BaseResultOfCardCompound> {
        let url_ = this.baseUrl + "/api/v1/kanban/CardsAPIControllerUI/public/{cardId}";
        if (cardId === undefined || cardId === null)
            throw new globalThis.Error("The parameter 'cardId' must be defined.");
        url_ = url_.replace("{cardId}", encodeURIComponent("" + cardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublic(_response);
        });
    }

    protected processPublic(response: Response): Promise<BaseResultOfCardCompound> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfCardCompound.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfCardCompound>(null as any);
    }

    create(card: CardFix): Promise<BaseResultOfCard> {
        let url_ = this.baseUrl + "/api/v1/kanban/CardsAPIControllerUI/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(card);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<BaseResultOfCard> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfCard.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfCard>(null as any);
    }

    updatePosition(data: CardsPositionRequest): Promise<BaseResultOfCardOf> {
        let url_ = this.baseUrl + "/api/v1/kanban/CardsAPIControllerUI/updatePosition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePosition(_response);
        });
    }

    protected processUpdatePosition(response: Response): Promise<BaseResultOfCardOf> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfCardOf.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfCardOf>(null as any);
    }

    updateDueDate(card: CardFix): Promise<BaseResultOfCard> {
        let url_ = this.baseUrl + "/api/v1/kanban/CardsAPIControllerUI/update-duedate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(card);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDueDate(_response);
        });
    }

    protected processUpdateDueDate(response: Response): Promise<BaseResultOfCard> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfCard.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfCard>(null as any);
    }

    updateDescription(card: CardFix): Promise<BaseResultOfCard> {
        let url_ = this.baseUrl + "/api/v1/kanban/CardsAPIControllerUI/update-description";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(card);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDescription(_response);
        });
    }

    protected processUpdateDescription(response: Response): Promise<BaseResultOfCard> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfCard.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfCard>(null as any);
    }

    updateCardName(card: CardFix): Promise<BaseResultOfCard> {
        let url_ = this.baseUrl + "/api/v1/kanban/CardsAPIControllerUI/update-name";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(card);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCardName(_response);
        });
    }

    protected processUpdateCardName(response: Response): Promise<BaseResultOfCard> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfCard.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfCard>(null as any);
    }

    updateResponsible(req: ResponsibleRequest): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/kanban/CardsAPIControllerUI/update-responsible";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateResponsible(_response);
        });
    }

    protected processUpdateResponsible(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfObject.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfObject>(null as any);
    }

    updateLabel(req: LabelRequest): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/kanban/CardsAPIControllerUI/update-label";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateLabel(_response);
        });
    }

    protected processUpdateLabel(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfObject.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfObject>(null as any);
    }

    updatePublic(req: PublicRequest): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/kanban/CardsAPIControllerUI/update-public";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePublic(_response);
        });
    }

    protected processUpdatePublic(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfObject.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfObject>(null as any);
    }

    updateAttributes(req: AttributesRequest): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/kanban/CardsAPIControllerUI/update-attributes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAttributes(_response);
        });
    }

    protected processUpdateAttributes(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfObject.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfObject>(null as any);
    }

    updateVueFormAttribute(req: AttributeRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/kanban/CardsAPIControllerUI/update-vueform-attribute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateVueFormAttribute(_response);
        });
    }

    protected processUpdateVueFormAttribute(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateSystemAttributes(req: SystemAttributesRequest): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/kanban/CardsAPIControllerUI/update-system-attributes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSystemAttributes(_response);
        });
    }

    protected processUpdateSystemAttributes(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfObject.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfObject>(null as any);
    }

    updateReadConfirmation(cardId: string | undefined): Promise<CardReadConfirmation> {
        let url_ = this.baseUrl + "/api/v1/kanban/CardsAPIControllerUI/update-read-confirmation?";
        if (cardId === null)
            throw new globalThis.Error("The parameter 'cardId' cannot be null.");
        else if (cardId !== undefined)
            url_ += "cardId=" + encodeURIComponent("" + cardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateReadConfirmation(_response);
        });
    }

    protected processUpdateReadConfirmation(response: Response): Promise<CardReadConfirmation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardReadConfirmation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CardReadConfirmation>(null as any);
    }

    move2Board(boardId: number, flowId: number | null | undefined, card: CardFix): Promise<BaseResultOfCard> {
        let url_ = this.baseUrl + "/api/v1/kanban/CardsAPIControllerUI/move2board/{boardId}?";
        if (boardId === undefined || boardId === null)
            throw new globalThis.Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (flowId !== undefined && flowId !== null)
            url_ += "flowId=" + encodeURIComponent("" + flowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(card);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMove2Board(_response);
        });
    }

    protected processMove2Board(response: Response): Promise<BaseResultOfCard> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfCard.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfCard>(null as any);
    }

    archive(card: CardFix): Promise<BaseResultOfCard> {
        let url_ = this.baseUrl + "/api/v1/kanban/CardsAPIControllerUI/archive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(card);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processArchive(_response);
        });
    }

    protected processArchive(response: Response): Promise<BaseResultOfCard> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfCard.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfCard>(null as any);
    }

    delete(cardId: string): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/kanban/CardsAPIControllerUI/detete/{cardId}";
        if (cardId === undefined || cardId === null)
            throw new globalThis.Error("The parameter 'cardId' must be defined.");
        url_ = url_.replace("{cardId}", encodeURIComponent("" + cardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result204 = BaseResultOfObject.fromJS(resultData204);
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfObject>(null as any);
    }

    addDuration(dur: CardDuration): Promise<BaseResultOfCardDuration> {
        let url_ = this.baseUrl + "/api/v1/kanban/CardsAPIControllerUI/add-duration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dur);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddDuration(_response);
        });
    }

    protected processAddDuration(response: Response): Promise<BaseResultOfCardDuration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfCardDuration.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfCardDuration>(null as any);
    }

    duplicate(cardId: string): Promise<Card> {
        let url_ = this.baseUrl + "/api/v1/kanban/CardsAPIControllerUI/duplicate/{cardId}";
        if (cardId === undefined || cardId === null)
            throw new globalThis.Error("The parameter 'cardId' must be defined.");
        url_ = url_.replace("{cardId}", encodeURIComponent("" + cardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicate(_response);
        });
    }

    protected processDuplicate(response: Response): Promise<Card> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Card.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Card>(null as any);
    }

    moveForward(cardId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/kanban/CardsAPIControllerUI/moveForward/{cardId}";
        if (cardId === undefined || cardId === null)
            throw new globalThis.Error("The parameter 'cardId' must be defined.");
        url_ = url_.replace("{cardId}", encodeURIComponent("" + cardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMoveForward(_response);
        });
    }

    protected processMoveForward(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICommentRepliesAPIControllerUIClient {

    create(commentReply: CommentReply): Promise<BaseResultOfCommentReply>;

    update(commentReply: CommentReply): Promise<BaseResultOfCommentReply>;

    delete(id: number): Promise<BaseResultOfObject>;
}

export class CommentRepliesAPIControllerUIClient implements ICommentRepliesAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    create(commentReply: CommentReply): Promise<BaseResultOfCommentReply> {
        let url_ = this.baseUrl + "/api/v1/kanban/CommentRepliesAPIControllerUI/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commentReply);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<BaseResultOfCommentReply> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfCommentReply.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    update(commentReply: CommentReply): Promise<BaseResultOfCommentReply> {
        let url_ = this.baseUrl + "/api/v1/kanban/CommentRepliesAPIControllerUI/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commentReply);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResultOfCommentReply> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfCommentReply.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    delete(id: number): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/kanban/CommentRepliesAPIControllerUI/detete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfObject.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }
}

export interface ICommentsAPIControllerUIClient {

    create(comment: Comment): Promise<BaseResultOfComment>;

    update(comment: Comment): Promise<BaseResultOfComment>;

    delete(id: number): Promise<BaseResultOfObject>;
}

export class CommentsAPIControllerUIClient implements ICommentsAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    create(comment: Comment): Promise<BaseResultOfComment> {
        let url_ = this.baseUrl + "/api/v1/kanban/CommentsAPIControllerUI/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<BaseResultOfComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfComment.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    update(comment: Comment): Promise<BaseResultOfComment> {
        let url_ = this.baseUrl + "/api/v1/kanban/CommentsAPIControllerUI/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResultOfComment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfComment.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    delete(id: number): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/kanban/CommentsAPIControllerUI/detete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfObject.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }
}

export interface ILabelsAPIControllerUIClient {

    list(): Promise<BaseResultOfLabelOf>;
}

export class LabelsAPIControllerUIClient implements ILabelsAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<BaseResultOfLabelOf> {
        let url_ = this.baseUrl + "/api/v1/kanban/LabelsAPIControllerUI/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<BaseResultOfLabelOf> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfLabelOf.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }
}

export interface ILoggingAPIControllerUIClient {

    getEvents(days: number | null | undefined): Promise<BaseResultOfLogItemResultDto>;
}

export class LoggingAPIControllerUIClient implements ILoggingAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getEvents(days: number | null | undefined): Promise<BaseResultOfLogItemResultDto> {
        let url_ = this.baseUrl + "/api/v1/kanban/LoggingAPIControllerUI/list?";
        if (days !== undefined && days !== null)
            url_ += "days=" + encodeURIComponent("" + days) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEvents(_response);
        });
    }

    protected processGetEvents(response: Response): Promise<BaseResultOfLogItemResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfLogItemResultDto.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }
}

export interface IPortAPIControllerUIClient {

    import(flowId: number, id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<BaseResultOfInteger>;

    export(flowId: number): Promise<FileResponse>;
}

export class PortAPIControllerUIClient implements IPortAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    import(flowId: number, id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<BaseResultOfInteger> {
        let url_ = this.baseUrl + "/api/v1/kanban/PortAPIControllerUI/import/{flowId}";
        if (flowId === undefined || flowId === null)
            throw new globalThis.Error("The parameter 'flowId' must be defined.");
        url_ = url_.replace("{flowId}", encodeURIComponent("" + flowId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (parentId !== null && parentId !== undefined)
            content_.append("ParentId", parentId.toString());
        if (uploads !== null && uploads !== undefined)
            uploads.forEach(item_ => content_.append("Uploads", item_.data, item_.fileName ? item_.fileName : "Uploads") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: Response): Promise<BaseResultOfInteger> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = BaseResultOfErrorResult.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfInteger.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    export(flowId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/kanban/PortAPIControllerUI/export/{flowId}";
        if (flowId === undefined || flowId === null)
            throw new globalThis.Error("The parameter 'flowId' must be defined.");
        url_ = url_.replace("{flowId}", encodeURIComponent("" + flowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = BaseResultOfErrorResult.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
    }
}

export interface IPrintAPIControllerUIClient {

    downloadPdfByCardGuid(id: string | undefined): Promise<FileResponse>;

    downloadPdfByCardGuids(list: string[]): Promise<FileResponse>;
}

export class PrintAPIControllerUIClient implements IPrintAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    downloadPdfByCardGuid(id: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/kanban/PrintAPIControllerUI/card?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadPdfByCardGuid(_response);
        });
    }

    protected processDownloadPdfByCardGuid(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadPdfByCardGuids(list: string[]): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/kanban/PrintAPIControllerUI/jobs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(list);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadPdfByCardGuids(_response);
        });
    }

    protected processDownloadPdfByCardGuids(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ITaskItemsAPIControllerUIClient {

    create(taskItem: TaskItem): Promise<BaseResultOfTaskItem>;

    update(taskItem: TaskItem): Promise<BaseResultOfTaskItem>;

    delete(id: number): Promise<BaseResultOfObject>;
}

export class TaskItemsAPIControllerUIClient implements ITaskItemsAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    create(taskItem: TaskItem): Promise<BaseResultOfTaskItem> {
        let url_ = this.baseUrl + "/api/v1/kanban/TaskItemsAPIControllerUI/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taskItem);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<BaseResultOfTaskItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfTaskItem.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    update(taskItem: TaskItem): Promise<BaseResultOfTaskItem> {
        let url_ = this.baseUrl + "/api/v1/kanban/TaskItemsAPIControllerUI/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taskItem);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResultOfTaskItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfTaskItem.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    delete(id: number): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/kanban/TaskItemsAPIControllerUI/detete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfObject.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }
}

export interface ITicketsAPIControllerUIClient {

    create(ticket: TicketFix): Promise<BaseResultOfTicket>;

    updatePosition(data: TicketsPositionRequest): Promise<BaseResultOfTicketOf>;

    update(ticket: TicketFix): Promise<BaseResultOfTicket>;

    archive(ticket: TicketFix): Promise<BaseResultOfTicket>;

    delete(ticketId: number): Promise<BaseResultOfObject>;
}

export class TicketsAPIControllerUIClient implements ITicketsAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    create(ticket: TicketFix): Promise<BaseResultOfTicket> {
        let url_ = this.baseUrl + "/api/v1/kanban/TicketsAPIControllerUI/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ticket);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<BaseResultOfTicket> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfTicket.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    updatePosition(data: TicketsPositionRequest): Promise<BaseResultOfTicketOf> {
        let url_ = this.baseUrl + "/api/v1/kanban/TicketsAPIControllerUI/updatePosition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePosition(_response);
        });
    }

    protected processUpdatePosition(response: Response): Promise<BaseResultOfTicketOf> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfTicketOf.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    update(ticket: TicketFix): Promise<BaseResultOfTicket> {
        let url_ = this.baseUrl + "/api/v1/kanban/TicketsAPIControllerUI/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ticket);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResultOfTicket> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfTicket.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    archive(ticket: TicketFix): Promise<BaseResultOfTicket> {
        let url_ = this.baseUrl + "/api/v1/kanban/TicketsAPIControllerUI/archive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ticket);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processArchive(_response);
        });
    }

    protected processArchive(response: Response): Promise<BaseResultOfTicket> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfTicket.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    delete(ticketId: number): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/kanban/TicketsAPIControllerUI/detete/{ticketId}";
        if (ticketId === undefined || ticketId === null)
            throw new globalThis.Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfObject.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }
}

export interface IUserBoardsAPIControllerUIClient {

    list(): Promise<BaseResultOfBoardSharedUserInfoOf>;

    create(boardId: number, userId: string): Promise<BaseResultOfObject>;

    delete(boardId: number, userId: string): Promise<BaseResultOfObject>;
}

export class UserBoardsAPIControllerUIClient implements IUserBoardsAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<BaseResultOfBoardSharedUserInfoOf> {
        let url_ = this.baseUrl + "/api/v1/kanban/UserBoardsAPIControllerUI/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<BaseResultOfBoardSharedUserInfoOf> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfBoardSharedUserInfoOf.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    create(boardId: number, userId: string): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/kanban/UserBoardsAPIControllerUI/create/{boardId}/{userId}";
        if (boardId === undefined || boardId === null)
            throw new globalThis.Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfObject.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    delete(boardId: number, userId: string): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/kanban/UserBoardsAPIControllerUI/detete/{boardId}/{userId}";
        if (boardId === undefined || boardId === null)
            throw new globalThis.Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfObject.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }
}

export interface IUserCardsAPIControllerUIClient {

    list(archived: boolean | undefined): Promise<BaseResultOfCardSharedUserInfoOf>;

    create(cardId: string, fkSharedAccountId: number, boardId: number): Promise<BaseResultOfObject>;

    delete(cardId: string, fkSharedAccountId: number): Promise<BaseResultOfObject>;
}

export class UserCardsAPIControllerUIClient implements IUserCardsAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(archived: boolean | undefined): Promise<BaseResultOfCardSharedUserInfoOf> {
        let url_ = this.baseUrl + "/api/v1/kanban/UserCardsAPIControllerUI/list?";
        if (archived === null)
            throw new globalThis.Error("The parameter 'archived' cannot be null.");
        else if (archived !== undefined)
            url_ += "archived=" + encodeURIComponent("" + archived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<BaseResultOfCardSharedUserInfoOf> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfCardSharedUserInfoOf.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    create(cardId: string, fkSharedAccountId: number, boardId: number): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/kanban/UserCardsAPIControllerUI/create/{cardId}/{fkSharedAccountId}/{boardId}";
        if (cardId === undefined || cardId === null)
            throw new globalThis.Error("The parameter 'cardId' must be defined.");
        url_ = url_.replace("{cardId}", encodeURIComponent("" + cardId));
        if (fkSharedAccountId === undefined || fkSharedAccountId === null)
            throw new globalThis.Error("The parameter 'fkSharedAccountId' must be defined.");
        url_ = url_.replace("{fkSharedAccountId}", encodeURIComponent("" + fkSharedAccountId));
        if (boardId === undefined || boardId === null)
            throw new globalThis.Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfObject.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    delete(cardId: string, fkSharedAccountId: number): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/v1/kanban/UserCardsAPIControllerUI/detete/{cardId}/{fkSharedAccountId}";
        if (cardId === undefined || cardId === null)
            throw new globalThis.Error("The parameter 'cardId' must be defined.");
        url_ = url_.replace("{cardId}", encodeURIComponent("" + cardId));
        if (fkSharedAccountId === undefined || fkSharedAccountId === null)
            throw new globalThis.Error("The parameter 'fkSharedAccountId' must be defined.");
        url_ = url_.replace("{fkSharedAccountId}", encodeURIComponent("" + fkSharedAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = BaseResultOfErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfObject.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }
}

export interface IUsersAPIControllerUIClient {

    list(): Promise<BaseResultOfListItemOf>;
}

export class UsersAPIControllerUIClient implements IUsersAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<BaseResultOfListItemOf> {
        let url_ = this.baseUrl + "/api/v1/kanban/UsersAPIControllerUI/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<BaseResultOfListItemOf> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfListItemOf.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }
}

export interface ILinksApiUiClient {

    list(): Promise<LinkCollection[]>;

    insert(collection: LinkCollection): Promise<LinkCollection>;

    update(collection: LinkCollection): Promise<LinkCollection>;

    getById(id: string): Promise<LinkCollection>;

    delete(id: string): Promise<void>;

    collectionQr(request: CollectionQrRequest): Promise<FileResponse>;
}

export class LinksApiUiClient implements ILinksApiUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<LinkCollection[]> {
        let url_ = this.baseUrl + "/api/v1/links";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<LinkCollection[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinkCollection.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LinkCollection[]>(null as any);
    }

    insert(collection: LinkCollection): Promise<LinkCollection> {
        let url_ = this.baseUrl + "/api/v1/links";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(collection);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: Response): Promise<LinkCollection> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = LinkCollection.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LinkCollection>(null as any);
    }

    update(collection: LinkCollection): Promise<LinkCollection> {
        let url_ = this.baseUrl + "/api/v1/links";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(collection);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<LinkCollection> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LinkCollection.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LinkCollection>(null as any);
    }

    getById(id: string): Promise<LinkCollection> {
        let url_ = this.baseUrl + "/api/v1/links/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<LinkCollection> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LinkCollection.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LinkCollection>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/links/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    collectionQr(request: CollectionQrRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/links/qr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCollectionQr(_response);
        });
    }

    protected processCollectionQr(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IAreaClient {

    getAreaData(): Promise<FileResponse>;

    postAreaData(node: VMLabelNode): Promise<FileResponse>;

    updateEventData(e: LabelNode): Promise<FileResponse>;

    deleteEventData(e: LabelNode[]): Promise<FileResponse>;
}

export class AreaClient implements IAreaClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAreaData(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Area/areas";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAreaData(_response);
        });
    }

    protected processGetAreaData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    postAreaData(node: VMLabelNode): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Area/addarea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(node);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostAreaData(_response);
        });
    }

    protected processPostAreaData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateEventData(e: LabelNode): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Area/updatearea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(e);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateEventData(_response);
        });
    }

    protected processUpdateEventData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteEventData(e: LabelNode[]): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Area/deletearea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(e);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteEventData(_response);
        });
    }

    protected processDeleteEventData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ICellClient {

    getCellsData(): Promise<Cell[]>;

    getCellsAndTreeData(): Promise<CellList[]>;

    getCellTree(): Promise<TreeNodeCell>;

    postCellData(cellEdit: VMCellEdit): Promise<any>;

    updateCellData(l: Cell): Promise<any>;

    deleteCellData(l: number[]): Promise<any>;

    generateQRCodes(columns: number, option1: CellQrLabelOption | null | undefined, option2: CellQrLabelOption | null | undefined, l: Cell[]): Promise<FileResponse>;

    generateNFCCodes(l: Cell[]): Promise<NfcWrite[]>;

    getCellData(id: number): Promise<Cell>;

    setMedia(media: Media2): Promise<any>;

    setMediaForCell(model: SetMediaForCellRequestModel): Promise<any>;

    getCellEventData(startTime: Date | undefined, endTime: Date | undefined, oeeKey: number | undefined): Promise<BaseResultOfListOfVMEventRecordPareto>;

    getCellCost(cellId: number | undefined, subCategory: string | null | undefined): Promise<BaseResultOfICostSumup>;

    getLastActivities(cellId: number | undefined): Promise<BaseResultOfActivityLogOf>;

    getLastPos(cellId: number | undefined): Promise<BaseResultOfGpsPosDto>;

    getInventories(): Promise<BaseResultOfInventoryOf>;

    getLinkedInventories(cellId: number | undefined): Promise<BaseResultOfInventoryOf>;

    setCellInventories(req: SetCellInventoriesRequest): Promise<BaseResultOfObject>;

    import(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<BaseResultOfObject>;

    setParent(cellId: number | undefined, parentId: number | undefined): Promise<BaseResultOfObject>;

    addCostCorrection(cellId: number | undefined, minutes: number | undefined, cost: number | undefined): Promise<BaseResultOfObject>;

    getCellQrAsJson(cellId: number, printerType: PrinterType | undefined): Promise<QrResponseAsEncodedJson>;

    extraModels(): Promise<ExtraModelsClass>;
}

export class CellClient implements ICellClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCellsData(): Promise<Cell[]> {
        let url_ = this.baseUrl + "/api/Cell/Cells";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCellsData(_response);
        });
    }

    protected processGetCellsData(response: Response): Promise<Cell[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Cell.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Cell[]>(null as any);
    }

    getCellsAndTreeData(): Promise<CellList[]> {
        let url_ = this.baseUrl + "/api/Cell/CellsWithTree";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCellsAndTreeData(_response);
        });
    }

    protected processGetCellsAndTreeData(response: Response): Promise<CellList[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CellList.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CellList[]>(null as any);
    }

    getCellTree(): Promise<TreeNodeCell> {
        let url_ = this.baseUrl + "/api/Cell/CellsAsTree";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCellTree(_response);
        });
    }

    protected processGetCellTree(response: Response): Promise<TreeNodeCell> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreeNodeCell.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeNodeCell>(null as any);
    }

    postCellData(cellEdit: VMCellEdit): Promise<any> {
        let url_ = this.baseUrl + "/api/Cell/addCell";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cellEdit);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostCellData(_response);
        });
    }

    protected processPostCellData(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    updateCellData(l: Cell): Promise<any> {
        let url_ = this.baseUrl + "/api/Cell/updateCell";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(l);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCellData(_response);
        });
    }

    protected processUpdateCellData(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    deleteCellData(l: number[]): Promise<any> {
        let url_ = this.baseUrl + "/api/Cell/deleteCell";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(l);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCellData(_response);
        });
    }

    protected processDeleteCellData(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    generateQRCodes(columns: number, option1: CellQrLabelOption | null | undefined, option2: CellQrLabelOption | null | undefined, l: Cell[]): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Cell/generateQR/{columns}?";
        if (columns === undefined || columns === null)
            throw new globalThis.Error("The parameter 'columns' must be defined.");
        url_ = url_.replace("{columns}", encodeURIComponent("" + columns));
        if (option1 !== undefined && option1 !== null)
            url_ += "option1=" + encodeURIComponent("" + option1) + "&";
        if (option2 !== undefined && option2 !== null)
            url_ += "option2=" + encodeURIComponent("" + option2) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(l);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateQRCodes(_response);
        });
    }

    protected processGenerateQRCodes(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    generateNFCCodes(l: Cell[]): Promise<NfcWrite[]> {
        let url_ = this.baseUrl + "/api/Cell/generateNFC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(l);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateNFCCodes(_response);
        });
    }

    protected processGenerateNFCCodes(response: Response): Promise<NfcWrite[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NfcWrite.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NfcWrite[]>(null as any);
    }

    getCellData(id: number): Promise<Cell> {
        let url_ = this.baseUrl + "/api/Cell/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCellData(_response);
        });
    }

    protected processGetCellData(response: Response): Promise<Cell> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Cell.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Cell>(null as any);
    }

    setMedia(media: Media2): Promise<any> {
        let url_ = this.baseUrl + "/api/Cell/updateKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(media);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetMedia(_response);
        });
    }

    protected processSetMedia(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    setMediaForCell(model: SetMediaForCellRequestModel): Promise<any> {
        let url_ = this.baseUrl + "/api/Cell/setMediaForCell";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetMediaForCell(_response);
        });
    }

    protected processSetMediaForCell(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    getCellEventData(startTime: Date | undefined, endTime: Date | undefined, oeeKey: number | undefined): Promise<BaseResultOfListOfVMEventRecordPareto> {
        let url_ = this.baseUrl + "/api/Cell/getEvents?";
        if (startTime === null)
            throw new globalThis.Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new globalThis.Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (oeeKey === null)
            throw new globalThis.Error("The parameter 'oeeKey' cannot be null.");
        else if (oeeKey !== undefined)
            url_ += "oeeKey=" + encodeURIComponent("" + oeeKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCellEventData(_response);
        });
    }

    protected processGetCellEventData(response: Response): Promise<BaseResultOfListOfVMEventRecordPareto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfListOfVMEventRecordPareto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfListOfVMEventRecordPareto>(null as any);
    }

    getCellCost(cellId: number | undefined, subCategory: string | null | undefined): Promise<BaseResultOfICostSumup> {
        let url_ = this.baseUrl + "/api/Cell/getCost?";
        if (cellId === null)
            throw new globalThis.Error("The parameter 'cellId' cannot be null.");
        else if (cellId !== undefined)
            url_ += "cellId=" + encodeURIComponent("" + cellId) + "&";
        if (subCategory !== undefined && subCategory !== null)
            url_ += "subCategory=" + encodeURIComponent("" + subCategory) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCellCost(_response);
        });
    }

    protected processGetCellCost(response: Response): Promise<BaseResultOfICostSumup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfICostSumup.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfICostSumup>(null as any);
    }

    getLastActivities(cellId: number | undefined): Promise<BaseResultOfActivityLogOf> {
        let url_ = this.baseUrl + "/api/Cell/getLastActivities?";
        if (cellId === null)
            throw new globalThis.Error("The parameter 'cellId' cannot be null.");
        else if (cellId !== undefined)
            url_ += "cellId=" + encodeURIComponent("" + cellId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLastActivities(_response);
        });
    }

    protected processGetLastActivities(response: Response): Promise<BaseResultOfActivityLogOf> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfActivityLogOf.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfActivityLogOf>(null as any);
    }

    getLastPos(cellId: number | undefined): Promise<BaseResultOfGpsPosDto> {
        let url_ = this.baseUrl + "/api/Cell/getLastPos?";
        if (cellId === null)
            throw new globalThis.Error("The parameter 'cellId' cannot be null.");
        else if (cellId !== undefined)
            url_ += "cellId=" + encodeURIComponent("" + cellId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLastPos(_response);
        });
    }

    protected processGetLastPos(response: Response): Promise<BaseResultOfGpsPosDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfGpsPosDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfGpsPosDto>(null as any);
    }

    getInventories(): Promise<BaseResultOfInventoryOf> {
        let url_ = this.baseUrl + "/api/Cell/inventories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInventories(_response);
        });
    }

    protected processGetInventories(response: Response): Promise<BaseResultOfInventoryOf> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfInventoryOf.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfInventoryOf>(null as any);
    }

    getLinkedInventories(cellId: number | undefined): Promise<BaseResultOfInventoryOf> {
        let url_ = this.baseUrl + "/api/Cell/InventoriesGetLinked?";
        if (cellId === null)
            throw new globalThis.Error("The parameter 'cellId' cannot be null.");
        else if (cellId !== undefined)
            url_ += "cellId=" + encodeURIComponent("" + cellId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLinkedInventories(_response);
        });
    }

    protected processGetLinkedInventories(response: Response): Promise<BaseResultOfInventoryOf> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfInventoryOf.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfInventoryOf>(null as any);
    }

    setCellInventories(req: SetCellInventoriesRequest): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/Cell/InventoriesSet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetCellInventories(_response);
        });
    }

    protected processSetCellInventories(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfObject.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfObject>(null as any);
    }

    import(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/Cell/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (parentId !== null && parentId !== undefined)
            content_.append("ParentId", parentId.toString());
        if (uploads !== null && uploads !== undefined)
            uploads.forEach(item_ => content_.append("Uploads", item_.data, item_.fileName ? item_.fileName : "Uploads") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfObject.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfObject>(null as any);
    }

    setParent(cellId: number | undefined, parentId: number | undefined): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/Cell/setparent?";
        if (cellId === null)
            throw new globalThis.Error("The parameter 'cellId' cannot be null.");
        else if (cellId !== undefined)
            url_ += "cellId=" + encodeURIComponent("" + cellId) + "&";
        if (parentId === null)
            throw new globalThis.Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetParent(_response);
        });
    }

    protected processSetParent(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfObject.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfObject>(null as any);
    }

    addCostCorrection(cellId: number | undefined, minutes: number | undefined, cost: number | undefined): Promise<BaseResultOfObject> {
        let url_ = this.baseUrl + "/api/Cell/addcostcorrection?";
        if (cellId === null)
            throw new globalThis.Error("The parameter 'cellId' cannot be null.");
        else if (cellId !== undefined)
            url_ += "cellId=" + encodeURIComponent("" + cellId) + "&";
        if (minutes === null)
            throw new globalThis.Error("The parameter 'minutes' cannot be null.");
        else if (minutes !== undefined)
            url_ += "minutes=" + encodeURIComponent("" + minutes) + "&";
        if (cost === null)
            throw new globalThis.Error("The parameter 'cost' cannot be null.");
        else if (cost !== undefined)
            url_ += "cost=" + encodeURIComponent("" + cost) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddCostCorrection(_response);
        });
    }

    protected processAddCostCorrection(response: Response): Promise<BaseResultOfObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfObject.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfObject>(null as any);
    }

    getCellQrAsJson(cellId: number, printerType: PrinterType | undefined): Promise<QrResponseAsEncodedJson> {
        let url_ = this.baseUrl + "/api/Cell/{cellId}/qrAsJson?";
        if (cellId === undefined || cellId === null)
            throw new globalThis.Error("The parameter 'cellId' must be defined.");
        url_ = url_.replace("{cellId}", encodeURIComponent("" + cellId));
        if (printerType === null)
            throw new globalThis.Error("The parameter 'printerType' cannot be null.");
        else if (printerType !== undefined)
            url_ += "printerType=" + encodeURIComponent("" + printerType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCellQrAsJson(_response);
        });
    }

    protected processGetCellQrAsJson(response: Response): Promise<QrResponseAsEncodedJson> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QrResponseAsEncodedJson.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QrResponseAsEncodedJson>(null as any);
    }

    extraModels(): Promise<ExtraModelsClass> {
        let url_ = this.baseUrl + "/api/Cell/_extra-models";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExtraModels(_response);
        });
    }

    protected processExtraModels(response: Response): Promise<ExtraModelsClass> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ExtraModelsClass.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }
}

export interface IChartDataClient {

    getSiteData(): Promise<FileResponse>;

    test(vm: ARequestVM): Promise<FileResponse>;
}

export class ChartDataClient implements IChartDataClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getSiteData(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/reportingapi/sites";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSiteData(_response);
        });
    }

    protected processGetSiteData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    test(vm: ARequestVM): Promise<FileResponse> {
        let url_ = this.baseUrl + "/reportingapi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTest(_response);
        });
    }

    protected processTest(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IConfigClient {

    getEventData(): Promise<FileResponse>;

    postEventData(e: DTOEvent): Promise<FileResponse>;

    updateEventData(e: Event): Promise<FileResponse>;

    deleteEventData(e: Event[]): Promise<FileResponse>;
}

export class ConfigClient implements IConfigClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getEventData(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Config/event";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEventData(_response);
        });
    }

    protected processGetEventData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    postEventData(e: DTOEvent): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Config/addevent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(e);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostEventData(_response);
        });
    }

    protected processPostEventData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateEventData(e: Event): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Config/updateevent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(e);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateEventData(_response);
        });
    }

    protected processUpdateEventData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteEventData(e: Event[]): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Config/deleteevent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(e);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteEventData(_response);
        });
    }

    protected processDeleteEventData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IDutyClient {

    getDutiesData(): Promise<VMDutiesIndex>;

    getDutiesWithNameAndCellIdsOnly(): Promise<BaseResultOfDutyNameWithCellIdsOf>;

    postDutyData(vm: VMDutyCreate): Promise<void>;

    updateDuty(vm: VMDutyCreate): Promise<void>;

    deleteConfirmed(vm: Duty[]): Promise<void>;

    createActivityConfirmed(id: number, skipNextAutoTrigger: boolean | null | undefined): Promise<BaseResultOfActivity>;

    getActvities(startDate: Date | undefined, endDate: Date | undefined): Promise<string>;

    updateChecklist(duties: Duty[] | undefined, dateForDuties: Date[] | undefined, strJsonTodo: string | null | undefined, idTodoList: number | undefined, users: ListItem[] | null | undefined, triggerSelected: number | undefined, triggers: ListDutyTriggerItem[] | null | undefined, cells: ListItemCell[] | null | undefined, userListId: string | null | undefined, duty_DutyId: number | undefined, duty_FKOwnerId: number | undefined, duty_FKDomainObjectNodeId: number | undefined, duty_FKUserId: string | null | undefined, duty_Dates: DutyDate[] | undefined, duty_Files: Media2[] | undefined, duty_Activities: Activity[] | undefined, duty_Checklists: TodoItemDb[] | undefined, duty_Notifications: Notification[] | undefined, duty_DutyTriggers: DutyTrigger[] | undefined, duty_Cells: DutyCellsMapping[] | undefined, duty_IdentString: string | null | undefined, duty_Desc: string | null | undefined, duty_Area: string | null | undefined, duty_SubArea: string | null | undefined, duty_TechArea: string | null | undefined, duty_CostCenter: string | null | undefined, duty_Conditions: Condition | null | undefined, duty_BgColor: string | null | undefined, duty_LinkedEventId: number | undefined, duty_DesiredMin: number | undefined, duty_IsChecklist: boolean | undefined, duty_DatePattern: DatePatternType | null | undefined, duty_FirstDate_DutyDateId: number | undefined, duty_FirstDate_FreqType: Type | undefined, duty_FirstDate_Start: Date | null | undefined, duty_FirstDate_End: Date | null | undefined, duty_FirstDate_Duty_DutyId: number | undefined, duty_FirstDate_Duty_FKOwnerId: number | undefined, duty_FirstDate_Duty_FKDomainObjectNodeId: number | undefined, duty_FirstDate_Duty_FKUserId: string | null | undefined, duty_FirstDate_Duty_Dates: DutyDate[] | undefined, duty_FirstDate_Duty_Files: Media2[] | undefined, duty_FirstDate_Duty_Activities: Activity[] | undefined, duty_FirstDate_Duty_Checklists: TodoItemDb[] | undefined, duty_FirstDate_Duty_Notifications: Notification[] | undefined, duty_FirstDate_Duty_DutyTriggers: DutyTrigger[] | undefined, duty_FirstDate_Duty_Cells: DutyCellsMapping[] | undefined, duty_FirstDate_Duty_IdentString: string | null | undefined, duty_FirstDate_Duty_Desc: string | null | undefined, duty_FirstDate_Duty_Area: string | null | undefined, duty_FirstDate_Duty_SubArea: string | null | undefined, duty_FirstDate_Duty_TechArea: string | null | undefined, duty_FirstDate_Duty_CostCenter: string | null | undefined, duty_FirstDate_Duty_Conditions: Condition | null | undefined, duty_FirstDate_Duty_BgColor: string | null | undefined, duty_FirstDate_Duty_LinkedEventId: number | undefined, duty_FirstDate_Duty_DesiredMin: number | undefined, duty_FirstDate_Duty_IsChecklist: boolean | undefined, duty_FirstDate_Duty_DatePattern: DatePatternType | null | undefined, duty_FirstDate_Duty_FirstDate: DutyDate | null | undefined, duty_FirstDate_Duty_ReccuringDates: Date[] | undefined, duty_FirstDate_Duty_Title: string | undefined, duty_FirstDate_Duty_Cell: string | null | undefined, duty_FirstDate_Duty_Label: string | null | undefined, duty_FirstDate_Duty_SkipNextAutoTrigger: boolean | undefined, duty_FirstDate_Duty_Modified: Date | undefined, duty_FirstDate_Duty_IsDisabled: boolean | undefined, duty_FirstDate_Duty_AdvancedReminderHours: number | undefined, duty_FirstDate_Duty_DueSeconds: number | undefined, duty_FirstDate_Duty_RatePerHour: number | undefined, duty_FirstDate_Duty_PreventAutoTriggeredActivityDuplicates: boolean | undefined, duty_FirstDate_Duty_CbmAnonymousEnabled: boolean | undefined, duty_FirstDate_Duty_CbmAnonymousId: string | null | undefined, duty_FirstDate_Duty_CbmInsertIntoWorkflowEnabled: boolean | undefined, duty_FirstDate_Duty_CbmInsertIntoWorkflowFlow: string | null | undefined, duty_FirstDate_Duty_CbmAutoCloseActivity: boolean | undefined, duty_FirstDate_Duty_CbmMailAnswerEnabled: boolean | undefined, duty_FirstDate_Duty_CbmAuthedId: string | null | undefined, duty_FirstDate_Duty_TitleRegex: string | null | undefined, duty_FirstDate_Duty_IgnoreRegex: string | null | undefined, duty_FirstDate_Duty_AutoCloseAfterDays: number | null | undefined, duty_FirstDate_RepeatStart: Date | null | undefined, duty_FirstDate_RepeatInterval: string | null | undefined, duty_FirstDate_RepeatYear: string | null | undefined, duty_FirstDate_RepeatMonth: string | null | undefined, duty_FirstDate_RepeatDay: string | null | undefined, duty_FirstDate_RepeatWeek: string | null | undefined, duty_FirstDate_RepeatWeekday: string | null | undefined, duty_FirstDate_RepeatWeekOfMonth: string | null | undefined, duty_FirstDate_RepeatHour: number | undefined, duty_FirstDate_DatePattern: DatePatternType | undefined, duty_ReccuringDates: Date[] | undefined, duty_Title: string | undefined, duty_Cell: string | null | undefined, duty_Label: string | null | undefined, duty_SkipNextAutoTrigger: boolean | undefined, duty_Modified: Date | undefined, duty_IsDisabled: boolean | undefined, duty_AdvancedReminderHours: number | undefined, duty_DueSeconds: number | undefined, duty_RatePerHour: number | undefined, duty_PreventAutoTriggeredActivityDuplicates: boolean | undefined, duty_CbmAnonymousEnabled: boolean | undefined, duty_CbmAnonymousId: string | null | undefined, duty_CbmInsertIntoWorkflowEnabled: boolean | undefined, duty_CbmInsertIntoWorkflowFlow: string | null | undefined, duty_CbmAutoCloseActivity: boolean | undefined, duty_CbmMailAnswerEnabled: boolean | undefined, duty_CbmAuthedId: string | null | undefined, duty_TitleRegex: string | null | undefined, duty_IgnoreRegex: string | null | undefined, duty_AutoCloseAfterDays: number | null | undefined): Promise<void>;

    getDuty(id: number): Promise<VMDutyEdit>;

    generateQRCodes(columns: number, l: Duty[]): Promise<FileResponse>;

    cloneDuty(id: number): Promise<void>;

    import(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<void>;

    export(): Promise<FileResponse>;

    getTemplates(): Promise<OptionItem[]>;

    importTemplates(options: OptionItem[]): Promise<void>;

    triggerCbmAnonymousDuty(model: TriggerCbmAnonymousDuty): Promise<void>;

    triggerCbmDuties(model: TriggerCbmDuty): Promise<void>;

    triggerCbmByMailDuties(model: TriggerCbmDuty): Promise<void>;
}

export class DutyClient implements IDutyClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getDutiesData(): Promise<VMDutiesIndex> {
        let url_ = this.baseUrl + "/api/Duty/Duties";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDutiesData(_response);
        });
    }

    protected processGetDutiesData(response: Response): Promise<VMDutiesIndex> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VMDutiesIndex.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VMDutiesIndex>(null as any);
    }

    getDutiesWithNameAndCellIdsOnly(): Promise<BaseResultOfDutyNameWithCellIdsOf> {
        let url_ = this.baseUrl + "/api/Duty/DutiesWithNameAndCellIdsOnly";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDutiesWithNameAndCellIdsOnly(_response);
        });
    }

    protected processGetDutiesWithNameAndCellIdsOnly(response: Response): Promise<BaseResultOfDutyNameWithCellIdsOf> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfDutyNameWithCellIdsOf.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfDutyNameWithCellIdsOf>(null as any);
    }

    postDutyData(vm: VMDutyCreate): Promise<void> {
        let url_ = this.baseUrl + "/api/Duty/addDuty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDutyData(_response);
        });
    }

    protected processPostDutyData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateDuty(vm: VMDutyCreate): Promise<void> {
        let url_ = this.baseUrl + "/api/Duty/updateDuty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDuty(_response);
        });
    }

    protected processUpdateDuty(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteConfirmed(vm: Duty[]): Promise<void> {
        let url_ = this.baseUrl + "/api/Duty/deleteduties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteConfirmed(_response);
        });
    }

    protected processDeleteConfirmed(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createActivityConfirmed(id: number, skipNextAutoTrigger: boolean | null | undefined): Promise<BaseResultOfActivity> {
        let url_ = this.baseUrl + "/api/Duty/CreateActivity/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (skipNextAutoTrigger !== undefined && skipNextAutoTrigger !== null)
            url_ += "skipNextAutoTrigger=" + encodeURIComponent("" + skipNextAutoTrigger) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateActivityConfirmed(_response);
        });
    }

    protected processCreateActivityConfirmed(response: Response): Promise<BaseResultOfActivity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfActivity.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfActivity>(null as any);
    }

    getActvities(startDate: Date | undefined, endDate: Date | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Duty/getcalendar?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActvities(_response);
        });
    }

    protected processGetActvities(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    updateChecklist(duties: Duty[] | undefined, dateForDuties: Date[] | undefined, strJsonTodo: string | null | undefined, idTodoList: number | undefined, users: ListItem[] | null | undefined, triggerSelected: number | undefined, triggers: ListDutyTriggerItem[] | null | undefined, cells: ListItemCell[] | null | undefined, userListId: string | null | undefined, duty_DutyId: number | undefined, duty_FKOwnerId: number | undefined, duty_FKDomainObjectNodeId: number | undefined, duty_FKUserId: string | null | undefined, duty_Dates: DutyDate[] | undefined, duty_Files: Media2[] | undefined, duty_Activities: Activity[] | undefined, duty_Checklists: TodoItemDb[] | undefined, duty_Notifications: Notification[] | undefined, duty_DutyTriggers: DutyTrigger[] | undefined, duty_Cells: DutyCellsMapping[] | undefined, duty_IdentString: string | null | undefined, duty_Desc: string | null | undefined, duty_Area: string | null | undefined, duty_SubArea: string | null | undefined, duty_TechArea: string | null | undefined, duty_CostCenter: string | null | undefined, duty_Conditions: Condition | null | undefined, duty_BgColor: string | null | undefined, duty_LinkedEventId: number | undefined, duty_DesiredMin: number | undefined, duty_IsChecklist: boolean | undefined, duty_DatePattern: DatePatternType | null | undefined, duty_FirstDate_DutyDateId: number | undefined, duty_FirstDate_FreqType: Type | undefined, duty_FirstDate_Start: Date | null | undefined, duty_FirstDate_End: Date | null | undefined, duty_FirstDate_Duty_DutyId: number | undefined, duty_FirstDate_Duty_FKOwnerId: number | undefined, duty_FirstDate_Duty_FKDomainObjectNodeId: number | undefined, duty_FirstDate_Duty_FKUserId: string | null | undefined, duty_FirstDate_Duty_Dates: DutyDate[] | undefined, duty_FirstDate_Duty_Files: Media2[] | undefined, duty_FirstDate_Duty_Activities: Activity[] | undefined, duty_FirstDate_Duty_Checklists: TodoItemDb[] | undefined, duty_FirstDate_Duty_Notifications: Notification[] | undefined, duty_FirstDate_Duty_DutyTriggers: DutyTrigger[] | undefined, duty_FirstDate_Duty_Cells: DutyCellsMapping[] | undefined, duty_FirstDate_Duty_IdentString: string | null | undefined, duty_FirstDate_Duty_Desc: string | null | undefined, duty_FirstDate_Duty_Area: string | null | undefined, duty_FirstDate_Duty_SubArea: string | null | undefined, duty_FirstDate_Duty_TechArea: string | null | undefined, duty_FirstDate_Duty_CostCenter: string | null | undefined, duty_FirstDate_Duty_Conditions: Condition | null | undefined, duty_FirstDate_Duty_BgColor: string | null | undefined, duty_FirstDate_Duty_LinkedEventId: number | undefined, duty_FirstDate_Duty_DesiredMin: number | undefined, duty_FirstDate_Duty_IsChecklist: boolean | undefined, duty_FirstDate_Duty_DatePattern: DatePatternType | null | undefined, duty_FirstDate_Duty_FirstDate: DutyDate | null | undefined, duty_FirstDate_Duty_ReccuringDates: Date[] | undefined, duty_FirstDate_Duty_Title: string | undefined, duty_FirstDate_Duty_Cell: string | null | undefined, duty_FirstDate_Duty_Label: string | null | undefined, duty_FirstDate_Duty_SkipNextAutoTrigger: boolean | undefined, duty_FirstDate_Duty_Modified: Date | undefined, duty_FirstDate_Duty_IsDisabled: boolean | undefined, duty_FirstDate_Duty_AdvancedReminderHours: number | undefined, duty_FirstDate_Duty_DueSeconds: number | undefined, duty_FirstDate_Duty_RatePerHour: number | undefined, duty_FirstDate_Duty_PreventAutoTriggeredActivityDuplicates: boolean | undefined, duty_FirstDate_Duty_CbmAnonymousEnabled: boolean | undefined, duty_FirstDate_Duty_CbmAnonymousId: string | null | undefined, duty_FirstDate_Duty_CbmInsertIntoWorkflowEnabled: boolean | undefined, duty_FirstDate_Duty_CbmInsertIntoWorkflowFlow: string | null | undefined, duty_FirstDate_Duty_CbmAutoCloseActivity: boolean | undefined, duty_FirstDate_Duty_CbmMailAnswerEnabled: boolean | undefined, duty_FirstDate_Duty_CbmAuthedId: string | null | undefined, duty_FirstDate_Duty_TitleRegex: string | null | undefined, duty_FirstDate_Duty_IgnoreRegex: string | null | undefined, duty_FirstDate_Duty_AutoCloseAfterDays: number | null | undefined, duty_FirstDate_RepeatStart: Date | null | undefined, duty_FirstDate_RepeatInterval: string | null | undefined, duty_FirstDate_RepeatYear: string | null | undefined, duty_FirstDate_RepeatMonth: string | null | undefined, duty_FirstDate_RepeatDay: string | null | undefined, duty_FirstDate_RepeatWeek: string | null | undefined, duty_FirstDate_RepeatWeekday: string | null | undefined, duty_FirstDate_RepeatWeekOfMonth: string | null | undefined, duty_FirstDate_RepeatHour: number | undefined, duty_FirstDate_DatePattern: DatePatternType | undefined, duty_ReccuringDates: Date[] | undefined, duty_Title: string | undefined, duty_Cell: string | null | undefined, duty_Label: string | null | undefined, duty_SkipNextAutoTrigger: boolean | undefined, duty_Modified: Date | undefined, duty_IsDisabled: boolean | undefined, duty_AdvancedReminderHours: number | undefined, duty_DueSeconds: number | undefined, duty_RatePerHour: number | undefined, duty_PreventAutoTriggeredActivityDuplicates: boolean | undefined, duty_CbmAnonymousEnabled: boolean | undefined, duty_CbmAnonymousId: string | null | undefined, duty_CbmInsertIntoWorkflowEnabled: boolean | undefined, duty_CbmInsertIntoWorkflowFlow: string | null | undefined, duty_CbmAutoCloseActivity: boolean | undefined, duty_CbmMailAnswerEnabled: boolean | undefined, duty_CbmAuthedId: string | null | undefined, duty_TitleRegex: string | null | undefined, duty_IgnoreRegex: string | null | undefined, duty_AutoCloseAfterDays: number | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Duty?";
        if (duties === null)
            throw new globalThis.Error("The parameter 'duties' cannot be null.");
        else if (duties !== undefined)
            duties && duties.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Duties[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (dateForDuties === null)
            throw new globalThis.Error("The parameter 'dateForDuties' cannot be null.");
        else if (dateForDuties !== undefined)
            dateForDuties && dateForDuties.forEach(item_ => { url_ += "DateForDuties=" + encodeURIComponent(item_ ? "" + item_.toISOString() : "null") + "&"; });
        if (strJsonTodo !== undefined && strJsonTodo !== null)
            url_ += "StrJsonTodo=" + encodeURIComponent("" + strJsonTodo) + "&";
        if (idTodoList === null)
            throw new globalThis.Error("The parameter 'idTodoList' cannot be null.");
        else if (idTodoList !== undefined)
            url_ += "IdTodoList=" + encodeURIComponent("" + idTodoList) + "&";
        if (users !== undefined && users !== null)
            users && users.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Users[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (triggerSelected === null)
            throw new globalThis.Error("The parameter 'triggerSelected' cannot be null.");
        else if (triggerSelected !== undefined)
            url_ += "TriggerSelected=" + encodeURIComponent("" + triggerSelected) + "&";
        if (triggers !== undefined && triggers !== null)
            triggers && triggers.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Triggers[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (cells !== undefined && cells !== null)
            cells && cells.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Cells[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (userListId !== undefined && userListId !== null)
            url_ += "UserListId=" + encodeURIComponent("" + userListId) + "&";
        if (duty_DutyId === null)
            throw new globalThis.Error("The parameter 'duty_DutyId' cannot be null.");
        else if (duty_DutyId !== undefined)
            url_ += "Duty.DutyId=" + encodeURIComponent("" + duty_DutyId) + "&";
        if (duty_FKOwnerId === null)
            throw new globalThis.Error("The parameter 'duty_FKOwnerId' cannot be null.");
        else if (duty_FKOwnerId !== undefined)
            url_ += "Duty.FKOwnerId=" + encodeURIComponent("" + duty_FKOwnerId) + "&";
        if (duty_FKDomainObjectNodeId === null)
            throw new globalThis.Error("The parameter 'duty_FKDomainObjectNodeId' cannot be null.");
        else if (duty_FKDomainObjectNodeId !== undefined)
            url_ += "Duty.FKDomainObjectNodeId=" + encodeURIComponent("" + duty_FKDomainObjectNodeId) + "&";
        if (duty_FKUserId !== undefined && duty_FKUserId !== null)
            url_ += "Duty.FKUserId=" + encodeURIComponent("" + duty_FKUserId) + "&";
        if (duty_Dates === null)
            throw new globalThis.Error("The parameter 'duty_Dates' cannot be null.");
        else if (duty_Dates !== undefined)
            duty_Dates && duty_Dates.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Duty.Dates[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (duty_Files === null)
            throw new globalThis.Error("The parameter 'duty_Files' cannot be null.");
        else if (duty_Files !== undefined)
            duty_Files && duty_Files.forEach(item => { url_ += "Duty.Files=" + encodeURIComponent("" + item) + "&"; });
        if (duty_Activities === null)
            throw new globalThis.Error("The parameter 'duty_Activities' cannot be null.");
        else if (duty_Activities !== undefined)
            duty_Activities && duty_Activities.forEach(item => { url_ += "Duty.Activities=" + encodeURIComponent("" + item) + "&"; });
        if (duty_Checklists === null)
            throw new globalThis.Error("The parameter 'duty_Checklists' cannot be null.");
        else if (duty_Checklists !== undefined)
            duty_Checklists && duty_Checklists.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Duty.Checklists[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (duty_Notifications === null)
            throw new globalThis.Error("The parameter 'duty_Notifications' cannot be null.");
        else if (duty_Notifications !== undefined)
            duty_Notifications && duty_Notifications.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Duty.Notifications[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (duty_DutyTriggers === null)
            throw new globalThis.Error("The parameter 'duty_DutyTriggers' cannot be null.");
        else if (duty_DutyTriggers !== undefined)
            duty_DutyTriggers && duty_DutyTriggers.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Duty.DutyTriggers[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (duty_Cells === null)
            throw new globalThis.Error("The parameter 'duty_Cells' cannot be null.");
        else if (duty_Cells !== undefined)
            duty_Cells && duty_Cells.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Duty.Cells[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (duty_IdentString !== undefined && duty_IdentString !== null)
            url_ += "Duty.IdentString=" + encodeURIComponent("" + duty_IdentString) + "&";
        if (duty_Desc !== undefined && duty_Desc !== null)
            url_ += "Duty.Desc=" + encodeURIComponent("" + duty_Desc) + "&";
        if (duty_Area !== undefined && duty_Area !== null)
            url_ += "Duty.Area=" + encodeURIComponent("" + duty_Area) + "&";
        if (duty_SubArea !== undefined && duty_SubArea !== null)
            url_ += "Duty.SubArea=" + encodeURIComponent("" + duty_SubArea) + "&";
        if (duty_TechArea !== undefined && duty_TechArea !== null)
            url_ += "Duty.TechArea=" + encodeURIComponent("" + duty_TechArea) + "&";
        if (duty_CostCenter !== undefined && duty_CostCenter !== null)
            url_ += "Duty.CostCenter=" + encodeURIComponent("" + duty_CostCenter) + "&";
        if (duty_Conditions !== undefined && duty_Conditions !== null)
            url_ += "Duty.Conditions=" + encodeURIComponent("" + duty_Conditions) + "&";
        if (duty_BgColor !== undefined && duty_BgColor !== null)
            url_ += "Duty.BgColor=" + encodeURIComponent("" + duty_BgColor) + "&";
        if (duty_LinkedEventId === null)
            throw new globalThis.Error("The parameter 'duty_LinkedEventId' cannot be null.");
        else if (duty_LinkedEventId !== undefined)
            url_ += "Duty.LinkedEventId=" + encodeURIComponent("" + duty_LinkedEventId) + "&";
        if (duty_DesiredMin === null)
            throw new globalThis.Error("The parameter 'duty_DesiredMin' cannot be null.");
        else if (duty_DesiredMin !== undefined)
            url_ += "Duty.DesiredMin=" + encodeURIComponent("" + duty_DesiredMin) + "&";
        if (duty_IsChecklist === null)
            throw new globalThis.Error("The parameter 'duty_IsChecklist' cannot be null.");
        else if (duty_IsChecklist !== undefined)
            url_ += "Duty.IsChecklist=" + encodeURIComponent("" + duty_IsChecklist) + "&";
        if (duty_DatePattern !== undefined && duty_DatePattern !== null)
            url_ += "Duty.DatePattern=" + encodeURIComponent("" + duty_DatePattern) + "&";
        if (duty_FirstDate_DutyDateId === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_DutyDateId' cannot be null.");
        else if (duty_FirstDate_DutyDateId !== undefined)
            url_ += "Duty.FirstDate.DutyDateId=" + encodeURIComponent("" + duty_FirstDate_DutyDateId) + "&";
        if (duty_FirstDate_FreqType === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_FreqType' cannot be null.");
        else if (duty_FirstDate_FreqType !== undefined)
            url_ += "Duty.FirstDate.FreqType=" + encodeURIComponent("" + duty_FirstDate_FreqType) + "&";
        if (duty_FirstDate_Start !== undefined && duty_FirstDate_Start !== null)
            url_ += "Duty.FirstDate.Start=" + encodeURIComponent(duty_FirstDate_Start ? "" + duty_FirstDate_Start.toISOString() : "") + "&";
        if (duty_FirstDate_End !== undefined && duty_FirstDate_End !== null)
            url_ += "Duty.FirstDate.End=" + encodeURIComponent(duty_FirstDate_End ? "" + duty_FirstDate_End.toISOString() : "") + "&";
        if (duty_FirstDate_Duty_DutyId === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_DutyId' cannot be null.");
        else if (duty_FirstDate_Duty_DutyId !== undefined)
            url_ += "Duty.FirstDate.Duty.DutyId=" + encodeURIComponent("" + duty_FirstDate_Duty_DutyId) + "&";
        if (duty_FirstDate_Duty_FKOwnerId === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_FKOwnerId' cannot be null.");
        else if (duty_FirstDate_Duty_FKOwnerId !== undefined)
            url_ += "Duty.FirstDate.Duty.FKOwnerId=" + encodeURIComponent("" + duty_FirstDate_Duty_FKOwnerId) + "&";
        if (duty_FirstDate_Duty_FKDomainObjectNodeId === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_FKDomainObjectNodeId' cannot be null.");
        else if (duty_FirstDate_Duty_FKDomainObjectNodeId !== undefined)
            url_ += "Duty.FirstDate.Duty.FKDomainObjectNodeId=" + encodeURIComponent("" + duty_FirstDate_Duty_FKDomainObjectNodeId) + "&";
        if (duty_FirstDate_Duty_FKUserId !== undefined && duty_FirstDate_Duty_FKUserId !== null)
            url_ += "Duty.FirstDate.Duty.FKUserId=" + encodeURIComponent("" + duty_FirstDate_Duty_FKUserId) + "&";
        if (duty_FirstDate_Duty_Dates === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_Dates' cannot be null.");
        else if (duty_FirstDate_Duty_Dates !== undefined)
            duty_FirstDate_Duty_Dates && duty_FirstDate_Duty_Dates.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Duty.FirstDate.Duty.Dates[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (duty_FirstDate_Duty_Files === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_Files' cannot be null.");
        else if (duty_FirstDate_Duty_Files !== undefined)
            duty_FirstDate_Duty_Files && duty_FirstDate_Duty_Files.forEach(item => { url_ += "Duty.FirstDate.Duty.Files=" + encodeURIComponent("" + item) + "&"; });
        if (duty_FirstDate_Duty_Activities === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_Activities' cannot be null.");
        else if (duty_FirstDate_Duty_Activities !== undefined)
            duty_FirstDate_Duty_Activities && duty_FirstDate_Duty_Activities.forEach(item => { url_ += "Duty.FirstDate.Duty.Activities=" + encodeURIComponent("" + item) + "&"; });
        if (duty_FirstDate_Duty_Checklists === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_Checklists' cannot be null.");
        else if (duty_FirstDate_Duty_Checklists !== undefined)
            duty_FirstDate_Duty_Checklists && duty_FirstDate_Duty_Checklists.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Duty.FirstDate.Duty.Checklists[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (duty_FirstDate_Duty_Notifications === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_Notifications' cannot be null.");
        else if (duty_FirstDate_Duty_Notifications !== undefined)
            duty_FirstDate_Duty_Notifications && duty_FirstDate_Duty_Notifications.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Duty.FirstDate.Duty.Notifications[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (duty_FirstDate_Duty_DutyTriggers === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_DutyTriggers' cannot be null.");
        else if (duty_FirstDate_Duty_DutyTriggers !== undefined)
            duty_FirstDate_Duty_DutyTriggers && duty_FirstDate_Duty_DutyTriggers.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Duty.FirstDate.Duty.DutyTriggers[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (duty_FirstDate_Duty_Cells === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_Cells' cannot be null.");
        else if (duty_FirstDate_Duty_Cells !== undefined)
            duty_FirstDate_Duty_Cells && duty_FirstDate_Duty_Cells.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Duty.FirstDate.Duty.Cells[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (duty_FirstDate_Duty_IdentString !== undefined && duty_FirstDate_Duty_IdentString !== null)
            url_ += "Duty.FirstDate.Duty.IdentString=" + encodeURIComponent("" + duty_FirstDate_Duty_IdentString) + "&";
        if (duty_FirstDate_Duty_Desc !== undefined && duty_FirstDate_Duty_Desc !== null)
            url_ += "Duty.FirstDate.Duty.Desc=" + encodeURIComponent("" + duty_FirstDate_Duty_Desc) + "&";
        if (duty_FirstDate_Duty_Area !== undefined && duty_FirstDate_Duty_Area !== null)
            url_ += "Duty.FirstDate.Duty.Area=" + encodeURIComponent("" + duty_FirstDate_Duty_Area) + "&";
        if (duty_FirstDate_Duty_SubArea !== undefined && duty_FirstDate_Duty_SubArea !== null)
            url_ += "Duty.FirstDate.Duty.SubArea=" + encodeURIComponent("" + duty_FirstDate_Duty_SubArea) + "&";
        if (duty_FirstDate_Duty_TechArea !== undefined && duty_FirstDate_Duty_TechArea !== null)
            url_ += "Duty.FirstDate.Duty.TechArea=" + encodeURIComponent("" + duty_FirstDate_Duty_TechArea) + "&";
        if (duty_FirstDate_Duty_CostCenter !== undefined && duty_FirstDate_Duty_CostCenter !== null)
            url_ += "Duty.FirstDate.Duty.CostCenter=" + encodeURIComponent("" + duty_FirstDate_Duty_CostCenter) + "&";
        if (duty_FirstDate_Duty_Conditions !== undefined && duty_FirstDate_Duty_Conditions !== null)
            url_ += "Duty.FirstDate.Duty.Conditions=" + encodeURIComponent("" + duty_FirstDate_Duty_Conditions) + "&";
        if (duty_FirstDate_Duty_BgColor !== undefined && duty_FirstDate_Duty_BgColor !== null)
            url_ += "Duty.FirstDate.Duty.BgColor=" + encodeURIComponent("" + duty_FirstDate_Duty_BgColor) + "&";
        if (duty_FirstDate_Duty_LinkedEventId === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_LinkedEventId' cannot be null.");
        else if (duty_FirstDate_Duty_LinkedEventId !== undefined)
            url_ += "Duty.FirstDate.Duty.LinkedEventId=" + encodeURIComponent("" + duty_FirstDate_Duty_LinkedEventId) + "&";
        if (duty_FirstDate_Duty_DesiredMin === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_DesiredMin' cannot be null.");
        else if (duty_FirstDate_Duty_DesiredMin !== undefined)
            url_ += "Duty.FirstDate.Duty.DesiredMin=" + encodeURIComponent("" + duty_FirstDate_Duty_DesiredMin) + "&";
        if (duty_FirstDate_Duty_IsChecklist === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_IsChecklist' cannot be null.");
        else if (duty_FirstDate_Duty_IsChecklist !== undefined)
            url_ += "Duty.FirstDate.Duty.IsChecklist=" + encodeURIComponent("" + duty_FirstDate_Duty_IsChecklist) + "&";
        if (duty_FirstDate_Duty_DatePattern !== undefined && duty_FirstDate_Duty_DatePattern !== null)
            url_ += "Duty.FirstDate.Duty.DatePattern=" + encodeURIComponent("" + duty_FirstDate_Duty_DatePattern) + "&";
        if (duty_FirstDate_Duty_FirstDate !== undefined && duty_FirstDate_Duty_FirstDate !== null)
            url_ += "Duty.FirstDate.Duty.FirstDate=" + encodeURIComponent("" + duty_FirstDate_Duty_FirstDate) + "&";
        if (duty_FirstDate_Duty_ReccuringDates === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_ReccuringDates' cannot be null.");
        else if (duty_FirstDate_Duty_ReccuringDates !== undefined)
            duty_FirstDate_Duty_ReccuringDates && duty_FirstDate_Duty_ReccuringDates.forEach(item_ => { url_ += "Duty.FirstDate.Duty.ReccuringDates=" + encodeURIComponent(item_ ? "" + item_.toISOString() : "null") + "&"; });
        if (duty_FirstDate_Duty_Title === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_Title' cannot be null.");
        else if (duty_FirstDate_Duty_Title !== undefined)
            url_ += "Duty.FirstDate.Duty.Title=" + encodeURIComponent("" + duty_FirstDate_Duty_Title) + "&";
        if (duty_FirstDate_Duty_Cell !== undefined && duty_FirstDate_Duty_Cell !== null)
            url_ += "Duty.FirstDate.Duty.Cell=" + encodeURIComponent("" + duty_FirstDate_Duty_Cell) + "&";
        if (duty_FirstDate_Duty_Label !== undefined && duty_FirstDate_Duty_Label !== null)
            url_ += "Duty.FirstDate.Duty.Label=" + encodeURIComponent("" + duty_FirstDate_Duty_Label) + "&";
        if (duty_FirstDate_Duty_SkipNextAutoTrigger === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_SkipNextAutoTrigger' cannot be null.");
        else if (duty_FirstDate_Duty_SkipNextAutoTrigger !== undefined)
            url_ += "Duty.FirstDate.Duty.SkipNextAutoTrigger=" + encodeURIComponent("" + duty_FirstDate_Duty_SkipNextAutoTrigger) + "&";
        if (duty_FirstDate_Duty_Modified === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_Modified' cannot be null.");
        else if (duty_FirstDate_Duty_Modified !== undefined)
            url_ += "Duty.FirstDate.Duty.Modified=" + encodeURIComponent(duty_FirstDate_Duty_Modified ? "" + duty_FirstDate_Duty_Modified.toISOString() : "") + "&";
        if (duty_FirstDate_Duty_IsDisabled === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_IsDisabled' cannot be null.");
        else if (duty_FirstDate_Duty_IsDisabled !== undefined)
            url_ += "Duty.FirstDate.Duty.IsDisabled=" + encodeURIComponent("" + duty_FirstDate_Duty_IsDisabled) + "&";
        if (duty_FirstDate_Duty_AdvancedReminderHours === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_AdvancedReminderHours' cannot be null.");
        else if (duty_FirstDate_Duty_AdvancedReminderHours !== undefined)
            url_ += "Duty.FirstDate.Duty.AdvancedReminderHours=" + encodeURIComponent("" + duty_FirstDate_Duty_AdvancedReminderHours) + "&";
        if (duty_FirstDate_Duty_DueSeconds === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_DueSeconds' cannot be null.");
        else if (duty_FirstDate_Duty_DueSeconds !== undefined)
            url_ += "Duty.FirstDate.Duty.DueSeconds=" + encodeURIComponent("" + duty_FirstDate_Duty_DueSeconds) + "&";
        if (duty_FirstDate_Duty_RatePerHour === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_RatePerHour' cannot be null.");
        else if (duty_FirstDate_Duty_RatePerHour !== undefined)
            url_ += "Duty.FirstDate.Duty.RatePerHour=" + encodeURIComponent("" + duty_FirstDate_Duty_RatePerHour) + "&";
        if (duty_FirstDate_Duty_PreventAutoTriggeredActivityDuplicates === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_PreventAutoTriggeredActivityDuplicates' cannot be null.");
        else if (duty_FirstDate_Duty_PreventAutoTriggeredActivityDuplicates !== undefined)
            url_ += "Duty.FirstDate.Duty.PreventAutoTriggeredActivityDuplicates=" + encodeURIComponent("" + duty_FirstDate_Duty_PreventAutoTriggeredActivityDuplicates) + "&";
        if (duty_FirstDate_Duty_CbmAnonymousEnabled === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_CbmAnonymousEnabled' cannot be null.");
        else if (duty_FirstDate_Duty_CbmAnonymousEnabled !== undefined)
            url_ += "Duty.FirstDate.Duty.CbmAnonymousEnabled=" + encodeURIComponent("" + duty_FirstDate_Duty_CbmAnonymousEnabled) + "&";
        if (duty_FirstDate_Duty_CbmAnonymousId !== undefined && duty_FirstDate_Duty_CbmAnonymousId !== null)
            url_ += "Duty.FirstDate.Duty.CbmAnonymousId=" + encodeURIComponent("" + duty_FirstDate_Duty_CbmAnonymousId) + "&";
        if (duty_FirstDate_Duty_CbmInsertIntoWorkflowEnabled === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_CbmInsertIntoWorkflowEnabled' cannot be null.");
        else if (duty_FirstDate_Duty_CbmInsertIntoWorkflowEnabled !== undefined)
            url_ += "Duty.FirstDate.Duty.CbmInsertIntoWorkflowEnabled=" + encodeURIComponent("" + duty_FirstDate_Duty_CbmInsertIntoWorkflowEnabled) + "&";
        if (duty_FirstDate_Duty_CbmInsertIntoWorkflowFlow !== undefined && duty_FirstDate_Duty_CbmInsertIntoWorkflowFlow !== null)
            url_ += "Duty.FirstDate.Duty.CbmInsertIntoWorkflowFlow=" + encodeURIComponent("" + duty_FirstDate_Duty_CbmInsertIntoWorkflowFlow) + "&";
        if (duty_FirstDate_Duty_CbmAutoCloseActivity === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_CbmAutoCloseActivity' cannot be null.");
        else if (duty_FirstDate_Duty_CbmAutoCloseActivity !== undefined)
            url_ += "Duty.FirstDate.Duty.CbmAutoCloseActivity=" + encodeURIComponent("" + duty_FirstDate_Duty_CbmAutoCloseActivity) + "&";
        if (duty_FirstDate_Duty_CbmMailAnswerEnabled === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_Duty_CbmMailAnswerEnabled' cannot be null.");
        else if (duty_FirstDate_Duty_CbmMailAnswerEnabled !== undefined)
            url_ += "Duty.FirstDate.Duty.CbmMailAnswerEnabled=" + encodeURIComponent("" + duty_FirstDate_Duty_CbmMailAnswerEnabled) + "&";
        if (duty_FirstDate_Duty_CbmAuthedId !== undefined && duty_FirstDate_Duty_CbmAuthedId !== null)
            url_ += "Duty.FirstDate.Duty.CbmAuthedId=" + encodeURIComponent("" + duty_FirstDate_Duty_CbmAuthedId) + "&";
        if (duty_FirstDate_Duty_TitleRegex !== undefined && duty_FirstDate_Duty_TitleRegex !== null)
            url_ += "Duty.FirstDate.Duty.TitleRegex=" + encodeURIComponent("" + duty_FirstDate_Duty_TitleRegex) + "&";
        if (duty_FirstDate_Duty_IgnoreRegex !== undefined && duty_FirstDate_Duty_IgnoreRegex !== null)
            url_ += "Duty.FirstDate.Duty.IgnoreRegex=" + encodeURIComponent("" + duty_FirstDate_Duty_IgnoreRegex) + "&";
        if (duty_FirstDate_Duty_AutoCloseAfterDays !== undefined && duty_FirstDate_Duty_AutoCloseAfterDays !== null)
            url_ += "Duty.FirstDate.Duty.AutoCloseAfterDays=" + encodeURIComponent("" + duty_FirstDate_Duty_AutoCloseAfterDays) + "&";
        if (duty_FirstDate_RepeatStart !== undefined && duty_FirstDate_RepeatStart !== null)
            url_ += "Duty.FirstDate.RepeatStart=" + encodeURIComponent(duty_FirstDate_RepeatStart ? "" + duty_FirstDate_RepeatStart.toISOString() : "") + "&";
        if (duty_FirstDate_RepeatInterval !== undefined && duty_FirstDate_RepeatInterval !== null)
            url_ += "Duty.FirstDate.RepeatInterval=" + encodeURIComponent("" + duty_FirstDate_RepeatInterval) + "&";
        if (duty_FirstDate_RepeatYear !== undefined && duty_FirstDate_RepeatYear !== null)
            url_ += "Duty.FirstDate.RepeatYear=" + encodeURIComponent("" + duty_FirstDate_RepeatYear) + "&";
        if (duty_FirstDate_RepeatMonth !== undefined && duty_FirstDate_RepeatMonth !== null)
            url_ += "Duty.FirstDate.RepeatMonth=" + encodeURIComponent("" + duty_FirstDate_RepeatMonth) + "&";
        if (duty_FirstDate_RepeatDay !== undefined && duty_FirstDate_RepeatDay !== null)
            url_ += "Duty.FirstDate.RepeatDay=" + encodeURIComponent("" + duty_FirstDate_RepeatDay) + "&";
        if (duty_FirstDate_RepeatWeek !== undefined && duty_FirstDate_RepeatWeek !== null)
            url_ += "Duty.FirstDate.RepeatWeek=" + encodeURIComponent("" + duty_FirstDate_RepeatWeek) + "&";
        if (duty_FirstDate_RepeatWeekday !== undefined && duty_FirstDate_RepeatWeekday !== null)
            url_ += "Duty.FirstDate.RepeatWeekday=" + encodeURIComponent("" + duty_FirstDate_RepeatWeekday) + "&";
        if (duty_FirstDate_RepeatWeekOfMonth !== undefined && duty_FirstDate_RepeatWeekOfMonth !== null)
            url_ += "Duty.FirstDate.RepeatWeekOfMonth=" + encodeURIComponent("" + duty_FirstDate_RepeatWeekOfMonth) + "&";
        if (duty_FirstDate_RepeatHour === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_RepeatHour' cannot be null.");
        else if (duty_FirstDate_RepeatHour !== undefined)
            url_ += "Duty.FirstDate.RepeatHour=" + encodeURIComponent("" + duty_FirstDate_RepeatHour) + "&";
        if (duty_FirstDate_DatePattern === null)
            throw new globalThis.Error("The parameter 'duty_FirstDate_DatePattern' cannot be null.");
        else if (duty_FirstDate_DatePattern !== undefined)
            url_ += "Duty.FirstDate.DatePattern=" + encodeURIComponent("" + duty_FirstDate_DatePattern) + "&";
        if (duty_ReccuringDates === null)
            throw new globalThis.Error("The parameter 'duty_ReccuringDates' cannot be null.");
        else if (duty_ReccuringDates !== undefined)
            duty_ReccuringDates && duty_ReccuringDates.forEach(item_ => { url_ += "Duty.ReccuringDates=" + encodeURIComponent(item_ ? "" + item_.toISOString() : "null") + "&"; });
        if (duty_Title === null)
            throw new globalThis.Error("The parameter 'duty_Title' cannot be null.");
        else if (duty_Title !== undefined)
            url_ += "Duty.Title=" + encodeURIComponent("" + duty_Title) + "&";
        if (duty_Cell !== undefined && duty_Cell !== null)
            url_ += "Duty.Cell=" + encodeURIComponent("" + duty_Cell) + "&";
        if (duty_Label !== undefined && duty_Label !== null)
            url_ += "Duty.Label=" + encodeURIComponent("" + duty_Label) + "&";
        if (duty_SkipNextAutoTrigger === null)
            throw new globalThis.Error("The parameter 'duty_SkipNextAutoTrigger' cannot be null.");
        else if (duty_SkipNextAutoTrigger !== undefined)
            url_ += "Duty.SkipNextAutoTrigger=" + encodeURIComponent("" + duty_SkipNextAutoTrigger) + "&";
        if (duty_Modified === null)
            throw new globalThis.Error("The parameter 'duty_Modified' cannot be null.");
        else if (duty_Modified !== undefined)
            url_ += "Duty.Modified=" + encodeURIComponent(duty_Modified ? "" + duty_Modified.toISOString() : "") + "&";
        if (duty_IsDisabled === null)
            throw new globalThis.Error("The parameter 'duty_IsDisabled' cannot be null.");
        else if (duty_IsDisabled !== undefined)
            url_ += "Duty.IsDisabled=" + encodeURIComponent("" + duty_IsDisabled) + "&";
        if (duty_AdvancedReminderHours === null)
            throw new globalThis.Error("The parameter 'duty_AdvancedReminderHours' cannot be null.");
        else if (duty_AdvancedReminderHours !== undefined)
            url_ += "Duty.AdvancedReminderHours=" + encodeURIComponent("" + duty_AdvancedReminderHours) + "&";
        if (duty_DueSeconds === null)
            throw new globalThis.Error("The parameter 'duty_DueSeconds' cannot be null.");
        else if (duty_DueSeconds !== undefined)
            url_ += "Duty.DueSeconds=" + encodeURIComponent("" + duty_DueSeconds) + "&";
        if (duty_RatePerHour === null)
            throw new globalThis.Error("The parameter 'duty_RatePerHour' cannot be null.");
        else if (duty_RatePerHour !== undefined)
            url_ += "Duty.RatePerHour=" + encodeURIComponent("" + duty_RatePerHour) + "&";
        if (duty_PreventAutoTriggeredActivityDuplicates === null)
            throw new globalThis.Error("The parameter 'duty_PreventAutoTriggeredActivityDuplicates' cannot be null.");
        else if (duty_PreventAutoTriggeredActivityDuplicates !== undefined)
            url_ += "Duty.PreventAutoTriggeredActivityDuplicates=" + encodeURIComponent("" + duty_PreventAutoTriggeredActivityDuplicates) + "&";
        if (duty_CbmAnonymousEnabled === null)
            throw new globalThis.Error("The parameter 'duty_CbmAnonymousEnabled' cannot be null.");
        else if (duty_CbmAnonymousEnabled !== undefined)
            url_ += "Duty.CbmAnonymousEnabled=" + encodeURIComponent("" + duty_CbmAnonymousEnabled) + "&";
        if (duty_CbmAnonymousId !== undefined && duty_CbmAnonymousId !== null)
            url_ += "Duty.CbmAnonymousId=" + encodeURIComponent("" + duty_CbmAnonymousId) + "&";
        if (duty_CbmInsertIntoWorkflowEnabled === null)
            throw new globalThis.Error("The parameter 'duty_CbmInsertIntoWorkflowEnabled' cannot be null.");
        else if (duty_CbmInsertIntoWorkflowEnabled !== undefined)
            url_ += "Duty.CbmInsertIntoWorkflowEnabled=" + encodeURIComponent("" + duty_CbmInsertIntoWorkflowEnabled) + "&";
        if (duty_CbmInsertIntoWorkflowFlow !== undefined && duty_CbmInsertIntoWorkflowFlow !== null)
            url_ += "Duty.CbmInsertIntoWorkflowFlow=" + encodeURIComponent("" + duty_CbmInsertIntoWorkflowFlow) + "&";
        if (duty_CbmAutoCloseActivity === null)
            throw new globalThis.Error("The parameter 'duty_CbmAutoCloseActivity' cannot be null.");
        else if (duty_CbmAutoCloseActivity !== undefined)
            url_ += "Duty.CbmAutoCloseActivity=" + encodeURIComponent("" + duty_CbmAutoCloseActivity) + "&";
        if (duty_CbmMailAnswerEnabled === null)
            throw new globalThis.Error("The parameter 'duty_CbmMailAnswerEnabled' cannot be null.");
        else if (duty_CbmMailAnswerEnabled !== undefined)
            url_ += "Duty.CbmMailAnswerEnabled=" + encodeURIComponent("" + duty_CbmMailAnswerEnabled) + "&";
        if (duty_CbmAuthedId !== undefined && duty_CbmAuthedId !== null)
            url_ += "Duty.CbmAuthedId=" + encodeURIComponent("" + duty_CbmAuthedId) + "&";
        if (duty_TitleRegex !== undefined && duty_TitleRegex !== null)
            url_ += "Duty.TitleRegex=" + encodeURIComponent("" + duty_TitleRegex) + "&";
        if (duty_IgnoreRegex !== undefined && duty_IgnoreRegex !== null)
            url_ += "Duty.IgnoreRegex=" + encodeURIComponent("" + duty_IgnoreRegex) + "&";
        if (duty_AutoCloseAfterDays !== undefined && duty_AutoCloseAfterDays !== null)
            url_ += "Duty.AutoCloseAfterDays=" + encodeURIComponent("" + duty_AutoCloseAfterDays) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateChecklist(_response);
        });
    }

    protected processUpdateChecklist(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDuty(id: number): Promise<VMDutyEdit> {
        let url_ = this.baseUrl + "/api/Duty/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDuty(_response);
        });
    }

    protected processGetDuty(response: Response): Promise<VMDutyEdit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VMDutyEdit.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VMDutyEdit>(null as any);
    }

    generateQRCodes(columns: number, l: Duty[]): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Duty/generateQR/{columns}";
        if (columns === undefined || columns === null)
            throw new globalThis.Error("The parameter 'columns' must be defined.");
        url_ = url_.replace("{columns}", encodeURIComponent("" + columns));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(l);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateQRCodes(_response);
        });
    }

    protected processGenerateQRCodes(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    cloneDuty(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Duty/CopyDuty/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCloneDuty(_response);
        });
    }

    protected processCloneDuty(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    import(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Duty/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (parentId !== null && parentId !== undefined)
            content_.append("ParentId", parentId.toString());
        if (uploads !== null && uploads !== undefined)
            uploads.forEach(item_ => content_.append("Uploads", item_.data, item_.fileName ? item_.fileName : "Uploads") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    export(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Duty/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTemplates(): Promise<OptionItem[]> {
        let url_ = this.baseUrl + "/api/Duty/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTemplates(_response);
        });
    }

    protected processGetTemplates(response: Response): Promise<OptionItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OptionItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItem[]>(null as any);
    }

    importTemplates(options: OptionItem[]): Promise<void> {
        let url_ = this.baseUrl + "/api/Duty/template/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportTemplates(_response);
        });
    }

    protected processImportTemplates(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    triggerCbmAnonymousDuty(model: TriggerCbmAnonymousDuty): Promise<void> {
        let url_ = this.baseUrl + "/api/Duty/cbm/anonymous";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTriggerCbmAnonymousDuty(_response);
        });
    }

    protected processTriggerCbmAnonymousDuty(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    triggerCbmDuties(model: TriggerCbmDuty): Promise<void> {
        let url_ = this.baseUrl + "/api/Duty/cbm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTriggerCbmDuties(_response);
        });
    }

    protected processTriggerCbmDuties(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    triggerCbmByMailDuties(model: TriggerCbmDuty): Promise<void> {
        let url_ = this.baseUrl + "/api/Duty/cbmmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTriggerCbmByMailDuties(_response);
        });
    }

    protected processTriggerCbmByMailDuties(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IEventClient {

    getData(): Promise<FileResponse>;

    postData(model: VMEvent): Promise<FileResponse>;
}

export class EventClient implements IEventClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getData(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Event";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetData(_response);
        });
    }

    protected processGetData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    postData(model: VMEvent): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Event";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostData(_response);
        });
    }

    protected processPostData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IGpsPositionUiClient {

    last(): Promise<GpsPosDto[]>;
}

export class GpsPositionUiClient implements IGpsPositionUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    last(): Promise<GpsPosDto[]> {
        let url_ = this.baseUrl + "/api/v1/gps/position/last";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLast(_response);
        });
    }

    protected processLast(response: Response): Promise<GpsPosDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GpsPosDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GpsPosDto[]>(null as any);
    }
}

export interface IGpsTrackerUiClient {

    list(): Promise<GpsTrackerDto[]>;

    add(model: GpsTrackerDto): Promise<GpsTrackerDto>;

    update(model: GpsTrackerDto): Promise<GpsTrackerDto>;

    delete(id: number): Promise<void>;
}

export class GpsTrackerUiClient implements IGpsTrackerUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<GpsTrackerDto[]> {
        let url_ = this.baseUrl + "/api/v1/gps/tracker";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<GpsTrackerDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GpsTrackerDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GpsTrackerDto[]>(null as any);
    }

    add(model: GpsTrackerDto): Promise<GpsTrackerDto> {
        let url_ = this.baseUrl + "/api/v1/gps/tracker";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<GpsTrackerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GpsTrackerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GpsTrackerDto>(null as any);
    }

    update(model: GpsTrackerDto): Promise<GpsTrackerDto> {
        let url_ = this.baseUrl + "/api/v1/gps/tracker";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<GpsTrackerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GpsTrackerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GpsTrackerDto>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/gps/tracker/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IGroupMaintenanceExtensionUiClient {

    list(): Promise<GroupMaintenanceExtension[]>;

    create(vm: GroupMaintenanceExtension): Promise<GroupMaintenanceExtension>;

    update(vm: GroupMaintenanceExtension): Promise<GroupMaintenanceExtension>;

    delete(groupMaintenanceExtensionId: string): Promise<void>;
}

export class GroupMaintenanceExtensionUiClient implements IGroupMaintenanceExtensionUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<GroupMaintenanceExtension[]> {
        let url_ = this.baseUrl + "/api/v1/maintenance/group";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<GroupMaintenanceExtension[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupMaintenanceExtension.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupMaintenanceExtension[]>(null as any);
    }

    create(vm: GroupMaintenanceExtension): Promise<GroupMaintenanceExtension> {
        let url_ = this.baseUrl + "/api/v1/maintenance/group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<GroupMaintenanceExtension> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = GroupMaintenanceExtension.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupMaintenanceExtension>(null as any);
    }

    update(vm: GroupMaintenanceExtension): Promise<GroupMaintenanceExtension> {
        let url_ = this.baseUrl + "/api/v1/maintenance/group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<GroupMaintenanceExtension> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupMaintenanceExtension.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupMaintenanceExtension>(null as any);
    }

    delete(groupMaintenanceExtensionId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/maintenance/group/{groupMaintenanceExtensionId}";
        if (groupMaintenanceExtensionId === undefined || groupMaintenanceExtensionId === null)
            throw new globalThis.Error("The parameter 'groupMaintenanceExtensionId' must be defined.");
        url_ = url_.replace("{groupMaintenanceExtensionId}", encodeURIComponent("" + groupMaintenanceExtensionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IInventoryUiClient {

    getData(_offset: number | undefined, _limit: number | undefined): Promise<Inventory[]>;

    getInventory(inventoryId: number): Promise<Inventory>;

    postData(l: Inventory): Promise<void>;

    updateData(l: Inventory): Promise<void>;

    deleteData(l: Inventory[]): Promise<void>;

    generateQRCodes(columns: number, l: Inventory[]): Promise<FileResponse>;

    getInventoryQrAsJson(inventoryId: number, printerType: PrinterType | undefined): Promise<QrResponseAsEncodedJson>;

    import(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<FileStatusMessage>;

    getPickfile(id: string | undefined): Promise<FileResponse>;

    downInventory(l: Inventory[]): Promise<void>;

    linkMedia(request: LinkMediaRequest): Promise<InventoryMedia>;

    getMediasForInventoryId(inventoryId: number): Promise<Media2[]>;

    getBin(id: string): Promise<InventoryBin>;

    deleteBin(id: string): Promise<void>;

    listBins(ids: string[] | null | undefined): Promise<InventoryBin[]>;

    addBin(bin: InventoryBin): Promise<InventoryBin>;

    updateBin(bin: InventoryBin): Promise<InventoryBin>;

    binQr(request: BinQrRequest): Promise<FileResponse>;

    addBinMapping(mapping: InventoryBinMapping): Promise<InventoryBinMapping>;

    deleteBinMapping(id: string): Promise<void>;

    importBin(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<void>;

    addContactMapping(mapping: InventoryContactMapping): Promise<InventoryContactMapping>;

    deleteContactMapping(id: string): Promise<void>;

    signOff(model: SignOffInventoryRequest): Promise<void>;
}

export class InventoryUiClient implements IInventoryUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getData(_offset: number | undefined, _limit: number | undefined): Promise<Inventory[]> {
        let url_ = this.baseUrl + "/api/v1/inventory/list?";
        if (_offset === null)
            throw new globalThis.Error("The parameter '_offset' cannot be null.");
        else if (_offset !== undefined)
            url_ += "_offset=" + encodeURIComponent("" + _offset) + "&";
        if (_limit === null)
            throw new globalThis.Error("The parameter '_limit' cannot be null.");
        else if (_limit !== undefined)
            url_ += "_limit=" + encodeURIComponent("" + _limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetData(_response);
        });
    }

    protected processGetData(response: Response): Promise<Inventory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Inventory.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Inventory[]>(null as any);
    }

    getInventory(inventoryId: number): Promise<Inventory> {
        let url_ = this.baseUrl + "/api/v1/inventory/{inventoryId}";
        if (inventoryId === undefined || inventoryId === null)
            throw new globalThis.Error("The parameter 'inventoryId' must be defined.");
        url_ = url_.replace("{inventoryId}", encodeURIComponent("" + inventoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInventory(_response);
        });
    }

    protected processGetInventory(response: Response): Promise<Inventory> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Inventory.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Inventory>(null as any);
    }

    postData(l: Inventory): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/inventory/addInventory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(l);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostData(_response);
        });
    }

    protected processPostData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateData(l: Inventory): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/inventory/updateInventory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(l);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateData(_response);
        });
    }

    protected processUpdateData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteData(l: Inventory[]): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/inventory/deleteInventory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(l);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteData(_response);
        });
    }

    protected processDeleteData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    generateQRCodes(columns: number, l: Inventory[]): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/inventory/generateQR/{columns}";
        if (columns === undefined || columns === null)
            throw new globalThis.Error("The parameter 'columns' must be defined.");
        url_ = url_.replace("{columns}", encodeURIComponent("" + columns));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(l);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateQRCodes(_response);
        });
    }

    protected processGenerateQRCodes(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getInventoryQrAsJson(inventoryId: number, printerType: PrinterType | undefined): Promise<QrResponseAsEncodedJson> {
        let url_ = this.baseUrl + "/api/v1/inventory/{inventoryId}/qrAsJson?";
        if (inventoryId === undefined || inventoryId === null)
            throw new globalThis.Error("The parameter 'inventoryId' must be defined.");
        url_ = url_.replace("{inventoryId}", encodeURIComponent("" + inventoryId));
        if (printerType === null)
            throw new globalThis.Error("The parameter 'printerType' cannot be null.");
        else if (printerType !== undefined)
            url_ += "printerType=" + encodeURIComponent("" + printerType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInventoryQrAsJson(_response);
        });
    }

    protected processGetInventoryQrAsJson(response: Response): Promise<QrResponseAsEncodedJson> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QrResponseAsEncodedJson.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QrResponseAsEncodedJson>(null as any);
    }

    import(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<FileStatusMessage> {
        let url_ = this.baseUrl + "/api/v1/inventory/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (parentId !== null && parentId !== undefined)
            content_.append("ParentId", parentId.toString());
        if (uploads !== null && uploads !== undefined)
            uploads.forEach(item_ => content_.append("Uploads", item_.data, item_.fileName ? item_.fileName : "Uploads") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: Response): Promise<FileStatusMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileStatusMessage.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileStatusMessage>(null as any);
    }

    getPickfile(id: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/inventory?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPickfile(_response);
        });
    }

    protected processGetPickfile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downInventory(l: Inventory[]): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/inventory/downInventory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(l);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownInventory(_response);
        });
    }

    protected processDownInventory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    linkMedia(request: LinkMediaRequest): Promise<InventoryMedia> {
        let url_ = this.baseUrl + "/api/v1/inventory/media/link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLinkMedia(_response);
        });
    }

    protected processLinkMedia(response: Response): Promise<InventoryMedia> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InventoryMedia.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryMedia>(null as any);
    }

    getMediasForInventoryId(inventoryId: number): Promise<Media2[]> {
        let url_ = this.baseUrl + "/api/v1/inventory/media/{inventoryId}";
        if (inventoryId === undefined || inventoryId === null)
            throw new globalThis.Error("The parameter 'inventoryId' must be defined.");
        url_ = url_.replace("{inventoryId}", encodeURIComponent("" + inventoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMediasForInventoryId(_response);
        });
    }

    protected processGetMediasForInventoryId(response: Response): Promise<Media2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Media2.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Media2[]>(null as any);
    }

    getBin(id: string): Promise<InventoryBin> {
        let url_ = this.baseUrl + "/api/v1/inventory/bin/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBin(_response);
        });
    }

    protected processGetBin(response: Response): Promise<InventoryBin> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InventoryBin.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryBin>(null as any);
    }

    deleteBin(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/inventory/bin/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteBin(_response);
        });
    }

    protected processDeleteBin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    listBins(ids: string[] | null | undefined): Promise<InventoryBin[]> {
        let url_ = this.baseUrl + "/api/v1/inventory/bin?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListBins(_response);
        });
    }

    protected processListBins(response: Response): Promise<InventoryBin[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InventoryBin.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryBin[]>(null as any);
    }

    addBin(bin: InventoryBin): Promise<InventoryBin> {
        let url_ = this.baseUrl + "/api/v1/inventory/bin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bin);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddBin(_response);
        });
    }

    protected processAddBin(response: Response): Promise<InventoryBin> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InventoryBin.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryBin>(null as any);
    }

    updateBin(bin: InventoryBin): Promise<InventoryBin> {
        let url_ = this.baseUrl + "/api/v1/inventory/bin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bin);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateBin(_response);
        });
    }

    protected processUpdateBin(response: Response): Promise<InventoryBin> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InventoryBin.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryBin>(null as any);
    }

    binQr(request: BinQrRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/inventory/bin/qr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBinQr(_response);
        });
    }

    protected processBinQr(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addBinMapping(mapping: InventoryBinMapping): Promise<InventoryBinMapping> {
        let url_ = this.baseUrl + "/api/v1/inventory/bin/mapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mapping);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddBinMapping(_response);
        });
    }

    protected processAddBinMapping(response: Response): Promise<InventoryBinMapping> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InventoryBinMapping.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryBinMapping>(null as any);
    }

    deleteBinMapping(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/inventory/bin/mapping/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteBinMapping(_response);
        });
    }

    protected processDeleteBinMapping(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    importBin(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/inventory/bin/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (parentId !== null && parentId !== undefined)
            content_.append("ParentId", parentId.toString());
        if (uploads !== null && uploads !== undefined)
            uploads.forEach(item_ => content_.append("Uploads", item_.data, item_.fileName ? item_.fileName : "Uploads") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportBin(_response);
        });
    }

    protected processImportBin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    addContactMapping(mapping: InventoryContactMapping): Promise<InventoryContactMapping> {
        let url_ = this.baseUrl + "/api/v1/inventory/contact/mapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mapping);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddContactMapping(_response);
        });
    }

    protected processAddContactMapping(response: Response): Promise<InventoryContactMapping> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InventoryContactMapping.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryContactMapping>(null as any);
    }

    deleteContactMapping(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/inventory/contact/mapping/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteContactMapping(_response);
        });
    }

    protected processDeleteContactMapping(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    signOff(model: SignOffInventoryRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/inventory/signOff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignOff(_response);
        });
    }

    protected processSignOff(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IInventoryStockTakingsUiClient {

    list(filter: string | null | undefined): Promise<InventoryStockTaking[]>;

    add(inventoryStockTaking: InventoryStockTaking[]): Promise<InventoryStockTaking[]>;

    update(id: string, stockTaking: InventoryStockTaking): Promise<InventoryStockTaking>;

    delete(id: string): Promise<void>;

    updateEntry(stockTakingId: string, entryId: string, entry: InventoryStockTakingEntry): Promise<InventoryStockTakingEntry>;
}

export class InventoryStockTakingsUiClient implements IInventoryStockTakingsUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(filter: string | null | undefined): Promise<InventoryStockTaking[]> {
        let url_ = this.baseUrl + "/api/v1/inventories/stockTakings?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<InventoryStockTaking[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InventoryStockTaking.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryStockTaking[]>(null as any);
    }

    add(inventoryStockTaking: InventoryStockTaking[]): Promise<InventoryStockTaking[]> {
        let url_ = this.baseUrl + "/api/v1/inventories/stockTakings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inventoryStockTaking);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<InventoryStockTaking[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item of resultData201)
                    result201!.push(InventoryStockTaking.fromJS(item));
            }
            else {
                result201 = null as any;
            }
            return result201;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryStockTaking[]>(null as any);
    }

    update(id: string, stockTaking: InventoryStockTaking): Promise<InventoryStockTaking> {
        let url_ = this.baseUrl + "/api/v1/inventories/stockTakings/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stockTaking);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<InventoryStockTaking> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InventoryStockTaking.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryStockTaking>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/inventories/stockTakings/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateEntry(stockTakingId: string, entryId: string, entry: InventoryStockTakingEntry): Promise<InventoryStockTakingEntry> {
        let url_ = this.baseUrl + "/api/v1/inventories/stockTakings/{stockTakingId}/entries/{entryId}";
        if (stockTakingId === undefined || stockTakingId === null)
            throw new globalThis.Error("The parameter 'stockTakingId' must be defined.");
        url_ = url_.replace("{stockTakingId}", encodeURIComponent("" + stockTakingId));
        if (entryId === undefined || entryId === null)
            throw new globalThis.Error("The parameter 'entryId' must be defined.");
        url_ = url_.replace("{entryId}", encodeURIComponent("" + entryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entry);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateEntry(_response);
        });
    }

    protected processUpdateEntry(response: Response): Promise<InventoryStockTakingEntry> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InventoryStockTakingEntry.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryStockTakingEntry>(null as any);
    }
}

export interface ILineClient {

    getLinesData(): Promise<Line[]>;

    getLineData(id: number): Promise<BaseResultOfLine>;

    postLineData(l: Line): Promise<FileResponse>;

    updateLineData(l: Line): Promise<FileResponse>;

    deleteLineData(l: Line[]): Promise<FileResponse>;
}

export class LineClient implements ILineClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getLinesData(): Promise<Line[]> {
        let url_ = this.baseUrl + "/api/Line/lines";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLinesData(_response);
        });
    }

    protected processGetLinesData(response: Response): Promise<Line[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultDatadefault)) {
                resultdefault = [] as any;
                for (let item of resultDatadefault)
                    resultdefault!.push(Line.fromJS(item));
            }
            else {
                resultdefault = null as any;
            }
            return resultdefault;
            });
        }
    }

    getLineData(id: number): Promise<BaseResultOfLine> {
        let url_ = this.baseUrl + "/api/Line/line/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLineData(_response);
        });
    }

    protected processGetLineData(response: Response): Promise<BaseResultOfLine> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = BaseResultOfErrorResult.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfLine.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    postLineData(l: Line): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Line/addline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(l);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostLineData(_response);
        });
    }

    protected processPostLineData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
    }

    updateLineData(l: Line): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Line/updateline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(l);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateLineData(_response);
        });
    }

    protected processUpdateLineData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
    }

    deleteLineData(l: Line[]): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Line/deleteline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(l);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteLineData(_response);
        });
    }

    protected processDeleteLineData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
    }
}

export interface ILinksClient {

    getlinkData(): Promise<FileResponse>;

    postlinkData(node: LinkAreaCellEvent): Promise<FileResponse>;

    deleteEventData(e: LinkAreaCellEvent[]): Promise<FileResponse>;
}

export class LinksClient implements ILinksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getlinkData(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Links/links";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetlinkData(_response);
        });
    }

    protected processGetlinkData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    postlinkData(node: LinkAreaCellEvent): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Links/addlink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(node);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostlinkData(_response);
        });
    }

    protected processPostlinkData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteEventData(e: LinkAreaCellEvent[]): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Links/deletelink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(e);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteEventData(_response);
        });
    }

    protected processDeleteEventData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IOeeSettingsClient {

    getCellsData(): Promise<OeeSettings[]>;

    postSettingData(l: OeeSettings): Promise<void>;

    updateSettingData(l: OeeSettings): Promise<void>;

    deleteCellData(l: OeeSettings[]): Promise<void>;

    getShiftData(): Promise<ShiftTime[]>;

    postShiftData(l: ShiftTime): Promise<void>;

    updateShiftData(l: ShiftTime): Promise<void>;

    deleteCellData2(l: ShiftTime[]): Promise<void>;
}

export class OeeSettingsClient implements IOeeSettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCellsData(): Promise<OeeSettings[]> {
        let url_ = this.baseUrl + "/api/OeeSettings/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCellsData(_response);
        });
    }

    protected processGetCellsData(response: Response): Promise<OeeSettings[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OeeSettings.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OeeSettings[]>(null as any);
    }

    postSettingData(l: OeeSettings): Promise<void> {
        let url_ = this.baseUrl + "/api/OeeSettings/addOeeSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(l);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSettingData(_response);
        });
    }

    protected processPostSettingData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateSettingData(l: OeeSettings): Promise<void> {
        let url_ = this.baseUrl + "/api/OeeSettings/updateOeeSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(l);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSettingData(_response);
        });
    }

    protected processUpdateSettingData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteCellData(l: OeeSettings[]): Promise<void> {
        let url_ = this.baseUrl + "/api/OeeSettings/deleteOeeSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(l);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCellData(_response);
        });
    }

    protected processDeleteCellData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getShiftData(): Promise<ShiftTime[]> {
        let url_ = this.baseUrl + "/api/OeeSettings/listShift";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetShiftData(_response);
        });
    }

    protected processGetShiftData(response: Response): Promise<ShiftTime[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShiftTime.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShiftTime[]>(null as any);
    }

    postShiftData(l: ShiftTime): Promise<void> {
        let url_ = this.baseUrl + "/api/OeeSettings/addOeeShift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(l);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostShiftData(_response);
        });
    }

    protected processPostShiftData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateShiftData(l: ShiftTime): Promise<void> {
        let url_ = this.baseUrl + "/api/OeeSettings/updateOeeShift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(l);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateShiftData(_response);
        });
    }

    protected processUpdateShiftData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteCellData2(l: ShiftTime[]): Promise<void> {
        let url_ = this.baseUrl + "/api/OeeSettings/deleteOeeShift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(l);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCellData2(_response);
        });
    }

    protected processDeleteCellData2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IOperatorsClient {

    get(): Promise<FileResponse>;
}

export class OperatorsClient implements IOperatorsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Operators";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ISiteClient {

    getSiteData(): Promise<FileResponse>;

    postSiteData(s: Site): Promise<FileResponse>;

    updateSiteData(s: Site): Promise<FileResponse>;

    deletSiteData(s: Site[]): Promise<FileResponse>;
}

export class SiteClient implements ISiteClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getSiteData(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Site/sites";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSiteData(_response);
        });
    }

    protected processGetSiteData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    postSiteData(s: Site): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Site/addsite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(s);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSiteData(_response);
        });
    }

    protected processPostSiteData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateSiteData(s: Site): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Site/updatesite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(s);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSiteData(_response);
        });
    }

    protected processUpdateSiteData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deletSiteData(s: Site[]): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Site/deletesite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(s);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletSiteData(_response);
        });
    }

    protected processDeletSiteData(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IActivityControllerUIClient {

    getActivites(sort: string | null | undefined, filter: string | null | undefined, page: number | undefined, per_page: number | undefined): Promise<VMActivitiesIndex>;

    getActivity(id: number): Promise<BaseResultOfActivity>;

    updateActivity(activity: Activity): Promise<void>;

    search(query: SuperSearch): Promise<SearchResult[]>;

    addFlow(flow: CreateFlow): Promise<void>;

    getAvailableResponsibles(): Promise<BaseResultOfListItemOf>;

    updateResponsible(activityId: number | undefined, userId: string | null | undefined): Promise<void>;

    getAvailablePriorities(): Promise<BaseResultOfActivityPriorityOf>;

    updatePriority(activityId: number | undefined, priorityId: number | null | undefined): Promise<void>;

    updateReference(activityId: number | undefined, reference: string | null | undefined): Promise<void>;

    updateDescription(activityId: number | undefined, description: string | null | undefined): Promise<void>;

    createActivityWithDutyAndCell(dutyId: number | undefined, cellId: number | undefined, skipNextAutoTrigger: boolean | undefined, title: string | null | undefined, reference: string | null | undefined): Promise<BaseResultOfActivity>;

    getDistinctValues(): Promise<ActivityDistinctValues>;

    getLogDistinctValues(): Promise<ActivityLogDistinctValues>;

    textAboutActivity(activityId: number | undefined, subject: string | null | undefined): Promise<TextAboutActivity>;

    notificationAboutActivity(activityId: number | undefined, toEmail: string | undefined, subject: string | undefined, isWorkFlowEntry: boolean | undefined): Promise<void>;

    linkMedia(request: ActivityLinkMediaRequest): Promise<BaseResultOfActivity>;
}

export class ActivityControllerUIClient implements IActivityControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getActivites(sort: string | null | undefined, filter: string | null | undefined, page: number | undefined, per_page: number | undefined): Promise<VMActivitiesIndex> {
        let url_ = this.baseUrl + "/api/activity/activities?";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (per_page === null)
            throw new globalThis.Error("The parameter 'per_page' cannot be null.");
        else if (per_page !== undefined)
            url_ += "per_page=" + encodeURIComponent("" + per_page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActivites(_response);
        });
    }

    protected processGetActivites(response: Response): Promise<VMActivitiesIndex> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VMActivitiesIndex.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VMActivitiesIndex>(null as any);
    }

    getActivity(id: number): Promise<BaseResultOfActivity> {
        let url_ = this.baseUrl + "/api/activity/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActivity(_response);
        });
    }

    protected processGetActivity(response: Response): Promise<BaseResultOfActivity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfActivity.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfActivity>(null as any);
    }

    updateActivity(activity: Activity): Promise<void> {
        let url_ = this.baseUrl + "/api/activity/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateActivity(_response);
        });
    }

    protected processUpdateActivity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    search(query: SuperSearch): Promise<SearchResult[]> {
        let url_ = this.baseUrl + "/api/activity/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<SearchResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchResult[]>(null as any);
    }

    addFlow(flow: CreateFlow): Promise<void> {
        let url_ = this.baseUrl + "/api/activity/addflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(flow);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddFlow(_response);
        });
    }

    protected processAddFlow(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAvailableResponsibles(): Promise<BaseResultOfListItemOf> {
        let url_ = this.baseUrl + "/api/activity/available-responsibles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableResponsibles(_response);
        });
    }

    protected processGetAvailableResponsibles(response: Response): Promise<BaseResultOfListItemOf> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfListItemOf.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfListItemOf>(null as any);
    }

    updateResponsible(activityId: number | undefined, userId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/activity/update-responsible?";
        if (activityId === null)
            throw new globalThis.Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateResponsible(_response);
        });
    }

    protected processUpdateResponsible(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAvailablePriorities(): Promise<BaseResultOfActivityPriorityOf> {
        let url_ = this.baseUrl + "/api/activity/available-priorities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailablePriorities(_response);
        });
    }

    protected processGetAvailablePriorities(response: Response): Promise<BaseResultOfActivityPriorityOf> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfActivityPriorityOf.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfActivityPriorityOf>(null as any);
    }

    updatePriority(activityId: number | undefined, priorityId: number | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/activity/update-priority?";
        if (activityId === null)
            throw new globalThis.Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (priorityId !== undefined && priorityId !== null)
            url_ += "priorityId=" + encodeURIComponent("" + priorityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePriority(_response);
        });
    }

    protected processUpdatePriority(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateReference(activityId: number | undefined, reference: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/activity/update-reference?";
        if (activityId === null)
            throw new globalThis.Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (reference !== undefined && reference !== null)
            url_ += "reference=" + encodeURIComponent("" + reference) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateReference(_response);
        });
    }

    protected processUpdateReference(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateDescription(activityId: number | undefined, description: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/activity/update-description?";
        if (activityId === null)
            throw new globalThis.Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDescription(_response);
        });
    }

    protected processUpdateDescription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createActivityWithDutyAndCell(dutyId: number | undefined, cellId: number | undefined, skipNextAutoTrigger: boolean | undefined, title: string | null | undefined, reference: string | null | undefined): Promise<BaseResultOfActivity> {
        let url_ = this.baseUrl + "/api/activity/createActivityWithDutyAndCell?";
        if (dutyId === null)
            throw new globalThis.Error("The parameter 'dutyId' cannot be null.");
        else if (dutyId !== undefined)
            url_ += "dutyId=" + encodeURIComponent("" + dutyId) + "&";
        if (cellId === null)
            throw new globalThis.Error("The parameter 'cellId' cannot be null.");
        else if (cellId !== undefined)
            url_ += "cellId=" + encodeURIComponent("" + cellId) + "&";
        if (skipNextAutoTrigger === null)
            throw new globalThis.Error("The parameter 'skipNextAutoTrigger' cannot be null.");
        else if (skipNextAutoTrigger !== undefined)
            url_ += "skipNextAutoTrigger=" + encodeURIComponent("" + skipNextAutoTrigger) + "&";
        if (title !== undefined && title !== null)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (reference !== undefined && reference !== null)
            url_ += "reference=" + encodeURIComponent("" + reference) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateActivityWithDutyAndCell(_response);
        });
    }

    protected processCreateActivityWithDutyAndCell(response: Response): Promise<BaseResultOfActivity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfActivity.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfActivity>(null as any);
    }

    getDistinctValues(): Promise<ActivityDistinctValues> {
        let url_ = this.baseUrl + "/api/activity/distinct-values";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDistinctValues(_response);
        });
    }

    protected processGetDistinctValues(response: Response): Promise<ActivityDistinctValues> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDistinctValues.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityDistinctValues>(null as any);
    }

    getLogDistinctValues(): Promise<ActivityLogDistinctValues> {
        let url_ = this.baseUrl + "/api/activity/distinct-values-log";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLogDistinctValues(_response);
        });
    }

    protected processGetLogDistinctValues(response: Response): Promise<ActivityLogDistinctValues> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityLogDistinctValues.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityLogDistinctValues>(null as any);
    }

    textAboutActivity(activityId: number | undefined, subject: string | null | undefined): Promise<TextAboutActivity> {
        let url_ = this.baseUrl + "/api/activity/text-about-activity?";
        if (activityId === null)
            throw new globalThis.Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (subject !== undefined && subject !== null)
            url_ += "subject=" + encodeURIComponent("" + subject) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTextAboutActivity(_response);
        });
    }

    protected processTextAboutActivity(response: Response): Promise<TextAboutActivity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TextAboutActivity.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TextAboutActivity>(null as any);
    }

    notificationAboutActivity(activityId: number | undefined, toEmail: string | undefined, subject: string | undefined, isWorkFlowEntry: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/activity/notification-about-activity?";
        if (activityId === null)
            throw new globalThis.Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (toEmail === null)
            throw new globalThis.Error("The parameter 'toEmail' cannot be null.");
        else if (toEmail !== undefined)
            url_ += "toEmail=" + encodeURIComponent("" + toEmail) + "&";
        if (subject === null)
            throw new globalThis.Error("The parameter 'subject' cannot be null.");
        else if (subject !== undefined)
            url_ += "subject=" + encodeURIComponent("" + subject) + "&";
        if (isWorkFlowEntry === null)
            throw new globalThis.Error("The parameter 'isWorkFlowEntry' cannot be null.");
        else if (isWorkFlowEntry !== undefined)
            url_ += "isWorkFlowEntry=" + encodeURIComponent("" + isWorkFlowEntry) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNotificationAboutActivity(_response);
        });
    }

    protected processNotificationAboutActivity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    linkMedia(request: ActivityLinkMediaRequest): Promise<BaseResultOfActivity> {
        let url_ = this.baseUrl + "/api/activity/linkmedia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLinkMedia(_response);
        });
    }

    protected processLinkMedia(response: Response): Promise<BaseResultOfActivity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfActivity.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfActivity>(null as any);
    }
}

export interface IOeeApiClient {

    working(id: number): Promise<FileResponse>;

    listWorking(l: number[]): Promise<FileResponse>;

    getOpenOvershifts(): Promise<BaseResultOfIListOfOeeOverShiftBreakdown>;

    closeOpenOvershifts(id: number): Promise<FileResponse>;

    getOnOffOverTime(startTime: Date | undefined, endTime: Date | undefined, oeeKey: number | undefined): Promise<BaseResultOfListOfXY>;
}

export class OeeApiClient implements IOeeApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    working(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/oee/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWorking(_response);
        });
    }

    protected processWorking(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    listWorking(l: number[]): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/oee/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(l);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListWorking(_response);
        });
    }

    protected processListWorking(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getOpenOvershifts(): Promise<BaseResultOfIListOfOeeOverShiftBreakdown> {
        let url_ = this.baseUrl + "/api/v1/oee/openOverShifts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOpenOvershifts(_response);
        });
    }

    protected processGetOpenOvershifts(response: Response): Promise<BaseResultOfIListOfOeeOverShiftBreakdown> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfIListOfOeeOverShiftBreakdown.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    closeOpenOvershifts(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/oee/closeOverShift/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCloseOpenOvershifts(_response);
        });
    }

    protected processCloseOpenOvershifts(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
    }

    getOnOffOverTime(startTime: Date | undefined, endTime: Date | undefined, oeeKey: number | undefined): Promise<BaseResultOfListOfXY> {
        let url_ = this.baseUrl + "/api/v1/oee/onoff?";
        if (startTime === null)
            throw new globalThis.Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new globalThis.Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (oeeKey === null)
            throw new globalThis.Error("The parameter 'oeeKey' cannot be null.");
        else if (oeeKey !== undefined)
            url_ += "oeeKey=" + encodeURIComponent("" + oeeKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOnOffOverTime(_response);
        });
    }

    protected processGetOnOffOverTime(response: Response): Promise<BaseResultOfListOfXY> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfListOfXY.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }
}

export interface IOeeCellShiftApiClient {

    data(cellid: number | undefined, shiftId: number | undefined, start: Date | undefined): Promise<BaseResultOfXYOf>;
}

export class OeeCellShiftApiClient implements IOeeCellShiftApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    data(cellid: number | undefined, shiftId: number | undefined, start: Date | undefined): Promise<BaseResultOfXYOf> {
        let url_ = this.baseUrl + "/api/v1/oeeCellShift/data?";
        if (cellid === null)
            throw new globalThis.Error("The parameter 'cellid' cannot be null.");
        else if (cellid !== undefined)
            url_ += "cellid=" + encodeURIComponent("" + cellid) + "&";
        if (shiftId === null)
            throw new globalThis.Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processData(_response);
        });
    }

    protected processData(response: Response): Promise<BaseResultOfXYOf> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = BaseResultOfXYOf.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }
}

export interface IOeeDashboardApiClient {

    getCosts(machine: string | null | undefined, from: Date | undefined, to: Date | undefined): Promise<FileResponse>;

    getThroughput(machine: string | null | undefined, from: Date | undefined, to: Date | undefined): Promise<FileResponse>;

    getGuage(machine: string | null | undefined, from: Date | undefined, to: Date | undefined): Promise<FileResponse>;

    getTotalOee(from: Date | undefined, to: Date | undefined): Promise<FileResponse>;
}

export class OeeDashboardApiClient implements IOeeDashboardApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCosts(machine: string | null | undefined, from: Date | undefined, to: Date | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/oeedashboard/costs?";
        if (machine !== undefined && machine !== null)
            url_ += "machine=" + encodeURIComponent("" + machine) + "&";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCosts(_response);
        });
    }

    protected processGetCosts(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getThroughput(machine: string | null | undefined, from: Date | undefined, to: Date | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/oeedashboard/throughput?";
        if (machine !== undefined && machine !== null)
            url_ += "machine=" + encodeURIComponent("" + machine) + "&";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetThroughput(_response);
        });
    }

    protected processGetThroughput(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getGuage(machine: string | null | undefined, from: Date | undefined, to: Date | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/oeedashboard/gauges?";
        if (machine !== undefined && machine !== null)
            url_ += "machine=" + encodeURIComponent("" + machine) + "&";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGuage(_response);
        });
    }

    protected processGetGuage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTotalOee(from: Date | undefined, to: Date | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/oeedashboard/totalOee?";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTotalOee(_response);
        });
    }

    protected processGetTotalOee(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IPqtApiUiV2Client {

    import(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<void>;

    listProducts(filter: string | null | undefined, order: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined): Promise<PqtProduct[]>;

    createProducts(products: PqtProduct[]): Promise<PqtProduct[]>;

    updateProduct(productId: number, product: PqtProduct): Promise<PqtProduct>;

    archiveProduct(productId: number, req: PqtArchiveRequest): Promise<void>;

    linkProductMedia(productId: number, mediaId: string): Promise<Media2>;

    productAsPdf(productId: number): Promise<FileResponse>;

    listTests(productId: number): Promise<PqtProductTest[]>;

    createTests(productId: number, tests: PqtProductTest[]): Promise<PqtProductTest[]>;

    updateTest(productId: number, testId: number, test: PqtProductTest): Promise<PqtProductTest>;

    linkTestMedia(productId: number, testId: number, mediaId: string): Promise<Media2>;

    exportTestToExcel(productId: number, testId: number): Promise<FileResponse>;
}

export class PqtApiUiV2Client implements IPqtApiUiV2Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    import(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/productQualityTests/products/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (parentId !== null && parentId !== undefined)
            content_.append("ParentId", parentId.toString());
        if (uploads !== null && uploads !== undefined)
            uploads.forEach(item_ => content_.append("Uploads", item_.data, item_.fileName ? item_.fileName : "Uploads") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    listProducts(filter: string | null | undefined, order: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined): Promise<PqtProduct[]> {
        let url_ = this.baseUrl + "/api/v2/productQualityTests/products?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (order !== undefined && order !== null)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListProducts(_response);
        });
    }

    protected processListProducts(response: Response): Promise<PqtProduct[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PqtProduct.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PqtProduct[]>(null as any);
    }

    createProducts(products: PqtProduct[]): Promise<PqtProduct[]> {
        let url_ = this.baseUrl + "/api/v2/productQualityTests/products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(products);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateProducts(_response);
        });
    }

    protected processCreateProducts(response: Response): Promise<PqtProduct[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item of resultData201)
                    result201!.push(PqtProduct.fromJS(item));
            }
            else {
                result201 = null as any;
            }
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PqtProduct[]>(null as any);
    }

    updateProduct(productId: number, product: PqtProduct): Promise<PqtProduct> {
        let url_ = this.baseUrl + "/api/v2/productQualityTests/products/{productId}";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(product);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateProduct(_response);
        });
    }

    protected processUpdateProduct(response: Response): Promise<PqtProduct> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PqtProduct.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PqtProduct>(null as any);
    }

    archiveProduct(productId: number, req: PqtArchiveRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/productQualityTests/products/{productId}/archive";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processArchiveProduct(_response);
        });
    }

    protected processArchiveProduct(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    linkProductMedia(productId: number, mediaId: string): Promise<Media2> {
        let url_ = this.baseUrl + "/api/v2/productQualityTests/products/{productId}/linkMedia/{mediaId}";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (mediaId === undefined || mediaId === null)
            throw new globalThis.Error("The parameter 'mediaId' must be defined.");
        url_ = url_.replace("{mediaId}", encodeURIComponent("" + mediaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLinkProductMedia(_response);
        });
    }

    protected processLinkProductMedia(response: Response): Promise<Media2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Media2.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Media2>(null as any);
    }

    productAsPdf(productId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/productQualityTests/products/{productId}/pdf";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductAsPdf(_response);
        });
    }

    protected processProductAsPdf(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    listTests(productId: number): Promise<PqtProductTest[]> {
        let url_ = this.baseUrl + "/api/v2/productQualityTests/products/{productId}/tests";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListTests(_response);
        });
    }

    protected processListTests(response: Response): Promise<PqtProductTest[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PqtProductTest.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PqtProductTest[]>(null as any);
    }

    createTests(productId: number, tests: PqtProductTest[]): Promise<PqtProductTest[]> {
        let url_ = this.baseUrl + "/api/v2/productQualityTests/products/{productId}/tests";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tests);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTests(_response);
        });
    }

    protected processCreateTests(response: Response): Promise<PqtProductTest[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item of resultData201)
                    result201!.push(PqtProductTest.fromJS(item));
            }
            else {
                result201 = null as any;
            }
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PqtProductTest[]>(null as any);
    }

    updateTest(productId: number, testId: number, test: PqtProductTest): Promise<PqtProductTest> {
        let url_ = this.baseUrl + "/api/v2/productQualityTests/products/{productId}/tests/{testId}";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (testId === undefined || testId === null)
            throw new globalThis.Error("The parameter 'testId' must be defined.");
        url_ = url_.replace("{testId}", encodeURIComponent("" + testId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(test);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTest(_response);
        });
    }

    protected processUpdateTest(response: Response): Promise<PqtProductTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PqtProductTest.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PqtProductTest>(null as any);
    }

    linkTestMedia(productId: number, testId: number, mediaId: string): Promise<Media2> {
        let url_ = this.baseUrl + "/api/v2/productQualityTests/products/{productId}/tests/{testId}/linkMedia/{mediaId}";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (testId === undefined || testId === null)
            throw new globalThis.Error("The parameter 'testId' must be defined.");
        url_ = url_.replace("{testId}", encodeURIComponent("" + testId));
        if (mediaId === undefined || mediaId === null)
            throw new globalThis.Error("The parameter 'mediaId' must be defined.");
        url_ = url_.replace("{mediaId}", encodeURIComponent("" + mediaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLinkTestMedia(_response);
        });
    }

    protected processLinkTestMedia(response: Response): Promise<Media2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Media2.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Media2>(null as any);
    }

    exportTestToExcel(productId: number, testId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/productQualityTests/products/{productId}/tests/{testId}/asExcel";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (testId === undefined || testId === null)
            throw new globalThis.Error("The parameter 'testId' must be defined.");
        url_ = url_.replace("{testId}", encodeURIComponent("" + testId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportTestToExcel(_response);
        });
    }

    protected processExportTestToExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IPqtMeasurementSpecificationTemplatesUiV2Client {

    list(): Promise<PqtMeasurementSpecificationTemplate[]>;

    create(templates: PqtMeasurementSpecificationTemplate[]): Promise<PqtMeasurementSpecificationTemplate[]>;

    update(id: string, template: PqtMeasurementSpecificationTemplate): Promise<PqtMeasurementSpecificationTemplate>;

    delete(id: string): Promise<void>;
}

export class PqtMeasurementSpecificationTemplatesUiV2Client implements IPqtMeasurementSpecificationTemplatesUiV2Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<PqtMeasurementSpecificationTemplate[]> {
        let url_ = this.baseUrl + "/api/v2/productQualityTests/measurementSpecificationTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PqtMeasurementSpecificationTemplate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PqtMeasurementSpecificationTemplate.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PqtMeasurementSpecificationTemplate[]>(null as any);
    }

    create(templates: PqtMeasurementSpecificationTemplate[]): Promise<PqtMeasurementSpecificationTemplate[]> {
        let url_ = this.baseUrl + "/api/v2/productQualityTests/measurementSpecificationTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(templates);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<PqtMeasurementSpecificationTemplate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PqtMeasurementSpecificationTemplate.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PqtMeasurementSpecificationTemplate[]>(null as any);
    }

    update(id: string, template: PqtMeasurementSpecificationTemplate): Promise<PqtMeasurementSpecificationTemplate> {
        let url_ = this.baseUrl + "/api/v2/productQualityTests/measurementSpecificationTemplates/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(template);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<PqtMeasurementSpecificationTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PqtMeasurementSpecificationTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PqtMeasurementSpecificationTemplate>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/productQualityTests/measurementSpecificationTemplates/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IPqtGroupTypeAPIControllerUIClient {

    list(): Promise<PqtGroupType[]>;

    create(group: PqtGroupType): Promise<PqtGroupType>;

    update(group: PqtGroupType): Promise<PqtGroupType>;

    delete(id: number): Promise<any>;
}

export class PqtGroupTypeAPIControllerUIClient implements IPqtGroupTypeAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<PqtGroupType[]> {
        let url_ = this.baseUrl + "/api/v1/PqtGroupTypeAPIControllerUI/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PqtGroupType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultDatadefault)) {
                resultdefault = [] as any;
                for (let item of resultDatadefault)
                    resultdefault!.push(PqtGroupType.fromJS(item));
            }
            else {
                resultdefault = null as any;
            }
            return resultdefault;
            });
        }
    }

    create(group: PqtGroupType): Promise<PqtGroupType> {
        let url_ = this.baseUrl + "/api/v1/PqtGroupTypeAPIControllerUI/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(group);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<PqtGroupType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = PqtGroupType.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    update(group: PqtGroupType): Promise<PqtGroupType> {
        let url_ = this.baseUrl + "/api/v1/PqtGroupTypeAPIControllerUI/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(group);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<PqtGroupType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = PqtGroupType.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    delete(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/v1/PqtGroupTypeAPIControllerUI/detete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = resultDatadefault !== undefined ? resultDatadefault : null as any;
    
            return resultdefault;
            });
        }
    }
}

export interface ISensorDataUiClient {

    post(sensorDataList: SensorData[]): Promise<void>;
}

export class SensorDataUiClient implements ISensorDataUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    post(sensorDataList: SensorData[]): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/sensorData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sensorDataList);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ITestEquipmentApiUiV2Client {

    import(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<void>;

    listDevices(filter: string | null | undefined, order: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined): Promise<TestEquipmentDevice[]>;

    createDevices(devices: TestEquipmentDevice[]): Promise<TestEquipmentDevice[]>;

    updateDevice(deviceId: number, device: TestEquipmentDevice): Promise<TestEquipmentDevice>;

    archiveDevice(deviceId: number, req: ArchiveRequest): Promise<void>;

    linkDeviceMedia(deviceId: number, mediaId: string): Promise<Media2>;

    listTests(deviceId: number): Promise<TestEquipmentTest[]>;

    createTests(deviceId: number, tests: TestEquipmentTest[]): Promise<TestEquipmentTest[]>;

    updateTest(deviceId: number, testId: number, test: TestEquipmentTest): Promise<TestEquipmentTest>;

    linkTestMedia(deviceId: number, testId: number, mediaId: string): Promise<Media2>;

    exportTestToExcel(deviceId: number, testId: number): Promise<FileResponse>;
}

export class TestEquipmentApiUiV2Client implements ITestEquipmentApiUiV2Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    import(id: string | null | undefined, parentId: string | null | undefined, uploads: FileParameter[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/testEquipment/devices/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (parentId !== null && parentId !== undefined)
            content_.append("ParentId", parentId.toString());
        if (uploads !== null && uploads !== undefined)
            uploads.forEach(item_ => content_.append("Uploads", item_.data, item_.fileName ? item_.fileName : "Uploads") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    listDevices(filter: string | null | undefined, order: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined): Promise<TestEquipmentDevice[]> {
        let url_ = this.baseUrl + "/api/v2/testEquipment/devices?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (order !== undefined && order !== null)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListDevices(_response);
        });
    }

    protected processListDevices(response: Response): Promise<TestEquipmentDevice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TestEquipmentDevice.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestEquipmentDevice[]>(null as any);
    }

    createDevices(devices: TestEquipmentDevice[]): Promise<TestEquipmentDevice[]> {
        let url_ = this.baseUrl + "/api/v2/testEquipment/devices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(devices);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateDevices(_response);
        });
    }

    protected processCreateDevices(response: Response): Promise<TestEquipmentDevice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item of resultData201)
                    result201!.push(TestEquipmentDevice.fromJS(item));
            }
            else {
                result201 = null as any;
            }
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestEquipmentDevice[]>(null as any);
    }

    updateDevice(deviceId: number, device: TestEquipmentDevice): Promise<TestEquipmentDevice> {
        let url_ = this.baseUrl + "/api/v2/testEquipment/devices/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(device);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDevice(_response);
        });
    }

    protected processUpdateDevice(response: Response): Promise<TestEquipmentDevice> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TestEquipmentDevice.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestEquipmentDevice>(null as any);
    }

    archiveDevice(deviceId: number, req: ArchiveRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/testEquipment/devices/{deviceId}/archive";
        if (deviceId === undefined || deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processArchiveDevice(_response);
        });
    }

    protected processArchiveDevice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    linkDeviceMedia(deviceId: number, mediaId: string): Promise<Media2> {
        let url_ = this.baseUrl + "/api/v2/testEquipment/devices/{deviceId}/linkMedia/{mediaId}";
        if (deviceId === undefined || deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        if (mediaId === undefined || mediaId === null)
            throw new globalThis.Error("The parameter 'mediaId' must be defined.");
        url_ = url_.replace("{mediaId}", encodeURIComponent("" + mediaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLinkDeviceMedia(_response);
        });
    }

    protected processLinkDeviceMedia(response: Response): Promise<Media2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Media2.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Media2>(null as any);
    }

    listTests(deviceId: number): Promise<TestEquipmentTest[]> {
        let url_ = this.baseUrl + "/api/v2/testEquipment/devices/{deviceId}/tests";
        if (deviceId === undefined || deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListTests(_response);
        });
    }

    protected processListTests(response: Response): Promise<TestEquipmentTest[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TestEquipmentTest.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestEquipmentTest[]>(null as any);
    }

    createTests(deviceId: number, tests: TestEquipmentTest[]): Promise<TestEquipmentTest[]> {
        let url_ = this.baseUrl + "/api/v2/testEquipment/devices/{deviceId}/tests";
        if (deviceId === undefined || deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tests);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTests(_response);
        });
    }

    protected processCreateTests(response: Response): Promise<TestEquipmentTest[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item of resultData201)
                    result201!.push(TestEquipmentTest.fromJS(item));
            }
            else {
                result201 = null as any;
            }
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestEquipmentTest[]>(null as any);
    }

    updateTest(deviceId: number, testId: number, test: TestEquipmentTest): Promise<TestEquipmentTest> {
        let url_ = this.baseUrl + "/api/v2/testEquipment/devices/{deviceId}/tests/{testId}";
        if (deviceId === undefined || deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        if (testId === undefined || testId === null)
            throw new globalThis.Error("The parameter 'testId' must be defined.");
        url_ = url_.replace("{testId}", encodeURIComponent("" + testId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(test);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTest(_response);
        });
    }

    protected processUpdateTest(response: Response): Promise<TestEquipmentTest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TestEquipmentTest.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestEquipmentTest>(null as any);
    }

    linkTestMedia(deviceId: number, testId: number, mediaId: string): Promise<Media2> {
        let url_ = this.baseUrl + "/api/v2/testEquipment/devices/{deviceId}/tests/{testId}/linkMedia/{mediaId}";
        if (deviceId === undefined || deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        if (testId === undefined || testId === null)
            throw new globalThis.Error("The parameter 'testId' must be defined.");
        url_ = url_.replace("{testId}", encodeURIComponent("" + testId));
        if (mediaId === undefined || mediaId === null)
            throw new globalThis.Error("The parameter 'mediaId' must be defined.");
        url_ = url_.replace("{mediaId}", encodeURIComponent("" + mediaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLinkTestMedia(_response);
        });
    }

    protected processLinkTestMedia(response: Response): Promise<Media2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Media2.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Media2>(null as any);
    }

    exportTestToExcel(deviceId: number, testId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/testEquipment/devices/{deviceId}/tests/{testId}/asExcel";
        if (deviceId === undefined || deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        if (testId === undefined || testId === null)
            throw new globalThis.Error("The parameter 'testId' must be defined.");
        url_ = url_.replace("{testId}", encodeURIComponent("" + testId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportTestToExcel(_response);
        });
    }

    protected processExportTestToExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ITestEquipmentMeasurementSpecificationTemplatesUiV2Client {

    list(): Promise<MeasurementSpecificationTemplate[]>;

    create(templates: MeasurementSpecificationTemplate[]): Promise<MeasurementSpecificationTemplate[]>;

    update(id: string, template: MeasurementSpecificationTemplate): Promise<MeasurementSpecificationTemplate>;

    delete(id: string): Promise<void>;
}

export class TestEquipmentMeasurementSpecificationTemplatesUiV2Client implements ITestEquipmentMeasurementSpecificationTemplatesUiV2Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<MeasurementSpecificationTemplate[]> {
        let url_ = this.baseUrl + "/api/v2/testEquipment/measurementSpecificationTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<MeasurementSpecificationTemplate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasurementSpecificationTemplate.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeasurementSpecificationTemplate[]>(null as any);
    }

    create(templates: MeasurementSpecificationTemplate[]): Promise<MeasurementSpecificationTemplate[]> {
        let url_ = this.baseUrl + "/api/v2/testEquipment/measurementSpecificationTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(templates);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<MeasurementSpecificationTemplate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasurementSpecificationTemplate.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeasurementSpecificationTemplate[]>(null as any);
    }

    update(id: string, template: MeasurementSpecificationTemplate): Promise<MeasurementSpecificationTemplate> {
        let url_ = this.baseUrl + "/api/v2/testEquipment/measurementSpecificationTemplates/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(template);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<MeasurementSpecificationTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeasurementSpecificationTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeasurementSpecificationTemplate>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/testEquipment/measurementSpecificationTemplates/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ITestEquipmentGroupTypeAPIControllerUIClient {

    list(): Promise<GroupType[]>;

    create(group: GroupType): Promise<GroupType>;

    update(group: GroupType): Promise<GroupType>;

    delete(id: number): Promise<any>;
}

export class TestEquipmentGroupTypeAPIControllerUIClient implements ITestEquipmentGroupTypeAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<GroupType[]> {
        let url_ = this.baseUrl + "/api/v1/TestEquipmentGroupTypeAPIControllerUI/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<GroupType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultDatadefault)) {
                resultdefault = [] as any;
                for (let item of resultDatadefault)
                    resultdefault!.push(GroupType.fromJS(item));
            }
            else {
                resultdefault = null as any;
            }
            return resultdefault;
            });
        }
    }

    create(group: GroupType): Promise<GroupType> {
        let url_ = this.baseUrl + "/api/v1/TestEquipmentGroupTypeAPIControllerUI/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(group);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<GroupType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = GroupType.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    update(group: GroupType): Promise<GroupType> {
        let url_ = this.baseUrl + "/api/v1/TestEquipmentGroupTypeAPIControllerUI/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(group);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<GroupType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = GroupType.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    delete(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/v1/TestEquipmentGroupTypeAPIControllerUI/detete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = resultDatadefault !== undefined ? resultDatadefault : null as any;
    
            return resultdefault;
            });
        }
    }
}

export interface ITestEquipmentKindTypeAPIControllerUIClient {

    list(): Promise<KindType[]>;

    create(kind: KindType): Promise<KindType>;

    update(kind: KindType): Promise<KindType>;

    delete(id: number): Promise<any>;
}

export class TestEquipmentKindTypeAPIControllerUIClient implements ITestEquipmentKindTypeAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<KindType[]> {
        let url_ = this.baseUrl + "/api/v1/TestEquipmentKindTypeAPIControllerUI/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<KindType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultDatadefault)) {
                resultdefault = [] as any;
                for (let item of resultDatadefault)
                    resultdefault!.push(KindType.fromJS(item));
            }
            else {
                resultdefault = null as any;
            }
            return resultdefault;
            });
        }
    }

    create(kind: KindType): Promise<KindType> {
        let url_ = this.baseUrl + "/api/v1/TestEquipmentKindTypeAPIControllerUI/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(kind);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<KindType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = KindType.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    update(kind: KindType): Promise<KindType> {
        let url_ = this.baseUrl + "/api/v1/TestEquipmentKindTypeAPIControllerUI/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(kind);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<KindType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = KindType.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    delete(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/v1/TestEquipmentKindTypeAPIControllerUI/detete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = resultDatadefault !== undefined ? resultDatadefault : null as any;
    
            return resultdefault;
            });
        }
    }
}

export interface ITestEquipmentPlaceOfUseAPIControllerUIClient {

    list(): Promise<PlaceOfUseType[]>;

    create(placeOfUse: PlaceOfUseType): Promise<PlaceOfUseType>;

    update(placeOfUse: PlaceOfUseType): Promise<PlaceOfUseType>;

    delete(id: number): Promise<any>;
}

export class TestEquipmentPlaceOfUseAPIControllerUIClient implements ITestEquipmentPlaceOfUseAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<PlaceOfUseType[]> {
        let url_ = this.baseUrl + "/api/v1/TestEquipmentPlaceOfUseAPIControllerUI/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PlaceOfUseType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultDatadefault)) {
                resultdefault = [] as any;
                for (let item of resultDatadefault)
                    resultdefault!.push(PlaceOfUseType.fromJS(item));
            }
            else {
                resultdefault = null as any;
            }
            return resultdefault;
            });
        }
    }

    create(placeOfUse: PlaceOfUseType): Promise<PlaceOfUseType> {
        let url_ = this.baseUrl + "/api/v1/TestEquipmentPlaceOfUseAPIControllerUI/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(placeOfUse);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<PlaceOfUseType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = PlaceOfUseType.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    update(placeOfUse: PlaceOfUseType): Promise<PlaceOfUseType> {
        let url_ = this.baseUrl + "/api/v1/TestEquipmentPlaceOfUseAPIControllerUI/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(placeOfUse);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<PlaceOfUseType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = PlaceOfUseType.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    delete(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/v1/TestEquipmentPlaceOfUseAPIControllerUI/detete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = resultDatadefault !== undefined ? resultDatadefault : null as any;
    
            return resultdefault;
            });
        }
    }
}

export interface ITestEquipmentTimeUnitAPIControllerUIClient {

    list(): Promise<TimeUnit[]>;

    create(timeUnit: TimeUnit): Promise<TimeUnit>;

    update(timeUnit: TimeUnit): Promise<TimeUnit>;

    delete(id: number): Promise<any>;
}

export class TestEquipmentTimeUnitAPIControllerUIClient implements ITestEquipmentTimeUnitAPIControllerUIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<TimeUnit[]> {
        let url_ = this.baseUrl + "/api/v1/TestEquipmentTimeUnitAPIControllerUI/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<TimeUnit[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultDatadefault)) {
                resultdefault = [] as any;
                for (let item of resultDatadefault)
                    resultdefault!.push(TimeUnit.fromJS(item));
            }
            else {
                resultdefault = null as any;
            }
            return resultdefault;
            });
        }
    }

    create(timeUnit: TimeUnit): Promise<TimeUnit> {
        let url_ = this.baseUrl + "/api/v1/TestEquipmentTimeUnitAPIControllerUI/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(timeUnit);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<TimeUnit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = TimeUnit.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    update(timeUnit: TimeUnit): Promise<TimeUnit> {
        let url_ = this.baseUrl + "/api/v1/TestEquipmentTimeUnitAPIControllerUI/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(timeUnit);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<TimeUnit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = TimeUnit.fromJS(resultDatadefault);
            return resultdefault;
            });
        }
    }

    delete(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/v1/TestEquipmentTimeUnitAPIControllerUI/detete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                resultdefault = resultDatadefault !== undefined ? resultDatadefault : null as any;
    
            return resultdefault;
            });
        }
    }
}

export interface ITntBatchUiClient {

    getAll(): Promise<BaseResultOfListOfTntBatch>;

    create(batch: TntBatch): Promise<BaseResultOfTntBatch>;

    update(batch: TntBatch): Promise<BaseResultOfTntBatch>;

    getById(id: string): Promise<BaseResultOfTntBatch>;

    getByIdentifier(identifier: string): Promise<BaseResultOfTntBatch>;

    qr(request: TntQrRequest): Promise<FileResponse>;
}

export class TntBatchUiClient implements ITntBatchUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Promise<BaseResultOfListOfTntBatch> {
        let url_ = this.baseUrl + "/api/v1/tnt/batch";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<BaseResultOfListOfTntBatch> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfListOfTntBatch.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfListOfTntBatch>(null as any);
    }

    create(batch: TntBatch): Promise<BaseResultOfTntBatch> {
        let url_ = this.baseUrl + "/api/v1/tnt/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(batch);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<BaseResultOfTntBatch> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntBatch.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = BaseResultOfErrorResult.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntBatch>(null as any);
    }

    update(batch: TntBatch): Promise<BaseResultOfTntBatch> {
        let url_ = this.baseUrl + "/api/v1/tnt/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(batch);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResultOfTntBatch> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntBatch.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntBatch>(null as any);
    }

    getById(id: string): Promise<BaseResultOfTntBatch> {
        let url_ = this.baseUrl + "/api/v1/tnt/batch/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<BaseResultOfTntBatch> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntBatch.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntBatch>(null as any);
    }

    getByIdentifier(identifier: string): Promise<BaseResultOfTntBatch> {
        let url_ = this.baseUrl + "/api/v1/tnt/batch/identifier/{identifier}";
        if (identifier === undefined || identifier === null)
            throw new globalThis.Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByIdentifier(_response);
        });
    }

    protected processGetByIdentifier(response: Response): Promise<BaseResultOfTntBatch> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntBatch.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntBatch>(null as any);
    }

    qr(request: TntQrRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tnt/batch/qr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processQr(_response);
        });
    }

    protected processQr(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ITntBookingUiClient {

    consume(request: TntBookingConsumeRequest): Promise<TntConsumeResult>;

    transferUntilEnoughInTarget(request: TntBookingTransferUntilEnoughInTargetRequest): Promise<void>;
}

export class TntBookingUiClient implements ITntBookingUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    consume(request: TntBookingConsumeRequest): Promise<TntConsumeResult> {
        let url_ = this.baseUrl + "/api/v1/tnt/booking/Consume";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConsume(_response);
        });
    }

    protected processConsume(response: Response): Promise<TntConsumeResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TntConsumeResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TntConsumeResult>(null as any);
    }

    transferUntilEnoughInTarget(request: TntBookingTransferUntilEnoughInTargetRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tnt/booking/TransferUntilEnoughInTarget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransferUntilEnoughInTarget(_response);
        });
    }

    protected processTransferUntilEnoughInTarget(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ITntItemAttributeDefinitionUiClient {

    getAll(): Promise<BaseResultOfListOfTntItemAttributeDefinition>;

    create(definition: TntItemAttributeDefinition): Promise<BaseResultOfTntItemAttributeDefinition>;

    update(definition: TntItemAttributeDefinition): Promise<BaseResultOfTntItemAttributeDefinition>;

    getById(id: string): Promise<BaseResultOfTntItemAttributeDefinition>;

    getByName(name: string): Promise<BaseResultOfTntItemAttributeDefinition>;
}

export class TntItemAttributeDefinitionUiClient implements ITntItemAttributeDefinitionUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Promise<BaseResultOfListOfTntItemAttributeDefinition> {
        let url_ = this.baseUrl + "/api/v1/tnt/item/attribute/definition";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<BaseResultOfListOfTntItemAttributeDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfListOfTntItemAttributeDefinition.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfListOfTntItemAttributeDefinition>(null as any);
    }

    create(definition: TntItemAttributeDefinition): Promise<BaseResultOfTntItemAttributeDefinition> {
        let url_ = this.baseUrl + "/api/v1/tnt/item/attribute/definition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(definition);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<BaseResultOfTntItemAttributeDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntItemAttributeDefinition.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = BaseResultOfErrorResult.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntItemAttributeDefinition>(null as any);
    }

    update(definition: TntItemAttributeDefinition): Promise<BaseResultOfTntItemAttributeDefinition> {
        let url_ = this.baseUrl + "/api/v1/tnt/item/attribute/definition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(definition);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResultOfTntItemAttributeDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntItemAttributeDefinition.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntItemAttributeDefinition>(null as any);
    }

    getById(id: string): Promise<BaseResultOfTntItemAttributeDefinition> {
        let url_ = this.baseUrl + "/api/v1/tnt/item/attribute/definition/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<BaseResultOfTntItemAttributeDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntItemAttributeDefinition.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntItemAttributeDefinition>(null as any);
    }

    getByName(name: string): Promise<BaseResultOfTntItemAttributeDefinition> {
        let url_ = this.baseUrl + "/api/v1/tnt/item/attribute/definition/name/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByName(_response);
        });
    }

    protected processGetByName(response: Response): Promise<BaseResultOfTntItemAttributeDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntItemAttributeDefinition.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntItemAttributeDefinition>(null as any);
    }
}

export interface ITntItemUiClient {

    getAll(): Promise<BaseResultOfListOfTntItem>;

    patch(request: TntItemPatchRequest): Promise<BaseResultOfListOfTntItem>;

    getById(id: string): Promise<BaseResultOfTntItem>;

    getByProductId(productId: string): Promise<BaseResultOfListOfTntItem>;

    getByFilter(filter: TntItemFilter): Promise<BaseResultOfListOfTntItem>;

    qr(request: TntQrRequest): Promise<FileResponse>;
}

export class TntItemUiClient implements ITntItemUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Promise<BaseResultOfListOfTntItem> {
        let url_ = this.baseUrl + "/api/v1/tnt/item";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<BaseResultOfListOfTntItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfListOfTntItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfListOfTntItem>(null as any);
    }

    patch(request: TntItemPatchRequest): Promise<BaseResultOfListOfTntItem> {
        let url_ = this.baseUrl + "/api/v1/tnt/item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<BaseResultOfListOfTntItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfListOfTntItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfListOfTntItem>(null as any);
    }

    getById(id: string): Promise<BaseResultOfTntItem> {
        let url_ = this.baseUrl + "/api/v1/tnt/item/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<BaseResultOfTntItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntItem.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntItem>(null as any);
    }

    getByProductId(productId: string): Promise<BaseResultOfListOfTntItem> {
        let url_ = this.baseUrl + "/api/v1/tnt/item/product/{productId}";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByProductId(_response);
        });
    }

    protected processGetByProductId(response: Response): Promise<BaseResultOfListOfTntItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfListOfTntItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfListOfTntItem>(null as any);
    }

    getByFilter(filter: TntItemFilter): Promise<BaseResultOfListOfTntItem> {
        let url_ = this.baseUrl + "/api/v1/tnt/item/filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByFilter(_response);
        });
    }

    protected processGetByFilter(response: Response): Promise<BaseResultOfListOfTntItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfListOfTntItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfListOfTntItem>(null as any);
    }

    qr(request: TntQrRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tnt/item/qr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processQr(_response);
        });
    }

    protected processQr(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ITntItemLocationUiClient {

    getAll(): Promise<BaseResultOfListOfTntItemLocation>;

    getById(id: string): Promise<BaseResultOfTntItemLocation>;

    getByLocationId(locationId: string): Promise<BaseResultOfListOfTntItemLocation>;

    getByFilter(filter: TntItemLocationFilter): Promise<BaseResultOfListOfTntItemLocation>;

    qr(request: TntQrRequest): Promise<FileResponse>;
}

export class TntItemLocationUiClient implements ITntItemLocationUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Promise<BaseResultOfListOfTntItemLocation> {
        let url_ = this.baseUrl + "/api/v1/tnt/item-location";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<BaseResultOfListOfTntItemLocation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfListOfTntItemLocation.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfListOfTntItemLocation>(null as any);
    }

    getById(id: string): Promise<BaseResultOfTntItemLocation> {
        let url_ = this.baseUrl + "/api/v1/tnt/item-location/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<BaseResultOfTntItemLocation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntItemLocation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntItemLocation>(null as any);
    }

    getByLocationId(locationId: string): Promise<BaseResultOfListOfTntItemLocation> {
        let url_ = this.baseUrl + "/api/v1/tnt/item-location/location/{locationId}";
        if (locationId === undefined || locationId === null)
            throw new globalThis.Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByLocationId(_response);
        });
    }

    protected processGetByLocationId(response: Response): Promise<BaseResultOfListOfTntItemLocation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfListOfTntItemLocation.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfListOfTntItemLocation>(null as any);
    }

    getByFilter(filter: TntItemLocationFilter): Promise<BaseResultOfListOfTntItemLocation> {
        let url_ = this.baseUrl + "/api/v1/tnt/item-location/filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByFilter(_response);
        });
    }

    protected processGetByFilter(response: Response): Promise<BaseResultOfListOfTntItemLocation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfListOfTntItemLocation.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfListOfTntItemLocation>(null as any);
    }

    qr(request: TntQrRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tnt/item-location/qr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processQr(_response);
        });
    }

    protected processQr(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ITntLocationUiClient {

    getAll(): Promise<BaseResultOfListOfTntLocation>;

    create(location: TntLocation): Promise<BaseResultOfTntLocation>;

    update(location: TntLocation): Promise<BaseResultOfTntLocation>;

    getById(id: string): Promise<BaseResultOfTntLocation>;

    getByIdentifier(identifier: string): Promise<BaseResultOfTntLocation>;

    getByFilter(filter: TntLocationFilter): Promise<BaseResultOfListOfTntLocation>;

    qr(request: TntQrRequest): Promise<FileResponse>;
}

export class TntLocationUiClient implements ITntLocationUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Promise<BaseResultOfListOfTntLocation> {
        let url_ = this.baseUrl + "/api/v1/tnt/location";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<BaseResultOfListOfTntLocation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfListOfTntLocation.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfListOfTntLocation>(null as any);
    }

    create(location: TntLocation): Promise<BaseResultOfTntLocation> {
        let url_ = this.baseUrl + "/api/v1/tnt/location";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(location);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<BaseResultOfTntLocation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntLocation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = BaseResultOfErrorResult.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntLocation>(null as any);
    }

    update(location: TntLocation): Promise<BaseResultOfTntLocation> {
        let url_ = this.baseUrl + "/api/v1/tnt/location";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(location);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResultOfTntLocation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntLocation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntLocation>(null as any);
    }

    getById(id: string): Promise<BaseResultOfTntLocation> {
        let url_ = this.baseUrl + "/api/v1/tnt/location/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<BaseResultOfTntLocation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntLocation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntLocation>(null as any);
    }

    getByIdentifier(identifier: string): Promise<BaseResultOfTntLocation> {
        let url_ = this.baseUrl + "/api/v1/tnt/location/identifier/{identifier}";
        if (identifier === undefined || identifier === null)
            throw new globalThis.Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByIdentifier(_response);
        });
    }

    protected processGetByIdentifier(response: Response): Promise<BaseResultOfTntLocation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntLocation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntLocation>(null as any);
    }

    getByFilter(filter: TntLocationFilter): Promise<BaseResultOfListOfTntLocation> {
        let url_ = this.baseUrl + "/api/v1/tnt/location/filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByFilter(_response);
        });
    }

    protected processGetByFilter(response: Response): Promise<BaseResultOfListOfTntLocation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfListOfTntLocation.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfListOfTntLocation>(null as any);
    }

    qr(request: TntQrRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tnt/location/qr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processQr(_response);
        });
    }

    protected processQr(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ITntOrderUiClient {

    produce(request: TntProduceRequest): Promise<BaseResultOfTntProduceResult>;

    consume(request: TntConsumeRequest): Promise<BaseResultOfTntConsumeResult>;

    transfer(request: TntTransferRequest): Promise<BaseResultOfTntTransferResult>;

    transform(request: TntTransformRequest): Promise<BaseResultOfTntTransformResult>;

    qr(request: TntQrRequest): Promise<FileResponse>;
}

export class TntOrderUiClient implements ITntOrderUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    produce(request: TntProduceRequest): Promise<BaseResultOfTntProduceResult> {
        let url_ = this.baseUrl + "/api/v1/tnt/order/produce";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProduce(_response);
        });
    }

    protected processProduce(response: Response): Promise<BaseResultOfTntProduceResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntProduceResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = BaseResultOfErrorResult.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = BaseResultOfErrorResult.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntProduceResult>(null as any);
    }

    consume(request: TntConsumeRequest): Promise<BaseResultOfTntConsumeResult> {
        let url_ = this.baseUrl + "/api/v1/tnt/order/consume";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConsume(_response);
        });
    }

    protected processConsume(response: Response): Promise<BaseResultOfTntConsumeResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntConsumeResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = BaseResultOfErrorResult.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = BaseResultOfErrorResult.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntConsumeResult>(null as any);
    }

    transfer(request: TntTransferRequest): Promise<BaseResultOfTntTransferResult> {
        let url_ = this.baseUrl + "/api/v1/tnt/order/transfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransfer(_response);
        });
    }

    protected processTransfer(response: Response): Promise<BaseResultOfTntTransferResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntTransferResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = BaseResultOfErrorResult.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = BaseResultOfErrorResult.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntTransferResult>(null as any);
    }

    transform(request: TntTransformRequest): Promise<BaseResultOfTntTransformResult> {
        let url_ = this.baseUrl + "/api/v1/tnt/order/transform";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransform(_response);
        });
    }

    protected processTransform(response: Response): Promise<BaseResultOfTntTransformResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntTransformResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = BaseResultOfErrorResult.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = BaseResultOfErrorResult.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntTransformResult>(null as any);
    }

    qr(request: TntQrRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tnt/order/qr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processQr(_response);
        });
    }

    protected processQr(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ITntProductUiClient {

    getAll(): Promise<BaseResultOfListOfTntProduct>;

    create(product: TntProduct): Promise<BaseResultOfTntProduct>;

    update(product: TntProduct): Promise<BaseResultOfTntProduct>;

    getById(id: string): Promise<BaseResultOfTntProduct>;

    qr(request: TntQrRequest): Promise<FileResponse>;
}

export class TntProductUiClient implements ITntProductUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Promise<BaseResultOfListOfTntProduct> {
        let url_ = this.baseUrl + "/api/v1/tnt/product";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<BaseResultOfListOfTntProduct> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfListOfTntProduct.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfListOfTntProduct>(null as any);
    }

    create(product: TntProduct): Promise<BaseResultOfTntProduct> {
        let url_ = this.baseUrl + "/api/v1/tnt/product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(product);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<BaseResultOfTntProduct> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntProduct.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntProduct>(null as any);
    }

    update(product: TntProduct): Promise<BaseResultOfTntProduct> {
        let url_ = this.baseUrl + "/api/v1/tnt/product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(product);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResultOfTntProduct> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntProduct.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntProduct>(null as any);
    }

    getById(id: string): Promise<BaseResultOfTntProduct> {
        let url_ = this.baseUrl + "/api/v1/tnt/product/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<BaseResultOfTntProduct> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntProduct.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntProduct>(null as any);
    }

    qr(request: TntQrRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tnt/product/qr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processQr(_response);
        });
    }

    protected processQr(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ITntSupplierUiClient {

    getAll(): Promise<BaseResultOfListOfTntSupplier>;

    create(supplier: TntSupplier): Promise<BaseResultOfTntSupplier>;

    update(supplier: TntSupplier): Promise<BaseResultOfTntSupplier>;

    getById(id: string): Promise<BaseResultOfTntSupplier>;

    qr(request: TntQrRequest): Promise<FileResponse>;
}

export class TntSupplierUiClient implements ITntSupplierUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Promise<BaseResultOfListOfTntSupplier> {
        let url_ = this.baseUrl + "/api/v1/tnt/supplier";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<BaseResultOfListOfTntSupplier> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfListOfTntSupplier.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfListOfTntSupplier>(null as any);
    }

    create(supplier: TntSupplier): Promise<BaseResultOfTntSupplier> {
        let url_ = this.baseUrl + "/api/v1/tnt/supplier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(supplier);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<BaseResultOfTntSupplier> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntSupplier.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = BaseResultOfErrorResult.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntSupplier>(null as any);
    }

    update(supplier: TntSupplier): Promise<BaseResultOfTntSupplier> {
        let url_ = this.baseUrl + "/api/v1/tnt/supplier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(supplier);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResultOfTntSupplier> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntSupplier.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntSupplier>(null as any);
    }

    getById(id: string): Promise<BaseResultOfTntSupplier> {
        let url_ = this.baseUrl + "/api/v1/tnt/supplier/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<BaseResultOfTntSupplier> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntSupplier.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntSupplier>(null as any);
    }

    qr(request: TntQrRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tnt/supplier/qr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processQr(_response);
        });
    }

    protected processQr(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ITntTransactionUiClient {

    list(filter: string | null | undefined, order: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined): Promise<TntTransaction[]>;

    getById(id: string): Promise<BaseResultOfTntTransaction>;

    getByFilter(filter: TntTransactionFilter): Promise<BaseResultOfListOfTntTransaction>;

    qr(request: TntQrRequest): Promise<FileResponse>;
}

export class TntTransactionUiClient implements ITntTransactionUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(filter: string | null | undefined, order: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined): Promise<TntTransaction[]> {
        let url_ = this.baseUrl + "/api/v1/tnt/transaction?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (order !== undefined && order !== null)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<TntTransaction[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TntTransaction.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TntTransaction[]>(null as any);
    }

    getById(id: string): Promise<BaseResultOfTntTransaction> {
        let url_ = this.baseUrl + "/api/v1/tnt/transaction/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<BaseResultOfTntTransaction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntTransaction.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntTransaction>(null as any);
    }

    getByFilter(filter: TntTransactionFilter): Promise<BaseResultOfListOfTntTransaction> {
        let url_ = this.baseUrl + "/api/v1/tnt/transaction/filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByFilter(_response);
        });
    }

    protected processGetByFilter(response: Response): Promise<BaseResultOfListOfTntTransaction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfListOfTntTransaction.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfListOfTntTransaction>(null as any);
    }

    qr(request: TntQrRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tnt/transaction/qr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processQr(_response);
        });
    }

    protected processQr(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ITntUnitUiClient {

    getAll(): Promise<BaseResultOfListOfTntUnit>;

    create(unit: TntUnit): Promise<BaseResultOfTntUnit>;

    update(unit: TntUnit): Promise<BaseResultOfTntUnit>;

    getById(id: string): Promise<BaseResultOfTntUnit>;

    getByName(name: string): Promise<BaseResultOfTntUnit>;

    qr(request: TntQrRequest): Promise<FileResponse>;
}

export class TntUnitUiClient implements ITntUnitUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Promise<BaseResultOfListOfTntUnit> {
        let url_ = this.baseUrl + "/api/v1/tnt/unit";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<BaseResultOfListOfTntUnit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfListOfTntUnit.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfListOfTntUnit>(null as any);
    }

    create(unit: TntUnit): Promise<BaseResultOfTntUnit> {
        let url_ = this.baseUrl + "/api/v1/tnt/unit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unit);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<BaseResultOfTntUnit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntUnit.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = BaseResultOfErrorResult.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntUnit>(null as any);
    }

    update(unit: TntUnit): Promise<BaseResultOfTntUnit> {
        let url_ = this.baseUrl + "/api/v1/tnt/unit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unit);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResultOfTntUnit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntUnit.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntUnit>(null as any);
    }

    getById(id: string): Promise<BaseResultOfTntUnit> {
        let url_ = this.baseUrl + "/api/v1/tnt/unit/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<BaseResultOfTntUnit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntUnit.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntUnit>(null as any);
    }

    getByName(name: string): Promise<BaseResultOfTntUnit> {
        let url_ = this.baseUrl + "/api/v1/tnt/unit/name/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByName(_response);
        });
    }

    protected processGetByName(response: Response): Promise<BaseResultOfTntUnit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntUnit.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntUnit>(null as any);
    }

    qr(request: TntQrRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tnt/unit/qr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processQr(_response);
        });
    }

    protected processQr(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ITntUtilUiClient {

    find(idLike: string | null | undefined): Promise<BaseResultOfTntFindResult>;

    input(idLike: string | null | undefined): Promise<BaseResultOfTntInputResult>;

    createLoginQr(): Promise<FileResponse>;

    createGenericQr(request: TntGenericQrRequest): Promise<FileResponse>;
}

export class TntUtilUiClient implements ITntUtilUiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    find(idLike: string | null | undefined): Promise<BaseResultOfTntFindResult> {
        let url_ = this.baseUrl + "/api/v1/tnt/util/find";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (idLike !== null && idLike !== undefined)
            content_.append("idLike", idLike.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFind(_response);
        });
    }

    protected processFind(response: Response): Promise<BaseResultOfTntFindResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntFindResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntFindResult>(null as any);
    }

    input(idLike: string | null | undefined): Promise<BaseResultOfTntInputResult> {
        let url_ = this.baseUrl + "/api/v1/tnt/util/input";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (idLike !== null && idLike !== undefined)
            content_.append("idLike", idLike.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInput(_response);
        });
    }

    protected processInput(response: Response): Promise<BaseResultOfTntInputResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResultOfTntInputResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResultOfErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResultOfErrorResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResultOfTntInputResult>(null as any);
    }

    createLoginQr(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tnt/util/loginqr";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateLoginQr(_response);
        });
    }

    protected processCreateLoginQr(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createGenericQr(request: TntGenericQrRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tnt/util/genericqr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateGenericQr(_response);
        });
    }

    protected processCreateGenericQr(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class BasePoI implements IBasePoI {
    id?: string;
    creatorId?: string;
    fkAccountId?: number | undefined;
    name?: string | undefined;
    adress?: string | undefined;
    description?: string | undefined;
    lastChecked?: Date;
    type?: TypePOI;
    created?: Date;
    latitude?: number;
    longitude?: number;
    status?: string | undefined;
    locationHistory?: LocationHistoryEntry[] | undefined;

    constructor(data?: IBasePoI) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorId = _data["creatorId"];
            this.fkAccountId = _data["fkAccountId"];
            this.name = _data["name"];
            this.adress = _data["adress"];
            this.description = _data["description"];
            this.lastChecked = _data["lastChecked"] ? new Date(_data["lastChecked"].toString()) : undefined as any;
            this.type = _data["type"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.status = _data["status"];
            if (Array.isArray(_data["locationHistory"])) {
                this.locationHistory = [] as any;
                for (let item of _data["locationHistory"])
                    this.locationHistory!.push(LocationHistoryEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BasePoI {
        data = typeof data === 'object' ? data : {};
        let result = new BasePoI();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorId"] = this.creatorId;
        data["fkAccountId"] = this.fkAccountId;
        data["name"] = this.name;
        data["adress"] = this.adress;
        data["description"] = this.description;
        data["lastChecked"] = this.lastChecked ? this.lastChecked.toISOString() : undefined as any;
        data["type"] = this.type;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["status"] = this.status;
        if (Array.isArray(this.locationHistory)) {
            data["locationHistory"] = [];
            for (let item of this.locationHistory)
                data["locationHistory"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BasePoI {
        const json = this.toJSON();
        let result = new BasePoI();
        result.init(json);
        return result;
    }
}

export interface IBasePoI {
    id?: string;
    creatorId?: string;
    fkAccountId?: number | undefined;
    name?: string | undefined;
    adress?: string | undefined;
    description?: string | undefined;
    lastChecked?: Date;
    type?: TypePOI;
    created?: Date;
    latitude?: number;
    longitude?: number;
    status?: string | undefined;
    locationHistory?: LocationHistoryEntry[] | undefined;
}

export enum TypePOI {
    Waterpoint = 0,
    FireAlarmSystem = 1,
    Resource = 2,
    ObjectPlan = 3,
    User = 4,
}

export class LocationHistoryEntry implements ILocationHistoryEntry {
    dateTime?: Date;
    latitude?: number;
    longitude?: number;

    constructor(data?: ILocationHistoryEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : undefined as any;
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): LocationHistoryEntry {
        data = typeof data === 'object' ? data : {};
        let result = new LocationHistoryEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : undefined as any;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }

    clone(): LocationHistoryEntry {
        const json = this.toJSON();
        let result = new LocationHistoryEntry();
        result.init(json);
        return result;
    }
}

export interface ILocationHistoryEntry {
    dateTime?: Date;
    latitude?: number;
    longitude?: number;
}

export class BaseResultOfErrorResult implements IBaseResultOfErrorResult {
    id?: number;
    isOk?: boolean;
    result?: ErrorResult | undefined;

    constructor(data?: IBaseResultOfErrorResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? ErrorResult.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfErrorResult {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfErrorResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfErrorResult {
        const json = this.toJSON();
        let result = new BaseResultOfErrorResult();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfErrorResult {
    id?: number;
    isOk?: boolean;
    result?: ErrorResult | undefined;
}

export class ErrorResult implements IErrorResult {
    id?: number;
    status?: number;
    errorMsg?: string | undefined;

    constructor(data?: IErrorResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.errorMsg = _data["errorMsg"];
        }
    }

    static fromJS(data: any): ErrorResult {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["errorMsg"] = this.errorMsg;
        return data;
    }

    clone(): ErrorResult {
        const json = this.toJSON();
        let result = new ErrorResult();
        result.init(json);
        return result;
    }
}

export interface IErrorResult {
    id?: number;
    status?: number;
    errorMsg?: string | undefined;
}

/** Poiquery carries the query and param for the api request */
export class POIQuery implements IPOIQuery {
    maxCnt?: number;
    v?: number;
    param?: POIQueryParam | undefined;

    constructor(data?: IPOIQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxCnt = _data["maxCnt"];
            this.v = _data["v"];
            this.param = _data["param"] ? POIQueryParam.fromJS(_data["param"]) : undefined as any;
        }
    }

    static fromJS(data: any): POIQuery {
        data = typeof data === 'object' ? data : {};
        let result = new POIQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxCnt"] = this.maxCnt;
        data["v"] = this.v;
        data["param"] = this.param ? this.param.toJSON() : undefined as any;
        return data;
    }

    clone(): POIQuery {
        const json = this.toJSON();
        let result = new POIQuery();
        result.init(json);
        return result;
    }
}

/** Poiquery carries the query and param for the api request */
export interface IPOIQuery {
    maxCnt?: number;
    v?: number;
    param?: POIQueryParam | undefined;
}

/** Param class for future usages, no worries about older app versions */
export class POIQueryParam implements IPOIQueryParam {
    isUserPOIOnly?: boolean;
    isShowSharedPoI?: boolean;
    historyMinDate?: Date | undefined;
    historyMaxDate?: Date | undefined;

    constructor(data?: IPOIQueryParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isUserPOIOnly = _data["isUserPOIOnly"];
            this.isShowSharedPoI = _data["isShowSharedPoI"];
            this.historyMinDate = _data["historyMinDate"] ? new Date(_data["historyMinDate"].toString()) : undefined as any;
            this.historyMaxDate = _data["historyMaxDate"] ? new Date(_data["historyMaxDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): POIQueryParam {
        data = typeof data === 'object' ? data : {};
        let result = new POIQueryParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isUserPOIOnly"] = this.isUserPOIOnly;
        data["isShowSharedPoI"] = this.isShowSharedPoI;
        data["historyMinDate"] = this.historyMinDate ? this.historyMinDate.toISOString() : undefined as any;
        data["historyMaxDate"] = this.historyMaxDate ? this.historyMaxDate.toISOString() : undefined as any;
        return data;
    }

    clone(): POIQueryParam {
        const json = this.toJSON();
        let result = new POIQueryParam();
        result.init(json);
        return result;
    }
}

/** Param class for future usages, no worries about older app versions */
export interface IPOIQueryParam {
    isUserPOIOnly?: boolean;
    isShowSharedPoI?: boolean;
    historyMinDate?: Date | undefined;
    historyMaxDate?: Date | undefined;
}

export class SettingItem implements ISettingItem {
    /** Gets/sets the internal id. */
    internalId?: string;
    /** Gets/sets the display name. */
    name?: string;
    /** Gets/sets the optional CSS class. */
    css?: string;
    /** Gets/sets the policy needed to see this item. */
    policy?: string;
    /** Gets/sets an additional condition on whether to show the menu item */
    condition?: FuncOfClaimsPrincipalAndBoolean;
    /** Is it enabled */
    isChecked?: boolean;
    value?: string;
    valueMisc?: string;
    /** Shows default value of platform */
    default?: string;
    /** Used to show a status of the setting item, e.g. "Not set" or "Set", or "Connected" or "Not connected" */
    status?: string | undefined;
    /** Indicates if the status is OK */
    isStatusOk?: boolean | undefined;
    type?: SettingItemType;
    /** Gets/sets the optional category for grouping. */
    category?: string;
    /** Helpt text for setting item, can be used for tooltip or description */
    helpText?: string;
    /** Optional byte payload or stream wrapper if the image is uploaded via memory/file stream directly */
    imageBytes?: string | undefined;
    imageFilename?: string | undefined;
    /** Indicates if the image should be removed */
    removeImage?: boolean;

    constructor(data?: ISettingItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalId = _data["internalId"];
            this.name = _data["name"];
            this.css = _data["css"];
            this.policy = _data["policy"];
            this.condition = _data["condition"] ? FuncOfClaimsPrincipalAndBoolean.fromJS(_data["condition"]) : undefined as any;
            this.isChecked = _data["isChecked"];
            this.value = _data["value"];
            this.valueMisc = _data["valueMisc"];
            this.default = _data["default"];
            this.status = _data["status"];
            this.isStatusOk = _data["isStatusOk"];
            this.type = _data["type"];
            this.category = _data["category"];
            this.helpText = _data["helpText"];
            this.imageBytes = _data["imageBytes"];
            this.imageFilename = _data["imageFilename"];
            this.removeImage = _data["removeImage"];
        }
    }

    static fromJS(data: any): SettingItem {
        data = typeof data === 'object' ? data : {};
        let result = new SettingItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalId"] = this.internalId;
        data["name"] = this.name;
        data["css"] = this.css;
        data["policy"] = this.policy;
        data["condition"] = this.condition ? this.condition.toJSON() : undefined as any;
        data["isChecked"] = this.isChecked;
        data["value"] = this.value;
        data["valueMisc"] = this.valueMisc;
        data["default"] = this.default;
        data["status"] = this.status;
        data["isStatusOk"] = this.isStatusOk;
        data["type"] = this.type;
        data["category"] = this.category;
        data["helpText"] = this.helpText;
        data["imageBytes"] = this.imageBytes;
        data["imageFilename"] = this.imageFilename;
        data["removeImage"] = this.removeImage;
        return data;
    }

    clone(): SettingItem {
        const json = this.toJSON();
        let result = new SettingItem();
        result.init(json);
        return result;
    }
}

export interface ISettingItem {
    /** Gets/sets the internal id. */
    internalId?: string;
    /** Gets/sets the display name. */
    name?: string;
    /** Gets/sets the optional CSS class. */
    css?: string;
    /** Gets/sets the policy needed to see this item. */
    policy?: string;
    /** Gets/sets an additional condition on whether to show the menu item */
    condition?: FuncOfClaimsPrincipalAndBoolean;
    /** Is it enabled */
    isChecked?: boolean;
    value?: string;
    valueMisc?: string;
    /** Shows default value of platform */
    default?: string;
    /** Used to show a status of the setting item, e.g. "Not set" or "Set", or "Connected" or "Not connected" */
    status?: string | undefined;
    /** Indicates if the status is OK */
    isStatusOk?: boolean | undefined;
    type?: SettingItemType;
    /** Gets/sets the optional category for grouping. */
    category?: string;
    /** Helpt text for setting item, can be used for tooltip or description */
    helpText?: string;
    /** Optional byte payload or stream wrapper if the image is uploaded via memory/file stream directly */
    imageBytes?: string | undefined;
    imageFilename?: string | undefined;
    /** Indicates if the image should be removed */
    removeImage?: boolean;
}

export abstract class Delegate implements IDelegate {
    target?: any | undefined;
    method?: MethodInfo;

    constructor(data?: IDelegate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.target = _data["target"];
            this.method = _data["method"] ? MethodInfo.fromJS(_data["method"]) : undefined as any;
        }
    }

    static fromJS(data: any): Delegate {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Delegate' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["target"] = this.target;
        data["method"] = this.method ? this.method.toJSON() : undefined as any;
        return data;
    }

    clone(): Delegate {
        throw new Error("The abstract class 'Delegate' cannot be instantiated.");
    }
}

export interface IDelegate {
    target?: any | undefined;
    method?: MethodInfo;
}

export abstract class MulticastDelegate extends Delegate implements IMulticastDelegate {

    constructor(data?: IMulticastDelegate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MulticastDelegate {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MulticastDelegate' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): MulticastDelegate {
        throw new Error("The abstract class 'MulticastDelegate' cannot be instantiated.");
    }
}

export interface IMulticastDelegate extends IDelegate {
}

export class FuncOfClaimsPrincipalAndBoolean extends MulticastDelegate implements IFuncOfClaimsPrincipalAndBoolean {

    constructor(data?: IFuncOfClaimsPrincipalAndBoolean) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): FuncOfClaimsPrincipalAndBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new FuncOfClaimsPrincipalAndBoolean();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): FuncOfClaimsPrincipalAndBoolean {
        const json = this.toJSON();
        let result = new FuncOfClaimsPrincipalAndBoolean();
        result.init(json);
        return result;
    }
}

export interface IFuncOfClaimsPrincipalAndBoolean extends IMulticastDelegate {
}

export abstract class MemberInfo implements IMemberInfo {
    module?: Module;
    customAttributes?: CustomAttributeData[];
    isCollectible?: boolean;
    metadataToken?: number;

    constructor(data?: IMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined as any;
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    this.customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            this.isCollectible = _data["isCollectible"];
            this.metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): MemberInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MemberInfo' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["module"] = this.module ? this.module.toJSON() : undefined as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }

    clone(): MemberInfo {
        throw new Error("The abstract class 'MemberInfo' cannot be instantiated.");
    }
}

export interface IMemberInfo {
    module?: Module;
    customAttributes?: CustomAttributeData[];
    isCollectible?: boolean;
    metadataToken?: number;
}

export abstract class MethodBase extends MemberInfo implements IMethodBase {
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    isAbstract?: boolean;
    isConstructor?: boolean;
    isFinal?: boolean;
    isHideBySig?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isVirtual?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isConstructedGenericMethod?: boolean;
    isGenericMethod?: boolean;
    isGenericMethodDefinition?: boolean;
    containsGenericParameters?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;

    constructor(data?: IMethodBase) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            this.isAbstract = _data["isAbstract"];
            this.isConstructor = _data["isConstructor"];
            this.isFinal = _data["isFinal"];
            this.isHideBySig = _data["isHideBySig"];
            this.isSpecialName = _data["isSpecialName"];
            this.isStatic = _data["isStatic"];
            this.isVirtual = _data["isVirtual"];
            this.isAssembly = _data["isAssembly"];
            this.isFamily = _data["isFamily"];
            this.isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            this.isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            this.isPrivate = _data["isPrivate"];
            this.isPublic = _data["isPublic"];
            this.isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            this.isGenericMethod = _data["isGenericMethod"];
            this.isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            this.containsGenericParameters = _data["containsGenericParameters"];
            this.isSecurityCritical = _data["isSecurityCritical"];
            this.isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            this.isSecurityTransparent = _data["isSecurityTransparent"];
        }
    }

    static override fromJS(data: any): MethodBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MethodBase' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        super.toJSON(data);
        return data;
    }

    clone(): MethodBase {
        throw new Error("The abstract class 'MethodBase' cannot be instantiated.");
    }
}

export interface IMethodBase extends IMemberInfo {
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    isAbstract?: boolean;
    isConstructor?: boolean;
    isFinal?: boolean;
    isHideBySig?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isVirtual?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isConstructedGenericMethod?: boolean;
    isGenericMethod?: boolean;
    isGenericMethodDefinition?: boolean;
    containsGenericParameters?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
}

export abstract class MethodInfo extends MethodBase implements IMethodInfo {
    memberType?: MemberTypes;
    returnParameter?: ParameterInfo;
    returnType?: string;

    constructor(data?: IMethodInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.memberType = _data["memberType"];
            this.returnParameter = _data["returnParameter"] ? ParameterInfo.fromJS(_data["returnParameter"]) : undefined as any;
            this.returnType = _data["returnType"];
        }
    }

    static override fromJS(data: any): MethodInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MethodInfo' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["returnParameter"] = this.returnParameter ? this.returnParameter.toJSON() : undefined as any;
        data["returnType"] = this.returnType;
        super.toJSON(data);
        return data;
    }

    clone(): MethodInfo {
        throw new Error("The abstract class 'MethodInfo' cannot be instantiated.");
    }
}

export interface IMethodInfo extends IMethodBase {
    memberType?: MemberTypes;
    returnParameter?: ParameterInfo;
    returnType?: string;
}

export enum MemberTypes {
    Constructor = 1,
    Event = 2,
    Field = 4,
    Method = 8,
    Property = 16,
    TypeInfo = 32,
    Custom = 64,
    NestedType = 128,
    All = 191,
}

export class ParameterInfo implements IParameterInfo {
    attributes?: ParameterAttributes;
    member?: MemberInfo;
    name?: string | undefined;
    parameterType?: string;
    position?: number;
    isIn?: boolean;
    isLcid?: boolean;
    isOptional?: boolean;
    isOut?: boolean;
    isRetval?: boolean;
    defaultValue?: any | undefined;
    rawDefaultValue?: any | undefined;
    hasDefaultValue?: boolean;
    customAttributes?: CustomAttributeData[];
    metadataToken?: number;

    constructor(data?: IParameterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributes = _data["attributes"];
            this.member = _data["member"] ? MemberInfo.fromJS(_data["member"]) : undefined as any;
            this.name = _data["name"];
            this.parameterType = _data["parameterType"];
            this.position = _data["position"];
            this.isIn = _data["isIn"];
            this.isLcid = _data["isLcid"];
            this.isOptional = _data["isOptional"];
            this.isOut = _data["isOut"];
            this.isRetval = _data["isRetval"];
            this.defaultValue = _data["defaultValue"];
            this.rawDefaultValue = _data["rawDefaultValue"];
            this.hasDefaultValue = _data["hasDefaultValue"];
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    this.customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            this.metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): ParameterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes;
        data["member"] = this.member ? this.member.toJSON() : undefined as any;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType;
        data["position"] = this.position;
        data["isIn"] = this.isIn;
        data["isLcid"] = this.isLcid;
        data["isOptional"] = this.isOptional;
        data["isOut"] = this.isOut;
        data["isRetval"] = this.isRetval;
        data["defaultValue"] = this.defaultValue;
        data["rawDefaultValue"] = this.rawDefaultValue;
        data["hasDefaultValue"] = this.hasDefaultValue;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }

    clone(): ParameterInfo {
        const json = this.toJSON();
        let result = new ParameterInfo();
        result.init(json);
        return result;
    }
}

export interface IParameterInfo {
    attributes?: ParameterAttributes;
    member?: MemberInfo;
    name?: string | undefined;
    parameterType?: string;
    position?: number;
    isIn?: boolean;
    isLcid?: boolean;
    isOptional?: boolean;
    isOut?: boolean;
    isRetval?: boolean;
    defaultValue?: any | undefined;
    rawDefaultValue?: any | undefined;
    hasDefaultValue?: boolean;
    customAttributes?: CustomAttributeData[];
    metadataToken?: number;
}

export enum ParameterAttributes {
    None = 0,
    In = 1,
    Out = 2,
    Lcid = 4,
    Retval = 8,
    Optional = 16,
    HasDefault = 4096,
    HasFieldMarshal = 8192,
    Reserved3 = 16384,
    Reserved4 = 32768,
    ReservedMask = 61440,
}

export abstract class Module implements IModule {
    assembly?: Assembly;
    fullyQualifiedName?: string;
    name?: string;
    mdStreamVersion?: number;
    moduleVersionId?: string;
    scopeName?: string;
    moduleHandle?: ModuleHandle;
    customAttributes?: CustomAttributeData[];
    metadataToken?: number;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : undefined as any;
            this.fullyQualifiedName = _data["fullyQualifiedName"];
            this.name = _data["name"];
            this.mdStreamVersion = _data["mdStreamVersion"];
            this.moduleVersionId = _data["moduleVersionId"];
            this.scopeName = _data["scopeName"];
            this.moduleHandle = _data["moduleHandle"] ? ModuleHandle.fromJS(_data["moduleHandle"]) : undefined as any;
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    this.customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            this.metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Module' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assembly"] = this.assembly ? this.assembly.toJSON() : undefined as any;
        data["fullyQualifiedName"] = this.fullyQualifiedName;
        data["name"] = this.name;
        data["mdStreamVersion"] = this.mdStreamVersion;
        data["moduleVersionId"] = this.moduleVersionId;
        data["scopeName"] = this.scopeName;
        data["moduleHandle"] = this.moduleHandle ? this.moduleHandle.toJSON() : undefined as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }

    clone(): Module {
        throw new Error("The abstract class 'Module' cannot be instantiated.");
    }
}

export interface IModule {
    assembly?: Assembly;
    fullyQualifiedName?: string;
    name?: string;
    mdStreamVersion?: number;
    moduleVersionId?: string;
    scopeName?: string;
    moduleHandle?: ModuleHandle;
    customAttributes?: CustomAttributeData[];
    metadataToken?: number;
}

export abstract class Assembly implements IAssembly {
    definedTypes?: string[];
    exportedTypes?: string[];
    codeBase?: string | undefined;
    entryPoint?: MethodInfo | undefined;
    fullName?: string | undefined;
    imageRuntimeVersion?: string;
    isDynamic?: boolean;
    location?: string;
    reflectionOnly?: boolean;
    isCollectible?: boolean;
    isFullyTrusted?: boolean;
    customAttributes?: CustomAttributeData[];
    escapedCodeBase?: string;
    manifestModule?: Module;
    modules?: Module[];
    globalAssemblyCache?: boolean;
    hostContext?: number;
    securityRuleSet?: SecurityRuleSet;

    constructor(data?: IAssembly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["definedTypes"])) {
                this.definedTypes = [] as any;
                for (let item of _data["definedTypes"])
                    this.definedTypes!.push(item);
            }
            if (Array.isArray(_data["exportedTypes"])) {
                this.exportedTypes = [] as any;
                for (let item of _data["exportedTypes"])
                    this.exportedTypes!.push(item);
            }
            this.codeBase = _data["codeBase"];
            this.entryPoint = _data["entryPoint"] ? MethodInfo.fromJS(_data["entryPoint"]) : undefined as any;
            this.fullName = _data["fullName"];
            this.imageRuntimeVersion = _data["imageRuntimeVersion"];
            this.isDynamic = _data["isDynamic"];
            this.location = _data["location"];
            this.reflectionOnly = _data["reflectionOnly"];
            this.isCollectible = _data["isCollectible"];
            this.isFullyTrusted = _data["isFullyTrusted"];
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    this.customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            this.escapedCodeBase = _data["escapedCodeBase"];
            this.manifestModule = _data["manifestModule"] ? Module.fromJS(_data["manifestModule"]) : undefined as any;
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules!.push(Module.fromJS(item));
            }
            this.globalAssemblyCache = _data["globalAssemblyCache"];
            this.hostContext = _data["hostContext"];
            this.securityRuleSet = _data["securityRuleSet"];
        }
    }

    static fromJS(data: any): Assembly {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Assembly' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definedTypes)) {
            data["definedTypes"] = [];
            for (let item of this.definedTypes)
                data["definedTypes"].push(item);
        }
        if (Array.isArray(this.exportedTypes)) {
            data["exportedTypes"] = [];
            for (let item of this.exportedTypes)
                data["exportedTypes"].push(item);
        }
        data["codeBase"] = this.codeBase;
        data["entryPoint"] = this.entryPoint ? this.entryPoint.toJSON() : undefined as any;
        data["fullName"] = this.fullName;
        data["imageRuntimeVersion"] = this.imageRuntimeVersion;
        data["isDynamic"] = this.isDynamic;
        data["location"] = this.location;
        data["reflectionOnly"] = this.reflectionOnly;
        data["isCollectible"] = this.isCollectible;
        data["isFullyTrusted"] = this.isFullyTrusted;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["escapedCodeBase"] = this.escapedCodeBase;
        data["manifestModule"] = this.manifestModule ? this.manifestModule.toJSON() : undefined as any;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item ? item.toJSON() : undefined as any);
        }
        data["globalAssemblyCache"] = this.globalAssemblyCache;
        data["hostContext"] = this.hostContext;
        data["securityRuleSet"] = this.securityRuleSet;
        return data;
    }

    clone(): Assembly {
        throw new Error("The abstract class 'Assembly' cannot be instantiated.");
    }
}

export interface IAssembly {
    definedTypes?: string[];
    exportedTypes?: string[];
    codeBase?: string | undefined;
    entryPoint?: MethodInfo | undefined;
    fullName?: string | undefined;
    imageRuntimeVersion?: string;
    isDynamic?: boolean;
    location?: string;
    reflectionOnly?: boolean;
    isCollectible?: boolean;
    isFullyTrusted?: boolean;
    customAttributes?: CustomAttributeData[];
    escapedCodeBase?: string;
    manifestModule?: Module;
    modules?: Module[];
    globalAssemblyCache?: boolean;
    hostContext?: number;
    securityRuleSet?: SecurityRuleSet;
}

export class CustomAttributeData implements ICustomAttributeData {
    attributeType?: string;
    constructor_?: ConstructorInfo;
    constructorArguments?: CustomAttributeTypedArgument[];
    namedArguments?: CustomAttributeNamedArgument[];

    constructor(data?: ICustomAttributeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeType = _data["attributeType"];
            this.constructor_ = _data["constructor"] ? ConstructorInfo.fromJS(_data["constructor"]) : undefined as any;
            if (Array.isArray(_data["constructorArguments"])) {
                this.constructorArguments = [] as any;
                for (let item of _data["constructorArguments"])
                    this.constructorArguments!.push(CustomAttributeTypedArgument.fromJS(item));
            }
            if (Array.isArray(_data["namedArguments"])) {
                this.namedArguments = [] as any;
                for (let item of _data["namedArguments"])
                    this.namedArguments!.push(CustomAttributeNamedArgument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomAttributeData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeType"] = this.attributeType;
        data["constructor"] = this.constructor_ ? this.constructor_.toJSON() : undefined as any;
        if (Array.isArray(this.constructorArguments)) {
            data["constructorArguments"] = [];
            for (let item of this.constructorArguments)
                data["constructorArguments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.namedArguments)) {
            data["namedArguments"] = [];
            for (let item of this.namedArguments)
                data["namedArguments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CustomAttributeData {
        const json = this.toJSON();
        let result = new CustomAttributeData();
        result.init(json);
        return result;
    }
}

export interface ICustomAttributeData {
    attributeType?: string;
    constructor_?: ConstructorInfo;
    constructorArguments?: CustomAttributeTypedArgument[];
    namedArguments?: CustomAttributeNamedArgument[];
}

export abstract class ConstructorInfo extends MethodBase implements IConstructorInfo {
    memberType?: MemberTypes;

    constructor(data?: IConstructorInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.memberType = _data["memberType"];
        }
    }

    static override fromJS(data: any): ConstructorInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ConstructorInfo' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        super.toJSON(data);
        return data;
    }

    clone(): ConstructorInfo {
        throw new Error("The abstract class 'ConstructorInfo' cannot be instantiated.");
    }
}

export interface IConstructorInfo extends IMethodBase {
    memberType?: MemberTypes;
}

export enum MethodImplAttributes {
    IL = 0,
    Managed = 0,
    Native = 1,
    OPTIL = 2,
    CodeTypeMask = 3,
    Runtime = 3,
    ManagedMask = 4,
    Unmanaged = 4,
    NoInlining = 8,
    ForwardRef = 16,
    Synchronized = 32,
    NoOptimization = 64,
    PreserveSig = 128,
    AggressiveInlining = 256,
    AggressiveOptimization = 512,
    InternalCall = 4096,
    MaxMethodImplVal = 65535,
}

export enum CallingConventions {
    Standard = 1,
    VarArgs = 2,
    Any = 3,
    HasThis = 32,
    ExplicitThis = 64,
}

export class CustomAttributeTypedArgument implements ICustomAttributeTypedArgument {
    argumentType?: string;
    value?: any | undefined;

    constructor(data?: ICustomAttributeTypedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.argumentType = _data["argumentType"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CustomAttributeTypedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeTypedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["argumentType"] = this.argumentType;
        data["value"] = this.value;
        return data;
    }

    clone(): CustomAttributeTypedArgument {
        const json = this.toJSON();
        let result = new CustomAttributeTypedArgument();
        result.init(json);
        return result;
    }
}

export interface ICustomAttributeTypedArgument {
    argumentType?: string;
    value?: any | undefined;
}

export class CustomAttributeNamedArgument implements ICustomAttributeNamedArgument {
    memberInfo?: MemberInfo;
    typedValue?: CustomAttributeTypedArgument;
    memberName?: string;
    isField?: boolean;

    constructor(data?: ICustomAttributeNamedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberInfo = _data["memberInfo"] ? MemberInfo.fromJS(_data["memberInfo"]) : undefined as any;
            this.typedValue = _data["typedValue"] ? CustomAttributeTypedArgument.fromJS(_data["typedValue"]) : undefined as any;
            this.memberName = _data["memberName"];
            this.isField = _data["isField"];
        }
    }

    static fromJS(data: any): CustomAttributeNamedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeNamedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberInfo"] = this.memberInfo ? this.memberInfo.toJSON() : undefined as any;
        data["typedValue"] = this.typedValue ? this.typedValue.toJSON() : undefined as any;
        data["memberName"] = this.memberName;
        data["isField"] = this.isField;
        return data;
    }

    clone(): CustomAttributeNamedArgument {
        const json = this.toJSON();
        let result = new CustomAttributeNamedArgument();
        result.init(json);
        return result;
    }
}

export interface ICustomAttributeNamedArgument {
    memberInfo?: MemberInfo;
    typedValue?: CustomAttributeTypedArgument;
    memberName?: string;
    isField?: boolean;
}

export enum SecurityRuleSet {
    None = 0,
    Level1 = 1,
    Level2 = 2,
}

export class ModuleHandle implements IModuleHandle {
    mdStreamVersion?: number;

    constructor(data?: IModuleHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mdStreamVersion = _data["mdStreamVersion"];
        }
    }

    static fromJS(data: any): ModuleHandle {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mdStreamVersion"] = this.mdStreamVersion;
        return data;
    }

    clone(): ModuleHandle {
        const json = this.toJSON();
        let result = new ModuleHandle();
        result.init(json);
        return result;
    }
}

export interface IModuleHandle {
    mdStreamVersion?: number;
}

export enum SettingItemType {
    None = 0,
    Checkbox = 1,
    String = 2,
    Integer = 3,
    Html = 4,
    Image = 5,
    Xls = 6,
}

export class SettingItemUser implements ISettingItemUser {
    /** Gets/sets the internal id. */
    internalId?: string;
    /** Key used for setting storage */
    key?: string;
    /** Gets/sets the display name. */
    name?: string;
    /** Gets/sets the optional CSS class. */
    css?: string;
    /** Gets/sets the policy needed to see this item. */
    policy?: string;
    /** Gets/sets an additional condition on whether to show the menu item */
    condition?: FuncOfClaimsPrincipalAndBoolean;
    /** Is it enabled */
    isChecked?: boolean;
    value?: string;
    /** Shows default value of platform */
    default?: string;
    type?: SettingItemType2;
    /** Gets/sets the optional category for grouping. */
    category?: string;

    constructor(data?: ISettingItemUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalId = _data["internalId"];
            this.key = _data["key"];
            this.name = _data["name"];
            this.css = _data["css"];
            this.policy = _data["policy"];
            this.condition = _data["condition"] ? FuncOfClaimsPrincipalAndBoolean.fromJS(_data["condition"]) : undefined as any;
            this.isChecked = _data["isChecked"];
            this.value = _data["value"];
            this.default = _data["default"];
            this.type = _data["type"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): SettingItemUser {
        data = typeof data === 'object' ? data : {};
        let result = new SettingItemUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalId"] = this.internalId;
        data["key"] = this.key;
        data["name"] = this.name;
        data["css"] = this.css;
        data["policy"] = this.policy;
        data["condition"] = this.condition ? this.condition.toJSON() : undefined as any;
        data["isChecked"] = this.isChecked;
        data["value"] = this.value;
        data["default"] = this.default;
        data["type"] = this.type;
        data["category"] = this.category;
        return data;
    }

    clone(): SettingItemUser {
        const json = this.toJSON();
        let result = new SettingItemUser();
        result.init(json);
        return result;
    }
}

export interface ISettingItemUser {
    /** Gets/sets the internal id. */
    internalId?: string;
    /** Key used for setting storage */
    key?: string;
    /** Gets/sets the display name. */
    name?: string;
    /** Gets/sets the optional CSS class. */
    css?: string;
    /** Gets/sets the policy needed to see this item. */
    policy?: string;
    /** Gets/sets an additional condition on whether to show the menu item */
    condition?: FuncOfClaimsPrincipalAndBoolean;
    /** Is it enabled */
    isChecked?: boolean;
    value?: string;
    /** Shows default value of platform */
    default?: string;
    type?: SettingItemType2;
    /** Gets/sets the optional category for grouping. */
    category?: string;
}

export enum SettingItemType2 {
    None = 0,
    Checkbox = 1,
    String = 2,
    Integer = 3,
    Html = 4,
}

/** Response DTO for image upload operations */
export class ImageUploadResponse implements IImageUploadResponse {
    /** The unique media identifier for the uploaded image */
    mediaId?: string;
    /** URL to access the uploaded image */
    url?: string;
    /** Original filename of the uploaded image */
    filename?: string;

    constructor(data?: IImageUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mediaId = _data["mediaId"];
            this.url = _data["url"];
            this.filename = _data["filename"];
        }
    }

    static fromJS(data: any): ImageUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImageUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mediaId"] = this.mediaId;
        data["url"] = this.url;
        data["filename"] = this.filename;
        return data;
    }

    clone(): ImageUploadResponse {
        const json = this.toJSON();
        let result = new ImageUploadResponse();
        result.init(json);
        return result;
    }
}

/** Response DTO for image upload operations */
export interface IImageUploadResponse {
    /** The unique media identifier for the uploaded image */
    mediaId?: string;
    /** URL to access the uploaded image */
    url?: string;
    /** Original filename of the uploaded image */
    filename?: string;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (this.extensions as any)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (data["extensions"] as any)[key] = (this.extensions as any)[key];
            }
        }
        return data;
    }

    clone(): ProblemDetails {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export class ActivityColumns implements IActivityColumns {
    columns!: string[];

    constructor(data?: IActivityColumns) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.columns = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(item);
            }
        }
    }

    static fromJS(data: any): ActivityColumns {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityColumns();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item);
        }
        return data;
    }

    clone(): ActivityColumns {
        const json = this.toJSON();
        let result = new ActivityColumns();
        result.init(json);
        return result;
    }
}

export interface IActivityColumns {
    columns: string[];
}

export class ActivitySettings implements IActivitySettings {
    enableCreatePushNotifications!: boolean;
    enableCreateEmailNotifications!: boolean;
    enableUpdatePushNotifications!: boolean;
    enableUpdateEmailNotifications!: boolean;
    enableClosePushNotifications!: boolean;
    enableCloseEmailNotifications!: boolean;
    enableResponsbileNotifications!: boolean;
    enableInventoryDownEmailNotifications!: boolean;
    permanentSearch!: PermanentSearchParameters;

    constructor(data?: IActivitySettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.permanentSearch = new PermanentSearchParameters();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enableCreatePushNotifications = _data["enableCreatePushNotifications"];
            this.enableCreateEmailNotifications = _data["enableCreateEmailNotifications"];
            this.enableUpdatePushNotifications = _data["enableUpdatePushNotifications"];
            this.enableUpdateEmailNotifications = _data["enableUpdateEmailNotifications"];
            this.enableClosePushNotifications = _data["enableClosePushNotifications"];
            this.enableCloseEmailNotifications = _data["enableCloseEmailNotifications"];
            this.enableResponsbileNotifications = _data["enableResponsbileNotifications"];
            this.enableInventoryDownEmailNotifications = _data["enableInventoryDownEmailNotifications"];
            this.permanentSearch = _data["permanentSearch"] ? PermanentSearchParameters.fromJS(_data["permanentSearch"]) : new PermanentSearchParameters();
        }
    }

    static fromJS(data: any): ActivitySettings {
        data = typeof data === 'object' ? data : {};
        let result = new ActivitySettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enableCreatePushNotifications"] = this.enableCreatePushNotifications;
        data["enableCreateEmailNotifications"] = this.enableCreateEmailNotifications;
        data["enableUpdatePushNotifications"] = this.enableUpdatePushNotifications;
        data["enableUpdateEmailNotifications"] = this.enableUpdateEmailNotifications;
        data["enableClosePushNotifications"] = this.enableClosePushNotifications;
        data["enableCloseEmailNotifications"] = this.enableCloseEmailNotifications;
        data["enableResponsbileNotifications"] = this.enableResponsbileNotifications;
        data["enableInventoryDownEmailNotifications"] = this.enableInventoryDownEmailNotifications;
        data["permanentSearch"] = this.permanentSearch ? this.permanentSearch.toJSON() : undefined as any;
        return data;
    }

    clone(): ActivitySettings {
        const json = this.toJSON();
        let result = new ActivitySettings();
        result.init(json);
        return result;
    }
}

export interface IActivitySettings {
    enableCreatePushNotifications: boolean;
    enableCreateEmailNotifications: boolean;
    enableUpdatePushNotifications: boolean;
    enableUpdateEmailNotifications: boolean;
    enableClosePushNotifications: boolean;
    enableCloseEmailNotifications: boolean;
    enableResponsbileNotifications: boolean;
    enableInventoryDownEmailNotifications: boolean;
    permanentSearch: PermanentSearchParameters;
}

export class PermanentSearchParameters implements IPermanentSearchParameters {
    reference?: string | undefined;
    techArea?: string | undefined;
    responsibleUserId?: string | undefined;

    constructor(data?: IPermanentSearchParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference = _data["reference"];
            this.techArea = _data["techArea"];
            this.responsibleUserId = _data["responsibleUserId"];
        }
    }

    static fromJS(data: any): PermanentSearchParameters {
        data = typeof data === 'object' ? data : {};
        let result = new PermanentSearchParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference;
        data["techArea"] = this.techArea;
        data["responsibleUserId"] = this.responsibleUserId;
        return data;
    }

    clone(): PermanentSearchParameters {
        const json = this.toJSON();
        let result = new PermanentSearchParameters();
        result.init(json);
        return result;
    }
}

export interface IPermanentSearchParameters {
    reference?: string | undefined;
    techArea?: string | undefined;
    responsibleUserId?: string | undefined;
}

export class CellSettings implements ICellSettings {
    cellView!: string;
    sort?: string | undefined;

    constructor(data?: ICellSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cellView = _data["cellView"];
            this.sort = _data["sort"];
        }
    }

    static fromJS(data: any): CellSettings {
        data = typeof data === 'object' ? data : {};
        let result = new CellSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cellView"] = this.cellView;
        data["sort"] = this.sort;
        return data;
    }

    clone(): CellSettings {
        const json = this.toJSON();
        let result = new CellSettings();
        result.init(json);
        return result;
    }
}

export interface ICellSettings {
    cellView: string;
    sort?: string | undefined;
}

export class KanbanSettings implements IKanbanSettings {
    tourInitialCounter!: number;
    tourBoardExistsCounter!: number;
    tourFlowExistsCounter!: number;
    enableCardNewPushNotifications!: boolean;
    enableCardNewEmailNotifications!: boolean;
    enableCardClosedPushNotifications!: boolean;
    enableCardClosedEmailNotifications!: boolean;
    enableNotifyNewPushNotifications!: boolean;
    enableNotifyNewEmailNotifications!: boolean;
    enableResponsibleAssignedPushNotifications!: boolean;
    enableResponsibleAssignedEmailNotifications!: boolean;
    enableDescriptionEmailNotifications!: boolean;
    enableDescriptionPushNotifications!: boolean;
    enableShareInboxEmailNotifications!: boolean;
    enableShareInboxPushNotifications!: boolean;
    enableApprovalRequestPushNotifications!: boolean;
    enableApprovalRequestEmailNotifications!: boolean;
    alwaysShowMyBoards!: boolean;
    layout!: string;
    advancedUi!: boolean;
    largePdfImages!: boolean;

    constructor(data?: IKanbanSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tourInitialCounter = _data["tourInitialCounter"];
            this.tourBoardExistsCounter = _data["tourBoardExistsCounter"];
            this.tourFlowExistsCounter = _data["tourFlowExistsCounter"];
            this.enableCardNewPushNotifications = _data["enableCardNewPushNotifications"];
            this.enableCardNewEmailNotifications = _data["enableCardNewEmailNotifications"];
            this.enableCardClosedPushNotifications = _data["enableCardClosedPushNotifications"];
            this.enableCardClosedEmailNotifications = _data["enableCardClosedEmailNotifications"];
            this.enableNotifyNewPushNotifications = _data["enableNotifyNewPushNotifications"];
            this.enableNotifyNewEmailNotifications = _data["enableNotifyNewEmailNotifications"];
            this.enableResponsibleAssignedPushNotifications = _data["enableResponsibleAssignedPushNotifications"];
            this.enableResponsibleAssignedEmailNotifications = _data["enableResponsibleAssignedEmailNotifications"];
            this.enableDescriptionEmailNotifications = _data["enableDescriptionEmailNotifications"];
            this.enableDescriptionPushNotifications = _data["enableDescriptionPushNotifications"];
            this.enableShareInboxEmailNotifications = _data["enableShareInboxEmailNotifications"];
            this.enableShareInboxPushNotifications = _data["enableShareInboxPushNotifications"];
            this.enableApprovalRequestPushNotifications = _data["enableApprovalRequestPushNotifications"];
            this.enableApprovalRequestEmailNotifications = _data["enableApprovalRequestEmailNotifications"];
            this.alwaysShowMyBoards = _data["alwaysShowMyBoards"];
            this.layout = _data["layout"];
            this.advancedUi = _data["advancedUi"];
            this.largePdfImages = _data["largePdfImages"];
        }
    }

    static fromJS(data: any): KanbanSettings {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tourInitialCounter"] = this.tourInitialCounter;
        data["tourBoardExistsCounter"] = this.tourBoardExistsCounter;
        data["tourFlowExistsCounter"] = this.tourFlowExistsCounter;
        data["enableCardNewPushNotifications"] = this.enableCardNewPushNotifications;
        data["enableCardNewEmailNotifications"] = this.enableCardNewEmailNotifications;
        data["enableCardClosedPushNotifications"] = this.enableCardClosedPushNotifications;
        data["enableCardClosedEmailNotifications"] = this.enableCardClosedEmailNotifications;
        data["enableNotifyNewPushNotifications"] = this.enableNotifyNewPushNotifications;
        data["enableNotifyNewEmailNotifications"] = this.enableNotifyNewEmailNotifications;
        data["enableResponsibleAssignedPushNotifications"] = this.enableResponsibleAssignedPushNotifications;
        data["enableResponsibleAssignedEmailNotifications"] = this.enableResponsibleAssignedEmailNotifications;
        data["enableDescriptionEmailNotifications"] = this.enableDescriptionEmailNotifications;
        data["enableDescriptionPushNotifications"] = this.enableDescriptionPushNotifications;
        data["enableShareInboxEmailNotifications"] = this.enableShareInboxEmailNotifications;
        data["enableShareInboxPushNotifications"] = this.enableShareInboxPushNotifications;
        data["enableApprovalRequestPushNotifications"] = this.enableApprovalRequestPushNotifications;
        data["enableApprovalRequestEmailNotifications"] = this.enableApprovalRequestEmailNotifications;
        data["alwaysShowMyBoards"] = this.alwaysShowMyBoards;
        data["layout"] = this.layout;
        data["advancedUi"] = this.advancedUi;
        data["largePdfImages"] = this.largePdfImages;
        return data;
    }

    clone(): KanbanSettings {
        const json = this.toJSON();
        let result = new KanbanSettings();
        result.init(json);
        return result;
    }
}

export interface IKanbanSettings {
    tourInitialCounter: number;
    tourBoardExistsCounter: number;
    tourFlowExistsCounter: number;
    enableCardNewPushNotifications: boolean;
    enableCardNewEmailNotifications: boolean;
    enableCardClosedPushNotifications: boolean;
    enableCardClosedEmailNotifications: boolean;
    enableNotifyNewPushNotifications: boolean;
    enableNotifyNewEmailNotifications: boolean;
    enableResponsibleAssignedPushNotifications: boolean;
    enableResponsibleAssignedEmailNotifications: boolean;
    enableDescriptionEmailNotifications: boolean;
    enableDescriptionPushNotifications: boolean;
    enableShareInboxEmailNotifications: boolean;
    enableShareInboxPushNotifications: boolean;
    enableApprovalRequestPushNotifications: boolean;
    enableApprovalRequestEmailNotifications: boolean;
    alwaysShowMyBoards: boolean;
    layout: string;
    advancedUi: boolean;
    largePdfImages: boolean;
}

export class ChartwizardTemplates implements IChartwizardTemplates {
    templates!: ChartwizardTemplate[];

    constructor(data?: IChartwizardTemplates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.templates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates!.push(ChartwizardTemplate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChartwizardTemplates {
        data = typeof data === 'object' ? data : {};
        let result = new ChartwizardTemplates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ChartwizardTemplates {
        const json = this.toJSON();
        let result = new ChartwizardTemplates();
        result.init(json);
        return result;
    }
}

export interface IChartwizardTemplates {
    templates: ChartwizardTemplate[];
}

export class ChartwizardTemplate implements IChartwizardTemplate {
    name!: string;
    graphs!: ChartwizardTemplateGraph[];

    constructor(data?: IChartwizardTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.graphs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["graphs"])) {
                this.graphs = [] as any;
                for (let item of _data["graphs"])
                    this.graphs!.push(ChartwizardTemplateGraph.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChartwizardTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new ChartwizardTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.graphs)) {
            data["graphs"] = [];
            for (let item of this.graphs)
                data["graphs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ChartwizardTemplate {
        const json = this.toJSON();
        let result = new ChartwizardTemplate();
        result.init(json);
        return result;
    }
}

export interface IChartwizardTemplate {
    name: string;
    graphs: ChartwizardTemplateGraph[];
}

export class ChartwizardTemplateGraph implements IChartwizardTemplateGraph {
    server!: string;
    dbase!: string;
    table!: string;
    field!: string;
    start!: number;
    end!: number;
    color!: string;

    constructor(data?: IChartwizardTemplateGraph) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.server = _data["server"];
            this.dbase = _data["dbase"];
            this.table = _data["table"];
            this.field = _data["field"];
            this.start = _data["start"];
            this.end = _data["end"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): ChartwizardTemplateGraph {
        data = typeof data === 'object' ? data : {};
        let result = new ChartwizardTemplateGraph();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["server"] = this.server;
        data["dbase"] = this.dbase;
        data["table"] = this.table;
        data["field"] = this.field;
        data["start"] = this.start;
        data["end"] = this.end;
        data["color"] = this.color;
        return data;
    }

    clone(): ChartwizardTemplateGraph {
        const json = this.toJSON();
        let result = new ChartwizardTemplateGraph();
        result.init(json);
        return result;
    }
}

export interface IChartwizardTemplateGraph {
    server: string;
    dbase: string;
    table: string;
    field: string;
    start: number;
    end: number;
    color: string;
}

export class GeneralUserSettings implements IGeneralUserSettings {
    accountIdsOfInterest!: number[];

    constructor(data?: IGeneralUserSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.accountIdsOfInterest = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountIdsOfInterest"])) {
                this.accountIdsOfInterest = [] as any;
                for (let item of _data["accountIdsOfInterest"])
                    this.accountIdsOfInterest!.push(item);
            }
        }
    }

    static fromJS(data: any): GeneralUserSettings {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralUserSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountIdsOfInterest)) {
            data["accountIdsOfInterest"] = [];
            for (let item of this.accountIdsOfInterest)
                data["accountIdsOfInterest"].push(item);
        }
        return data;
    }

    clone(): GeneralUserSettings {
        const json = this.toJSON();
        let result = new GeneralUserSettings();
        result.init(json);
        return result;
    }
}

export interface IGeneralUserSettings {
    accountIdsOfInterest: number[];
}

export class Overview2DSettings implements IOverview2DSettings {
    lastSelectedMediaId?: string | undefined;

    constructor(data?: IOverview2DSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastSelectedMediaId = _data["lastSelectedMediaId"];
        }
    }

    static fromJS(data: any): Overview2DSettings {
        data = typeof data === 'object' ? data : {};
        let result = new Overview2DSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastSelectedMediaId"] = this.lastSelectedMediaId;
        return data;
    }

    clone(): Overview2DSettings {
        const json = this.toJSON();
        let result = new Overview2DSettings();
        result.init(json);
        return result;
    }
}

export interface IOverview2DSettings {
    lastSelectedMediaId?: string | undefined;
}

export class PqtConfig implements IPqtConfig {
    hiddenElements?: string[];
    hiddenFields?: string[];
    requiredFields?: string[];
    unarchivedListFields?: string[];
    archivedListFields?: string[];
    digitsOfPrecision?: number;

    constructor(data?: IPqtConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["hiddenElements"])) {
                this.hiddenElements = [] as any;
                for (let item of _data["hiddenElements"])
                    this.hiddenElements!.push(item);
            }
            if (Array.isArray(_data["hiddenFields"])) {
                this.hiddenFields = [] as any;
                for (let item of _data["hiddenFields"])
                    this.hiddenFields!.push(item);
            }
            if (Array.isArray(_data["requiredFields"])) {
                this.requiredFields = [] as any;
                for (let item of _data["requiredFields"])
                    this.requiredFields!.push(item);
            }
            if (Array.isArray(_data["unarchivedListFields"])) {
                this.unarchivedListFields = [] as any;
                for (let item of _data["unarchivedListFields"])
                    this.unarchivedListFields!.push(item);
            }
            if (Array.isArray(_data["archivedListFields"])) {
                this.archivedListFields = [] as any;
                for (let item of _data["archivedListFields"])
                    this.archivedListFields!.push(item);
            }
            this.digitsOfPrecision = _data["digitsOfPrecision"];
        }
    }

    static fromJS(data: any): PqtConfig {
        data = typeof data === 'object' ? data : {};
        let result = new PqtConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.hiddenElements)) {
            data["hiddenElements"] = [];
            for (let item of this.hiddenElements)
                data["hiddenElements"].push(item);
        }
        if (Array.isArray(this.hiddenFields)) {
            data["hiddenFields"] = [];
            for (let item of this.hiddenFields)
                data["hiddenFields"].push(item);
        }
        if (Array.isArray(this.requiredFields)) {
            data["requiredFields"] = [];
            for (let item of this.requiredFields)
                data["requiredFields"].push(item);
        }
        if (Array.isArray(this.unarchivedListFields)) {
            data["unarchivedListFields"] = [];
            for (let item of this.unarchivedListFields)
                data["unarchivedListFields"].push(item);
        }
        if (Array.isArray(this.archivedListFields)) {
            data["archivedListFields"] = [];
            for (let item of this.archivedListFields)
                data["archivedListFields"].push(item);
        }
        data["digitsOfPrecision"] = this.digitsOfPrecision;
        return data;
    }

    clone(): PqtConfig {
        const json = this.toJSON();
        let result = new PqtConfig();
        result.init(json);
        return result;
    }
}

export interface IPqtConfig {
    hiddenElements?: string[];
    hiddenFields?: string[];
    requiredFields?: string[];
    unarchivedListFields?: string[];
    archivedListFields?: string[];
    digitsOfPrecision?: number;
}

export class CreateMqttFromVisitorManagementResultParam implements ICreateMqttFromVisitorManagementResultParam {
    action?: MqttAction;
    userId?: string;

    constructor(data?: ICreateMqttFromVisitorManagementResultParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): CreateMqttFromVisitorManagementResultParam {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMqttFromVisitorManagementResultParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["userId"] = this.userId;
        return data;
    }

    clone(): CreateMqttFromVisitorManagementResultParam {
        const json = this.toJSON();
        let result = new CreateMqttFromVisitorManagementResultParam();
        result.init(json);
        return result;
    }
}

export interface ICreateMqttFromVisitorManagementResultParam {
    action?: MqttAction;
    userId?: string;
}

export enum MqttAction {
    DoNothing = 0,
    Enter = 1,
    Exit = 2,
}

export class BaseResultOfBoolean implements IBaseResultOfBoolean {
    id?: number;
    isOk?: boolean;
    result?: boolean;

    constructor(data?: IBaseResultOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): BaseResultOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result;
        return data;
    }

    clone(): BaseResultOfBoolean {
        const json = this.toJSON();
        let result = new BaseResultOfBoolean();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfBoolean {
    id?: number;
    isOk?: boolean;
    result?: boolean;
}

export class BaseResultOfAppConfig implements IBaseResultOfAppConfig {
    id?: number;
    isOk?: boolean;
    result?: AppConfig | undefined;

    constructor(data?: IBaseResultOfAppConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? AppConfig.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfAppConfig {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfAppConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfAppConfig {
        const json = this.toJSON();
        let result = new BaseResultOfAppConfig();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfAppConfig {
    id?: number;
    isOk?: boolean;
    result?: AppConfig | undefined;
}

export class AppConfig implements IAppConfig {
    key?: number;
    endpoint?: string | undefined;
    organization_name?: string | undefined;
    organization_logo?: string | undefined;
    remote_storage_configuration?: string | undefined;
    organization_activity_options?: string | undefined;

    constructor(data?: IAppConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.endpoint = _data["endpoint"];
            this.organization_name = _data["organization_name"];
            this.organization_logo = _data["organization_logo"];
            this.remote_storage_configuration = _data["remote_storage_configuration"];
            this.organization_activity_options = _data["organization_activity_options"];
        }
    }

    static fromJS(data: any): AppConfig {
        data = typeof data === 'object' ? data : {};
        let result = new AppConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["endpoint"] = this.endpoint;
        data["organization_name"] = this.organization_name;
        data["organization_logo"] = this.organization_logo;
        data["remote_storage_configuration"] = this.remote_storage_configuration;
        data["organization_activity_options"] = this.organization_activity_options;
        return data;
    }

    clone(): AppConfig {
        const json = this.toJSON();
        let result = new AppConfig();
        result.init(json);
        return result;
    }
}

export interface IAppConfig {
    key?: number;
    endpoint?: string | undefined;
    organization_name?: string | undefined;
    organization_logo?: string | undefined;
    remote_storage_configuration?: string | undefined;
    organization_activity_options?: string | undefined;
}

export class ConfigDto implements IConfigDto {
    key!: string;

    constructor(data?: IConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): ConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        return data;
    }

    clone(): ConfigDto {
        const json = this.toJSON();
        let result = new ConfigDto();
        result.init(json);
        return result;
    }
}

export interface IConfigDto {
    key: string;
}

export class AppUiConfigResponse implements IAppUiConfigResponse {
    accountId!: number;
    elementKeysToHide!: string[];
    elementKeysToShow!: string[];

    constructor(data?: IAppUiConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.elementKeysToHide = [];
            this.elementKeysToShow = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            if (Array.isArray(_data["elementKeysToHide"])) {
                this.elementKeysToHide = [] as any;
                for (let item of _data["elementKeysToHide"])
                    this.elementKeysToHide!.push(item);
            }
            if (Array.isArray(_data["elementKeysToShow"])) {
                this.elementKeysToShow = [] as any;
                for (let item of _data["elementKeysToShow"])
                    this.elementKeysToShow!.push(item);
            }
        }
    }

    static fromJS(data: any): AppUiConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AppUiConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        if (Array.isArray(this.elementKeysToHide)) {
            data["elementKeysToHide"] = [];
            for (let item of this.elementKeysToHide)
                data["elementKeysToHide"].push(item);
        }
        if (Array.isArray(this.elementKeysToShow)) {
            data["elementKeysToShow"] = [];
            for (let item of this.elementKeysToShow)
                data["elementKeysToShow"].push(item);
        }
        return data;
    }

    clone(): AppUiConfigResponse {
        const json = this.toJSON();
        let result = new AppUiConfigResponse();
        result.init(json);
        return result;
    }
}

export interface IAppUiConfigResponse {
    accountId: number;
    elementKeysToHide: string[];
    elementKeysToShow: string[];
}

export class AppSettingConfigResponse implements IAppSettingConfigResponse {
    accountId!: number;
    config!: AppSettingConfig;

    constructor(data?: IAppSettingConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.config = new AppSettingConfig();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.config = _data["config"] ? AppSettingConfig.fromJS(_data["config"]) : new AppSettingConfig();
        }
    }

    static fromJS(data: any): AppSettingConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["config"] = this.config ? this.config.toJSON() : undefined as any;
        return data;
    }

    clone(): AppSettingConfigResponse {
        const json = this.toJSON();
        let result = new AppSettingConfigResponse();
        result.init(json);
        return result;
    }
}

export interface IAppSettingConfigResponse {
    accountId: number;
    config: AppSettingConfig;
}

export class AppSettingConfig implements IAppSettingConfig {
    alwaysShowFollowupToast?: boolean;
    allowedPrinterInfo?: AllowedPrinterInfo | undefined;
    visitorManagementSettings?: VisitorManagementSettings | undefined;
    visitorManagementUserSettings?: VisitorManagementUserSettings | undefined;

    constructor(data?: IAppSettingConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alwaysShowFollowupToast = _data["alwaysShowFollowupToast"];
            this.allowedPrinterInfo = _data["allowedPrinterInfo"] ? AllowedPrinterInfo.fromJS(_data["allowedPrinterInfo"]) : undefined as any;
            this.visitorManagementSettings = _data["visitorManagementSettings"] ? VisitorManagementSettings.fromJS(_data["visitorManagementSettings"]) : undefined as any;
            this.visitorManagementUserSettings = _data["visitorManagementUserSettings"] ? VisitorManagementUserSettings.fromJS(_data["visitorManagementUserSettings"]) : undefined as any;
        }
    }

    static fromJS(data: any): AppSettingConfig {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alwaysShowFollowupToast"] = this.alwaysShowFollowupToast;
        data["allowedPrinterInfo"] = this.allowedPrinterInfo ? this.allowedPrinterInfo.toJSON() : undefined as any;
        data["visitorManagementSettings"] = this.visitorManagementSettings ? this.visitorManagementSettings.toJSON() : undefined as any;
        data["visitorManagementUserSettings"] = this.visitorManagementUserSettings ? this.visitorManagementUserSettings.toJSON() : undefined as any;
        return data;
    }

    clone(): AppSettingConfig {
        const json = this.toJSON();
        let result = new AppSettingConfig();
        result.init(json);
        return result;
    }
}

export interface IAppSettingConfig {
    alwaysShowFollowupToast?: boolean;
    allowedPrinterInfo?: AllowedPrinterInfo | undefined;
    visitorManagementSettings?: VisitorManagementSettings | undefined;
    visitorManagementUserSettings?: VisitorManagementUserSettings | undefined;
}

export class AllowedPrinterInfo implements IAllowedPrinterInfo {
    printers!: Printer[];
    allowAll!: boolean;

    constructor(data?: IAllowedPrinterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.printers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["printers"])) {
                this.printers = [] as any;
                for (let item of _data["printers"])
                    this.printers!.push(Printer.fromJS(item));
            }
            this.allowAll = _data["allowAll"];
        }
    }

    static fromJS(data: any): AllowedPrinterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AllowedPrinterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.printers)) {
            data["printers"] = [];
            for (let item of this.printers)
                data["printers"].push(item ? item.toJSON() : undefined as any);
        }
        data["allowAll"] = this.allowAll;
        return data;
    }

    clone(): AllowedPrinterInfo {
        const json = this.toJSON();
        let result = new AllowedPrinterInfo();
        result.init(json);
        return result;
    }
}

export interface IAllowedPrinterInfo {
    printers: Printer[];
    allowAll: boolean;
}

export class Printer implements IPrinter {
    name!: string;
    address!: string;
    modelType?: string | undefined;
    printerType!: MobilePrinterType;

    constructor(data?: IPrinter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"];
            this.modelType = _data["modelType"];
            this.printerType = _data["printerType"];
        }
    }

    static fromJS(data: any): Printer {
        data = typeof data === 'object' ? data : {};
        let result = new Printer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address;
        data["modelType"] = this.modelType;
        data["printerType"] = this.printerType;
        return data;
    }

    clone(): Printer {
        const json = this.toJSON();
        let result = new Printer();
        result.init(json);
        return result;
    }
}

export interface IPrinter {
    name: string;
    address: string;
    modelType?: string | undefined;
    printerType: MobilePrinterType;
}

export enum MobilePrinterType {
    Zebra = 1,
    Star = 2,
}

export class VisitorManagementSettings implements IVisitorManagementSettings {
    isKiosk?: boolean;
    isDoNotSendEmailToExternal?: boolean;
    appKioskCompletationUrl?: string | undefined;
    appKioskStart?: string | undefined;
    idleTimeInSec?: number;
    presenceEndSurveyId?: string;
    isPrintBadge?: boolean;
    badgeImageUrl?: string | undefined;
    scanNeededForEntered?: boolean;
    advanceRegistrationOnlyAllowToggleForEnableScanEntry?: boolean;
    showQrInCodeVisitorView?: boolean;
    codeVisitorViewImageUrl?: string | undefined;
    advancedRegistrationImageUrl?: string | undefined;
    advanceRegistrationOnlyNeedsApproval?: boolean;
    enableAdvanceRegistrationSurveySelectionViaGroups?: boolean;
    advanceRegistrationSurveySelectionViaGroupsMaxGroups?: number;
    advanceRegistrationExtraInfoJson?: string | undefined;
    cockpitHiddenColumns?: string | undefined;
    appKioskScreensaverImageUrl?: string | undefined;
    appKioskScreensaverLandscapeImageUrl?: string | undefined;
    appKioskScreensaverImageConstraint?: string | undefined;
    appKioskScreensaverBackgroundColor?: string | undefined;
    appKioskTopBarBackgroundColor?: string | undefined;
    appKioskBackgroundGradientColor1?: string | undefined;
    appKioskBackgroundGradientColor2?: string | undefined;
    appKioskLanguageSelectorBorderAndIconAndTextColor?: string | undefined;
    appKioskLanguageSelectorBackgroundColor?: string | undefined;
    appKioskButtonBackgroundColor?: string | undefined;
    appKioskButtonLineColor?: string | undefined;
    appKioskTextColor?: string | undefined;

    constructor(data?: IVisitorManagementSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isKiosk = _data["isKiosk"];
            this.isDoNotSendEmailToExternal = _data["isDoNotSendEmailToExternal"];
            this.appKioskCompletationUrl = _data["appKioskCompletationUrl"];
            this.appKioskStart = _data["appKioskStart"];
            this.idleTimeInSec = _data["idleTimeInSec"];
            this.presenceEndSurveyId = _data["presenceEndSurveyId"];
            this.isPrintBadge = _data["isPrintBadge"];
            this.badgeImageUrl = _data["badgeImageUrl"];
            this.scanNeededForEntered = _data["scanNeededForEntered"];
            this.advanceRegistrationOnlyAllowToggleForEnableScanEntry = _data["advanceRegistrationOnlyAllowToggleForEnableScanEntry"];
            this.showQrInCodeVisitorView = _data["showQrInCodeVisitorView"];
            this.codeVisitorViewImageUrl = _data["codeVisitorViewImageUrl"];
            this.advancedRegistrationImageUrl = _data["advancedRegistrationImageUrl"];
            this.advanceRegistrationOnlyNeedsApproval = _data["advanceRegistrationOnlyNeedsApproval"];
            this.enableAdvanceRegistrationSurveySelectionViaGroups = _data["enableAdvanceRegistrationSurveySelectionViaGroups"];
            this.advanceRegistrationSurveySelectionViaGroupsMaxGroups = _data["advanceRegistrationSurveySelectionViaGroupsMaxGroups"];
            this.advanceRegistrationExtraInfoJson = _data["advanceRegistrationExtraInfoJson"];
            this.cockpitHiddenColumns = _data["cockpitHiddenColumns"];
            this.appKioskScreensaverImageUrl = _data["appKioskScreensaverImageUrl"];
            this.appKioskScreensaverLandscapeImageUrl = _data["appKioskScreensaverLandscapeImageUrl"];
            this.appKioskScreensaverImageConstraint = _data["appKioskScreensaverImageConstraint"];
            this.appKioskScreensaverBackgroundColor = _data["appKioskScreensaverBackgroundColor"];
            this.appKioskTopBarBackgroundColor = _data["appKioskTopBarBackgroundColor"];
            this.appKioskBackgroundGradientColor1 = _data["appKioskBackgroundGradientColor1"];
            this.appKioskBackgroundGradientColor2 = _data["appKioskBackgroundGradientColor2"];
            this.appKioskLanguageSelectorBorderAndIconAndTextColor = _data["appKioskLanguageSelectorBorderAndIconAndTextColor"];
            this.appKioskLanguageSelectorBackgroundColor = _data["appKioskLanguageSelectorBackgroundColor"];
            this.appKioskButtonBackgroundColor = _data["appKioskButtonBackgroundColor"];
            this.appKioskButtonLineColor = _data["appKioskButtonLineColor"];
            this.appKioskTextColor = _data["appKioskTextColor"];
        }
    }

    static fromJS(data: any): VisitorManagementSettings {
        data = typeof data === 'object' ? data : {};
        let result = new VisitorManagementSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isKiosk"] = this.isKiosk;
        data["isDoNotSendEmailToExternal"] = this.isDoNotSendEmailToExternal;
        data["appKioskCompletationUrl"] = this.appKioskCompletationUrl;
        data["appKioskStart"] = this.appKioskStart;
        data["idleTimeInSec"] = this.idleTimeInSec;
        data["presenceEndSurveyId"] = this.presenceEndSurveyId;
        data["isPrintBadge"] = this.isPrintBadge;
        data["badgeImageUrl"] = this.badgeImageUrl;
        data["scanNeededForEntered"] = this.scanNeededForEntered;
        data["advanceRegistrationOnlyAllowToggleForEnableScanEntry"] = this.advanceRegistrationOnlyAllowToggleForEnableScanEntry;
        data["showQrInCodeVisitorView"] = this.showQrInCodeVisitorView;
        data["codeVisitorViewImageUrl"] = this.codeVisitorViewImageUrl;
        data["advancedRegistrationImageUrl"] = this.advancedRegistrationImageUrl;
        data["advanceRegistrationOnlyNeedsApproval"] = this.advanceRegistrationOnlyNeedsApproval;
        data["enableAdvanceRegistrationSurveySelectionViaGroups"] = this.enableAdvanceRegistrationSurveySelectionViaGroups;
        data["advanceRegistrationSurveySelectionViaGroupsMaxGroups"] = this.advanceRegistrationSurveySelectionViaGroupsMaxGroups;
        data["advanceRegistrationExtraInfoJson"] = this.advanceRegistrationExtraInfoJson;
        data["cockpitHiddenColumns"] = this.cockpitHiddenColumns;
        data["appKioskScreensaverImageUrl"] = this.appKioskScreensaverImageUrl;
        data["appKioskScreensaverLandscapeImageUrl"] = this.appKioskScreensaverLandscapeImageUrl;
        data["appKioskScreensaverImageConstraint"] = this.appKioskScreensaverImageConstraint;
        data["appKioskScreensaverBackgroundColor"] = this.appKioskScreensaverBackgroundColor;
        data["appKioskTopBarBackgroundColor"] = this.appKioskTopBarBackgroundColor;
        data["appKioskBackgroundGradientColor1"] = this.appKioskBackgroundGradientColor1;
        data["appKioskBackgroundGradientColor2"] = this.appKioskBackgroundGradientColor2;
        data["appKioskLanguageSelectorBorderAndIconAndTextColor"] = this.appKioskLanguageSelectorBorderAndIconAndTextColor;
        data["appKioskLanguageSelectorBackgroundColor"] = this.appKioskLanguageSelectorBackgroundColor;
        data["appKioskButtonBackgroundColor"] = this.appKioskButtonBackgroundColor;
        data["appKioskButtonLineColor"] = this.appKioskButtonLineColor;
        data["appKioskTextColor"] = this.appKioskTextColor;
        return data;
    }

    clone(): VisitorManagementSettings {
        const json = this.toJSON();
        let result = new VisitorManagementSettings();
        result.init(json);
        return result;
    }
}

export interface IVisitorManagementSettings {
    isKiosk?: boolean;
    isDoNotSendEmailToExternal?: boolean;
    appKioskCompletationUrl?: string | undefined;
    appKioskStart?: string | undefined;
    idleTimeInSec?: number;
    presenceEndSurveyId?: string;
    isPrintBadge?: boolean;
    badgeImageUrl?: string | undefined;
    scanNeededForEntered?: boolean;
    advanceRegistrationOnlyAllowToggleForEnableScanEntry?: boolean;
    showQrInCodeVisitorView?: boolean;
    codeVisitorViewImageUrl?: string | undefined;
    advancedRegistrationImageUrl?: string | undefined;
    advanceRegistrationOnlyNeedsApproval?: boolean;
    enableAdvanceRegistrationSurveySelectionViaGroups?: boolean;
    advanceRegistrationSurveySelectionViaGroupsMaxGroups?: number;
    advanceRegistrationExtraInfoJson?: string | undefined;
    cockpitHiddenColumns?: string | undefined;
    appKioskScreensaverImageUrl?: string | undefined;
    appKioskScreensaverLandscapeImageUrl?: string | undefined;
    appKioskScreensaverImageConstraint?: string | undefined;
    appKioskScreensaverBackgroundColor?: string | undefined;
    appKioskTopBarBackgroundColor?: string | undefined;
    appKioskBackgroundGradientColor1?: string | undefined;
    appKioskBackgroundGradientColor2?: string | undefined;
    appKioskLanguageSelectorBorderAndIconAndTextColor?: string | undefined;
    appKioskLanguageSelectorBackgroundColor?: string | undefined;
    appKioskButtonBackgroundColor?: string | undefined;
    appKioskButtonLineColor?: string | undefined;
    appKioskTextColor?: string | undefined;
}

export class VisitorManagementUserSettings implements IVisitorManagementUserSettings {
    showKioskRegisterOnApp?: boolean;
    showKioskScanOnApp?: boolean;

    constructor(data?: IVisitorManagementUserSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showKioskRegisterOnApp = _data["showKioskRegisterOnApp"];
            this.showKioskScanOnApp = _data["showKioskScanOnApp"];
        }
    }

    static fromJS(data: any): VisitorManagementUserSettings {
        data = typeof data === 'object' ? data : {};
        let result = new VisitorManagementUserSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showKioskRegisterOnApp"] = this.showKioskRegisterOnApp;
        data["showKioskScanOnApp"] = this.showKioskScanOnApp;
        return data;
    }

    clone(): VisitorManagementUserSettings {
        const json = this.toJSON();
        let result = new VisitorManagementUserSettings();
        result.init(json);
        return result;
    }
}

export interface IVisitorManagementUserSettings {
    showKioskRegisterOnApp?: boolean;
    showKioskScanOnApp?: boolean;
}

export class Group implements IGroup {
    id!: string;
    name!: string;
    feature!: string;
    createdOn!: Date;
    createdBy!: string;
    createdByFullName!: string;
    archived!: boolean;
    archivedOn?: Date | undefined;
    archivedBy?: string | undefined;
    userIds!: GroupUser[];
    externalUsers!: GroupUserExternal[];
    isPinned!: boolean;

    constructor(data?: IGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.userIds = [];
            this.externalUsers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.feature = _data["feature"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.createdByFullName = _data["createdByFullName"];
            this.archived = _data["archived"];
            this.archivedOn = _data["archivedOn"] ? new Date(_data["archivedOn"].toString()) : undefined as any;
            this.archivedBy = _data["archivedBy"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(GroupUser.fromJS(item));
            }
            if (Array.isArray(_data["externalUsers"])) {
                this.externalUsers = [] as any;
                for (let item of _data["externalUsers"])
                    this.externalUsers!.push(GroupUserExternal.fromJS(item));
            }
            this.isPinned = _data["isPinned"];
        }
    }

    static fromJS(data: any): Group {
        data = typeof data === 'object' ? data : {};
        let result = new Group();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["feature"] = this.feature;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["createdByFullName"] = this.createdByFullName;
        data["archived"] = this.archived;
        data["archivedOn"] = this.archivedOn ? this.archivedOn.toISOString() : undefined as any;
        data["archivedBy"] = this.archivedBy;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.externalUsers)) {
            data["externalUsers"] = [];
            for (let item of this.externalUsers)
                data["externalUsers"].push(item ? item.toJSON() : undefined as any);
        }
        data["isPinned"] = this.isPinned;
        return data;
    }

    clone(): Group {
        const json = this.toJSON();
        let result = new Group();
        result.init(json);
        return result;
    }
}

export interface IGroup {
    id: string;
    name: string;
    feature: string;
    createdOn: Date;
    createdBy: string;
    createdByFullName: string;
    archived: boolean;
    archivedOn?: Date | undefined;
    archivedBy?: string | undefined;
    userIds: GroupUser[];
    externalUsers: GroupUserExternal[];
    isPinned: boolean;
}

export class GroupUser implements IGroupUser {
    id!: number;
    groupId!: string;
    userId!: string;
    addedOn!: Date;

    constructor(data?: IGroupUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupId = _data["groupId"];
            this.userId = _data["userId"];
            this.addedOn = _data["addedOn"] ? new Date(_data["addedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GroupUser {
        data = typeof data === 'object' ? data : {};
        let result = new GroupUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupId"] = this.groupId;
        data["userId"] = this.userId;
        data["addedOn"] = this.addedOn ? this.addedOn.toISOString() : undefined as any;
        return data;
    }

    clone(): GroupUser {
        const json = this.toJSON();
        let result = new GroupUser();
        result.init(json);
        return result;
    }
}

export interface IGroupUser {
    id: number;
    groupId: string;
    userId: string;
    addedOn: Date;
}

export class GroupUserExternal implements IGroupUserExternal {
    id!: string;
    groupId!: string;
    firstName!: string;
    lastName!: string;
    salutation?: string | undefined;
    email!: string;
    company?: string | undefined;
    addedOn!: Date;
    code!: number;
    disabled!: boolean;
    mediaId?: string | undefined;
    entryScanQrCode?: string | undefined;

    constructor(data?: IGroupUserExternal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupId = _data["groupId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.salutation = _data["salutation"];
            this.email = _data["email"];
            this.company = _data["company"];
            this.addedOn = _data["addedOn"] ? new Date(_data["addedOn"].toString()) : undefined as any;
            this.code = _data["code"];
            this.disabled = _data["disabled"];
            this.mediaId = _data["mediaId"];
            this.entryScanQrCode = _data["entryScanQrCode"];
        }
    }

    static fromJS(data: any): GroupUserExternal {
        data = typeof data === 'object' ? data : {};
        let result = new GroupUserExternal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupId"] = this.groupId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["salutation"] = this.salutation;
        data["email"] = this.email;
        data["company"] = this.company;
        data["addedOn"] = this.addedOn ? this.addedOn.toISOString() : undefined as any;
        data["code"] = this.code;
        data["disabled"] = this.disabled;
        data["mediaId"] = this.mediaId;
        data["entryScanQrCode"] = this.entryScanQrCode;
        return data;
    }

    clone(): GroupUserExternal {
        const json = this.toJSON();
        let result = new GroupUserExternal();
        result.init(json);
        return result;
    }
}

export interface IGroupUserExternal {
    id: string;
    groupId: string;
    firstName: string;
    lastName: string;
    salutation?: string | undefined;
    email: string;
    company?: string | undefined;
    addedOn: Date;
    code: number;
    disabled: boolean;
    mediaId?: string | undefined;
    entryScanQrCode?: string | undefined;
}

export class ListItem implements IListItem {
    id?: string;
    userName?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    general?: string | undefined;
    roles?: string[] | undefined;

    constructor(data?: IListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.general = _data["general"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): ListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["general"] = this.general;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }

    clone(): ListItem {
        const json = this.toJSON();
        let result = new ListItem();
        result.init(json);
        return result;
    }
}

export interface IListItem {
    id?: string;
    userName?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    general?: string | undefined;
    roles?: string[] | undefined;
}

export class PivotTableReportConfig implements IPivotTableReportConfig {
    cubeName?: string | undefined;
    accountIds?: number[] | undefined;
    rows?: Dimension[] | undefined;
    columns?: Dimension[] | undefined;
    measures?: Measure[] | undefined;
    subtotalColumns?: boolean;
    subtotalRows?: boolean;
    grandTotal?: boolean;
    totalsRow?: boolean;
    totalsColumn?: boolean;
    limitRows?: number | undefined;
    limitColumns?: number | undefined;
    orderBy?: OrderOptions | undefined;
    filter?: string | undefined;
    columnPage?: Page | undefined;
    rowPage?: Page | undefined;
    expandCollapse?: ExpandCollapseOptions | undefined;
    start?: number | undefined;
    end?: number | undefined;
    translations?: { [key: string]: string; } | undefined;

    constructor(data?: IPivotTableReportConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cubeName = _data["cubeName"];
            if (Array.isArray(_data["accountIds"])) {
                this.accountIds = [] as any;
                for (let item of _data["accountIds"])
                    this.accountIds!.push(item);
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(Dimension.fromJS(item));
            }
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(Dimension.fromJS(item));
            }
            if (Array.isArray(_data["measures"])) {
                this.measures = [] as any;
                for (let item of _data["measures"])
                    this.measures!.push(Measure.fromJS(item));
            }
            this.subtotalColumns = _data["subtotalColumns"];
            this.subtotalRows = _data["subtotalRows"];
            this.grandTotal = _data["grandTotal"];
            this.totalsRow = _data["totalsRow"];
            this.totalsColumn = _data["totalsColumn"];
            this.limitRows = _data["limitRows"];
            this.limitColumns = _data["limitColumns"];
            this.orderBy = _data["orderBy"] ? OrderOptions.fromJS(_data["orderBy"]) : undefined as any;
            this.filter = _data["filter"];
            this.columnPage = _data["columnPage"] ? Page.fromJS(_data["columnPage"]) : undefined as any;
            this.rowPage = _data["rowPage"] ? Page.fromJS(_data["rowPage"]) : undefined as any;
            this.expandCollapse = _data["expandCollapse"] ? ExpandCollapseOptions.fromJS(_data["expandCollapse"]) : undefined as any;
            this.start = _data["start"];
            this.end = _data["end"];
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (this.translations as any)![key] = _data["translations"][key];
                }
            }
        }
    }

    static fromJS(data: any): PivotTableReportConfig {
        data = typeof data === 'object' ? data : {};
        let result = new PivotTableReportConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cubeName"] = this.cubeName;
        if (Array.isArray(this.accountIds)) {
            data["accountIds"] = [];
            for (let item of this.accountIds)
                data["accountIds"].push(item);
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.measures)) {
            data["measures"] = [];
            for (let item of this.measures)
                data["measures"].push(item ? item.toJSON() : undefined as any);
        }
        data["subtotalColumns"] = this.subtotalColumns;
        data["subtotalRows"] = this.subtotalRows;
        data["grandTotal"] = this.grandTotal;
        data["totalsRow"] = this.totalsRow;
        data["totalsColumn"] = this.totalsColumn;
        data["limitRows"] = this.limitRows;
        data["limitColumns"] = this.limitColumns;
        data["orderBy"] = this.orderBy ? this.orderBy.toJSON() : undefined as any;
        data["filter"] = this.filter;
        data["columnPage"] = this.columnPage ? this.columnPage.toJSON() : undefined as any;
        data["rowPage"] = this.rowPage ? this.rowPage.toJSON() : undefined as any;
        data["expandCollapse"] = this.expandCollapse ? this.expandCollapse.toJSON() : undefined as any;
        data["start"] = this.start;
        data["end"] = this.end;
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (data["translations"] as any)[key] = (this.translations as any)[key];
            }
        }
        return data;
    }

    clone(): PivotTableReportConfig {
        const json = this.toJSON();
        let result = new PivotTableReportConfig();
        result.init(json);
        return result;
    }
}

export interface IPivotTableReportConfig {
    cubeName?: string | undefined;
    accountIds?: number[] | undefined;
    rows?: Dimension[] | undefined;
    columns?: Dimension[] | undefined;
    measures?: Measure[] | undefined;
    subtotalColumns?: boolean;
    subtotalRows?: boolean;
    grandTotal?: boolean;
    totalsRow?: boolean;
    totalsColumn?: boolean;
    limitRows?: number | undefined;
    limitColumns?: number | undefined;
    orderBy?: OrderOptions | undefined;
    filter?: string | undefined;
    columnPage?: Page | undefined;
    rowPage?: Page | undefined;
    expandCollapse?: ExpandCollapseOptions | undefined;
    start?: number | undefined;
    end?: number | undefined;
    translations?: { [key: string]: string; } | undefined;
}

export class Dimension implements IDimension {
    name?: string | undefined;

    constructor(data?: IDimension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Dimension {
        data = typeof data === 'object' ? data : {};
        let result = new Dimension();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }

    clone(): Dimension {
        const json = this.toJSON();
        let result = new Dimension();
        result.init(json);
        return result;
    }
}

export interface IDimension {
    name?: string | undefined;
}

export class Measure implements IMeasure {
    name?: string | undefined;
    percentage?: PercentageMode | undefined;
    difference?: DifferenceMode | undefined;
    runningTotal?: Direction | undefined;
    differenceAsPercentage?: boolean;
    heatmap?: HeatmapMode | undefined;

    constructor(data?: IMeasure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.percentage = _data["percentage"];
            this.difference = _data["difference"];
            this.runningTotal = _data["runningTotal"];
            this.differenceAsPercentage = _data["differenceAsPercentage"];
            this.heatmap = _data["heatmap"];
        }
    }

    static fromJS(data: any): Measure {
        data = typeof data === 'object' ? data : {};
        let result = new Measure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["percentage"] = this.percentage;
        data["difference"] = this.difference;
        data["runningTotal"] = this.runningTotal;
        data["differenceAsPercentage"] = this.differenceAsPercentage;
        data["heatmap"] = this.heatmap;
        return data;
    }

    clone(): Measure {
        const json = this.toJSON();
        let result = new Measure();
        result.init(json);
        return result;
    }
}

export interface IMeasure {
    name?: string | undefined;
    percentage?: PercentageMode | undefined;
    difference?: DifferenceMode | undefined;
    runningTotal?: Direction | undefined;
    differenceAsPercentage?: boolean;
    heatmap?: HeatmapMode | undefined;
}

/** Specifies the mode of a percentage calculation. */
export enum PercentageMode {
    GrandTotal = 0,
    RowTotal = 1,
    ColumnTotal = 2,
}

/** Specifies the mode of a difference calculation. */
export enum DifferenceMode {
    PreviousRow = 0,
    NextRow = 1,
    PreviousColumn = 2,
    NextColumn = 3,
}

/** Specifies the direction of running value. */
export enum Direction {
    Column = 0,
    Row = 1,
}

/** Specifies heatmap highlighting mode. */
export enum HeatmapMode {
    Table = 0,
    Row = 1,
    Column = 2,
    RowTotal = 3,
    ColumnTotal = 4,
}

export class OrderOptions implements IOrderOptions {
    dimensions?: AxisKeysOrder[] | undefined;
    values?: AxisValuesOrder | undefined;
    preserveGroupOrder?: boolean;

    constructor(data?: IOrderOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dimensions"])) {
                this.dimensions = [] as any;
                for (let item of _data["dimensions"])
                    this.dimensions!.push(AxisKeysOrder.fromJS(item));
            }
            this.values = _data["values"] ? AxisValuesOrder.fromJS(_data["values"]) : undefined as any;
            this.preserveGroupOrder = _data["preserveGroupOrder"];
        }
    }

    static fromJS(data: any): OrderOptions {
        data = typeof data === 'object' ? data : {};
        let result = new OrderOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dimensions)) {
            data["dimensions"] = [];
            for (let item of this.dimensions)
                data["dimensions"].push(item ? item.toJSON() : undefined as any);
        }
        data["values"] = this.values ? this.values.toJSON() : undefined as any;
        data["preserveGroupOrder"] = this.preserveGroupOrder;
        return data;
    }

    clone(): OrderOptions {
        const json = this.toJSON();
        let result = new OrderOptions();
        result.init(json);
        return result;
    }
}

export interface IOrderOptions {
    dimensions?: AxisKeysOrder[] | undefined;
    values?: AxisValuesOrder | undefined;
    preserveGroupOrder?: boolean;
}

export class AxisKeysOrder implements IAxisKeysOrder {
    axis?: TableAxis;
    index?: number;
    direction?: ListSortDirection;

    constructor(data?: IAxisKeysOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axis = _data["axis"];
            this.index = _data["index"];
            this.direction = _data["direction"];
        }
    }

    static fromJS(data: any): AxisKeysOrder {
        data = typeof data === 'object' ? data : {};
        let result = new AxisKeysOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axis"] = this.axis;
        data["index"] = this.index;
        data["direction"] = this.direction;
        return data;
    }

    clone(): AxisKeysOrder {
        const json = this.toJSON();
        let result = new AxisKeysOrder();
        result.init(json);
        return result;
    }
}

export interface IAxisKeysOrder {
    axis?: TableAxis;
    index?: number;
    direction?: ListSortDirection;
}

export enum TableAxis {
    Rows = 0,
    Columns = 1,
}

export enum ListSortDirection {
    Ascending = 0,
    Descending = 1,
}

export class AxisValuesOrder implements IAxisValuesOrder {
    axis?: TableAxis;
    index?: number | undefined;
    subtotalLevel?: number | undefined;
    direction?: ListSortDirection;
    measure?: number | undefined;

    constructor(data?: IAxisValuesOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axis = _data["axis"];
            this.index = _data["index"];
            this.subtotalLevel = _data["subtotalLevel"];
            this.direction = _data["direction"];
            this.measure = _data["measure"];
        }
    }

    static fromJS(data: any): AxisValuesOrder {
        data = typeof data === 'object' ? data : {};
        let result = new AxisValuesOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axis"] = this.axis;
        data["index"] = this.index;
        data["subtotalLevel"] = this.subtotalLevel;
        data["direction"] = this.direction;
        data["measure"] = this.measure;
        return data;
    }

    clone(): AxisValuesOrder {
        const json = this.toJSON();
        let result = new AxisValuesOrder();
        result.init(json);
        return result;
    }
}

export interface IAxisValuesOrder {
    axis?: TableAxis;
    index?: number | undefined;
    subtotalLevel?: number | undefined;
    direction?: ListSortDirection;
    measure?: number | undefined;
}

/** Represents table segment (offset and limit). */
export class Page implements IPage {
    offset?: number;
    limit?: number;

    constructor(data?: IPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): Page {
        data = typeof data === 'object' ? data : {};
        let result = new Page();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }

    clone(): Page {
        const json = this.toJSON();
        let result = new Page();
        result.init(json);
        return result;
    }
}

/** Represents table segment (offset and limit). */
export interface IPage {
    offset?: number;
    limit?: number;
}

/** Defines configuration for CollapsePivotTable. */
export class CollapsePivotTableConfiguration implements ICollapsePivotTableConfiguration {
    /** List of expanded groups on rows. Each entry is an array of group indexes for appropriate dimensions. */
    expandedRows?: number[][] | undefined;
    /** List of expanded groups on columns. Each entry is an array of group indexes for appropriate dimensions. */
    expandedColumns?: number[][] | undefined;

    constructor(data?: ICollapsePivotTableConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["expandedRows"])) {
                this.expandedRows = [] as any;
                for (let item of _data["expandedRows"])
                    this.expandedRows!.push(item);
            }
            if (Array.isArray(_data["expandedColumns"])) {
                this.expandedColumns = [] as any;
                for (let item of _data["expandedColumns"])
                    this.expandedColumns!.push(item);
            }
        }
    }

    static fromJS(data: any): CollapsePivotTableConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new CollapsePivotTableConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expandedRows)) {
            data["expandedRows"] = [];
            for (let item of this.expandedRows)
                data["expandedRows"].push(item);
        }
        if (Array.isArray(this.expandedColumns)) {
            data["expandedColumns"] = [];
            for (let item of this.expandedColumns)
                data["expandedColumns"].push(item);
        }
        return data;
    }

    clone(): CollapsePivotTableConfiguration {
        const json = this.toJSON();
        let result = new CollapsePivotTableConfiguration();
        result.init(json);
        return result;
    }
}

/** Defines configuration for CollapsePivotTable. */
export interface ICollapsePivotTableConfiguration {
    /** List of expanded groups on rows. Each entry is an array of group indexes for appropriate dimensions. */
    expandedRows?: number[][] | undefined;
    /** List of expanded groups on columns. Each entry is an array of group indexes for appropriate dimensions. */
    expandedColumns?: number[][] | undefined;
}

export class ExpandCollapseOptions extends CollapsePivotTableConfiguration implements IExpandCollapseOptions {
    enabled?: boolean;

    constructor(data?: IExpandCollapseOptions) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.enabled = _data["enabled"];
        }
    }

    static override fromJS(data: any): ExpandCollapseOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ExpandCollapseOptions();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        super.toJSON(data);
        return data;
    }

    clone(): ExpandCollapseOptions {
        const json = this.toJSON();
        let result = new ExpandCollapseOptions();
        result.init(json);
        return result;
    }
}

export interface IExpandCollapseOptions extends ICollapsePivotTableConfiguration {
    enabled?: boolean;
}

export class PivotTemplates implements IPivotTemplates {
    templates!: PivotTemplate[];

    constructor(data?: IPivotTemplates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.templates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates!.push(PivotTemplate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PivotTemplates {
        data = typeof data === 'object' ? data : {};
        let result = new PivotTemplates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PivotTemplates {
        const json = this.toJSON();
        let result = new PivotTemplates();
        result.init(json);
        return result;
    }
}

export interface IPivotTemplates {
    templates: PivotTemplate[];
}

export class PivotTemplate implements IPivotTemplate {
    name!: string;
    json!: string;

    constructor(data?: IPivotTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.json = _data["json"];
        }
    }

    static fromJS(data: any): PivotTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new PivotTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["json"] = this.json;
        return data;
    }

    clone(): PivotTemplate {
        const json = this.toJSON();
        let result = new PivotTemplate();
        result.init(json);
        return result;
    }
}

export interface IPivotTemplate {
    name: string;
    json: string;
}

export class SaveTemplateInSubAccountsRequest implements ISaveTemplateInSubAccountsRequest {
    template!: PivotTemplate;
    accountIds!: number[];

    constructor(data?: ISaveTemplateInSubAccountsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.template = new PivotTemplate();
            this.accountIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.template = _data["template"] ? PivotTemplate.fromJS(_data["template"]) : new PivotTemplate();
            if (Array.isArray(_data["accountIds"])) {
                this.accountIds = [] as any;
                for (let item of _data["accountIds"])
                    this.accountIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveTemplateInSubAccountsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTemplateInSubAccountsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["template"] = this.template ? this.template.toJSON() : undefined as any;
        if (Array.isArray(this.accountIds)) {
            data["accountIds"] = [];
            for (let item of this.accountIds)
                data["accountIds"].push(item);
        }
        return data;
    }

    clone(): SaveTemplateInSubAccountsRequest {
        const json = this.toJSON();
        let result = new SaveTemplateInSubAccountsRequest();
        result.init(json);
        return result;
    }
}

export interface ISaveTemplateInSubAccountsRequest {
    template: PivotTemplate;
    accountIds: number[];
}

export class GroupSurveyExtension implements IGroupSurveyExtension {
    id!: string;
    group!: Group;
    groupId!: string;
    isAdvanceRegistration!: boolean;
    enableScanEntry!: boolean;
    scanEntryStartDate?: Date | undefined;
    scanEntryEndDate?: Date | undefined;
    responsibleContactId?: string | undefined;
    responsibleFallbackContactId?: string | undefined;
    collectiveApprovalState!: ApprovalState;
    isVisitorGroup!: boolean;
    extraInfoJson!: string;
    visitorGroupNames!: string[];
    surveyMappings!: GroupSurveyMapping[];
    userPresences!: GroupSurveyUserPresence[];
    approvals!: GroupSurveyExtensionApproval[];
    informationGroupMappings!: GroupSurveyExtensionInformationGroupMapping[];
    firstExternalUserFirstNameLetterAndLastName!: string;

    constructor(data?: IGroupSurveyExtension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.group = new Group();
            this.visitorGroupNames = [];
            this.surveyMappings = [];
            this.userPresences = [];
            this.approvals = [];
            this.informationGroupMappings = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.group = _data["group"] ? Group.fromJS(_data["group"]) : new Group();
            this.groupId = _data["groupId"];
            this.isAdvanceRegistration = _data["isAdvanceRegistration"];
            this.enableScanEntry = _data["enableScanEntry"];
            this.scanEntryStartDate = _data["scanEntryStartDate"] ? new Date(_data["scanEntryStartDate"].toString()) : undefined as any;
            this.scanEntryEndDate = _data["scanEntryEndDate"] ? new Date(_data["scanEntryEndDate"].toString()) : undefined as any;
            this.responsibleContactId = _data["responsibleContactId"];
            this.responsibleFallbackContactId = _data["responsibleFallbackContactId"];
            this.collectiveApprovalState = _data["collectiveApprovalState"];
            this.isVisitorGroup = _data["isVisitorGroup"];
            this.extraInfoJson = _data["extraInfoJson"];
            if (Array.isArray(_data["visitorGroupNames"])) {
                this.visitorGroupNames = [] as any;
                for (let item of _data["visitorGroupNames"])
                    this.visitorGroupNames!.push(item);
            }
            if (Array.isArray(_data["surveyMappings"])) {
                this.surveyMappings = [] as any;
                for (let item of _data["surveyMappings"])
                    this.surveyMappings!.push(GroupSurveyMapping.fromJS(item));
            }
            if (Array.isArray(_data["userPresences"])) {
                this.userPresences = [] as any;
                for (let item of _data["userPresences"])
                    this.userPresences!.push(GroupSurveyUserPresence.fromJS(item));
            }
            if (Array.isArray(_data["approvals"])) {
                this.approvals = [] as any;
                for (let item of _data["approvals"])
                    this.approvals!.push(GroupSurveyExtensionApproval.fromJS(item));
            }
            if (Array.isArray(_data["informationGroupMappings"])) {
                this.informationGroupMappings = [] as any;
                for (let item of _data["informationGroupMappings"])
                    this.informationGroupMappings!.push(GroupSurveyExtensionInformationGroupMapping.fromJS(item));
            }
            this.firstExternalUserFirstNameLetterAndLastName = _data["firstExternalUserFirstNameLetterAndLastName"];
        }
    }

    static fromJS(data: any): GroupSurveyExtension {
        data = typeof data === 'object' ? data : {};
        let result = new GroupSurveyExtension();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["group"] = this.group ? this.group.toJSON() : undefined as any;
        data["groupId"] = this.groupId;
        data["isAdvanceRegistration"] = this.isAdvanceRegistration;
        data["enableScanEntry"] = this.enableScanEntry;
        data["scanEntryStartDate"] = this.scanEntryStartDate ? this.scanEntryStartDate.toISOString() : undefined as any;
        data["scanEntryEndDate"] = this.scanEntryEndDate ? this.scanEntryEndDate.toISOString() : undefined as any;
        data["responsibleContactId"] = this.responsibleContactId;
        data["responsibleFallbackContactId"] = this.responsibleFallbackContactId;
        data["collectiveApprovalState"] = this.collectiveApprovalState;
        data["isVisitorGroup"] = this.isVisitorGroup;
        data["extraInfoJson"] = this.extraInfoJson;
        if (Array.isArray(this.visitorGroupNames)) {
            data["visitorGroupNames"] = [];
            for (let item of this.visitorGroupNames)
                data["visitorGroupNames"].push(item);
        }
        if (Array.isArray(this.surveyMappings)) {
            data["surveyMappings"] = [];
            for (let item of this.surveyMappings)
                data["surveyMappings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userPresences)) {
            data["userPresences"] = [];
            for (let item of this.userPresences)
                data["userPresences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.approvals)) {
            data["approvals"] = [];
            for (let item of this.approvals)
                data["approvals"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.informationGroupMappings)) {
            data["informationGroupMappings"] = [];
            for (let item of this.informationGroupMappings)
                data["informationGroupMappings"].push(item ? item.toJSON() : undefined as any);
        }
        data["firstExternalUserFirstNameLetterAndLastName"] = this.firstExternalUserFirstNameLetterAndLastName;
        return data;
    }

    clone(): GroupSurveyExtension {
        const json = this.toJSON();
        let result = new GroupSurveyExtension();
        result.init(json);
        return result;
    }
}

export interface IGroupSurveyExtension {
    id: string;
    group: Group;
    groupId: string;
    isAdvanceRegistration: boolean;
    enableScanEntry: boolean;
    scanEntryStartDate?: Date | undefined;
    scanEntryEndDate?: Date | undefined;
    responsibleContactId?: string | undefined;
    responsibleFallbackContactId?: string | undefined;
    collectiveApprovalState: ApprovalState;
    isVisitorGroup: boolean;
    extraInfoJson: string;
    visitorGroupNames: string[];
    surveyMappings: GroupSurveyMapping[];
    userPresences: GroupSurveyUserPresence[];
    approvals: GroupSurveyExtensionApproval[];
    informationGroupMappings: GroupSurveyExtensionInformationGroupMapping[];
    firstExternalUserFirstNameLetterAndLastName: string;
}

export enum ApprovalState {
    NotRequired = 0,
    Approved = 1,
    Rejected = 2,
    Unknown = 3,
}

export class GroupSurveyMapping implements IGroupSurveyMapping {
    id!: string;
    groupSurveyExtensionId!: string;
    surveyId!: string;

    constructor(data?: IGroupSurveyMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupSurveyExtensionId = _data["groupSurveyExtensionId"];
            this.surveyId = _data["surveyId"];
        }
    }

    static fromJS(data: any): GroupSurveyMapping {
        data = typeof data === 'object' ? data : {};
        let result = new GroupSurveyMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupSurveyExtensionId"] = this.groupSurveyExtensionId;
        data["surveyId"] = this.surveyId;
        return data;
    }

    clone(): GroupSurveyMapping {
        const json = this.toJSON();
        let result = new GroupSurveyMapping();
        result.init(json);
        return result;
    }
}

export interface IGroupSurveyMapping {
    id: string;
    groupSurveyExtensionId: string;
    surveyId: string;
}

export class GroupSurveyUserPresence implements IGroupSurveyUserPresence {
    id!: string;
    groupSurveyExtensionId!: string;
    groupUserExternalId?: string | undefined;
    userId?: string | undefined;
    startAt!: Date;
    startBy!: string;
    endAt?: Date | undefined;
    endBy?: string | undefined;

    constructor(data?: IGroupSurveyUserPresence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupSurveyExtensionId = _data["groupSurveyExtensionId"];
            this.groupUserExternalId = _data["groupUserExternalId"];
            this.userId = _data["userId"];
            this.startAt = _data["startAt"] ? new Date(_data["startAt"].toString()) : undefined as any;
            this.startBy = _data["startBy"];
            this.endAt = _data["endAt"] ? new Date(_data["endAt"].toString()) : undefined as any;
            this.endBy = _data["endBy"];
        }
    }

    static fromJS(data: any): GroupSurveyUserPresence {
        data = typeof data === 'object' ? data : {};
        let result = new GroupSurveyUserPresence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupSurveyExtensionId"] = this.groupSurveyExtensionId;
        data["groupUserExternalId"] = this.groupUserExternalId;
        data["userId"] = this.userId;
        data["startAt"] = this.startAt ? this.startAt.toISOString() : undefined as any;
        data["startBy"] = this.startBy;
        data["endAt"] = this.endAt ? this.endAt.toISOString() : undefined as any;
        data["endBy"] = this.endBy;
        return data;
    }

    clone(): GroupSurveyUserPresence {
        const json = this.toJSON();
        let result = new GroupSurveyUserPresence();
        result.init(json);
        return result;
    }
}

export interface IGroupSurveyUserPresence {
    id: string;
    groupSurveyExtensionId: string;
    groupUserExternalId?: string | undefined;
    userId?: string | undefined;
    startAt: Date;
    startBy: string;
    endAt?: Date | undefined;
    endBy?: string | undefined;
}

export class GroupSurveyExtensionApproval implements IGroupSurveyExtensionApproval {
    id!: string;
    groupSurveyExtensionId!: string;
    approvalState!: ApprovalState;
    approvalGroupId!: string;
    approvedByContactId?: string | undefined;
    approvedAt?: Date | undefined;

    constructor(data?: IGroupSurveyExtensionApproval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupSurveyExtensionId = _data["groupSurveyExtensionId"];
            this.approvalState = _data["approvalState"];
            this.approvalGroupId = _data["approvalGroupId"];
            this.approvedByContactId = _data["approvedByContactId"];
            this.approvedAt = _data["approvedAt"] ? new Date(_data["approvedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GroupSurveyExtensionApproval {
        data = typeof data === 'object' ? data : {};
        let result = new GroupSurveyExtensionApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupSurveyExtensionId"] = this.groupSurveyExtensionId;
        data["approvalState"] = this.approvalState;
        data["approvalGroupId"] = this.approvalGroupId;
        data["approvedByContactId"] = this.approvedByContactId;
        data["approvedAt"] = this.approvedAt ? this.approvedAt.toISOString() : undefined as any;
        return data;
    }

    clone(): GroupSurveyExtensionApproval {
        const json = this.toJSON();
        let result = new GroupSurveyExtensionApproval();
        result.init(json);
        return result;
    }
}

export interface IGroupSurveyExtensionApproval {
    id: string;
    groupSurveyExtensionId: string;
    approvalState: ApprovalState;
    approvalGroupId: string;
    approvedByContactId?: string | undefined;
    approvedAt?: Date | undefined;
}

export class GroupSurveyExtensionInformationGroupMapping implements IGroupSurveyExtensionInformationGroupMapping {
    id!: string;
    groupSurveyExtensionId!: string;
    informationGroupId!: string;

    constructor(data?: IGroupSurveyExtensionInformationGroupMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupSurveyExtensionId = _data["groupSurveyExtensionId"];
            this.informationGroupId = _data["informationGroupId"];
        }
    }

    static fromJS(data: any): GroupSurveyExtensionInformationGroupMapping {
        data = typeof data === 'object' ? data : {};
        let result = new GroupSurveyExtensionInformationGroupMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupSurveyExtensionId"] = this.groupSurveyExtensionId;
        data["informationGroupId"] = this.informationGroupId;
        return data;
    }

    clone(): GroupSurveyExtensionInformationGroupMapping {
        const json = this.toJSON();
        let result = new GroupSurveyExtensionInformationGroupMapping();
        result.init(json);
        return result;
    }
}

export interface IGroupSurveyExtensionInformationGroupMapping {
    id: string;
    groupSurveyExtensionId: string;
    informationGroupId: string;
}

export class SurveyResultMeta implements ISurveyResultMeta {
    surveyId!: string;
    surveyName!: string;
    surveyNames!: { [key: string]: string; };
    userId?: string | undefined;
    userFirstname!: string;
    userLastname!: string;
    userEmail!: string;
    userCompany!: string;
    resultId?: number | undefined;
    date?: Date | undefined;
    passed!: boolean;
    validInPeriod!: boolean;
    validTil?: Date | undefined;

    constructor(data?: ISurveyResultMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.surveyNames = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.surveyName = _data["surveyName"];
            if (_data["surveyNames"]) {
                this.surveyNames = {} as any;
                for (let key in _data["surveyNames"]) {
                    if (_data["surveyNames"].hasOwnProperty(key))
                        (this.surveyNames as any)![key] = _data["surveyNames"][key];
                }
            }
            this.userId = _data["userId"];
            this.userFirstname = _data["userFirstname"];
            this.userLastname = _data["userLastname"];
            this.userEmail = _data["userEmail"];
            this.userCompany = _data["userCompany"];
            this.resultId = _data["resultId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.passed = _data["passed"];
            this.validInPeriod = _data["validInPeriod"];
            this.validTil = _data["validTil"] ? new Date(_data["validTil"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SurveyResultMeta {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResultMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["surveyName"] = this.surveyName;
        if (this.surveyNames) {
            data["surveyNames"] = {};
            for (let key in this.surveyNames) {
                if (this.surveyNames.hasOwnProperty(key))
                    (data["surveyNames"] as any)[key] = (this.surveyNames as any)[key];
            }
        }
        data["userId"] = this.userId;
        data["userFirstname"] = this.userFirstname;
        data["userLastname"] = this.userLastname;
        data["userEmail"] = this.userEmail;
        data["userCompany"] = this.userCompany;
        data["resultId"] = this.resultId;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["passed"] = this.passed;
        data["validInPeriod"] = this.validInPeriod;
        data["validTil"] = this.validTil ? this.validTil.toISOString() : undefined as any;
        return data;
    }

    clone(): SurveyResultMeta {
        const json = this.toJSON();
        let result = new SurveyResultMeta();
        result.init(json);
        return result;
    }
}

export interface ISurveyResultMeta {
    surveyId: string;
    surveyName: string;
    surveyNames: { [key: string]: string; };
    userId?: string | undefined;
    userFirstname: string;
    userLastname: string;
    userEmail: string;
    userCompany: string;
    resultId?: number | undefined;
    date?: Date | undefined;
    passed: boolean;
    validInPeriod: boolean;
    validTil?: Date | undefined;
}

export class TitleAndContent implements ITitleAndContent {
    title!: string;
    content!: string;

    constructor(data?: ITitleAndContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): TitleAndContent {
        data = typeof data === 'object' ? data : {};
        let result = new TitleAndContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["content"] = this.content;
        return data;
    }

    clone(): TitleAndContent {
        const json = this.toJSON();
        let result = new TitleAndContent();
        result.init(json);
        return result;
    }
}

export interface ITitleAndContent {
    title: string;
    content: string;
}

export class PreviewUserMailRequest implements IPreviewUserMailRequest {
    userId!: string;
    templateName?: string | undefined;

    constructor(data?: IPreviewUserMailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.templateName = _data["templateName"];
        }
    }

    static fromJS(data: any): PreviewUserMailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewUserMailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["templateName"] = this.templateName;
        return data;
    }

    clone(): PreviewUserMailRequest {
        const json = this.toJSON();
        let result = new PreviewUserMailRequest();
        result.init(json);
        return result;
    }
}

export interface IPreviewUserMailRequest {
    userId: string;
    templateName?: string | undefined;
}

export class PreviewExternalUserMailRequest implements IPreviewExternalUserMailRequest {
    externalUserId!: string;
    templateName?: string | undefined;

    constructor(data?: IPreviewExternalUserMailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalUserId = _data["externalUserId"];
            this.templateName = _data["templateName"];
        }
    }

    static fromJS(data: any): PreviewExternalUserMailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewExternalUserMailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalUserId"] = this.externalUserId;
        data["templateName"] = this.templateName;
        return data;
    }

    clone(): PreviewExternalUserMailRequest {
        const json = this.toJSON();
        let result = new PreviewExternalUserMailRequest();
        result.init(json);
        return result;
    }
}

export interface IPreviewExternalUserMailRequest {
    externalUserId: string;
    templateName?: string | undefined;
}

export class SendUserMailRequest implements ISendUserMailRequest {
    userId!: string;
    templateName?: string | undefined;
    titleAndContent?: TitleAndContent | undefined;

    constructor(data?: ISendUserMailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.templateName = _data["templateName"];
            this.titleAndContent = _data["titleAndContent"] ? TitleAndContent.fromJS(_data["titleAndContent"]) : undefined as any;
        }
    }

    static fromJS(data: any): SendUserMailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendUserMailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["templateName"] = this.templateName;
        data["titleAndContent"] = this.titleAndContent ? this.titleAndContent.toJSON() : undefined as any;
        return data;
    }

    clone(): SendUserMailRequest {
        const json = this.toJSON();
        let result = new SendUserMailRequest();
        result.init(json);
        return result;
    }
}

export interface ISendUserMailRequest {
    userId: string;
    templateName?: string | undefined;
    titleAndContent?: TitleAndContent | undefined;
}

export class SendExternalUserMailRequest implements ISendExternalUserMailRequest {
    externalUserId!: string;
    templateName?: string | undefined;
    titleAndContent?: TitleAndContent | undefined;
    recipientContactId?: string | undefined;

    constructor(data?: ISendExternalUserMailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalUserId = _data["externalUserId"];
            this.templateName = _data["templateName"];
            this.titleAndContent = _data["titleAndContent"] ? TitleAndContent.fromJS(_data["titleAndContent"]) : undefined as any;
            this.recipientContactId = _data["recipientContactId"];
        }
    }

    static fromJS(data: any): SendExternalUserMailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendExternalUserMailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalUserId"] = this.externalUserId;
        data["templateName"] = this.templateName;
        data["titleAndContent"] = this.titleAndContent ? this.titleAndContent.toJSON() : undefined as any;
        data["recipientContactId"] = this.recipientContactId;
        return data;
    }

    clone(): SendExternalUserMailRequest {
        const json = this.toJSON();
        let result = new SendExternalUserMailRequest();
        result.init(json);
        return result;
    }
}

export interface ISendExternalUserMailRequest {
    externalUserId: string;
    templateName?: string | undefined;
    titleAndContent?: TitleAndContent | undefined;
    recipientContactId?: string | undefined;
}

export class PresenceStartRequest implements IPresenceStartRequest {
    userId?: string | undefined;
    externalUserId?: string | undefined;

    constructor(data?: IPresenceStartRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.externalUserId = _data["externalUserId"];
        }
    }

    static fromJS(data: any): PresenceStartRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PresenceStartRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["externalUserId"] = this.externalUserId;
        return data;
    }

    clone(): PresenceStartRequest {
        const json = this.toJSON();
        let result = new PresenceStartRequest();
        result.init(json);
        return result;
    }
}

export interface IPresenceStartRequest {
    userId?: string | undefined;
    externalUserId?: string | undefined;
}

export class PresenceEndRequest implements IPresenceEndRequest {
    id!: string;

    constructor(data?: IPresenceEndRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PresenceEndRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PresenceEndRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): PresenceEndRequest {
        const json = this.toJSON();
        let result = new PresenceEndRequest();
        result.init(json);
        return result;
    }
}

export interface IPresenceEndRequest {
    id: string;
}

export class GroupWithMetaInfo implements IGroupWithMetaInfo {
    group!: GroupSurveyExtension;
    currentOpenSurveys!: number;
    todayClosedSurveys!: number;

    constructor(data?: IGroupWithMetaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.group = new GroupSurveyExtension();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"] ? GroupSurveyExtension.fromJS(_data["group"]) : new GroupSurveyExtension();
            this.currentOpenSurveys = _data["currentOpenSurveys"];
            this.todayClosedSurveys = _data["todayClosedSurveys"];
        }
    }

    static fromJS(data: any): GroupWithMetaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new GroupWithMetaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group ? this.group.toJSON() : undefined as any;
        data["currentOpenSurveys"] = this.currentOpenSurveys;
        data["todayClosedSurveys"] = this.todayClosedSurveys;
        return data;
    }

    clone(): GroupWithMetaInfo {
        const json = this.toJSON();
        let result = new GroupWithMetaInfo();
        result.init(json);
        return result;
    }
}

export interface IGroupWithMetaInfo {
    group: GroupSurveyExtension;
    currentOpenSurveys: number;
    todayClosedSurveys: number;
}

export class FilterOption implements IFilterOption {
    column!: string;
    value!: string;
    operator?: FilterOperator;

    constructor(data?: IFilterOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.column = _data["column"];
            this.value = _data["value"];
            this.operator = _data["operator"];
        }
    }

    static fromJS(data: any): FilterOption {
        data = typeof data === 'object' ? data : {};
        let result = new FilterOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["column"] = this.column;
        data["value"] = this.value;
        data["operator"] = this.operator;
        return data;
    }

    clone(): FilterOption {
        const json = this.toJSON();
        let result = new FilterOption();
        result.init(json);
        return result;
    }
}

export interface IFilterOption {
    column: string;
    value: string;
    operator?: FilterOperator;
}

export enum FilterOperator {
    Equals = 0,
    NotEquals = 1,
    LessThan = 2,
    LessThanOrEqual = 3,
    GreaterThan = 4,
    GreaterThanOrEqual = 5,
}

export class SortOption implements ISortOption {
    column!: string;
    descending!: boolean;

    constructor(data?: ISortOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.column = _data["column"];
            this.descending = _data["descending"];
        }
    }

    static fromJS(data: any): SortOption {
        data = typeof data === 'object' ? data : {};
        let result = new SortOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["column"] = this.column;
        data["descending"] = this.descending;
        return data;
    }

    clone(): SortOption {
        const json = this.toJSON();
        let result = new SortOption();
        result.init(json);
        return result;
    }
}

export interface ISortOption {
    column: string;
    descending: boolean;
}

export class SurveyCodeStatusResponse implements ISurveyCodeStatusResponse {
    surveyResultMetas!: SurveyResultMeta[];
    entryQrCode?: string | undefined;

    constructor(data?: ISurveyCodeStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.surveyResultMetas = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["surveyResultMetas"])) {
                this.surveyResultMetas = [] as any;
                for (let item of _data["surveyResultMetas"])
                    this.surveyResultMetas!.push(SurveyResultMeta.fromJS(item));
            }
            this.entryQrCode = _data["entryQrCode"];
        }
    }

    static fromJS(data: any): SurveyCodeStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyCodeStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.surveyResultMetas)) {
            data["surveyResultMetas"] = [];
            for (let item of this.surveyResultMetas)
                data["surveyResultMetas"].push(item ? item.toJSON() : undefined as any);
        }
        data["entryQrCode"] = this.entryQrCode;
        return data;
    }

    clone(): SurveyCodeStatusResponse {
        const json = this.toJSON();
        let result = new SurveyCodeStatusResponse();
        result.init(json);
        return result;
    }
}

export interface ISurveyCodeStatusResponse {
    surveyResultMetas: SurveyResultMeta[];
    entryQrCode?: string | undefined;
}

export class SurveyCodeImage implements ISurveyCodeImage {
    url!: string;
    title!: string;

    constructor(data?: ISurveyCodeImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): SurveyCodeImage {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyCodeImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["title"] = this.title;
        return data;
    }

    clone(): SurveyCodeImage {
        const json = this.toJSON();
        let result = new SurveyCodeImage();
        result.init(json);
        return result;
    }
}

export interface ISurveyCodeImage {
    url: string;
    title: string;
}

export class SurveyCodeImageResponse extends SurveyCodeImage implements ISurveyCodeImageResponse {

    constructor(data?: ISurveyCodeImageResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SurveyCodeImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyCodeImageResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): SurveyCodeImageResponse {
        const json = this.toJSON();
        let result = new SurveyCodeImageResponse();
        result.init(json);
        return result;
    }
}

export interface ISurveyCodeImageResponse extends ISurveyCodeImage {
}

export class SurveyCodeAuthenticationRequest implements ISurveyCodeAuthenticationRequest {
    code!: number;
    firstLetterOfLastName!: string;

    constructor(data?: ISurveyCodeAuthenticationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.firstLetterOfLastName = _data["firstLetterOfLastName"];
        }
    }

    static fromJS(data: any): SurveyCodeAuthenticationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyCodeAuthenticationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["firstLetterOfLastName"] = this.firstLetterOfLastName;
        return data;
    }

    clone(): SurveyCodeAuthenticationRequest {
        const json = this.toJSON();
        let result = new SurveyCodeAuthenticationRequest();
        result.init(json);
        return result;
    }
}

export interface ISurveyCodeAuthenticationRequest {
    code: number;
    firstLetterOfLastName: string;
}

export class SurveyDto implements ISurveyDto {
    id!: string;
    name!: string;
    json!: string;
    accountId!: number;
    created!: Date;
    createdBy!: string;
    isRegisteredNeeded!: boolean;
    score!: number;
    validForSeconds?: number | undefined;
    hasContacts!: boolean;

    constructor(data?: ISurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.json = _data["json"];
            this.accountId = _data["accountId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.isRegisteredNeeded = _data["isRegisteredNeeded"];
            this.score = _data["score"];
            this.validForSeconds = _data["validForSeconds"];
            this.hasContacts = _data["hasContacts"];
        }
    }

    static fromJS(data: any): SurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["json"] = this.json;
        data["accountId"] = this.accountId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["isRegisteredNeeded"] = this.isRegisteredNeeded;
        data["score"] = this.score;
        data["validForSeconds"] = this.validForSeconds;
        data["hasContacts"] = this.hasContacts;
        return data;
    }

    clone(): SurveyDto {
        const json = this.toJSON();
        let result = new SurveyDto();
        result.init(json);
        return result;
    }
}

export interface ISurveyDto {
    id: string;
    name: string;
    json: string;
    accountId: number;
    created: Date;
    createdBy: string;
    isRegisteredNeeded: boolean;
    score: number;
    validForSeconds?: number | undefined;
    hasContacts: boolean;
}

export class SurveyView extends SurveyDto implements ISurveyView {
    contacts?: Contact[];

    constructor(data?: ISurveyView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(Contact.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SurveyView {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): SurveyView {
        const json = this.toJSON();
        let result = new SurveyView();
        result.init(json);
        return result;
    }
}

export interface ISurveyView extends ISurveyDto {
    contacts?: Contact[];
}

export class Contact implements IContact {
    id!: string;
    createdAt!: Date;
    createdBy!: string;
    updatedAt!: Date;
    updatedBy!: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    salutation?: string | undefined;
    company?: string | undefined;
    email?: string | undefined;
    tel?: string | undefined;
    region?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    mobile?: string | undefined;
    department?: string | undefined;
    position?: string | undefined;
    status?: string | undefined;
    comment?: string | undefined;
    isFoundInAd?: boolean | undefined;
    roleAccess?: string | undefined;
    ident1?: string | undefined;
    ident2?: string | undefined;
    mediaId?: string | undefined;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.salutation = _data["salutation"];
            this.company = _data["company"];
            this.email = _data["email"];
            this.tel = _data["tel"];
            this.region = _data["region"];
            this.street = _data["street"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.mobile = _data["mobile"];
            this.department = _data["department"];
            this.position = _data["position"];
            this.status = _data["status"];
            this.comment = _data["comment"];
            this.isFoundInAd = _data["isFoundInAd"];
            this.roleAccess = _data["roleAccess"];
            this.ident1 = _data["ident1"];
            this.ident2 = _data["ident2"];
            this.mediaId = _data["mediaId"];
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["salutation"] = this.salutation;
        data["company"] = this.company;
        data["email"] = this.email;
        data["tel"] = this.tel;
        data["region"] = this.region;
        data["street"] = this.street;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        data["mobile"] = this.mobile;
        data["department"] = this.department;
        data["position"] = this.position;
        data["status"] = this.status;
        data["comment"] = this.comment;
        data["isFoundInAd"] = this.isFoundInAd;
        data["roleAccess"] = this.roleAccess;
        data["ident1"] = this.ident1;
        data["ident2"] = this.ident2;
        data["mediaId"] = this.mediaId;
        return data;
    }

    clone(): Contact {
        const json = this.toJSON();
        let result = new Contact();
        result.init(json);
        return result;
    }
}

export interface IContact {
    id: string;
    createdAt: Date;
    createdBy: string;
    updatedAt: Date;
    updatedBy: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    salutation?: string | undefined;
    company?: string | undefined;
    email?: string | undefined;
    tel?: string | undefined;
    region?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    mobile?: string | undefined;
    department?: string | undefined;
    position?: string | undefined;
    status?: string | undefined;
    comment?: string | undefined;
    isFoundInAd?: boolean | undefined;
    roleAccess?: string | undefined;
    ident1?: string | undefined;
    ident2?: string | undefined;
    mediaId?: string | undefined;
}

export abstract class MediaBase implements IMediaBase {
    id?: string;
    folderId?: string | undefined;
    creatorId?: string;
    fkAccountId?: number | undefined;
    fkWaterPointId?: string | undefined;
    fkAlarmSystemId?: string | undefined;
    fkResourcePoIId?: string | undefined;
    fkObjectPlanId?: string | undefined;
    fkActivityId?: number | undefined;
    fkDutyId?: number | undefined;
    fkCellId?: number | undefined;
    type?: MediaType;
    filename!: string;
    contentType!: string;
    title?: string | undefined;
    altText?: string | undefined;
    description?: string | undefined;
    size?: number;
    publicUrl?: string | undefined;
    uri?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    created?: Date;
    lastModified?: Date;
    isPrivate?: boolean;

    constructor(data?: IMediaBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.folderId = _data["folderId"];
            this.creatorId = _data["creatorId"];
            this.fkAccountId = _data["fkAccountId"];
            this.fkWaterPointId = _data["fkWaterPointId"];
            this.fkAlarmSystemId = _data["fkAlarmSystemId"];
            this.fkResourcePoIId = _data["fkResourcePoIId"];
            this.fkObjectPlanId = _data["fkObjectPlanId"];
            this.fkActivityId = _data["fkActivityId"];
            this.fkDutyId = _data["fkDutyId"];
            this.fkCellId = _data["fkCellId"];
            this.type = _data["type"];
            this.filename = _data["filename"];
            this.contentType = _data["contentType"];
            this.title = _data["title"];
            this.altText = _data["altText"];
            this.description = _data["description"];
            this.size = _data["size"];
            this.publicUrl = _data["publicUrl"];
            this.uri = _data["uri"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.isPrivate = _data["isPrivate"];
        }
    }

    static fromJS(data: any): MediaBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MediaBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["folderId"] = this.folderId;
        data["creatorId"] = this.creatorId;
        data["fkAccountId"] = this.fkAccountId;
        data["fkWaterPointId"] = this.fkWaterPointId;
        data["fkAlarmSystemId"] = this.fkAlarmSystemId;
        data["fkResourcePoIId"] = this.fkResourcePoIId;
        data["fkObjectPlanId"] = this.fkObjectPlanId;
        data["fkActivityId"] = this.fkActivityId;
        data["fkDutyId"] = this.fkDutyId;
        data["fkCellId"] = this.fkCellId;
        data["type"] = this.type;
        data["filename"] = this.filename;
        data["contentType"] = this.contentType;
        data["title"] = this.title;
        data["altText"] = this.altText;
        data["description"] = this.description;
        data["size"] = this.size;
        data["publicUrl"] = this.publicUrl;
        data["uri"] = this.uri;
        data["width"] = this.width;
        data["height"] = this.height;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["isPrivate"] = this.isPrivate;
        return data;
    }

    clone(): MediaBase {
        throw new Error("The abstract class 'MediaBase' cannot be instantiated.");
    }
}

export interface IMediaBase {
    id?: string;
    folderId?: string | undefined;
    creatorId?: string;
    fkAccountId?: number | undefined;
    fkWaterPointId?: string | undefined;
    fkAlarmSystemId?: string | undefined;
    fkResourcePoIId?: string | undefined;
    fkObjectPlanId?: string | undefined;
    fkActivityId?: number | undefined;
    fkDutyId?: number | undefined;
    fkCellId?: number | undefined;
    type?: MediaType;
    filename: string;
    contentType: string;
    title?: string | undefined;
    altText?: string | undefined;
    description?: string | undefined;
    size?: number;
    publicUrl?: string | undefined;
    uri?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    created?: Date;
    lastModified?: Date;
    isPrivate?: boolean;
}

export class Media extends MediaBase implements IMedia {
    properties?: { [key: string]: string; } | undefined;
    versions?: MediaVersion[] | undefined;

    constructor(data?: IMedia) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (this.properties as any)![key] = _data["properties"][key];
                }
            }
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(MediaVersion.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Media {
        data = typeof data === 'object' ? data : {};
        let result = new Media();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (data["properties"] as any)[key] = (this.properties as any)[key];
            }
        }
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Media {
        const json = this.toJSON();
        let result = new Media();
        result.init(json);
        return result;
    }
}

export interface IMedia extends IMediaBase {
    properties?: { [key: string]: string; } | undefined;
    versions?: MediaVersion[] | undefined;
}

export class MediaVersion implements IMediaVersion {
    id?: string;
    creatorId?: string;
    fkAccountId?: number | undefined;
    size?: number;
    width?: number;
    height?: number | undefined;
    fileExtension?: string | undefined;

    constructor(data?: IMediaVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorId = _data["creatorId"];
            this.fkAccountId = _data["fkAccountId"];
            this.size = _data["size"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.fileExtension = _data["fileExtension"];
        }
    }

    static fromJS(data: any): MediaVersion {
        data = typeof data === 'object' ? data : {};
        let result = new MediaVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorId"] = this.creatorId;
        data["fkAccountId"] = this.fkAccountId;
        data["size"] = this.size;
        data["width"] = this.width;
        data["height"] = this.height;
        data["fileExtension"] = this.fileExtension;
        return data;
    }

    clone(): MediaVersion {
        const json = this.toJSON();
        let result = new MediaVersion();
        result.init(json);
        return result;
    }
}

export interface IMediaVersion {
    id?: string;
    creatorId?: string;
    fkAccountId?: number | undefined;
    size?: number;
    width?: number;
    height?: number | undefined;
    fileExtension?: string | undefined;
}

export enum MediaType {
    Unknown = 0,
    Document = 1,
    Image = 2,
    Video = 3,
    Audio = 4,
    Resource = 5,
}

export class CopyToRequest implements ICopyToRequest {
    id!: string;
    name!: string;
    accountIds!: number[];

    constructor(data?: ICopyToRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.accountIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["accountIds"])) {
                this.accountIds = [] as any;
                for (let item of _data["accountIds"])
                    this.accountIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CopyToRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyToRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.accountIds)) {
            data["accountIds"] = [];
            for (let item of this.accountIds)
                data["accountIds"].push(item);
        }
        return data;
    }

    clone(): CopyToRequest {
        const json = this.toJSON();
        let result = new CopyToRequest();
        result.init(json);
        return result;
    }
}

export interface ICopyToRequest {
    id: string;
    name: string;
    accountIds: number[];
}

export class VueGoodTableListOfSurveyResultView implements IVueGoodTableListOfSurveyResultView {
    data?: SurveyResultView[];
    page?: number;
    perPage?: number;
    totalRows?: number;

    constructor(data?: IVueGoodTableListOfSurveyResultView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SurveyResultView.fromJS(item));
            }
            this.page = _data["page"];
            this.perPage = _data["perPage"];
            this.totalRows = _data["totalRows"];
        }
    }

    static fromJS(data: any): VueGoodTableListOfSurveyResultView {
        data = typeof data === 'object' ? data : {};
        let result = new VueGoodTableListOfSurveyResultView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["perPage"] = this.perPage;
        data["totalRows"] = this.totalRows;
        return data;
    }

    clone(): VueGoodTableListOfSurveyResultView {
        const json = this.toJSON();
        let result = new VueGoodTableListOfSurveyResultView();
        result.init(json);
        return result;
    }
}

export interface IVueGoodTableListOfSurveyResultView {
    data?: SurveyResultView[];
    page?: number;
    perPage?: number;
    totalRows?: number;
}

export class SurveyResult implements ISurveyResult {
    id!: number;
    name!: string;
    jsonResult!: string;
    accountId!: number;
    participantFirstname!: string;
    participantLastname!: string;
    participantEmail!: string;
    participantUid?: string | undefined;
    participantCompany?: string | undefined;
    participantCity?: string | undefined;
    participantStreet?: string | undefined;
    participantZip?: string | undefined;
    startDate!: Date;
    doneDate!: Date;
    validTilSec?: number | undefined;
    isPassed!: boolean;
    isExitMark!: boolean;
    surveyId!: string;
    extraPropertiesJson!: string;
    survey?: SurveyDto | undefined;

    constructor(data?: ISurveyResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.extraPropertiesJson = "{}";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.jsonResult = _data["jsonResult"];
            this.accountId = _data["accountId"];
            this.participantFirstname = _data["participantFirstname"];
            this.participantLastname = _data["participantLastname"];
            this.participantEmail = _data["participantEmail"];
            this.participantUid = _data["participantUid"];
            this.participantCompany = _data["participantCompany"];
            this.participantCity = _data["participantCity"];
            this.participantStreet = _data["participantStreet"];
            this.participantZip = _data["participantZip"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.doneDate = _data["doneDate"] ? new Date(_data["doneDate"].toString()) : undefined as any;
            this.validTilSec = _data["validTilSec"];
            this.isPassed = _data["isPassed"];
            this.isExitMark = _data["isExitMark"];
            this.surveyId = _data["surveyId"];
            this.extraPropertiesJson = _data["extraPropertiesJson"] !== undefined ? _data["extraPropertiesJson"] : "{}";
            this.survey = _data["survey"] ? SurveyDto.fromJS(_data["survey"]) : undefined as any;
        }
    }

    static fromJS(data: any): SurveyResult {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["jsonResult"] = this.jsonResult;
        data["accountId"] = this.accountId;
        data["participantFirstname"] = this.participantFirstname;
        data["participantLastname"] = this.participantLastname;
        data["participantEmail"] = this.participantEmail;
        data["participantUid"] = this.participantUid;
        data["participantCompany"] = this.participantCompany;
        data["participantCity"] = this.participantCity;
        data["participantStreet"] = this.participantStreet;
        data["participantZip"] = this.participantZip;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["doneDate"] = this.doneDate ? this.doneDate.toISOString() : undefined as any;
        data["validTilSec"] = this.validTilSec;
        data["isPassed"] = this.isPassed;
        data["isExitMark"] = this.isExitMark;
        data["surveyId"] = this.surveyId;
        data["extraPropertiesJson"] = this.extraPropertiesJson;
        data["survey"] = this.survey ? this.survey.toJSON() : undefined as any;
        return data;
    }

    clone(): SurveyResult {
        const json = this.toJSON();
        let result = new SurveyResult();
        result.init(json);
        return result;
    }
}

export interface ISurveyResult {
    id: number;
    name: string;
    jsonResult: string;
    accountId: number;
    participantFirstname: string;
    participantLastname: string;
    participantEmail: string;
    participantUid?: string | undefined;
    participantCompany?: string | undefined;
    participantCity?: string | undefined;
    participantStreet?: string | undefined;
    participantZip?: string | undefined;
    startDate: Date;
    doneDate: Date;
    validTilSec?: number | undefined;
    isPassed: boolean;
    isExitMark: boolean;
    surveyId: string;
    extraPropertiesJson: string;
    survey?: SurveyDto | undefined;
}

export class SurveyResultView extends SurveyResult implements ISurveyResultView {
    score!: number;
    rememberCookieDueSeconds!: number;
    isKiosk!: boolean;
    uploadedMediaIds!: string[];

    constructor(data?: ISurveyResultView) {
        super(data);
        if (!data) {
            this.uploadedMediaIds = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.score = _data["score"];
            this.rememberCookieDueSeconds = _data["rememberCookieDueSeconds"];
            this.isKiosk = _data["isKiosk"];
            if (Array.isArray(_data["uploadedMediaIds"])) {
                this.uploadedMediaIds = [] as any;
                for (let item of _data["uploadedMediaIds"])
                    this.uploadedMediaIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): SurveyResultView {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResultView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        data["rememberCookieDueSeconds"] = this.rememberCookieDueSeconds;
        data["isKiosk"] = this.isKiosk;
        if (Array.isArray(this.uploadedMediaIds)) {
            data["uploadedMediaIds"] = [];
            for (let item of this.uploadedMediaIds)
                data["uploadedMediaIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): SurveyResultView {
        const json = this.toJSON();
        let result = new SurveyResultView();
        result.init(json);
        return result;
    }
}

export interface ISurveyResultView extends ISurveyResult {
    score: number;
    rememberCookieDueSeconds: number;
    isKiosk: boolean;
    uploadedMediaIds: string[];
}

export class SurveyAnswers implements ISurveyAnswers {
    name?: string;
    title?: string;
    pages?: SurveyAnswerPage[];

    constructor(data?: ISurveyAnswers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.title = _data["title"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(SurveyAnswerPage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyAnswers {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["title"] = this.title;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): SurveyAnswers {
        const json = this.toJSON();
        let result = new SurveyAnswers();
        result.init(json);
        return result;
    }
}

export interface ISurveyAnswers {
    name?: string;
    title?: string;
    pages?: SurveyAnswerPage[];
}

export class SurveyAnswerPage implements ISurveyAnswerPage {
    name?: string | undefined;
    title?: string | undefined;
    elements?: SurveyAnswerElement[];

    constructor(data?: ISurveyAnswerPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.title = _data["title"];
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(SurveyAnswerElement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyAnswerPage {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["title"] = this.title;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): SurveyAnswerPage {
        const json = this.toJSON();
        let result = new SurveyAnswerPage();
        result.init(json);
        return result;
    }
}

export interface ISurveyAnswerPage {
    name?: string | undefined;
    title?: string | undefined;
    elements?: SurveyAnswerElement[];
}

export class SurveyAnswerElement implements ISurveyAnswerElement {
    name?: string | undefined;
    title?: string | undefined;
    result?: string | undefined;
    info?: string;

    constructor(data?: ISurveyAnswerElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.title = _data["title"];
            this.result = _data["result"];
            this.info = _data["info"];
        }
    }

    static fromJS(data: any): SurveyAnswerElement {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerElement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["title"] = this.title;
        data["result"] = this.result;
        data["info"] = this.info;
        return data;
    }

    clone(): SurveyAnswerElement {
        const json = this.toJSON();
        let result = new SurveyAnswerElement();
        result.init(json);
        return result;
    }
}

export interface ISurveyAnswerElement {
    name?: string | undefined;
    title?: string | undefined;
    result?: string | undefined;
    info?: string;
}

export class SurveyResultValidityCheck implements ISurveyResultValidityCheck {
    email!: string;

    constructor(data?: ISurveyResultValidityCheck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SurveyResultValidityCheck {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResultValidityCheck();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }

    clone(): SurveyResultValidityCheck {
        const json = this.toJSON();
        let result = new SurveyResultValidityCheck();
        result.init(json);
        return result;
    }
}

export interface ISurveyResultValidityCheck {
    email: string;
}

export class SurveyUpdateRequest implements ISurveyUpdateRequest {
    id!: string;
    firstname!: string;
    lastname!: string;

    constructor(data?: ISurveyUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
        }
    }

    static fromJS(data: any): SurveyUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        return data;
    }

    clone(): SurveyUpdateRequest {
        const json = this.toJSON();
        let result = new SurveyUpdateRequest();
        result.init(json);
        return result;
    }
}

export interface ISurveyUpdateRequest {
    id: string;
    firstname: string;
    lastname: string;
}

export class ConvertReturn implements IConvertReturn {
    name!: string;
    pages!: HtmlPage[];

    constructor(data?: IConvertReturn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.pages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(HtmlPage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConvertReturn {
        data = typeof data === 'object' ? data : {};
        let result = new ConvertReturn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ConvertReturn {
        const json = this.toJSON();
        let result = new ConvertReturn();
        result.init(json);
        return result;
    }
}

export interface IConvertReturn {
    name: string;
    pages: HtmlPage[];
}

export class HtmlPage implements IHtmlPage {
    name!: string;
    htmlContent!: string;

    constructor(data?: IHtmlPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.htmlContent = _data["htmlContent"];
        }
    }

    static fromJS(data: any): HtmlPage {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["htmlContent"] = this.htmlContent;
        return data;
    }

    clone(): HtmlPage {
        const json = this.toJSON();
        let result = new HtmlPage();
        result.init(json);
        return result;
    }
}

export interface IHtmlPage {
    name: string;
    htmlContent: string;
}

export class PresenceViaQrResponse implements IPresenceViaQrResponse {
    presence!: GroupSurveyUserPresence;
    printBadge!: boolean;
    printerCommand?: string | undefined;

    constructor(data?: IPresenceViaQrResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.presence = new GroupSurveyUserPresence();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.presence = _data["presence"] ? GroupSurveyUserPresence.fromJS(_data["presence"]) : new GroupSurveyUserPresence();
            this.printBadge = _data["printBadge"];
            this.printerCommand = _data["printerCommand"];
        }
    }

    static fromJS(data: any): PresenceViaQrResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PresenceViaQrResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["presence"] = this.presence ? this.presence.toJSON() : undefined as any;
        data["printBadge"] = this.printBadge;
        data["printerCommand"] = this.printerCommand;
        return data;
    }

    clone(): PresenceViaQrResponse {
        const json = this.toJSON();
        let result = new PresenceViaQrResponse();
        result.init(json);
        return result;
    }
}

export interface IPresenceViaQrResponse {
    presence: GroupSurveyUserPresence;
    printBadge: boolean;
    printerCommand?: string | undefined;
}

export class PresenceViaQrRequest implements IPresenceViaQrRequest {
    qrCode!: string;
    printerType?: PrinterType | undefined;

    constructor(data?: IPresenceViaQrRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCode = _data["qrCode"];
            this.printerType = _data["printerType"];
        }
    }

    static fromJS(data: any): PresenceViaQrRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PresenceViaQrRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCode"] = this.qrCode;
        data["printerType"] = this.printerType;
        return data;
    }

    clone(): PresenceViaQrRequest {
        const json = this.toJSON();
        let result = new PresenceViaQrRequest();
        result.init(json);
        return result;
    }
}

export interface IPresenceViaQrRequest {
    qrCode: string;
    printerType?: PrinterType | undefined;
}

export enum PrinterType {
    ZebraZq220Plus = 0,
    Mcl32Cbi = 1,
}

export class ExternalUserFromSurveyResultRequest implements IExternalUserFromSurveyResultRequest {
    surveyResultId!: number;

    constructor(data?: IExternalUserFromSurveyResultRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyResultId = _data["surveyResultId"];
        }
    }

    static fromJS(data: any): ExternalUserFromSurveyResultRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalUserFromSurveyResultRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyResultId"] = this.surveyResultId;
        return data;
    }

    clone(): ExternalUserFromSurveyResultRequest {
        const json = this.toJSON();
        let result = new ExternalUserFromSurveyResultRequest();
        result.init(json);
        return result;
    }
}

export interface IExternalUserFromSurveyResultRequest {
    surveyResultId: number;
}

export class VisitorManagementApprovalCompleted implements IVisitorManagementApprovalCompleted {
    groupSurveyExtension!: GroupSurveyExtension;
    approval!: GroupSurveyExtensionApproval;
    alreadyCompleted?: boolean;
    approvedByContact!: Contact;

    constructor(data?: IVisitorManagementApprovalCompleted) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.groupSurveyExtension = new GroupSurveyExtension();
            this.approval = new GroupSurveyExtensionApproval();
            this.approvedByContact = new Contact();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupSurveyExtension = _data["groupSurveyExtension"] ? GroupSurveyExtension.fromJS(_data["groupSurveyExtension"]) : new GroupSurveyExtension();
            this.approval = _data["approval"] ? GroupSurveyExtensionApproval.fromJS(_data["approval"]) : new GroupSurveyExtensionApproval();
            this.alreadyCompleted = _data["alreadyCompleted"];
            this.approvedByContact = _data["approvedByContact"] ? Contact.fromJS(_data["approvedByContact"]) : new Contact();
        }
    }

    static fromJS(data: any): VisitorManagementApprovalCompleted {
        data = typeof data === 'object' ? data : {};
        let result = new VisitorManagementApprovalCompleted();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupSurveyExtension"] = this.groupSurveyExtension ? this.groupSurveyExtension.toJSON() : undefined as any;
        data["approval"] = this.approval ? this.approval.toJSON() : undefined as any;
        data["alreadyCompleted"] = this.alreadyCompleted;
        data["approvedByContact"] = this.approvedByContact ? this.approvedByContact.toJSON() : undefined as any;
        return data;
    }

    clone(): VisitorManagementApprovalCompleted {
        const json = this.toJSON();
        let result = new VisitorManagementApprovalCompleted();
        result.init(json);
        return result;
    }
}

export interface IVisitorManagementApprovalCompleted {
    groupSurveyExtension: GroupSurveyExtension;
    approval: GroupSurveyExtensionApproval;
    alreadyCompleted?: boolean;
    approvedByContact: Contact;
}

export class VisitorManagementApprovalRequest implements IVisitorManagementApprovalRequest {
    groupSurveyExtensionId!: string;
    userId?: string | undefined;
    externalUserId?: string | undefined;
    action!: ApprovalState;

    constructor(data?: IVisitorManagementApprovalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupSurveyExtensionId = _data["groupSurveyExtensionId"];
            this.userId = _data["userId"];
            this.externalUserId = _data["externalUserId"];
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): VisitorManagementApprovalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VisitorManagementApprovalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupSurveyExtensionId"] = this.groupSurveyExtensionId;
        data["userId"] = this.userId;
        data["externalUserId"] = this.externalUserId;
        data["action"] = this.action;
        return data;
    }

    clone(): VisitorManagementApprovalRequest {
        const json = this.toJSON();
        let result = new VisitorManagementApprovalRequest();
        result.init(json);
        return result;
    }
}

export interface IVisitorManagementApprovalRequest {
    groupSurveyExtensionId: string;
    userId?: string | undefined;
    externalUserId?: string | undefined;
    action: ApprovalState;
}

export class VmCockpitRow implements IVmCockpitRow {
    id!: string;
    groupSurveyExtensionId!: string;
    userId!: string;
    externalUserId!: string;
    visitorGroupNames!: string[];
    visitorGroupNamesAsString!: string;
    startDate!: Date;
    endDate!: Date;
    firstName!: string;
    lastName!: string;
    fullName!: string;
    company!: string;
    responsibleContactFirstName?: string | undefined;
    responsibleContactLastName?: string | undefined;
    responsibleContactFullName?: string | undefined;
    approvalState!: ApprovalState;
    approvalStateText!: string;
    presenceId?: string | undefined;
    checkedIn?: Date | undefined;
    checkedOut?: Date | undefined;
    presenceStatus!: CockpitPresenceStatus;
    presenceStatusText!: string;
    surveysCompleted!: boolean;
    instructionInPerson!: boolean;

    constructor(data?: IVmCockpitRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.visitorGroupNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupSurveyExtensionId = _data["groupSurveyExtensionId"];
            this.userId = _data["userId"];
            this.externalUserId = _data["externalUserId"];
            if (Array.isArray(_data["visitorGroupNames"])) {
                this.visitorGroupNames = [] as any;
                for (let item of _data["visitorGroupNames"])
                    this.visitorGroupNames!.push(item);
            }
            this.visitorGroupNamesAsString = _data["visitorGroupNamesAsString"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.company = _data["company"];
            this.responsibleContactFirstName = _data["responsibleContactFirstName"];
            this.responsibleContactLastName = _data["responsibleContactLastName"];
            this.responsibleContactFullName = _data["responsibleContactFullName"];
            this.approvalState = _data["approvalState"];
            this.approvalStateText = _data["approvalStateText"];
            this.presenceId = _data["presenceId"];
            this.checkedIn = _data["checkedIn"] ? new Date(_data["checkedIn"].toString()) : undefined as any;
            this.checkedOut = _data["checkedOut"] ? new Date(_data["checkedOut"].toString()) : undefined as any;
            this.presenceStatus = _data["presenceStatus"];
            this.presenceStatusText = _data["presenceStatusText"];
            this.surveysCompleted = _data["surveysCompleted"];
            this.instructionInPerson = _data["instructionInPerson"];
        }
    }

    static fromJS(data: any): VmCockpitRow {
        data = typeof data === 'object' ? data : {};
        let result = new VmCockpitRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupSurveyExtensionId"] = this.groupSurveyExtensionId;
        data["userId"] = this.userId;
        data["externalUserId"] = this.externalUserId;
        if (Array.isArray(this.visitorGroupNames)) {
            data["visitorGroupNames"] = [];
            for (let item of this.visitorGroupNames)
                data["visitorGroupNames"].push(item);
        }
        data["visitorGroupNamesAsString"] = this.visitorGroupNamesAsString;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["company"] = this.company;
        data["responsibleContactFirstName"] = this.responsibleContactFirstName;
        data["responsibleContactLastName"] = this.responsibleContactLastName;
        data["responsibleContactFullName"] = this.responsibleContactFullName;
        data["approvalState"] = this.approvalState;
        data["approvalStateText"] = this.approvalStateText;
        data["presenceId"] = this.presenceId;
        data["checkedIn"] = this.checkedIn ? this.checkedIn.toISOString() : undefined as any;
        data["checkedOut"] = this.checkedOut ? this.checkedOut.toISOString() : undefined as any;
        data["presenceStatus"] = this.presenceStatus;
        data["presenceStatusText"] = this.presenceStatusText;
        data["surveysCompleted"] = this.surveysCompleted;
        data["instructionInPerson"] = this.instructionInPerson;
        return data;
    }

    clone(): VmCockpitRow {
        const json = this.toJSON();
        let result = new VmCockpitRow();
        result.init(json);
        return result;
    }
}

export interface IVmCockpitRow {
    id: string;
    groupSurveyExtensionId: string;
    userId: string;
    externalUserId: string;
    visitorGroupNames: string[];
    visitorGroupNamesAsString: string;
    startDate: Date;
    endDate: Date;
    firstName: string;
    lastName: string;
    fullName: string;
    company: string;
    responsibleContactFirstName?: string | undefined;
    responsibleContactLastName?: string | undefined;
    responsibleContactFullName?: string | undefined;
    approvalState: ApprovalState;
    approvalStateText: string;
    presenceId?: string | undefined;
    checkedIn?: Date | undefined;
    checkedOut?: Date | undefined;
    presenceStatus: CockpitPresenceStatus;
    presenceStatusText: string;
    surveysCompleted: boolean;
    instructionInPerson: boolean;
}

export enum CockpitPresenceStatus {
    NotYetCheckedIn = 0,
    CheckedIn = 1,
    CheckedOut = 2,
}

export class CockpitStats implements ICockpitStats {
    from!: Date;
    to!: Date;
    checkedInCount!: number;
    totalCount!: number;

    constructor(data?: ICockpitStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.checkedInCount = _data["checkedInCount"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CockpitStats {
        data = typeof data === 'object' ? data : {};
        let result = new CockpitStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : undefined as any;
        data["to"] = this.to ? this.to.toISOString() : undefined as any;
        data["checkedInCount"] = this.checkedInCount;
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CockpitStats {
        const json = this.toJSON();
        let result = new CockpitStats();
        result.init(json);
        return result;
    }
}

export interface ICockpitStats {
    from: Date;
    to: Date;
    checkedInCount: number;
    totalCount: number;
}

export class LanguageAndResourcesVmV1 implements ILanguageAndResourcesVmV1 {
    language!: Language;
    translations!: LocaleStringResource[];

    constructor(data?: ILanguageAndResourcesVmV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.language = new Language();
            this.translations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : new Language();
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(LocaleStringResource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LanguageAndResourcesVmV1 {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageAndResourcesVmV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : undefined as any;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): LanguageAndResourcesVmV1 {
        const json = this.toJSON();
        let result = new LanguageAndResourcesVmV1();
        result.init(json);
        return result;
    }
}

export interface ILanguageAndResourcesVmV1 {
    language: Language;
    translations: LocaleStringResource[];
}

export abstract class BaseEntity implements IBaseEntity {
    id!: any;

    constructor(data?: IBaseEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BaseEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): BaseEntity {
        throw new Error("The abstract class 'BaseEntity' cannot be instantiated.");
    }
}

export interface IBaseEntity {
    id: any;
}

export abstract class BaseEntityOfInteger extends BaseEntity implements IBaseEntityOfInteger {
    id!: number;

    constructor(data?: IBaseEntityOfInteger) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): BaseEntityOfInteger {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEntityOfInteger' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }

    clone(): BaseEntityOfInteger {
        throw new Error("The abstract class 'BaseEntityOfInteger' cannot be instantiated.");
    }
}

export interface IBaseEntityOfInteger extends IBaseEntity {
    id: number;
}

export class Language extends BaseEntityOfInteger implements ILanguage {
    name?: string | undefined;
    fkAccountId?: number;
    languageCulture?: string | undefined;
    flagImageFileName?: string | undefined;
    rtl?: boolean;
    defaultCurrencyId?: number;
    published?: boolean;
    displayOrder?: number;

    constructor(data?: ILanguage) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.fkAccountId = _data["fkAccountId"];
            this.languageCulture = _data["languageCulture"];
            this.flagImageFileName = _data["flagImageFileName"];
            this.rtl = _data["rtl"];
            this.defaultCurrencyId = _data["defaultCurrencyId"];
            this.published = _data["published"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static override fromJS(data: any): Language {
        data = typeof data === 'object' ? data : {};
        let result = new Language();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["fkAccountId"] = this.fkAccountId;
        data["languageCulture"] = this.languageCulture;
        data["flagImageFileName"] = this.flagImageFileName;
        data["rtl"] = this.rtl;
        data["defaultCurrencyId"] = this.defaultCurrencyId;
        data["published"] = this.published;
        data["displayOrder"] = this.displayOrder;
        super.toJSON(data);
        return data;
    }

    clone(): Language {
        const json = this.toJSON();
        let result = new Language();
        result.init(json);
        return result;
    }
}

export interface ILanguage extends IBaseEntityOfInteger {
    name?: string | undefined;
    fkAccountId?: number;
    languageCulture?: string | undefined;
    flagImageFileName?: string | undefined;
    rtl?: boolean;
    defaultCurrencyId?: number;
    published?: boolean;
    displayOrder?: number;
}

export class LocaleStringResource extends BaseEntityOfInteger implements ILocaleStringResource {
    languageId?: number;
    resourceName?: string | undefined;
    resourceValue?: string | undefined;

    constructor(data?: ILocaleStringResource) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.resourceName = _data["resourceName"];
            this.resourceValue = _data["resourceValue"];
        }
    }

    static override fromJS(data: any): LocaleStringResource {
        data = typeof data === 'object' ? data : {};
        let result = new LocaleStringResource();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["resourceName"] = this.resourceName;
        data["resourceValue"] = this.resourceValue;
        super.toJSON(data);
        return data;
    }

    clone(): LocaleStringResource {
        const json = this.toJSON();
        let result = new LocaleStringResource();
        result.init(json);
        return result;
    }
}

export interface ILocaleStringResource extends IBaseEntityOfInteger {
    languageId?: number;
    resourceName?: string | undefined;
    resourceValue?: string | undefined;
}

export class AccountEdit implements IAccountEdit {
    treeNode?: TreeNode | undefined;
    parentList?: TreeNode[] | undefined;
    parentId?: number | undefined;
    selectedItem?: number;

    constructor(data?: IAccountEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
            if (Array.isArray(_data["parentList"])) {
                this.parentList = [] as any;
                for (let item of _data["parentList"])
                    this.parentList!.push(TreeNode.fromJS(item));
            }
            this.parentId = _data["parentId"];
            this.selectedItem = _data["selectedItem"];
        }
    }

    static fromJS(data: any): AccountEdit {
        data = typeof data === 'object' ? data : {};
        let result = new AccountEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        if (Array.isArray(this.parentList)) {
            data["parentList"] = [];
            for (let item of this.parentList)
                data["parentList"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentId"] = this.parentId;
        data["selectedItem"] = this.selectedItem;
        return data;
    }

    clone(): AccountEdit {
        const json = this.toJSON();
        let result = new AccountEdit();
        result.init(json);
        return result;
    }
}

export interface IAccountEdit {
    treeNode?: TreeNode | undefined;
    parentList?: TreeNode[] | undefined;
    parentId?: number | undefined;
    selectedItem?: number;
}

export class TreeNode implements ITreeNode {
    state?: StateStruct;
    dbId?: number;
    text?: string | undefined;
    path?: string | undefined;
    tags?: string[] | undefined;
    nodes?: TreeNode[] | undefined;
    account?: Account | undefined;

    constructor(data?: ITreeNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"] ? StateStruct.fromJS(_data["state"]) : undefined as any;
            this.dbId = _data["dbId"];
            this.text = _data["text"];
            this.path = _data["path"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["nodes"])) {
                this.nodes = [] as any;
                for (let item of _data["nodes"])
                    this.nodes!.push(TreeNode.fromJS(item));
            }
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : undefined as any;
        }
    }

    static fromJS(data: any): TreeNode {
        data = typeof data === 'object' ? data : {};
        let result = new TreeNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state ? this.state.toJSON() : undefined as any;
        data["dbId"] = this.dbId;
        data["text"] = this.text;
        data["path"] = this.path;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.nodes)) {
            data["nodes"] = [];
            for (let item of this.nodes)
                data["nodes"].push(item ? item.toJSON() : undefined as any);
        }
        data["account"] = this.account ? this.account.toJSON() : undefined as any;
        return data;
    }

    clone(): TreeNode {
        const json = this.toJSON();
        let result = new TreeNode();
        result.init(json);
        return result;
    }
}

export interface ITreeNode {
    state?: StateStruct;
    dbId?: number;
    text?: string | undefined;
    path?: string | undefined;
    tags?: string[] | undefined;
    nodes?: TreeNode[] | undefined;
    account?: Account | undefined;
}

export class StateStruct implements IStateStruct {

    constructor(data?: IStateStruct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): StateStruct {
        data = typeof data === 'object' ? data : {};
        let result = new StateStruct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): StateStruct {
        const json = this.toJSON();
        let result = new StateStruct();
        result.init(json);
        return result;
    }
}

export interface IStateStruct {
}

export class Account implements IAccount {
    accountId?: number;
    name?: string | undefined;
    isArchived?: boolean;
    companyName?: string | undefined;
    email?: string | undefined;
    adress?: string | undefined;
    maxUsers?: number;
    maxStorage?: number;
    culture?: string | undefined;
    costCenter?: string | undefined;
    licensedUsers?: number;
    timeZone!: string;

    constructor(data?: IAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.timeZone = "Europe/Vienna";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.name = _data["name"];
            this.isArchived = _data["isArchived"];
            this.companyName = _data["companyName"];
            this.email = _data["email"];
            this.adress = _data["adress"];
            this.maxUsers = _data["maxUsers"];
            this.maxStorage = _data["maxStorage"];
            this.culture = _data["culture"];
            this.costCenter = _data["costCenter"];
            this.licensedUsers = _data["licensedUsers"];
            this.timeZone = _data["timeZone"] !== undefined ? _data["timeZone"] : "Europe/Vienna";
        }
    }

    static fromJS(data: any): Account {
        data = typeof data === 'object' ? data : {};
        let result = new Account();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["name"] = this.name;
        data["isArchived"] = this.isArchived;
        data["companyName"] = this.companyName;
        data["email"] = this.email;
        data["adress"] = this.adress;
        data["maxUsers"] = this.maxUsers;
        data["maxStorage"] = this.maxStorage;
        data["culture"] = this.culture;
        data["costCenter"] = this.costCenter;
        data["licensedUsers"] = this.licensedUsers;
        data["timeZone"] = this.timeZone;
        return data;
    }

    clone(): Account {
        const json = this.toJSON();
        let result = new Account();
        result.init(json);
        return result;
    }
}

export interface IAccount {
    accountId?: number;
    name?: string | undefined;
    isArchived?: boolean;
    companyName?: string | undefined;
    email?: string | undefined;
    adress?: string | undefined;
    maxUsers?: number;
    maxStorage?: number;
    culture?: string | undefined;
    costCenter?: string | undefined;
    licensedUsers?: number;
    timeZone: string;
}

export class AccountSelect implements IAccountSelect {
    parentList?: TreeNode[] | undefined;
    selectedItem?: number;

    constructor(data?: IAccountSelect) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["parentList"])) {
                this.parentList = [] as any;
                for (let item of _data["parentList"])
                    this.parentList!.push(TreeNode.fromJS(item));
            }
            this.selectedItem = _data["selectedItem"];
        }
    }

    static fromJS(data: any): AccountSelect {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSelect();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.parentList)) {
            data["parentList"] = [];
            for (let item of this.parentList)
                data["parentList"].push(item ? item.toJSON() : undefined as any);
        }
        data["selectedItem"] = this.selectedItem;
        return data;
    }

    clone(): AccountSelect {
        const json = this.toJSON();
        let result = new AccountSelect();
        result.init(json);
        return result;
    }
}

export interface IAccountSelect {
    parentList?: TreeNode[] | undefined;
    selectedItem?: number;
}

export class OperationBase implements IOperationBase {
    path?: string | undefined;
    op?: string | undefined;
    from?: string | undefined;

    constructor(data?: IOperationBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"];
            this.op = _data["op"];
            this.from = _data["from"];
        }
    }

    static fromJS(data: any): OperationBase {
        data = typeof data === 'object' ? data : {};
        let result = new OperationBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        data["op"] = this.op;
        data["from"] = this.from;
        return data;
    }

    clone(): OperationBase {
        const json = this.toJSON();
        let result = new OperationBase();
        result.init(json);
        return result;
    }
}

export interface IOperationBase {
    path?: string | undefined;
    op?: string | undefined;
    from?: string | undefined;
}

export class Operation extends OperationBase implements IOperation {
    value?: any | undefined;

    constructor(data?: IOperation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): Operation {
        data = typeof data === 'object' ? data : {};
        let result = new Operation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): Operation {
        const json = this.toJSON();
        let result = new Operation();
        result.init(json);
        return result;
    }
}

export interface IOperation extends IOperationBase {
    value?: any | undefined;
}

/** A media item in the list view. */
export class MediaItem implements IMediaItem {
    /** Gets/sets the unique id. */
    id?: string;
    /** Gets/sets the optional folder id. */
    folderId?: string | undefined;
    /** Gets/sets the media type. */
    type?: string | undefined;
    /** Gets/sets the filename of the uploaded media. */
    filename?: string | undefined;
    /** Gets/sets the content type of the uploaded media. */
    contentType?: string | undefined;
    /** Gets/sets the optional title. */
    title?: string | undefined;
    /** Gets/sets the optional alt text. */
    altText?: string | undefined;
    /** Gets/sets the optional description. */
    description?: string | undefined;
    /** Gets/sets the optional properties. */
    properties?: KeyValuePairOfStringAndString[] | undefined;
    /** Gets/sets the public url used to access the uploaded media. */
    publicUrl?: string | undefined;
    /** Gets/sets the file size in bytes. */
    size?: number;
    /** Gets/sets the  */
    sizePrettyPrint?: string | undefined;
    /** Gets/sets the optional width. */
    width?: number | undefined;
    /** Gets/sets the optional height. */
    height?: number | undefined;
    /** An optional version url for a different size when requested via the list api call on the MediaApiController. Only use when expecting this call. */
    altVersionUrl?: string | undefined;
    /** Gets/sets the last modification date. */
    lastModified?: string | undefined;

    constructor(data?: IMediaItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.folderId = _data["folderId"];
            this.type = _data["type"];
            this.filename = _data["filename"];
            this.contentType = _data["contentType"];
            this.title = _data["title"];
            this.altText = _data["altText"];
            this.description = _data["description"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(KeyValuePairOfStringAndString.fromJS(item));
            }
            this.publicUrl = _data["publicUrl"];
            this.size = _data["size"];
            this.sizePrettyPrint = _data["sizePrettyPrint"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.altVersionUrl = _data["altVersionUrl"];
            this.lastModified = _data["lastModified"];
        }
    }

    static fromJS(data: any): MediaItem {
        data = typeof data === 'object' ? data : {};
        let result = new MediaItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["folderId"] = this.folderId;
        data["type"] = this.type;
        data["filename"] = this.filename;
        data["contentType"] = this.contentType;
        data["title"] = this.title;
        data["altText"] = this.altText;
        data["description"] = this.description;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item ? item.toJSON() : undefined as any);
        }
        data["publicUrl"] = this.publicUrl;
        data["size"] = this.size;
        data["sizePrettyPrint"] = this.sizePrettyPrint;
        data["width"] = this.width;
        data["height"] = this.height;
        data["altVersionUrl"] = this.altVersionUrl;
        data["lastModified"] = this.lastModified;
        return data;
    }

    clone(): MediaItem {
        const json = this.toJSON();
        let result = new MediaItem();
        result.init(json);
        return result;
    }
}

/** A media item in the list view. */
export interface IMediaItem {
    /** Gets/sets the unique id. */
    id?: string;
    /** Gets/sets the optional folder id. */
    folderId?: string | undefined;
    /** Gets/sets the media type. */
    type?: string | undefined;
    /** Gets/sets the filename of the uploaded media. */
    filename?: string | undefined;
    /** Gets/sets the content type of the uploaded media. */
    contentType?: string | undefined;
    /** Gets/sets the optional title. */
    title?: string | undefined;
    /** Gets/sets the optional alt text. */
    altText?: string | undefined;
    /** Gets/sets the optional description. */
    description?: string | undefined;
    /** Gets/sets the optional properties. */
    properties?: KeyValuePairOfStringAndString[] | undefined;
    /** Gets/sets the public url used to access the uploaded media. */
    publicUrl?: string | undefined;
    /** Gets/sets the file size in bytes. */
    size?: number;
    /** Gets/sets the  */
    sizePrettyPrint?: string | undefined;
    /** Gets/sets the optional width. */
    width?: number | undefined;
    /** Gets/sets the optional height. */
    height?: number | undefined;
    /** An optional version url for a different size when requested via the list api call on the MediaApiController. Only use when expecting this call. */
    altVersionUrl?: string | undefined;
    /** Gets/sets the last modification date. */
    lastModified?: string | undefined;
}

export class KeyValuePairOfStringAndString implements IKeyValuePairOfStringAndString {
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IKeyValuePairOfStringAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePairOfStringAndString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }

    clone(): KeyValuePairOfStringAndString {
        const json = this.toJSON();
        let result = new KeyValuePairOfStringAndString();
        result.init(json);
        return result;
    }
}

export interface IKeyValuePairOfStringAndString {
    key?: string | undefined;
    value?: string | undefined;
}

/** List model for the media view. */
export class MediaListModel implements IMediaListModel {
    /** Gets/sets the available folders. */
    folders?: FolderItem[] | undefined;
    /** Gets/sets the available media items. */
    media?: MediaItem[] | undefined;
    /** Gets/sets the optional folder id. */
    currentFolderId?: string | undefined;
    /** Gets/sets the optinal folder name */
    currentFolderName?: string | undefined;
    /** Gets/sets the optional parent id. */
    parentFolderId?: string | undefined;
    /** Gets/sets if the current folder can be deleted. */
    canDelete?: boolean;
    /** Gets/sets the optional status message from the last operation. */
    status?: StatusMessage | undefined;
    /** Gets/sets the recommended view mode for the folder. */
    viewMode?: string | undefined;
    /** Gets/sets the media folder structure. */
    structure?: Structure | undefined;
    /** Gets/sets the amount of media files at root level. */
    rootCount?: number;
    /** Gets/sets the total amount of media files. */
    totalCount?: number;

    constructor(data?: IMediaListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["folders"])) {
                this.folders = [] as any;
                for (let item of _data["folders"])
                    this.folders!.push(FolderItem.fromJS(item));
            }
            if (Array.isArray(_data["media"])) {
                this.media = [] as any;
                for (let item of _data["media"])
                    this.media!.push(MediaItem.fromJS(item));
            }
            this.currentFolderId = _data["currentFolderId"];
            this.currentFolderName = _data["currentFolderName"];
            this.parentFolderId = _data["parentFolderId"];
            this.canDelete = _data["canDelete"];
            this.status = _data["status"] ? StatusMessage.fromJS(_data["status"]) : undefined as any;
            this.viewMode = _data["viewMode"];
            this.structure = _data["structure"];
            this.rootCount = _data["rootCount"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MediaListModel {
        data = typeof data === 'object' ? data : {};
        let result = new MediaListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.folders)) {
            data["folders"] = [];
            for (let item of this.folders)
                data["folders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.media)) {
            data["media"] = [];
            for (let item of this.media)
                data["media"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentFolderId"] = this.currentFolderId;
        data["currentFolderName"] = this.currentFolderName;
        data["parentFolderId"] = this.parentFolderId;
        data["canDelete"] = this.canDelete;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["viewMode"] = this.viewMode;
        data["structure"] = this.structure;
        data["rootCount"] = this.rootCount;
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MediaListModel {
        const json = this.toJSON();
        let result = new MediaListModel();
        result.init(json);
        return result;
    }
}

/** List model for the media view. */
export interface IMediaListModel {
    /** Gets/sets the available folders. */
    folders?: FolderItem[] | undefined;
    /** Gets/sets the available media items. */
    media?: MediaItem[] | undefined;
    /** Gets/sets the optional folder id. */
    currentFolderId?: string | undefined;
    /** Gets/sets the optinal folder name */
    currentFolderName?: string | undefined;
    /** Gets/sets the optional parent id. */
    parentFolderId?: string | undefined;
    /** Gets/sets if the current folder can be deleted. */
    canDelete?: boolean;
    /** Gets/sets the optional status message from the last operation. */
    status?: StatusMessage | undefined;
    /** Gets/sets the recommended view mode for the folder. */
    viewMode?: string | undefined;
    /** Gets/sets the media folder structure. */
    structure?: Structure | undefined;
    /** Gets/sets the amount of media files at root level. */
    rootCount?: number;
    /** Gets/sets the total amount of media files. */
    totalCount?: number;
}

/** A folder item in the list view. */
export class FolderItem implements IFolderItem {
    /** Gets/sets the unique id. */
    id?: string;
    /** Gets/sets the name. */
    name?: string | undefined;
    /** Gets/sets the item count in the folder. */
    itemCount?: number;

    constructor(data?: IFolderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.itemCount = _data["itemCount"];
        }
    }

    static fromJS(data: any): FolderItem {
        data = typeof data === 'object' ? data : {};
        let result = new FolderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["itemCount"] = this.itemCount;
        return data;
    }

    clone(): FolderItem {
        const json = this.toJSON();
        let result = new FolderItem();
        result.init(json);
        return result;
    }
}

/** A folder item in the list view. */
export interface IFolderItem {
    /** Gets/sets the unique id. */
    id?: string;
    /** Gets/sets the name. */
    name?: string | undefined;
    /** Gets/sets the item count in the folder. */
    itemCount?: number;
}

/** Status message to pass from an api to the manager interface. */
export class StatusMessage implements IStatusMessage {
    /** Gets/sets the message type. */
    type?: string | undefined;
    /** Gets/sets the message body. */
    body?: string | undefined;
    /** Gets/sets if the status message should be hidden
automatically from the notification hub after a
period of time. */
    hide?: boolean;

    constructor(data?: IStatusMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.body = _data["body"];
            this.hide = _data["hide"];
        }
    }

    static fromJS(data: any): StatusMessage {
        data = typeof data === 'object' ? data : {};
        let result = new StatusMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["body"] = this.body;
        data["hide"] = this.hide;
        return data;
    }

    clone(): StatusMessage {
        const json = this.toJSON();
        let result = new StatusMessage();
        result.init(json);
        return result;
    }
}

/** Status message to pass from an api to the manager interface. */
export interface IStatusMessage {
    /** Gets/sets the message type. */
    type?: string | undefined;
    /** Gets/sets the message body. */
    body?: string | undefined;
    /** Gets/sets if the status message should be hidden
automatically from the notification hub after a
period of time. */
    hide?: boolean;
}

export enum MediaFilter {
    Standard = 0,
    NotLinked = 1,
}

export class MediaFolderModel implements IMediaFolderModel {
    id?: string | undefined;
    parentId?: string | undefined;
    name?: string | undefined;

    constructor(data?: IMediaFolderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MediaFolderModel {
        data = typeof data === 'object' ? data : {};
        let result = new MediaFolderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        return data;
    }

    clone(): MediaFolderModel {
        const json = this.toJSON();
        let result = new MediaFolderModel();
        result.init(json);
        return result;
    }
}

export interface IMediaFolderModel {
    id?: string | undefined;
    parentId?: string | undefined;
    name?: string | undefined;
}

export class FileStatusMessage extends StatusMessage implements IFileStatusMessage {
    /** Gets/sets file guid as string. */
    fileId?: string | undefined;
    publicUrl?: string | undefined;

    constructor(data?: IFileStatusMessage) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fileId = _data["fileId"];
            this.publicUrl = _data["publicUrl"];
        }
    }

    static override fromJS(data: any): FileStatusMessage {
        data = typeof data === 'object' ? data : {};
        let result = new FileStatusMessage();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["publicUrl"] = this.publicUrl;
        super.toJSON(data);
        return data;
    }

    clone(): FileStatusMessage {
        const json = this.toJSON();
        let result = new FileStatusMessage();
        result.init(json);
        return result;
    }
}

export interface IFileStatusMessage extends IStatusMessage {
    /** Gets/sets file guid as string. */
    fileId?: string | undefined;
    publicUrl?: string | undefined;
}

/** Modules model. */
export class ModuleListModel implements IModuleListModel {
    /** Gets/set the available items. */
    items?: ListItem2[] | undefined;

    constructor(data?: IModuleListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ListItem2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModuleListModel {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ModuleListModel {
        const json = this.toJSON();
        let result = new ModuleListModel();
        result.init(json);
        return result;
    }
}

/** Modules model. */
export interface IModuleListModel {
    /** Gets/set the available items. */
    items?: ListItem2[] | undefined;
}

/** A list item in the module model. */
export class ListItem2 implements IListItem2 {
    author?: string | undefined;
    name?: string | undefined;
    version?: string | undefined;
    description?: string | undefined;
    packageUrl?: string | undefined;
    iconUrl?: string | undefined;

    constructor(data?: IListItem2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.author = _data["author"];
            this.name = _data["name"];
            this.version = _data["version"];
            this.description = _data["description"];
            this.packageUrl = _data["packageUrl"];
            this.iconUrl = _data["iconUrl"];
        }
    }

    static fromJS(data: any): ListItem2 {
        data = typeof data === 'object' ? data : {};
        let result = new ListItem2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["author"] = this.author;
        data["name"] = this.name;
        data["version"] = this.version;
        data["description"] = this.description;
        data["packageUrl"] = this.packageUrl;
        data["iconUrl"] = this.iconUrl;
        return data;
    }

    clone(): ListItem2 {
        const json = this.toJSON();
        let result = new ListItem2();
        result.init(json);
        return result;
    }
}

/** A list item in the module model. */
export interface IListItem2 {
    author?: string | undefined;
    name?: string | undefined;
    version?: string | undefined;
    description?: string | undefined;
    packageUrl?: string | undefined;
    iconUrl?: string | undefined;
}

export class BaseResultOfISettings implements IBaseResultOfISettings {
    id?: number;
    isOk?: boolean;
    result?: ISettings | undefined;

    constructor(data?: IBaseResultOfISettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? ISettings.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfISettings {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfISettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfISettings {
        const json = this.toJSON();
        let result = new BaseResultOfISettings();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfISettings {
    id?: number;
    isOk?: boolean;
    result?: ISettings | undefined;
}

export abstract class ISettings implements IISettings {

    constructor(data?: IISettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ISettings {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ISettings' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ISettings {
        throw new Error("The abstract class 'ISettings' cannot be instantiated.");
    }
}

export interface IISettings {
}

export class BaseResultOfObject implements IBaseResultOfObject {
    id?: number;
    isOk?: boolean;
    result?: any | undefined;

    constructor(data?: IBaseResultOfObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): BaseResultOfObject {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result;
        return data;
    }

    clone(): BaseResultOfObject {
        const json = this.toJSON();
        let result = new BaseResultOfObject();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfObject {
    id?: number;
    isOk?: boolean;
    result?: any | undefined;
}

export class TranslationResult implements ITranslationResult {
    fromTranslate!: string[];

    constructor(data?: ITranslationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.fromTranslate = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fromTranslate"])) {
                this.fromTranslate = [] as any;
                for (let item of _data["fromTranslate"])
                    this.fromTranslate!.push(item);
            }
        }
    }

    static fromJS(data: any): TranslationResult {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fromTranslate)) {
            data["fromTranslate"] = [];
            for (let item of this.fromTranslate)
                data["fromTranslate"].push(item);
        }
        return data;
    }

    clone(): TranslationResult {
        const json = this.toJSON();
        let result = new TranslationResult();
        result.init(json);
        return result;
    }
}

export interface ITranslationResult {
    fromTranslate: string[];
}

export class TranslationRequest implements ITranslationRequest {
    toTranslate!: string[];
    toLocale!: string;
    fromLocale!: string;

    constructor(data?: ITranslationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.toTranslate = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["toTranslate"])) {
                this.toTranslate = [] as any;
                for (let item of _data["toTranslate"])
                    this.toTranslate!.push(item);
            }
            this.toLocale = _data["toLocale"];
            this.fromLocale = _data["fromLocale"];
        }
    }

    static fromJS(data: any): TranslationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.toTranslate)) {
            data["toTranslate"] = [];
            for (let item of this.toTranslate)
                data["toTranslate"].push(item);
        }
        data["toLocale"] = this.toLocale;
        data["fromLocale"] = this.fromLocale;
        return data;
    }

    clone(): TranslationRequest {
        const json = this.toJSON();
        let result = new TranslationRequest();
        result.init(json);
        return result;
    }
}

export interface ITranslationRequest {
    toTranslate: string[];
    toLocale: string;
    fromLocale: string;
}

export class SearchResponse implements ISearchResponse {
    answer?: string;
    sources?: SearchSources[];

    constructor(data?: ISearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answer = _data["answer"];
            if (Array.isArray(_data["sources"])) {
                this.sources = [] as any;
                for (let item of _data["sources"])
                    this.sources!.push(SearchSources.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answer"] = this.answer;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): SearchResponse {
        const json = this.toJSON();
        let result = new SearchResponse();
        result.init(json);
        return result;
    }
}

export interface ISearchResponse {
    answer?: string;
    sources?: SearchSources[];
}

export class SearchSources implements ISearchSources {
    documentId?: string;
    fileName?: string;
    snippet?: string;
    score?: number;
    start?: number;
    end?: number;
    isDownload?: boolean;
    mediaId?: string;

    constructor(data?: ISearchSources) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.fileName = _data["fileName"];
            this.snippet = _data["snippet"];
            this.score = _data["score"];
            this.start = _data["start"];
            this.end = _data["end"];
            this.isDownload = _data["isDownload"];
            this.mediaId = _data["mediaId"];
        }
    }

    static fromJS(data: any): SearchSources {
        data = typeof data === 'object' ? data : {};
        let result = new SearchSources();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["fileName"] = this.fileName;
        data["snippet"] = this.snippet;
        data["score"] = this.score;
        data["start"] = this.start;
        data["end"] = this.end;
        data["isDownload"] = this.isDownload;
        data["mediaId"] = this.mediaId;
        return data;
    }

    clone(): SearchSources {
        const json = this.toJSON();
        let result = new SearchSources();
        result.init(json);
        return result;
    }
}

export interface ISearchSources {
    documentId?: string;
    fileName?: string;
    snippet?: string;
    score?: number;
    start?: number;
    end?: number;
    isDownload?: boolean;
    mediaId?: string;
}

export class SearchRequest implements ISearchRequest {
    query?: string;
    topK?: number;
    tags?: string[] | undefined;

    constructor(data?: ISearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
            this.topK = _data["topK"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): SearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["topK"] = this.topK;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }

    clone(): SearchRequest {
        const json = this.toJSON();
        let result = new SearchRequest();
        result.init(json);
        return result;
    }
}

export interface ISearchRequest {
    query?: string;
    topK?: number;
    tags?: string[] | undefined;
}

export class EmailServiceRequest implements IEmailServiceRequest {
    query!: string;
    topK?: number;
    tags?: string[] | undefined;
    jobId?: string;

    constructor(data?: IEmailServiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
            this.topK = _data["topK"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.jobId = _data["jobId"];
        }
    }

    static fromJS(data: any): EmailServiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmailServiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["topK"] = this.topK;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["jobId"] = this.jobId;
        return data;
    }

    clone(): EmailServiceRequest {
        const json = this.toJSON();
        let result = new EmailServiceRequest();
        result.init(json);
        return result;
    }
}

export interface IEmailServiceRequest {
    query: string;
    topK?: number;
    tags?: string[] | undefined;
    jobId?: string;
}

export class QuestionResponse implements IQuestionResponse {
    questions?: string[];

    constructor(data?: IQuestionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(item);
            }
        }
    }

    static fromJS(data: any): QuestionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item);
        }
        return data;
    }

    clone(): QuestionResponse {
        const json = this.toJSON();
        let result = new QuestionResponse();
        result.init(json);
        return result;
    }
}

export interface IQuestionResponse {
    questions?: string[];
}

export class QuestionGenerationRequest implements IQuestionGenerationRequest {
    documents?: string[];
    questionsPerChunk?: number;

    constructor(data?: IQuestionGenerationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(item);
            }
            this.questionsPerChunk = _data["questionsPerChunk"];
        }
    }

    static fromJS(data: any): QuestionGenerationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionGenerationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item);
        }
        data["questionsPerChunk"] = this.questionsPerChunk;
        return data;
    }

    clone(): QuestionGenerationRequest {
        const json = this.toJSON();
        let result = new QuestionGenerationRequest();
        result.init(json);
        return result;
    }
}

export interface IQuestionGenerationRequest {
    documents?: string[];
    questionsPerChunk?: number;
}

export class ReqCellMediaEnqueue implements IReqCellMediaEnqueue {
    mediaId!: string;
    cellId!: number;

    constructor(data?: IReqCellMediaEnqueue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mediaId = _data["mediaId"];
            this.cellId = _data["cellId"];
        }
    }

    static fromJS(data: any): ReqCellMediaEnqueue {
        data = typeof data === 'object' ? data : {};
        let result = new ReqCellMediaEnqueue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mediaId"] = this.mediaId;
        data["cellId"] = this.cellId;
        return data;
    }

    clone(): ReqCellMediaEnqueue {
        const json = this.toJSON();
        let result = new ReqCellMediaEnqueue();
        result.init(json);
        return result;
    }
}

export interface IReqCellMediaEnqueue {
    mediaId: string;
    cellId: number;
}

export class AiDocument implements IAiDocument {
    id?: string;
    fkAccountId!: number;
    fileName!: string;
    displayName!: string;
    contentType!: string;
    isContentDownloadable!: boolean;
    metaInfo?: string | undefined;
    textContent?: string | undefined;
    fileBytes?: string | undefined;
    tag?: string | undefined;
    uploadedAt?: Date;
    chunks?: AiDocumentChunk[] | undefined;
    processingStatus?: string;

    constructor(data?: IAiDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkAccountId = _data["fkAccountId"];
            this.fileName = _data["fileName"];
            this.displayName = _data["displayName"];
            this.contentType = _data["contentType"];
            this.isContentDownloadable = _data["isContentDownloadable"];
            this.metaInfo = _data["metaInfo"];
            this.textContent = _data["textContent"];
            this.fileBytes = _data["fileBytes"];
            this.tag = _data["tag"];
            this.uploadedAt = _data["uploadedAt"] ? new Date(_data["uploadedAt"].toString()) : undefined as any;
            if (Array.isArray(_data["chunks"])) {
                this.chunks = [] as any;
                for (let item of _data["chunks"])
                    this.chunks!.push(AiDocumentChunk.fromJS(item));
            }
            this.processingStatus = _data["processingStatus"];
        }
    }

    static fromJS(data: any): AiDocument {
        data = typeof data === 'object' ? data : {};
        let result = new AiDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkAccountId"] = this.fkAccountId;
        data["fileName"] = this.fileName;
        data["displayName"] = this.displayName;
        data["contentType"] = this.contentType;
        data["isContentDownloadable"] = this.isContentDownloadable;
        data["metaInfo"] = this.metaInfo;
        data["textContent"] = this.textContent;
        data["fileBytes"] = this.fileBytes;
        data["tag"] = this.tag;
        data["uploadedAt"] = this.uploadedAt ? this.uploadedAt.toISOString() : undefined as any;
        if (Array.isArray(this.chunks)) {
            data["chunks"] = [];
            for (let item of this.chunks)
                data["chunks"].push(item ? item.toJSON() : undefined as any);
        }
        data["processingStatus"] = this.processingStatus;
        return data;
    }

    clone(): AiDocument {
        const json = this.toJSON();
        let result = new AiDocument();
        result.init(json);
        return result;
    }
}

export interface IAiDocument {
    id?: string;
    fkAccountId: number;
    fileName: string;
    displayName: string;
    contentType: string;
    isContentDownloadable: boolean;
    metaInfo?: string | undefined;
    textContent?: string | undefined;
    fileBytes?: string | undefined;
    tag?: string | undefined;
    uploadedAt?: Date;
    chunks?: AiDocumentChunk[] | undefined;
    processingStatus?: string;
}

export class AiDocumentChunk implements IAiDocumentChunk {
    id?: string;
    fkAccountId!: number;
    documentId!: string;
    document?: AiDocument | undefined;
    text?: string;
    embeddingJson?: string;
    startOffset?: number;
    endOffset?: number;
    score?: number | undefined;
    vectorIndexId!: number;
    metaInfo?: string | undefined;

    constructor(data?: IAiDocumentChunk) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkAccountId = _data["fkAccountId"];
            this.documentId = _data["documentId"];
            this.document = _data["document"] ? AiDocument.fromJS(_data["document"]) : undefined as any;
            this.text = _data["text"];
            this.embeddingJson = _data["embeddingJson"];
            this.startOffset = _data["startOffset"];
            this.endOffset = _data["endOffset"];
            this.score = _data["score"];
            this.vectorIndexId = _data["vectorIndexId"];
            this.metaInfo = _data["metaInfo"];
        }
    }

    static fromJS(data: any): AiDocumentChunk {
        data = typeof data === 'object' ? data : {};
        let result = new AiDocumentChunk();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkAccountId"] = this.fkAccountId;
        data["documentId"] = this.documentId;
        data["document"] = this.document ? this.document.toJSON() : undefined as any;
        data["text"] = this.text;
        data["embeddingJson"] = this.embeddingJson;
        data["startOffset"] = this.startOffset;
        data["endOffset"] = this.endOffset;
        data["score"] = this.score;
        data["vectorIndexId"] = this.vectorIndexId;
        data["metaInfo"] = this.metaInfo;
        return data;
    }

    clone(): AiDocumentChunk {
        const json = this.toJSON();
        let result = new AiDocumentChunk();
        result.init(json);
        return result;
    }
}

export interface IAiDocumentChunk {
    id?: string;
    fkAccountId: number;
    documentId: string;
    document?: AiDocument | undefined;
    text?: string;
    embeddingJson?: string;
    startOffset?: number;
    endOffset?: number;
    score?: number | undefined;
    vectorIndexId: number;
    metaInfo?: string | undefined;
}

export class ActionDefinition implements IActionDefinition {
    id!: string;
    accountId!: number;
    type!: string;
    name!: string;
    description?: string | undefined;
    configurationJson!: string;

    constructor(data?: IActionDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.configurationJson = _data["configurationJson"];
        }
    }

    static fromJS(data: any): ActionDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new ActionDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["type"] = this.type;
        data["name"] = this.name;
        data["description"] = this.description;
        data["configurationJson"] = this.configurationJson;
        return data;
    }

    clone(): ActionDefinition {
        const json = this.toJSON();
        let result = new ActionDefinition();
        result.init(json);
        return result;
    }
}

export interface IActionDefinition {
    id: string;
    accountId: number;
    type: string;
    name: string;
    description?: string | undefined;
    configurationJson: string;
}

export class TriggerActionRequest implements ITriggerActionRequest {
    definitionId!: string;
    extraOptionsJson?: string | undefined;

    constructor(data?: ITriggerActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.definitionId = _data["definitionId"];
            this.extraOptionsJson = _data["extraOptionsJson"];
        }
    }

    static fromJS(data: any): TriggerActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["definitionId"] = this.definitionId;
        data["extraOptionsJson"] = this.extraOptionsJson;
        return data;
    }

    clone(): TriggerActionRequest {
        const json = this.toJSON();
        let result = new TriggerActionRequest();
        result.init(json);
        return result;
    }
}

export interface ITriggerActionRequest {
    definitionId: string;
    extraOptionsJson?: string | undefined;
}

export class BaseResultOfAndonSettingOf implements IBaseResultOfAndonSettingOf {
    id?: number;
    isOk?: boolean;
    result?: AndonSetting[] | undefined;

    constructor(data?: IBaseResultOfAndonSettingOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(AndonSetting.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfAndonSettingOf {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfAndonSettingOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfAndonSettingOf {
        const json = this.toJSON();
        let result = new BaseResultOfAndonSettingOf();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfAndonSettingOf {
    id?: number;
    isOk?: boolean;
    result?: AndonSetting[] | undefined;
}

export class AndonSetting implements IAndonSetting {
    id!: number;
    name!: string;
    title!: string;
    server!: string;
    databaseType!: DBType;
    database!: string;
    port!: number;
    useTcpIp!: boolean;
    table!: string;
    user!: string;
    password!: string;
    useWindowsAuthenication!: boolean;
    dateFieldName!: string;
    amountFieldName!: string;
    refreshIntervalMinutes!: number;
    shiftFkAccountId!: number;
    targetValue!: number;
    targetDescription?: string | undefined;
    actualDescription?: string | undefined;
    previousDescription?: string | undefined;
    imageUrl?: string | undefined;

    constructor(data?: IAndonSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.server = _data["server"];
            this.databaseType = _data["databaseType"];
            this.database = _data["database"];
            this.port = _data["port"];
            this.useTcpIp = _data["useTcpIp"];
            this.table = _data["table"];
            this.user = _data["user"];
            this.password = _data["password"];
            this.useWindowsAuthenication = _data["useWindowsAuthenication"];
            this.dateFieldName = _data["dateFieldName"];
            this.amountFieldName = _data["amountFieldName"];
            this.refreshIntervalMinutes = _data["refreshIntervalMinutes"];
            this.shiftFkAccountId = _data["shiftFkAccountId"];
            this.targetValue = _data["targetValue"];
            this.targetDescription = _data["targetDescription"];
            this.actualDescription = _data["actualDescription"];
            this.previousDescription = _data["previousDescription"];
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): AndonSetting {
        data = typeof data === 'object' ? data : {};
        let result = new AndonSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["title"] = this.title;
        data["server"] = this.server;
        data["databaseType"] = this.databaseType;
        data["database"] = this.database;
        data["port"] = this.port;
        data["useTcpIp"] = this.useTcpIp;
        data["table"] = this.table;
        data["user"] = this.user;
        data["password"] = this.password;
        data["useWindowsAuthenication"] = this.useWindowsAuthenication;
        data["dateFieldName"] = this.dateFieldName;
        data["amountFieldName"] = this.amountFieldName;
        data["refreshIntervalMinutes"] = this.refreshIntervalMinutes;
        data["shiftFkAccountId"] = this.shiftFkAccountId;
        data["targetValue"] = this.targetValue;
        data["targetDescription"] = this.targetDescription;
        data["actualDescription"] = this.actualDescription;
        data["previousDescription"] = this.previousDescription;
        data["imageUrl"] = this.imageUrl;
        return data;
    }

    clone(): AndonSetting {
        const json = this.toJSON();
        let result = new AndonSetting();
        result.init(json);
        return result;
    }
}

export interface IAndonSetting {
    id: number;
    name: string;
    title: string;
    server: string;
    databaseType: DBType;
    database: string;
    port: number;
    useTcpIp: boolean;
    table: string;
    user: string;
    password: string;
    useWindowsAuthenication: boolean;
    dateFieldName: string;
    amountFieldName: string;
    refreshIntervalMinutes: number;
    shiftFkAccountId: number;
    targetValue: number;
    targetDescription?: string | undefined;
    actualDescription?: string | undefined;
    previousDescription?: string | undefined;
    imageUrl?: string | undefined;
}

export enum DBType {
    MSSQL = 0,
    MySQL = 1,
}

export class BaseResultOfTableOf implements IBaseResultOfTableOf {
    id?: number;
    isOk?: boolean;
    result?: Table[] | undefined;

    constructor(data?: IBaseResultOfTableOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(Table.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfTableOf {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfTableOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfTableOf {
        const json = this.toJSON();
        let result = new BaseResultOfTableOf();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfTableOf {
    id?: number;
    isOk?: boolean;
    result?: Table[] | undefined;
}

export class Table implements ITable {
    server!: string;
    dbase!: string;
    name!: string;
    timestampName!: string;
    fields!: string[];
    start?: Date;
    end?: Date;

    constructor(data?: ITable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.fields = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.server = _data["server"];
            this.dbase = _data["dbase"];
            this.name = _data["name"];
            this.timestampName = _data["timestampName"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(item);
            }
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Table {
        data = typeof data === 'object' ? data : {};
        let result = new Table();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["server"] = this.server;
        data["dbase"] = this.dbase;
        data["name"] = this.name;
        data["timestampName"] = this.timestampName;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item);
        }
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["end"] = this.end ? this.end.toISOString() : undefined as any;
        return data;
    }

    clone(): Table {
        const json = this.toJSON();
        let result = new Table();
        result.init(json);
        return result;
    }
}

export interface ITable {
    server: string;
    dbase: string;
    name: string;
    timestampName: string;
    fields: string[];
    start?: Date;
    end?: Date;
}

export class BaseResultOfDataPointOf implements IBaseResultOfDataPointOf {
    id?: number;
    isOk?: boolean;
    result?: DataPoint[] | undefined;

    constructor(data?: IBaseResultOfDataPointOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(DataPoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfDataPointOf {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfDataPointOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfDataPointOf {
        const json = this.toJSON();
        let result = new BaseResultOfDataPointOf();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfDataPointOf {
    id?: number;
    isOk?: boolean;
    result?: DataPoint[] | undefined;
}

export class DataPoint implements IDataPoint {
    value!: number;
    timeStamp!: Date;

    constructor(data?: IDataPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DataPoint {
        data = typeof data === 'object' ? data : {};
        let result = new DataPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : undefined as any;
        return data;
    }

    clone(): DataPoint {
        const json = this.toJSON();
        let result = new DataPoint();
        result.init(json);
        return result;
    }
}

export interface IDataPoint {
    value: number;
    timeStamp: Date;
}

export class Selection implements ISelection {
    server!: string;
    dbase!: string;
    table!: string;
    field!: string;
    start!: Date;
    end!: Date;

    constructor(data?: ISelection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.server = _data["server"];
            this.dbase = _data["dbase"];
            this.table = _data["table"];
            this.field = _data["field"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Selection {
        data = typeof data === 'object' ? data : {};
        let result = new Selection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["server"] = this.server;
        data["dbase"] = this.dbase;
        data["table"] = this.table;
        data["field"] = this.field;
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["end"] = this.end ? this.end.toISOString() : undefined as any;
        return data;
    }

    clone(): Selection {
        const json = this.toJSON();
        let result = new Selection();
        result.init(json);
        return result;
    }
}

export interface ISelection {
    server: string;
    dbase: string;
    table: string;
    field: string;
    start: Date;
    end: Date;
}

export class BaseResultOfChartwizardTranslationOf implements IBaseResultOfChartwizardTranslationOf {
    id?: number;
    isOk?: boolean;
    result?: ChartwizardTranslation[] | undefined;

    constructor(data?: IBaseResultOfChartwizardTranslationOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(ChartwizardTranslation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfChartwizardTranslationOf {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfChartwizardTranslationOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfChartwizardTranslationOf {
        const json = this.toJSON();
        let result = new BaseResultOfChartwizardTranslationOf();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfChartwizardTranslationOf {
    id?: number;
    isOk?: boolean;
    result?: ChartwizardTranslation[] | undefined;
}

export class ChartwizardTranslation implements IChartwizardTranslation {
    id!: number;
    name!: string;
    locale?: string | undefined;
    translation!: string;
    fkAccountId!: number;

    constructor(data?: IChartwizardTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.locale = _data["locale"];
            this.translation = _data["translation"];
            this.fkAccountId = _data["fkAccountId"];
        }
    }

    static fromJS(data: any): ChartwizardTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new ChartwizardTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["locale"] = this.locale;
        data["translation"] = this.translation;
        data["fkAccountId"] = this.fkAccountId;
        return data;
    }

    clone(): ChartwizardTranslation {
        const json = this.toJSON();
        let result = new ChartwizardTranslation();
        result.init(json);
        return result;
    }
}

export interface IChartwizardTranslation {
    id: number;
    name: string;
    locale?: string | undefined;
    translation: string;
    fkAccountId: number;
}

export class BaseResultOfChartwizardUnitOf implements IBaseResultOfChartwizardUnitOf {
    id?: number;
    isOk?: boolean;
    result?: ChartwizardUnit[] | undefined;

    constructor(data?: IBaseResultOfChartwizardUnitOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(ChartwizardUnit.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfChartwizardUnitOf {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfChartwizardUnitOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfChartwizardUnitOf {
        const json = this.toJSON();
        let result = new BaseResultOfChartwizardUnitOf();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfChartwizardUnitOf {
    id?: number;
    isOk?: boolean;
    result?: ChartwizardUnit[] | undefined;
}

export class ChartwizardUnit implements IChartwizardUnit {
    id!: number;
    name!: string;
    locale?: string | undefined;
    unit!: string;
    fkAccountId!: number;

    constructor(data?: IChartwizardUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.locale = _data["locale"];
            this.unit = _data["unit"];
            this.fkAccountId = _data["fkAccountId"];
        }
    }

    static fromJS(data: any): ChartwizardUnit {
        data = typeof data === 'object' ? data : {};
        let result = new ChartwizardUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["locale"] = this.locale;
        data["unit"] = this.unit;
        data["fkAccountId"] = this.fkAccountId;
        return data;
    }

    clone(): ChartwizardUnit {
        const json = this.toJSON();
        let result = new ChartwizardUnit();
        result.init(json);
        return result;
    }
}

export interface IChartwizardUnit {
    id: number;
    name: string;
    locale?: string | undefined;
    unit: string;
    fkAccountId: number;
}

export class Dashboard implements IDashboard {
    id!: string;
    accountId!: number;
    name!: string;
    title!: string;
    json!: string;
    public!: boolean;

    constructor(data?: IDashboard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.json = _data["json"];
            this.public = _data["public"];
        }
    }

    static fromJS(data: any): Dashboard {
        data = typeof data === 'object' ? data : {};
        let result = new Dashboard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["name"] = this.name;
        data["title"] = this.title;
        data["json"] = this.json;
        data["public"] = this.public;
        return data;
    }

    clone(): Dashboard {
        const json = this.toJSON();
        let result = new Dashboard();
        result.init(json);
        return result;
    }
}

export interface IDashboard {
    id: string;
    accountId: number;
    name: string;
    title: string;
    json: string;
    public: boolean;
}

export class SwaggerModels implements ISwaggerModels {
    activityStatusSums?: ActivityStatusSums | undefined;
    activityStatusSumsTree?: ActivityStatusSumsTree | undefined;
    activityAssignment?: ActivityAssignment | undefined;
    auditHistoryEntry?: AuditHistoryEntry | undefined;

    constructor(data?: ISwaggerModels) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityStatusSums = _data["activityStatusSums"] ? ActivityStatusSums.fromJS(_data["activityStatusSums"]) : undefined as any;
            this.activityStatusSumsTree = _data["activityStatusSumsTree"] ? ActivityStatusSumsTree.fromJS(_data["activityStatusSumsTree"]) : undefined as any;
            this.activityAssignment = _data["activityAssignment"] ? ActivityAssignment.fromJS(_data["activityAssignment"]) : undefined as any;
            this.auditHistoryEntry = _data["auditHistoryEntry"] ? AuditHistoryEntry.fromJS(_data["auditHistoryEntry"]) : undefined as any;
        }
    }

    static fromJS(data: any): SwaggerModels {
        data = typeof data === 'object' ? data : {};
        let result = new SwaggerModels();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityStatusSums"] = this.activityStatusSums ? this.activityStatusSums.toJSON() : undefined as any;
        data["activityStatusSumsTree"] = this.activityStatusSumsTree ? this.activityStatusSumsTree.toJSON() : undefined as any;
        data["activityAssignment"] = this.activityAssignment ? this.activityAssignment.toJSON() : undefined as any;
        data["auditHistoryEntry"] = this.auditHistoryEntry ? this.auditHistoryEntry.toJSON() : undefined as any;
        return data;
    }

    clone(): SwaggerModels {
        const json = this.toJSON();
        let result = new SwaggerModels();
        result.init(json);
        return result;
    }
}

export interface ISwaggerModels {
    activityStatusSums?: ActivityStatusSums | undefined;
    activityStatusSumsTree?: ActivityStatusSumsTree | undefined;
    activityAssignment?: ActivityAssignment | undefined;
    auditHistoryEntry?: AuditHistoryEntry | undefined;
}

export class ActivityStatusSums implements IActivityStatusSums {
    all!: number;
    open!: number;
    triggered!: number;
    inProgress!: number;
    unplanned!: number;
    planned!: number;
    overDue!: number;
    completedToday!: number;
    risk!: number;
    age!: number;
    fireProtection!: number;

    constructor(data?: IActivityStatusSums) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.all = _data["all"];
            this.open = _data["open"];
            this.triggered = _data["triggered"];
            this.inProgress = _data["inProgress"];
            this.unplanned = _data["unplanned"];
            this.planned = _data["planned"];
            this.overDue = _data["overDue"];
            this.completedToday = _data["completedToday"];
            this.risk = _data["risk"];
            this.age = _data["age"];
            this.fireProtection = _data["fireProtection"];
        }
    }

    static fromJS(data: any): ActivityStatusSums {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityStatusSums();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["all"] = this.all;
        data["open"] = this.open;
        data["triggered"] = this.triggered;
        data["inProgress"] = this.inProgress;
        data["unplanned"] = this.unplanned;
        data["planned"] = this.planned;
        data["overDue"] = this.overDue;
        data["completedToday"] = this.completedToday;
        data["risk"] = this.risk;
        data["age"] = this.age;
        data["fireProtection"] = this.fireProtection;
        return data;
    }

    clone(): ActivityStatusSums {
        const json = this.toJSON();
        let result = new ActivityStatusSums();
        result.init(json);
        return result;
    }
}

export interface IActivityStatusSums {
    all: number;
    open: number;
    triggered: number;
    inProgress: number;
    unplanned: number;
    planned: number;
    overDue: number;
    completedToday: number;
    risk: number;
    age: number;
    fireProtection: number;
}

export class ActivityStatusSumsTree implements IActivityStatusSumsTree {
    accountId!: number;
    accountName!: string;
    sums!: ActivityStatusSums;
    children!: ActivityStatusSumsTree[];

    constructor(data?: IActivityStatusSumsTree) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.sums = new ActivityStatusSums();
            this.children = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.accountName = _data["accountName"];
            this.sums = _data["sums"] ? ActivityStatusSums.fromJS(_data["sums"]) : new ActivityStatusSums();
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(ActivityStatusSumsTree.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityStatusSumsTree {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityStatusSumsTree();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["accountName"] = this.accountName;
        data["sums"] = this.sums ? this.sums.toJSON() : undefined as any;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ActivityStatusSumsTree {
        const json = this.toJSON();
        let result = new ActivityStatusSumsTree();
        result.init(json);
        return result;
    }
}

export interface IActivityStatusSumsTree {
    accountId: number;
    accountName: string;
    sums: ActivityStatusSums;
    children: ActivityStatusSumsTree[];
}

export class ActivityAssignment implements IActivityAssignment {
    firstName!: string;
    lastName!: string;
    email!: string;
    activity!: string;
    duty!: string;
    cell!: string;

    constructor(data?: IActivityAssignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.activity = _data["activity"];
            this.duty = _data["duty"];
            this.cell = _data["cell"];
        }
    }

    static fromJS(data: any): ActivityAssignment {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityAssignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["activity"] = this.activity;
        data["duty"] = this.duty;
        data["cell"] = this.cell;
        return data;
    }

    clone(): ActivityAssignment {
        const json = this.toJSON();
        let result = new ActivityAssignment();
        result.init(json);
        return result;
    }
}

export interface IActivityAssignment {
    firstName: string;
    lastName: string;
    email: string;
    activity: string;
    duty: string;
    cell: string;
}

export class AuditHistoryEntry implements IAuditHistoryEntry {
    year!: number;
    month!: number;
    plannedTriggered!: number;
    plannedDone!: number;
    unplannedTriggered!: number;
    unplannedDone!: number;

    constructor(data?: IAuditHistoryEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.plannedTriggered = _data["plannedTriggered"];
            this.plannedDone = _data["plannedDone"];
            this.unplannedTriggered = _data["unplannedTriggered"];
            this.unplannedDone = _data["unplannedDone"];
        }
    }

    static fromJS(data: any): AuditHistoryEntry {
        data = typeof data === 'object' ? data : {};
        let result = new AuditHistoryEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["plannedTriggered"] = this.plannedTriggered;
        data["plannedDone"] = this.plannedDone;
        data["unplannedTriggered"] = this.unplannedTriggered;
        data["unplannedDone"] = this.unplannedDone;
        return data;
    }

    clone(): AuditHistoryEntry {
        const json = this.toJSON();
        let result = new AuditHistoryEntry();
        result.init(json);
        return result;
    }
}

export interface IAuditHistoryEntry {
    year: number;
    month: number;
    plannedTriggered: number;
    plannedDone: number;
    unplannedTriggered: number;
    unplannedDone: number;
}

export class WorkflowApproval implements IWorkflowApproval {
    id!: string;
    accountId!: number;
    createdBy!: string;
    createdOn!: Date;
    assignedTo!: string;
    approvedBy?: string | undefined;
    approvedOn?: Date | undefined;
    signature?: string | undefined;
    cards?: WorkflowApprovalCard[] | undefined;

    constructor(data?: IWorkflowApproval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.assignedTo = _data["assignedTo"];
            this.approvedBy = _data["approvedBy"];
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : undefined as any;
            this.signature = _data["signature"];
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(WorkflowApprovalCard.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkflowApproval {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["assignedTo"] = this.assignedTo;
        data["approvedBy"] = this.approvedBy;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : undefined as any;
        data["signature"] = this.signature;
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): WorkflowApproval {
        const json = this.toJSON();
        let result = new WorkflowApproval();
        result.init(json);
        return result;
    }
}

export interface IWorkflowApproval {
    id: string;
    accountId: number;
    createdBy: string;
    createdOn: Date;
    assignedTo: string;
    approvedBy?: string | undefined;
    approvedOn?: Date | undefined;
    signature?: string | undefined;
    cards?: WorkflowApprovalCard[] | undefined;
}

export class WorkflowApprovalCard implements IWorkflowApprovalCard {
    id!: string;
    cardId!: string;
    workflowApprovalId!: string;

    constructor(data?: IWorkflowApprovalCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cardId = _data["cardId"];
            this.workflowApprovalId = _data["workflowApprovalId"];
        }
    }

    static fromJS(data: any): WorkflowApprovalCard {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowApprovalCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cardId"] = this.cardId;
        data["workflowApprovalId"] = this.workflowApprovalId;
        return data;
    }

    clone(): WorkflowApprovalCard {
        const json = this.toJSON();
        let result = new WorkflowApprovalCard();
        result.init(json);
        return result;
    }
}

export interface IWorkflowApprovalCard {
    id: string;
    cardId: string;
    workflowApprovalId: string;
}

export class WorkflowApprovalApproveRequest implements IWorkflowApprovalApproveRequest {
    approvalId!: string;
    signature!: string;

    constructor(data?: IWorkflowApprovalApproveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approvalId = _data["approvalId"];
            this.signature = _data["signature"];
        }
    }

    static fromJS(data: any): WorkflowApprovalApproveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowApprovalApproveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalId"] = this.approvalId;
        data["signature"] = this.signature;
        return data;
    }

    clone(): WorkflowApprovalApproveRequest {
        const json = this.toJSON();
        let result = new WorkflowApprovalApproveRequest();
        result.init(json);
        return result;
    }
}

export interface IWorkflowApprovalApproveRequest {
    approvalId: string;
    signature: string;
}

export class Board implements IBoard {
    id?: number;
    name?: string | undefined;
    createdOn?: Date | undefined;
    userId?: string | undefined;
    fkAccountId?: number;
    cardCnt?: number;
    bgColor?: string | undefined;
    tickets?: Ticket[] | undefined;
    userBoards?: UserBoard[] | undefined;
    userBoards1?: UserBoard[] | undefined;
    attributeDefinitions?: CardAttributeDefinition[] | undefined;
    visibleToUsers?: string[] | undefined;
    isTransactionLogActive?: boolean;
    lockdownDelay?: number;
    enableReadConfirmations?: boolean;
    onlyTimeTrackingForOthers?: boolean;
    onlyShowAssignedCardsToOthers?: boolean;

    constructor(data?: IBoard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.lockdownDelay = -1;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.fkAccountId = _data["fkAccountId"];
            this.cardCnt = _data["cardCnt"];
            this.bgColor = _data["bgColor"];
            if (Array.isArray(_data["tickets"])) {
                this.tickets = [] as any;
                for (let item of _data["tickets"])
                    this.tickets!.push(Ticket.fromJS(item));
            }
            if (Array.isArray(_data["userBoards"])) {
                this.userBoards = [] as any;
                for (let item of _data["userBoards"])
                    this.userBoards!.push(UserBoard.fromJS(item));
            }
            if (Array.isArray(_data["userBoards1"])) {
                this.userBoards1 = [] as any;
                for (let item of _data["userBoards1"])
                    this.userBoards1!.push(UserBoard.fromJS(item));
            }
            if (Array.isArray(_data["attributeDefinitions"])) {
                this.attributeDefinitions = [] as any;
                for (let item of _data["attributeDefinitions"])
                    this.attributeDefinitions!.push(CardAttributeDefinition.fromJS(item));
            }
            if (Array.isArray(_data["visibleToUsers"])) {
                this.visibleToUsers = [] as any;
                for (let item of _data["visibleToUsers"])
                    this.visibleToUsers!.push(item);
            }
            this.isTransactionLogActive = _data["isTransactionLogActive"];
            this.lockdownDelay = _data["lockdownDelay"] !== undefined ? _data["lockdownDelay"] : -1;
            this.enableReadConfirmations = _data["enableReadConfirmations"];
            this.onlyTimeTrackingForOthers = _data["onlyTimeTrackingForOthers"];
            this.onlyShowAssignedCardsToOthers = _data["onlyShowAssignedCardsToOthers"];
        }
    }

    static fromJS(data: any): Board {
        data = typeof data === 'object' ? data : {};
        let result = new Board();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["userId"] = this.userId;
        data["fkAccountId"] = this.fkAccountId;
        data["cardCnt"] = this.cardCnt;
        data["bgColor"] = this.bgColor;
        if (Array.isArray(this.tickets)) {
            data["tickets"] = [];
            for (let item of this.tickets)
                data["tickets"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userBoards)) {
            data["userBoards"] = [];
            for (let item of this.userBoards)
                data["userBoards"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userBoards1)) {
            data["userBoards1"] = [];
            for (let item of this.userBoards1)
                data["userBoards1"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attributeDefinitions)) {
            data["attributeDefinitions"] = [];
            for (let item of this.attributeDefinitions)
                data["attributeDefinitions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.visibleToUsers)) {
            data["visibleToUsers"] = [];
            for (let item of this.visibleToUsers)
                data["visibleToUsers"].push(item);
        }
        data["isTransactionLogActive"] = this.isTransactionLogActive;
        data["lockdownDelay"] = this.lockdownDelay;
        data["enableReadConfirmations"] = this.enableReadConfirmations;
        data["onlyTimeTrackingForOthers"] = this.onlyTimeTrackingForOthers;
        data["onlyShowAssignedCardsToOthers"] = this.onlyShowAssignedCardsToOthers;
        return data;
    }

    clone(): Board {
        const json = this.toJSON();
        let result = new Board();
        result.init(json);
        return result;
    }
}

export interface IBoard {
    id?: number;
    name?: string | undefined;
    createdOn?: Date | undefined;
    userId?: string | undefined;
    fkAccountId?: number;
    cardCnt?: number;
    bgColor?: string | undefined;
    tickets?: Ticket[] | undefined;
    userBoards?: UserBoard[] | undefined;
    userBoards1?: UserBoard[] | undefined;
    attributeDefinitions?: CardAttributeDefinition[] | undefined;
    visibleToUsers?: string[] | undefined;
    isTransactionLogActive?: boolean;
    lockdownDelay?: number;
    enableReadConfirmations?: boolean;
    onlyTimeTrackingForOthers?: boolean;
    onlyShowAssignedCardsToOthers?: boolean;
}

export class Ticket implements ITicket {
    id?: number;
    name!: string;
    createdOn?: Date | undefined;
    boardId?: number;
    positionNo?: number;
    archived!: boolean;
    board?: Board | undefined;
    cards?: Card[] | undefined;

    constructor(data?: ITicket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.boardId = _data["boardId"];
            this.positionNo = _data["positionNo"];
            this.archived = _data["archived"];
            this.board = _data["board"] ? Board.fromJS(_data["board"]) : undefined as any;
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(Card.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Ticket {
        data = typeof data === 'object' ? data : {};
        let result = new Ticket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["boardId"] = this.boardId;
        data["positionNo"] = this.positionNo;
        data["archived"] = this.archived;
        data["board"] = this.board ? this.board.toJSON() : undefined as any;
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): Ticket {
        const json = this.toJSON();
        let result = new Ticket();
        result.init(json);
        return result;
    }
}

export interface ITicket {
    id?: number;
    name: string;
    createdOn?: Date | undefined;
    boardId?: number;
    positionNo?: number;
    archived: boolean;
    board?: Board | undefined;
    cards?: Card[] | undefined;
}

export class Card implements ICard {
    id?: string;
    name!: string;
    description?: string | undefined;
    createdOn?: Date | undefined;
    dueDate?: Date | undefined;
    createdBy?: string;
    archivedOn?: Date | undefined;
    archivedBy?: string | undefined;
    attachement?: string | undefined;
    positionNo?: number;
    ticketId?: number;
    archived?: boolean;
    isPublic!: boolean;
    attachments?: Attachment[] | undefined;
    cardLabels?: CardLabel[] | undefined;
    taskItems?: TaskItem[] | undefined;
    comments?: Comment[] | undefined;
    responsibles?: Responsible[] | undefined;
    durations?: CardDuration[] | undefined;
    attributes?: CardAttribute[] | undefined;
    readConfirmations?: CardReadConfirmation[] | undefined;
    ticket?: Ticket | undefined;
    activityId?: number;
    cellId?: number | undefined;
    updatedOnForReadConfirmation?: Date | undefined;

    constructor(data?: ICard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.archivedOn = _data["archivedOn"] ? new Date(_data["archivedOn"].toString()) : undefined as any;
            this.archivedBy = _data["archivedBy"];
            this.attachement = _data["attachement"];
            this.positionNo = _data["positionNo"];
            this.ticketId = _data["ticketId"];
            this.archived = _data["archived"];
            this.isPublic = _data["isPublic"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(Attachment.fromJS(item));
            }
            if (Array.isArray(_data["cardLabels"])) {
                this.cardLabels = [] as any;
                for (let item of _data["cardLabels"])
                    this.cardLabels!.push(CardLabel.fromJS(item));
            }
            if (Array.isArray(_data["taskItems"])) {
                this.taskItems = [] as any;
                for (let item of _data["taskItems"])
                    this.taskItems!.push(TaskItem.fromJS(item));
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(Comment.fromJS(item));
            }
            if (Array.isArray(_data["responsibles"])) {
                this.responsibles = [] as any;
                for (let item of _data["responsibles"])
                    this.responsibles!.push(Responsible.fromJS(item));
            }
            if (Array.isArray(_data["durations"])) {
                this.durations = [] as any;
                for (let item of _data["durations"])
                    this.durations!.push(CardDuration.fromJS(item));
            }
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(CardAttribute.fromJS(item));
            }
            if (Array.isArray(_data["readConfirmations"])) {
                this.readConfirmations = [] as any;
                for (let item of _data["readConfirmations"])
                    this.readConfirmations!.push(CardReadConfirmation.fromJS(item));
            }
            this.ticket = _data["ticket"] ? Ticket.fromJS(_data["ticket"]) : undefined as any;
            this.activityId = _data["activityId"];
            this.cellId = _data["cellId"];
            this.updatedOnForReadConfirmation = _data["updatedOnForReadConfirmation"] ? new Date(_data["updatedOnForReadConfirmation"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Card {
        data = typeof data === 'object' ? data : {};
        let result = new Card();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["archivedOn"] = this.archivedOn ? this.archivedOn.toISOString() : undefined as any;
        data["archivedBy"] = this.archivedBy;
        data["attachement"] = this.attachement;
        data["positionNo"] = this.positionNo;
        data["ticketId"] = this.ticketId;
        data["archived"] = this.archived;
        data["isPublic"] = this.isPublic;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cardLabels)) {
            data["cardLabels"] = [];
            for (let item of this.cardLabels)
                data["cardLabels"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.taskItems)) {
            data["taskItems"] = [];
            for (let item of this.taskItems)
                data["taskItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.responsibles)) {
            data["responsibles"] = [];
            for (let item of this.responsibles)
                data["responsibles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.durations)) {
            data["durations"] = [];
            for (let item of this.durations)
                data["durations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.readConfirmations)) {
            data["readConfirmations"] = [];
            for (let item of this.readConfirmations)
                data["readConfirmations"].push(item ? item.toJSON() : undefined as any);
        }
        data["ticket"] = this.ticket ? this.ticket.toJSON() : undefined as any;
        data["activityId"] = this.activityId;
        data["cellId"] = this.cellId;
        data["updatedOnForReadConfirmation"] = this.updatedOnForReadConfirmation ? this.updatedOnForReadConfirmation.toISOString() : undefined as any;
        return data;
    }

    clone(): Card {
        const json = this.toJSON();
        let result = new Card();
        result.init(json);
        return result;
    }
}

export interface ICard {
    id?: string;
    name: string;
    description?: string | undefined;
    createdOn?: Date | undefined;
    dueDate?: Date | undefined;
    createdBy?: string;
    archivedOn?: Date | undefined;
    archivedBy?: string | undefined;
    attachement?: string | undefined;
    positionNo?: number;
    ticketId?: number;
    archived?: boolean;
    isPublic: boolean;
    attachments?: Attachment[] | undefined;
    cardLabels?: CardLabel[] | undefined;
    taskItems?: TaskItem[] | undefined;
    comments?: Comment[] | undefined;
    responsibles?: Responsible[] | undefined;
    durations?: CardDuration[] | undefined;
    attributes?: CardAttribute[] | undefined;
    readConfirmations?: CardReadConfirmation[] | undefined;
    ticket?: Ticket | undefined;
    activityId?: number;
    cellId?: number | undefined;
    updatedOnForReadConfirmation?: Date | undefined;
}

export class Attachment implements IAttachment {
    id?: number;
    fileName!: string;
    fileContent!: string;
    createdOn?: Date | undefined;
    cardId?: string | undefined;
    mediaId?: string | undefined;
    card?: Card | undefined;
    type!: AttachmentType;

    constructor(data?: IAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.fileContent = _data["fileContent"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.cardId = _data["cardId"];
            this.mediaId = _data["mediaId"];
            this.card = _data["card"] ? Card.fromJS(_data["card"]) : undefined as any;
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Attachment {
        data = typeof data === 'object' ? data : {};
        let result = new Attachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["fileContent"] = this.fileContent;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["cardId"] = this.cardId;
        data["mediaId"] = this.mediaId;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        data["type"] = this.type;
        return data;
    }

    clone(): Attachment {
        const json = this.toJSON();
        let result = new Attachment();
        result.init(json);
        return result;
    }
}

export interface IAttachment {
    id?: number;
    fileName: string;
    fileContent: string;
    createdOn?: Date | undefined;
    cardId?: string | undefined;
    mediaId?: string | undefined;
    card?: Card | undefined;
    type: AttachmentType;
}

export enum AttachmentType {
    CardAttachment = 0,
    VueForm = 1,
}

export class CardLabel implements ICardLabel {
    id?: number;
    cardId?: string;
    labelId?: number;
    card?: Card | undefined;
    label?: Label | undefined;

    constructor(data?: ICardLabel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cardId = _data["cardId"];
            this.labelId = _data["labelId"];
            this.card = _data["card"] ? Card.fromJS(_data["card"]) : undefined as any;
            this.label = _data["label"] ? Label.fromJS(_data["label"]) : undefined as any;
        }
    }

    static fromJS(data: any): CardLabel {
        data = typeof data === 'object' ? data : {};
        let result = new CardLabel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cardId"] = this.cardId;
        data["labelId"] = this.labelId;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        data["label"] = this.label ? this.label.toJSON() : undefined as any;
        return data;
    }

    clone(): CardLabel {
        const json = this.toJSON();
        let result = new CardLabel();
        result.init(json);
        return result;
    }
}

export interface ICardLabel {
    id?: number;
    cardId?: string;
    labelId?: number;
    card?: Card | undefined;
    label?: Label | undefined;
}

export class Label implements ILabel {
    id?: number;
    colorTag?: string | undefined;
    cardLabels?: CardLabel[] | undefined;

    constructor(data?: ILabel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.colorTag = _data["colorTag"];
            if (Array.isArray(_data["cardLabels"])) {
                this.cardLabels = [] as any;
                for (let item of _data["cardLabels"])
                    this.cardLabels!.push(CardLabel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Label {
        data = typeof data === 'object' ? data : {};
        let result = new Label();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["colorTag"] = this.colorTag;
        if (Array.isArray(this.cardLabels)) {
            data["cardLabels"] = [];
            for (let item of this.cardLabels)
                data["cardLabels"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): Label {
        const json = this.toJSON();
        let result = new Label();
        result.init(json);
        return result;
    }
}

export interface ILabel {
    id?: number;
    colorTag?: string | undefined;
    cardLabels?: CardLabel[] | undefined;
}

export class TaskItem implements ITaskItem {
    id?: number;
    name!: string;
    description?: string | undefined;
    status!: string;
    createdOn?: Date | undefined;
    completedOn?: Date | undefined;
    completedBy?: string | undefined;
    cardId?: string;
    card?: Card | undefined;

    constructor(data?: ITaskItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.completedOn = _data["completedOn"] ? new Date(_data["completedOn"].toString()) : undefined as any;
            this.completedBy = _data["completedBy"];
            this.cardId = _data["cardId"];
            this.card = _data["card"] ? Card.fromJS(_data["card"]) : undefined as any;
        }
    }

    static fromJS(data: any): TaskItem {
        data = typeof data === 'object' ? data : {};
        let result = new TaskItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : undefined as any;
        data["completedBy"] = this.completedBy;
        data["cardId"] = this.cardId;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        return data;
    }

    clone(): TaskItem {
        const json = this.toJSON();
        let result = new TaskItem();
        result.init(json);
        return result;
    }
}

export interface ITaskItem {
    id?: number;
    name: string;
    description?: string | undefined;
    status: string;
    createdOn?: Date | undefined;
    completedOn?: Date | undefined;
    completedBy?: string | undefined;
    cardId?: string;
    card?: Card | undefined;
}

export class Comment implements IComment {
    id?: number;
    text!: string;
    createdOn?: Date | undefined;
    cardId?: string;
    aspNetUserId?: string | undefined;
    aspNetUser?: UserBase | undefined;
    card?: Card | undefined;
    commentReplies?: CommentReply[] | undefined;

    constructor(data?: IComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.cardId = _data["cardId"];
            this.aspNetUserId = _data["aspNetUserId"];
            this.aspNetUser = _data["aspNetUser"] ? UserBase.fromJS(_data["aspNetUser"]) : undefined as any;
            this.card = _data["card"] ? Card.fromJS(_data["card"]) : undefined as any;
            if (Array.isArray(_data["commentReplies"])) {
                this.commentReplies = [] as any;
                for (let item of _data["commentReplies"])
                    this.commentReplies!.push(CommentReply.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Comment {
        data = typeof data === 'object' ? data : {};
        let result = new Comment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["cardId"] = this.cardId;
        data["aspNetUserId"] = this.aspNetUserId;
        data["aspNetUser"] = this.aspNetUser ? this.aspNetUser.toJSON() : undefined as any;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        if (Array.isArray(this.commentReplies)) {
            data["commentReplies"] = [];
            for (let item of this.commentReplies)
                data["commentReplies"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): Comment {
        const json = this.toJSON();
        let result = new Comment();
        result.init(json);
        return result;
    }
}

export interface IComment {
    id?: number;
    text: string;
    createdOn?: Date | undefined;
    cardId?: string;
    aspNetUserId?: string | undefined;
    aspNetUser?: UserBase | undefined;
    card?: Card | undefined;
    commentReplies?: CommentReply[] | undefined;
}

export class UserBase implements IUserBase {
    fkAccountId?: number;
    fkSelectedAccountId?: number;
    fkhqAccountId?: number;
    userName?: string | undefined;
    timeOffset?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    id?: string;
    firebaseToken?: string | undefined;
    selfRegistered?: boolean;
    general?: string | undefined;
    isDontSendEmail?: boolean;
    culture?: string | undefined;
    isDeletedOrDisabled?: boolean;

    constructor(data?: IUserBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fkAccountId = _data["fkAccountId"];
            this.fkSelectedAccountId = _data["fkSelectedAccountId"];
            this.fkhqAccountId = _data["fkhqAccountId"];
            this.userName = _data["userName"];
            this.timeOffset = _data["timeOffset"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.id = _data["id"];
            this.firebaseToken = _data["firebaseToken"];
            this.selfRegistered = _data["selfRegistered"];
            this.general = _data["general"];
            this.isDontSendEmail = _data["isDontSendEmail"];
            this.culture = _data["culture"];
            this.isDeletedOrDisabled = _data["isDeletedOrDisabled"];
        }
    }

    static fromJS(data: any): UserBase {
        data = typeof data === 'object' ? data : {};
        let result = new UserBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fkAccountId"] = this.fkAccountId;
        data["fkSelectedAccountId"] = this.fkSelectedAccountId;
        data["fkhqAccountId"] = this.fkhqAccountId;
        data["userName"] = this.userName;
        data["timeOffset"] = this.timeOffset;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["id"] = this.id;
        data["firebaseToken"] = this.firebaseToken;
        data["selfRegistered"] = this.selfRegistered;
        data["general"] = this.general;
        data["isDontSendEmail"] = this.isDontSendEmail;
        data["culture"] = this.culture;
        data["isDeletedOrDisabled"] = this.isDeletedOrDisabled;
        return data;
    }

    clone(): UserBase {
        const json = this.toJSON();
        let result = new UserBase();
        result.init(json);
        return result;
    }
}

export interface IUserBase {
    fkAccountId?: number;
    fkSelectedAccountId?: number;
    fkhqAccountId?: number;
    userName?: string | undefined;
    timeOffset?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    id?: string;
    firebaseToken?: string | undefined;
    selfRegistered?: boolean;
    general?: string | undefined;
    isDontSendEmail?: boolean;
    culture?: string | undefined;
    isDeletedOrDisabled?: boolean;
}

export class CommentReply implements ICommentReply {
    id?: number;
    text!: string;
    createdOn?: Date | undefined;
    commentId?: number;
    aspNetUserId!: string;
    aspNetUser?: UserBase | undefined;
    comment?: Comment | undefined;

    constructor(data?: ICommentReply) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.commentId = _data["commentId"];
            this.aspNetUserId = _data["aspNetUserId"];
            this.aspNetUser = _data["aspNetUser"] ? UserBase.fromJS(_data["aspNetUser"]) : undefined as any;
            this.comment = _data["comment"] ? Comment.fromJS(_data["comment"]) : undefined as any;
        }
    }

    static fromJS(data: any): CommentReply {
        data = typeof data === 'object' ? data : {};
        let result = new CommentReply();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["commentId"] = this.commentId;
        data["aspNetUserId"] = this.aspNetUserId;
        data["aspNetUser"] = this.aspNetUser ? this.aspNetUser.toJSON() : undefined as any;
        data["comment"] = this.comment ? this.comment.toJSON() : undefined as any;
        return data;
    }

    clone(): CommentReply {
        const json = this.toJSON();
        let result = new CommentReply();
        result.init(json);
        return result;
    }
}

export interface ICommentReply {
    id?: number;
    text: string;
    createdOn?: Date | undefined;
    commentId?: number;
    aspNetUserId: string;
    aspNetUser?: UserBase | undefined;
    comment?: Comment | undefined;
}

export class Responsible implements IResponsible {
    id?: number;
    cardId?: string;
    card?: Card | undefined;
    userId?: string;
    user?: ListItem | undefined;
    assignedOn!: Date;

    constructor(data?: IResponsible) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cardId = _data["cardId"];
            this.card = _data["card"] ? Card.fromJS(_data["card"]) : undefined as any;
            this.userId = _data["userId"];
            this.user = _data["user"] ? ListItem.fromJS(_data["user"]) : undefined as any;
            this.assignedOn = _data["assignedOn"] ? new Date(_data["assignedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Responsible {
        data = typeof data === 'object' ? data : {};
        let result = new Responsible();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cardId"] = this.cardId;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["assignedOn"] = this.assignedOn ? this.assignedOn.toISOString() : undefined as any;
        return data;
    }

    clone(): Responsible {
        const json = this.toJSON();
        let result = new Responsible();
        result.init(json);
        return result;
    }
}

export interface IResponsible {
    id?: number;
    cardId?: string;
    card?: Card | undefined;
    userId?: string;
    user?: ListItem | undefined;
    assignedOn: Date;
}

export class CardDuration implements ICardDuration {
    id!: number;
    cardId!: string;
    userId!: string;
    seconds!: number;
    comment?: string | undefined;
    timeStmp?: Date;
    card?: Card | undefined;

    constructor(data?: ICardDuration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cardId = _data["cardId"];
            this.userId = _data["userId"];
            this.seconds = _data["seconds"];
            this.comment = _data["comment"];
            this.timeStmp = _data["timeStmp"] ? new Date(_data["timeStmp"].toString()) : undefined as any;
            this.card = _data["card"] ? Card.fromJS(_data["card"]) : undefined as any;
        }
    }

    static fromJS(data: any): CardDuration {
        data = typeof data === 'object' ? data : {};
        let result = new CardDuration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cardId"] = this.cardId;
        data["userId"] = this.userId;
        data["seconds"] = this.seconds;
        data["comment"] = this.comment;
        data["timeStmp"] = this.timeStmp ? this.timeStmp.toISOString() : undefined as any;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        return data;
    }

    clone(): CardDuration {
        const json = this.toJSON();
        let result = new CardDuration();
        result.init(json);
        return result;
    }
}

export interface ICardDuration {
    id: number;
    cardId: string;
    userId: string;
    seconds: number;
    comment?: string | undefined;
    timeStmp?: Date;
    card?: Card | undefined;
}

export class CardAttribute implements ICardAttribute {
    id!: number;
    cardId!: string;
    card?: Card | undefined;
    definitionId!: number;
    definition?: CardAttributeDefinition | undefined;
    value?: string | undefined;

    constructor(data?: ICardAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cardId = _data["cardId"];
            this.card = _data["card"] ? Card.fromJS(_data["card"]) : undefined as any;
            this.definitionId = _data["definitionId"];
            this.definition = _data["definition"] ? CardAttributeDefinition.fromJS(_data["definition"]) : undefined as any;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CardAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new CardAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cardId"] = this.cardId;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        data["definitionId"] = this.definitionId;
        data["definition"] = this.definition ? this.definition.toJSON() : undefined as any;
        data["value"] = this.value;
        return data;
    }

    clone(): CardAttribute {
        const json = this.toJSON();
        let result = new CardAttribute();
        result.init(json);
        return result;
    }
}

export interface ICardAttribute {
    id: number;
    cardId: string;
    card?: Card | undefined;
    definitionId: number;
    definition?: CardAttributeDefinition | undefined;
    value?: string | undefined;
}

export class CardAttributeDefinition implements ICardAttributeDefinition {
    id!: number;
    boardId!: number;
    board?: Board | undefined;
    name!: string;
    type!: CardAttributeDefinitionType;
    order!: number;
    metaData?: string | undefined;

    constructor(data?: ICardAttributeDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.boardId = _data["boardId"];
            this.board = _data["board"] ? Board.fromJS(_data["board"]) : undefined as any;
            this.name = _data["name"];
            this.type = _data["type"];
            this.order = _data["order"];
            this.metaData = _data["metaData"];
        }
    }

    static fromJS(data: any): CardAttributeDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new CardAttributeDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["boardId"] = this.boardId;
        data["board"] = this.board ? this.board.toJSON() : undefined as any;
        data["name"] = this.name;
        data["type"] = this.type;
        data["order"] = this.order;
        data["metaData"] = this.metaData;
        return data;
    }

    clone(): CardAttributeDefinition {
        const json = this.toJSON();
        let result = new CardAttributeDefinition();
        result.init(json);
        return result;
    }
}

export interface ICardAttributeDefinition {
    id: number;
    boardId: number;
    board?: Board | undefined;
    name: string;
    type: CardAttributeDefinitionType;
    order: number;
    metaData?: string | undefined;
}

export enum CardAttributeDefinitionType {
    String = 0,
    Integer = 1,
    Datetime = 2,
    Link = 3,
    Double = 4,
    Object = 20,
    Signature = 30,
    GPS = 31,
    Form = 32,
    SurveyResult = 33,
}

export class CardReadConfirmation implements ICardReadConfirmation {
    id!: string;
    cardId!: string;
    userId!: string;
    user?: ListItem | undefined;
    dateTime!: Date;

    constructor(data?: ICardReadConfirmation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cardId = _data["cardId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? ListItem.fromJS(_data["user"]) : undefined as any;
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CardReadConfirmation {
        data = typeof data === 'object' ? data : {};
        let result = new CardReadConfirmation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cardId"] = this.cardId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : undefined as any;
        return data;
    }

    clone(): CardReadConfirmation {
        const json = this.toJSON();
        let result = new CardReadConfirmation();
        result.init(json);
        return result;
    }
}

export interface ICardReadConfirmation {
    id: string;
    cardId: string;
    userId: string;
    user?: ListItem | undefined;
    dateTime: Date;
}

export class UserBoard implements IUserBoard {
    id?: number;
    fkAccountId?: number;
    boardId?: number;
    userId!: string;
    aspNetUser?: UserBase | undefined;
    board?: Board | undefined;
    board1?: Board | undefined;

    constructor(data?: IUserBoard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkAccountId = _data["fkAccountId"];
            this.boardId = _data["boardId"];
            this.userId = _data["userId"];
            this.aspNetUser = _data["aspNetUser"] ? UserBase.fromJS(_data["aspNetUser"]) : undefined as any;
            this.board = _data["board"] ? Board.fromJS(_data["board"]) : undefined as any;
            this.board1 = _data["board1"] ? Board.fromJS(_data["board1"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserBoard {
        data = typeof data === 'object' ? data : {};
        let result = new UserBoard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkAccountId"] = this.fkAccountId;
        data["boardId"] = this.boardId;
        data["userId"] = this.userId;
        data["aspNetUser"] = this.aspNetUser ? this.aspNetUser.toJSON() : undefined as any;
        data["board"] = this.board ? this.board.toJSON() : undefined as any;
        data["board1"] = this.board1 ? this.board1.toJSON() : undefined as any;
        return data;
    }

    clone(): UserBoard {
        const json = this.toJSON();
        let result = new UserBoard();
        result.init(json);
        return result;
    }
}

export interface IUserBoard {
    id?: number;
    fkAccountId?: number;
    boardId?: number;
    userId: string;
    aspNetUser?: UserBase | undefined;
    board?: Board | undefined;
    board1?: Board | undefined;
}

export class KanbanCreateBoardFromTemplateRequest implements IKanbanCreateBoardFromTemplateRequest {
    name!: string;
    templateId!: number;

    constructor(data?: IKanbanCreateBoardFromTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.templateId = _data["templateId"];
        }
    }

    static fromJS(data: any): KanbanCreateBoardFromTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanCreateBoardFromTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["templateId"] = this.templateId;
        return data;
    }

    clone(): KanbanCreateBoardFromTemplateRequest {
        const json = this.toJSON();
        let result = new KanbanCreateBoardFromTemplateRequest();
        result.init(json);
        return result;
    }
}

export interface IKanbanCreateBoardFromTemplateRequest {
    name: string;
    templateId: number;
}

export class KanbanCreateTemplateFromBoardRequest implements IKanbanCreateTemplateFromBoardRequest {
    boardId!: number;

    constructor(data?: IKanbanCreateTemplateFromBoardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardId = _data["boardId"];
        }
    }

    static fromJS(data: any): KanbanCreateTemplateFromBoardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanCreateTemplateFromBoardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardId"] = this.boardId;
        return data;
    }

    clone(): KanbanCreateTemplateFromBoardRequest {
        const json = this.toJSON();
        let result = new KanbanCreateTemplateFromBoardRequest();
        result.init(json);
        return result;
    }
}

export interface IKanbanCreateTemplateFromBoardRequest {
    boardId: number;
}

export class TimeTracker implements ITimeTracker {
    id!: string;
    cardId!: string;
    userId!: string;
    startTime!: Date;
    comment?: string | undefined;

    constructor(data?: ITimeTracker) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cardId = _data["cardId"];
            this.userId = _data["userId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): TimeTracker {
        data = typeof data === 'object' ? data : {};
        let result = new TimeTracker();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cardId"] = this.cardId;
        data["userId"] = this.userId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["comment"] = this.comment;
        return data;
    }

    clone(): TimeTracker {
        const json = this.toJSON();
        let result = new TimeTracker();
        result.init(json);
        return result;
    }
}

export interface ITimeTracker {
    id: string;
    cardId: string;
    userId: string;
    startTime: Date;
    comment?: string | undefined;
}

export class KanbanTimeTrackingStartRequest implements IKanbanTimeTrackingStartRequest {
    cardId!: string;
    comment?: string | undefined;
    startTime?: Date | undefined;

    constructor(data?: IKanbanTimeTrackingStartRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardId = _data["cardId"];
            this.comment = _data["comment"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): KanbanTimeTrackingStartRequest {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanTimeTrackingStartRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardId"] = this.cardId;
        data["comment"] = this.comment;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        return data;
    }

    clone(): KanbanTimeTrackingStartRequest {
        const json = this.toJSON();
        let result = new KanbanTimeTrackingStartRequest();
        result.init(json);
        return result;
    }
}

export interface IKanbanTimeTrackingStartRequest {
    cardId: string;
    comment?: string | undefined;
    startTime?: Date | undefined;
}

export class KanbanTimeTrackingStopRequest implements IKanbanTimeTrackingStopRequest {
    id!: string;
    comment?: string | undefined;
    stopTime?: Date | undefined;

    constructor(data?: IKanbanTimeTrackingStopRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment = _data["comment"];
            this.stopTime = _data["stopTime"] ? new Date(_data["stopTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): KanbanTimeTrackingStopRequest {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanTimeTrackingStopRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment"] = this.comment;
        data["stopTime"] = this.stopTime ? this.stopTime.toISOString() : undefined as any;
        return data;
    }

    clone(): KanbanTimeTrackingStopRequest {
        const json = this.toJSON();
        let result = new KanbanTimeTrackingStopRequest();
        result.init(json);
        return result;
    }
}

export interface IKanbanTimeTrackingStopRequest {
    id: string;
    comment?: string | undefined;
    stopTime?: Date | undefined;
}

export class BaseResultOfAccountSelect implements IBaseResultOfAccountSelect {
    id?: number;
    isOk?: boolean;
    result?: AccountSelect | undefined;

    constructor(data?: IBaseResultOfAccountSelect) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? AccountSelect.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfAccountSelect {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfAccountSelect();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfAccountSelect {
        const json = this.toJSON();
        let result = new BaseResultOfAccountSelect();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfAccountSelect {
    id?: number;
    isOk?: boolean;
    result?: AccountSelect | undefined;
}

export class BaseResultOfAttachment implements IBaseResultOfAttachment {
    id?: number;
    isOk?: boolean;
    result?: Attachment | undefined;

    constructor(data?: IBaseResultOfAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? Attachment.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfAttachment {
        const json = this.toJSON();
        let result = new BaseResultOfAttachment();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfAttachment {
    id?: number;
    isOk?: boolean;
    result?: Attachment | undefined;
}

export class BaseResultOfMediaOf implements IBaseResultOfMediaOf {
    id?: number;
    isOk?: boolean;
    result?: Media[] | undefined;

    constructor(data?: IBaseResultOfMediaOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(Media.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfMediaOf {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfMediaOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfMediaOf {
        const json = this.toJSON();
        let result = new BaseResultOfMediaOf();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfMediaOf {
    id?: number;
    isOk?: boolean;
    result?: Media[] | undefined;
}

export class LinkAttachmentRequest implements ILinkAttachmentRequest {
    cardId!: string;
    mediaId!: string;
    type!: AttachmentType;

    constructor(data?: ILinkAttachmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardId = _data["cardId"];
            this.mediaId = _data["mediaId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): LinkAttachmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LinkAttachmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardId"] = this.cardId;
        data["mediaId"] = this.mediaId;
        data["type"] = this.type;
        return data;
    }

    clone(): LinkAttachmentRequest {
        const json = this.toJSON();
        let result = new LinkAttachmentRequest();
        result.init(json);
        return result;
    }
}

export interface ILinkAttachmentRequest {
    cardId: string;
    mediaId: string;
    type: AttachmentType;
}

export class BaseResultOfCardAttributeDefinition implements IBaseResultOfCardAttributeDefinition {
    id?: number;
    isOk?: boolean;
    result?: CardAttributeDefinition | undefined;

    constructor(data?: IBaseResultOfCardAttributeDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? CardAttributeDefinition.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfCardAttributeDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfCardAttributeDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfCardAttributeDefinition {
        const json = this.toJSON();
        let result = new BaseResultOfCardAttributeDefinition();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfCardAttributeDefinition {
    id?: number;
    isOk?: boolean;
    result?: CardAttributeDefinition | undefined;
}

export class BaseResultOfBoardOf implements IBaseResultOfBoardOf {
    id?: number;
    isOk?: boolean;
    result?: Board[] | undefined;

    constructor(data?: IBaseResultOfBoardOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(Board.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfBoardOf {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfBoardOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfBoardOf {
        const json = this.toJSON();
        let result = new BaseResultOfBoardOf();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfBoardOf {
    id?: number;
    isOk?: boolean;
    result?: Board[] | undefined;
}

export class BaseResultOfBoard implements IBaseResultOfBoard {
    id?: number;
    isOk?: boolean;
    result?: Board | undefined;

    constructor(data?: IBaseResultOfBoard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? Board.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfBoard {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfBoard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfBoard {
        const json = this.toJSON();
        let result = new BaseResultOfBoard();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfBoard {
    id?: number;
    isOk?: boolean;
    result?: Board | undefined;
}

export class ChangeBoardOwnerRequest implements IChangeBoardOwnerRequest {
    boardId!: number;
    userId!: string;

    constructor(data?: IChangeBoardOwnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardId = _data["boardId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ChangeBoardOwnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeBoardOwnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardId"] = this.boardId;
        data["userId"] = this.userId;
        return data;
    }

    clone(): ChangeBoardOwnerRequest {
        const json = this.toJSON();
        let result = new ChangeBoardOwnerRequest();
        result.init(json);
        return result;
    }
}

export interface IChangeBoardOwnerRequest {
    boardId: number;
    userId: string;
}

export class BaseResultOfCardCompound implements IBaseResultOfCardCompound {
    id?: number;
    isOk?: boolean;
    result?: CardCompound | undefined;

    constructor(data?: IBaseResultOfCardCompound) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? CardCompound.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfCardCompound {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfCardCompound();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfCardCompound {
        const json = this.toJSON();
        let result = new BaseResultOfCardCompound();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfCardCompound {
    id?: number;
    isOk?: boolean;
    result?: CardCompound | undefined;
}

export class CardCompound implements ICardCompound {
    card!: Card;
    flow!: Ticket;
    board!: Board;
    users!: ListItem[];

    constructor(data?: ICardCompound) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.card = new Card();
            this.flow = new Ticket();
            this.board = new Board();
            this.users = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.card = _data["card"] ? Card.fromJS(_data["card"]) : new Card();
            this.flow = _data["flow"] ? Ticket.fromJS(_data["flow"]) : new Ticket();
            this.board = _data["board"] ? Board.fromJS(_data["board"]) : new Board();
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(ListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CardCompound {
        data = typeof data === 'object' ? data : {};
        let result = new CardCompound();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        data["flow"] = this.flow ? this.flow.toJSON() : undefined as any;
        data["board"] = this.board ? this.board.toJSON() : undefined as any;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CardCompound {
        const json = this.toJSON();
        let result = new CardCompound();
        result.init(json);
        return result;
    }
}

export interface ICardCompound {
    card: Card;
    flow: Ticket;
    board: Board;
    users: ListItem[];
}

export class BaseResultOfCard implements IBaseResultOfCard {
    id?: number;
    isOk?: boolean;
    result?: Card | undefined;

    constructor(data?: IBaseResultOfCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? Card.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfCard {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfCard {
        const json = this.toJSON();
        let result = new BaseResultOfCard();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfCard {
    id?: number;
    isOk?: boolean;
    result?: Card | undefined;
}

export class CardFix extends Card implements ICardFix {
    comments?: Comment[] | undefined;

    constructor(data?: ICardFix) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(Comment.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CardFix {
        data = typeof data === 'object' ? data : {};
        let result = new CardFix();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): CardFix {
        const json = this.toJSON();
        let result = new CardFix();
        result.init(json);
        return result;
    }
}

export interface ICardFix extends ICard {
    comments?: Comment[] | undefined;
}

export class BaseResultOfCardOf implements IBaseResultOfCardOf {
    id?: number;
    isOk?: boolean;
    result?: Card[] | undefined;

    constructor(data?: IBaseResultOfCardOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(Card.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfCardOf {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfCardOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfCardOf {
        const json = this.toJSON();
        let result = new BaseResultOfCardOf();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfCardOf {
    id?: number;
    isOk?: boolean;
    result?: Card[] | undefined;
}

export class CardsPositionRequest implements ICardsPositionRequest {
    ticketId!: number;
    cards!: CardFix[];

    constructor(data?: ICardsPositionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.cards = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data["ticketId"];
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(CardFix.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CardsPositionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CardsPositionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CardsPositionRequest {
        const json = this.toJSON();
        let result = new CardsPositionRequest();
        result.init(json);
        return result;
    }
}

export interface ICardsPositionRequest {
    ticketId: number;
    cards: CardFix[];
}

export class ResponsibleRequest implements IResponsibleRequest {
    cardId!: string;
    userId!: string;
    add!: boolean;

    constructor(data?: IResponsibleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardId = _data["cardId"];
            this.userId = _data["userId"];
            this.add = _data["add"];
        }
    }

    static fromJS(data: any): ResponsibleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResponsibleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardId"] = this.cardId;
        data["userId"] = this.userId;
        data["add"] = this.add;
        return data;
    }

    clone(): ResponsibleRequest {
        const json = this.toJSON();
        let result = new ResponsibleRequest();
        result.init(json);
        return result;
    }
}

export interface IResponsibleRequest {
    cardId: string;
    userId: string;
    add: boolean;
}

export class LabelRequest implements ILabelRequest {
    cardId!: string;
    labelId!: number;
    add!: boolean;

    constructor(data?: ILabelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardId = _data["cardId"];
            this.labelId = _data["labelId"];
            this.add = _data["add"];
        }
    }

    static fromJS(data: any): LabelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LabelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardId"] = this.cardId;
        data["labelId"] = this.labelId;
        data["add"] = this.add;
        return data;
    }

    clone(): LabelRequest {
        const json = this.toJSON();
        let result = new LabelRequest();
        result.init(json);
        return result;
    }
}

export interface ILabelRequest {
    cardId: string;
    labelId: number;
    add: boolean;
}

export class PublicRequest implements IPublicRequest {
    cardId!: string;
    isPublic!: boolean;

    constructor(data?: IPublicRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardId = _data["cardId"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): PublicRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PublicRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardId"] = this.cardId;
        data["isPublic"] = this.isPublic;
        return data;
    }

    clone(): PublicRequest {
        const json = this.toJSON();
        let result = new PublicRequest();
        result.init(json);
        return result;
    }
}

export interface IPublicRequest {
    cardId: string;
    isPublic: boolean;
}

export class AttributesRequest implements IAttributesRequest {
    cardId!: string;
    attributes!: CardAttribute[];

    constructor(data?: IAttributesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.attributes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardId = _data["cardId"];
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(CardAttribute.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AttributesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AttributesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardId"] = this.cardId;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): AttributesRequest {
        const json = this.toJSON();
        let result = new AttributesRequest();
        result.init(json);
        return result;
    }
}

export interface IAttributesRequest {
    cardId: string;
    attributes: CardAttribute[];
}

export class AttributeRequest implements IAttributeRequest {
    cardId!: string;
    attribute!: CardAttribute;

    constructor(data?: IAttributeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.attribute = new CardAttribute();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardId = _data["cardId"];
            this.attribute = _data["attribute"] ? CardAttribute.fromJS(_data["attribute"]) : new CardAttribute();
        }
    }

    static fromJS(data: any): AttributeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardId"] = this.cardId;
        data["attribute"] = this.attribute ? this.attribute.toJSON() : undefined as any;
        return data;
    }

    clone(): AttributeRequest {
        const json = this.toJSON();
        let result = new AttributeRequest();
        result.init(json);
        return result;
    }
}

export interface IAttributeRequest {
    cardId: string;
    attribute: CardAttribute;
}

export class SystemAttributesRequest implements ISystemAttributesRequest {
    cardId!: string;
    activityIdSet?: boolean;
    activityId?: number | undefined;
    cellIdSet?: boolean;
    cellId?: number | undefined;

    constructor(data?: ISystemAttributesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardId = _data["cardId"];
            this.activityIdSet = _data["activityIdSet"];
            this.activityId = _data["activityId"];
            this.cellIdSet = _data["cellIdSet"];
            this.cellId = _data["cellId"];
        }
    }

    static fromJS(data: any): SystemAttributesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SystemAttributesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardId"] = this.cardId;
        data["activityIdSet"] = this.activityIdSet;
        data["activityId"] = this.activityId;
        data["cellIdSet"] = this.cellIdSet;
        data["cellId"] = this.cellId;
        return data;
    }

    clone(): SystemAttributesRequest {
        const json = this.toJSON();
        let result = new SystemAttributesRequest();
        result.init(json);
        return result;
    }
}

export interface ISystemAttributesRequest {
    cardId: string;
    activityIdSet?: boolean;
    activityId?: number | undefined;
    cellIdSet?: boolean;
    cellId?: number | undefined;
}

export class BaseResultOfCardDuration implements IBaseResultOfCardDuration {
    id?: number;
    isOk?: boolean;
    result?: CardDuration | undefined;

    constructor(data?: IBaseResultOfCardDuration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? CardDuration.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfCardDuration {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfCardDuration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfCardDuration {
        const json = this.toJSON();
        let result = new BaseResultOfCardDuration();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfCardDuration {
    id?: number;
    isOk?: boolean;
    result?: CardDuration | undefined;
}

export class BaseResultOfCommentReply implements IBaseResultOfCommentReply {
    id?: number;
    isOk?: boolean;
    result?: CommentReply | undefined;

    constructor(data?: IBaseResultOfCommentReply) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? CommentReply.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfCommentReply {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfCommentReply();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfCommentReply {
        const json = this.toJSON();
        let result = new BaseResultOfCommentReply();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfCommentReply {
    id?: number;
    isOk?: boolean;
    result?: CommentReply | undefined;
}

export class BaseResultOfComment implements IBaseResultOfComment {
    id?: number;
    isOk?: boolean;
    result?: Comment | undefined;

    constructor(data?: IBaseResultOfComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? Comment.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfComment {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfComment {
        const json = this.toJSON();
        let result = new BaseResultOfComment();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfComment {
    id?: number;
    isOk?: boolean;
    result?: Comment | undefined;
}

export class BaseResultOfLabelOf implements IBaseResultOfLabelOf {
    id?: number;
    isOk?: boolean;
    result?: Label[] | undefined;

    constructor(data?: IBaseResultOfLabelOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(Label.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfLabelOf {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfLabelOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfLabelOf {
        const json = this.toJSON();
        let result = new BaseResultOfLabelOf();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfLabelOf {
    id?: number;
    isOk?: boolean;
    result?: Label[] | undefined;
}

export class BaseResultOfLogItemResultDto implements IBaseResultOfLogItemResultDto {
    id?: number;
    isOk?: boolean;
    result?: LogItemResultDto | undefined;

    constructor(data?: IBaseResultOfLogItemResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? LogItemResultDto.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfLogItemResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfLogItemResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfLogItemResultDto {
        const json = this.toJSON();
        let result = new BaseResultOfLogItemResultDto();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfLogItemResultDto {
    id?: number;
    isOk?: boolean;
    result?: LogItemResultDto | undefined;
}

export class LogItemResultDto implements ILogItemResultDto {
    boardEvents!: BoardLogItemDto[];
    ticketEvents!: TicketLogItemDto[];
    cardEvents!: CardLogItemDto[];
    users!: UserNameDto[];

    constructor(data?: ILogItemResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.boardEvents = [];
            this.ticketEvents = [];
            this.cardEvents = [];
            this.users = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["boardEvents"])) {
                this.boardEvents = [] as any;
                for (let item of _data["boardEvents"])
                    this.boardEvents!.push(BoardLogItemDto.fromJS(item));
            }
            if (Array.isArray(_data["ticketEvents"])) {
                this.ticketEvents = [] as any;
                for (let item of _data["ticketEvents"])
                    this.ticketEvents!.push(TicketLogItemDto.fromJS(item));
            }
            if (Array.isArray(_data["cardEvents"])) {
                this.cardEvents = [] as any;
                for (let item of _data["cardEvents"])
                    this.cardEvents!.push(CardLogItemDto.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LogItemResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogItemResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.boardEvents)) {
            data["boardEvents"] = [];
            for (let item of this.boardEvents)
                data["boardEvents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ticketEvents)) {
            data["ticketEvents"] = [];
            for (let item of this.ticketEvents)
                data["ticketEvents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cardEvents)) {
            data["cardEvents"] = [];
            for (let item of this.cardEvents)
                data["cardEvents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): LogItemResultDto {
        const json = this.toJSON();
        let result = new LogItemResultDto();
        result.init(json);
        return result;
    }
}

export interface ILogItemResultDto {
    boardEvents: BoardLogItemDto[];
    ticketEvents: TicketLogItemDto[];
    cardEvents: CardLogItemDto[];
    users: UserNameDto[];
}

export class LogItemDto implements ILogItemDto {
    logItem!: LogItem;

    constructor(data?: ILogItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.logItem = new LogItem();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logItem = _data["logItem"] ? LogItem.fromJS(_data["logItem"]) : new LogItem();
        }
    }

    static fromJS(data: any): LogItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logItem"] = this.logItem ? this.logItem.toJSON() : undefined as any;
        return data;
    }

    clone(): LogItemDto {
        const json = this.toJSON();
        let result = new LogItemDto();
        result.init(json);
        return result;
    }
}

export interface ILogItemDto {
    logItem: LogItem;
}

export class BoardLogItemDto extends LogItemDto implements IBoardLogItemDto {
    boardId!: number;
    boardEvent!: BoardEvents;

    constructor(data?: IBoardLogItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.boardId = _data["boardId"];
            this.boardEvent = _data["boardEvent"];
        }
    }

    static override fromJS(data: any): BoardLogItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoardLogItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardId"] = this.boardId;
        data["boardEvent"] = this.boardEvent;
        super.toJSON(data);
        return data;
    }

    clone(): BoardLogItemDto {
        const json = this.toJSON();
        let result = new BoardLogItemDto();
        result.init(json);
        return result;
    }
}

export interface IBoardLogItemDto extends ILogItemDto {
    boardId: number;
    boardEvent: BoardEvents;
}

export enum BoardEvents {
    CREATED = 0,
    DELETED = 1,
    UPDATED = 2,
    TICKETS_ORDER_UPDATED = 3,
    APPROVAL_CREATED = 4,
    APPROVAL_APPROVED = 5,
    OWNER_CHANGED = 6,
}

export class LogItem implements ILogItem {
    id?: number;
    fkAccountId?: number;
    pos?: number;
    lastModified!: Date;
    type?: string | undefined;
    link?: string | undefined;
    content?: string | undefined;
    category?: number;
    relatedId?: string;
    userId?: string;

    constructor(data?: ILogItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkAccountId = _data["fkAccountId"];
            this.pos = _data["pos"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.type = _data["type"];
            this.link = _data["link"];
            this.content = _data["content"];
            this.category = _data["category"];
            this.relatedId = _data["relatedId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): LogItem {
        data = typeof data === 'object' ? data : {};
        let result = new LogItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkAccountId"] = this.fkAccountId;
        data["pos"] = this.pos;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["type"] = this.type;
        data["link"] = this.link;
        data["content"] = this.content;
        data["category"] = this.category;
        data["relatedId"] = this.relatedId;
        data["userId"] = this.userId;
        return data;
    }

    clone(): LogItem {
        const json = this.toJSON();
        let result = new LogItem();
        result.init(json);
        return result;
    }
}

export interface ILogItem {
    id?: number;
    fkAccountId?: number;
    pos?: number;
    lastModified: Date;
    type?: string | undefined;
    link?: string | undefined;
    content?: string | undefined;
    category?: number;
    relatedId?: string;
    userId?: string;
}

export class TicketLogItemDto extends LogItemDto implements ITicketLogItemDto {
    ticketId!: number;
    ticketEvent!: TicketEvents;

    constructor(data?: ITicketLogItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ticketId = _data["ticketId"];
            this.ticketEvent = _data["ticketEvent"];
        }
    }

    static override fromJS(data: any): TicketLogItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketLogItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketId"] = this.ticketId;
        data["ticketEvent"] = this.ticketEvent;
        super.toJSON(data);
        return data;
    }

    clone(): TicketLogItemDto {
        const json = this.toJSON();
        let result = new TicketLogItemDto();
        result.init(json);
        return result;
    }
}

export interface ITicketLogItemDto extends ILogItemDto {
    ticketId: number;
    ticketEvent: TicketEvents;
}

export enum TicketEvents {
    CREATED = 0,
    UPDATED = 1,
    DELETED = 2,
    CARDS_ORDER_UPDATED = 3,
}

export class CardLogItemDto extends LogItemDto implements ICardLogItemDto {
    cardId!: string;
    cardEvent!: CardEvents;

    constructor(data?: ICardLogItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cardId = _data["cardId"];
            this.cardEvent = _data["cardEvent"];
        }
    }

    static override fromJS(data: any): CardLogItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CardLogItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardId"] = this.cardId;
        data["cardEvent"] = this.cardEvent;
        super.toJSON(data);
        return data;
    }

    clone(): CardLogItemDto {
        const json = this.toJSON();
        let result = new CardLogItemDto();
        result.init(json);
        return result;
    }
}

export interface ICardLogItemDto extends ILogItemDto {
    cardId: string;
    cardEvent: CardEvents;
}

export enum CardEvents {
    CREATED = 0,
    UPDATED = 1,
    DELETED = 2,
    READ_CONFIRMATION = 10,
}

export class UserNameDto implements IUserNameDto {
    id!: string;
    name!: string;

    constructor(data?: IUserNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): UserNameDto {
        const json = this.toJSON();
        let result = new UserNameDto();
        result.init(json);
        return result;
    }
}

export interface IUserNameDto {
    id: string;
    name: string;
}

export class BaseResultOfInteger implements IBaseResultOfInteger {
    id?: number;
    isOk?: boolean;
    result?: number;

    constructor(data?: IBaseResultOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): BaseResultOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result;
        return data;
    }

    clone(): BaseResultOfInteger {
        const json = this.toJSON();
        let result = new BaseResultOfInteger();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfInteger {
    id?: number;
    isOk?: boolean;
    result?: number;
}

export class BaseResultOfTaskItem implements IBaseResultOfTaskItem {
    id?: number;
    isOk?: boolean;
    result?: TaskItem | undefined;

    constructor(data?: IBaseResultOfTaskItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? TaskItem.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfTaskItem {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfTaskItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfTaskItem {
        const json = this.toJSON();
        let result = new BaseResultOfTaskItem();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfTaskItem {
    id?: number;
    isOk?: boolean;
    result?: TaskItem | undefined;
}

export class BaseResultOfTicket implements IBaseResultOfTicket {
    id?: number;
    isOk?: boolean;
    result?: Ticket | undefined;

    constructor(data?: IBaseResultOfTicket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? Ticket.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfTicket {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfTicket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfTicket {
        const json = this.toJSON();
        let result = new BaseResultOfTicket();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfTicket {
    id?: number;
    isOk?: boolean;
    result?: Ticket | undefined;
}

export class TicketFix extends Ticket implements ITicketFix {
    cards?: CardFix[] | undefined;

    constructor(data?: ITicketFix) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(CardFix.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TicketFix {
        data = typeof data === 'object' ? data : {};
        let result = new TicketFix();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): TicketFix {
        const json = this.toJSON();
        let result = new TicketFix();
        result.init(json);
        return result;
    }
}

export interface ITicketFix extends ITicket {
    cards?: CardFix[] | undefined;
}

export class BaseResultOfTicketOf implements IBaseResultOfTicketOf {
    id?: number;
    isOk?: boolean;
    result?: Ticket[] | undefined;

    constructor(data?: IBaseResultOfTicketOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(Ticket.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfTicketOf {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfTicketOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfTicketOf {
        const json = this.toJSON();
        let result = new BaseResultOfTicketOf();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfTicketOf {
    id?: number;
    isOk?: boolean;
    result?: Ticket[] | undefined;
}

export class TicketsPositionRequest implements ITicketsPositionRequest {
    boardId?: number;
    tickets?: TicketFix[] | undefined;

    constructor(data?: ITicketsPositionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardId = _data["boardId"];
            if (Array.isArray(_data["tickets"])) {
                this.tickets = [] as any;
                for (let item of _data["tickets"])
                    this.tickets!.push(TicketFix.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketsPositionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TicketsPositionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardId"] = this.boardId;
        if (Array.isArray(this.tickets)) {
            data["tickets"] = [];
            for (let item of this.tickets)
                data["tickets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TicketsPositionRequest {
        const json = this.toJSON();
        let result = new TicketsPositionRequest();
        result.init(json);
        return result;
    }
}

export interface ITicketsPositionRequest {
    boardId?: number;
    tickets?: TicketFix[] | undefined;
}

export class BaseResultOfBoardSharedUserInfoOf implements IBaseResultOfBoardSharedUserInfoOf {
    id?: number;
    isOk?: boolean;
    result?: BoardSharedUserInfo[] | undefined;

    constructor(data?: IBaseResultOfBoardSharedUserInfoOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(BoardSharedUserInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfBoardSharedUserInfoOf {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfBoardSharedUserInfoOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfBoardSharedUserInfoOf {
        const json = this.toJSON();
        let result = new BaseResultOfBoardSharedUserInfoOf();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfBoardSharedUserInfoOf {
    id?: number;
    isOk?: boolean;
    result?: BoardSharedUserInfo[] | undefined;
}

export class BoardSharedUserInfo implements IBoardSharedUserInfo {
    boardId!: number;
    userIds!: string[];

    constructor(data?: IBoardSharedUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.userIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardId = _data["boardId"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BoardSharedUserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BoardSharedUserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardId"] = this.boardId;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        return data;
    }

    clone(): BoardSharedUserInfo {
        const json = this.toJSON();
        let result = new BoardSharedUserInfo();
        result.init(json);
        return result;
    }
}

export interface IBoardSharedUserInfo {
    boardId: number;
    userIds: string[];
}

export class BaseResultOfCardSharedUserInfoOf implements IBaseResultOfCardSharedUserInfoOf {
    id?: number;
    isOk?: boolean;
    result?: CardSharedUserInfo[] | undefined;

    constructor(data?: IBaseResultOfCardSharedUserInfoOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(CardSharedUserInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfCardSharedUserInfoOf {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfCardSharedUserInfoOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfCardSharedUserInfoOf {
        const json = this.toJSON();
        let result = new BaseResultOfCardSharedUserInfoOf();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfCardSharedUserInfoOf {
    id?: number;
    isOk?: boolean;
    result?: CardSharedUserInfo[] | undefined;
}

export class CardSharedUserInfo implements ICardSharedUserInfo {
    cardId!: string;
    accountIds!: number[];
    targetSelfShareBoard?: number | undefined;
    targetSelfShareFlow?: number | undefined;

    constructor(data?: ICardSharedUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.accountIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardId = _data["cardId"];
            if (Array.isArray(_data["accountIds"])) {
                this.accountIds = [] as any;
                for (let item of _data["accountIds"])
                    this.accountIds!.push(item);
            }
            this.targetSelfShareBoard = _data["targetSelfShareBoard"];
            this.targetSelfShareFlow = _data["targetSelfShareFlow"];
        }
    }

    static fromJS(data: any): CardSharedUserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CardSharedUserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardId"] = this.cardId;
        if (Array.isArray(this.accountIds)) {
            data["accountIds"] = [];
            for (let item of this.accountIds)
                data["accountIds"].push(item);
        }
        data["targetSelfShareBoard"] = this.targetSelfShareBoard;
        data["targetSelfShareFlow"] = this.targetSelfShareFlow;
        return data;
    }

    clone(): CardSharedUserInfo {
        const json = this.toJSON();
        let result = new CardSharedUserInfo();
        result.init(json);
        return result;
    }
}

export interface ICardSharedUserInfo {
    cardId: string;
    accountIds: number[];
    targetSelfShareBoard?: number | undefined;
    targetSelfShareFlow?: number | undefined;
}

export class BaseResultOfListItemOf implements IBaseResultOfListItemOf {
    id?: number;
    isOk?: boolean;
    result?: ListItem[] | undefined;

    constructor(data?: IBaseResultOfListItemOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(ListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfListItemOf {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfListItemOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfListItemOf {
        const json = this.toJSON();
        let result = new BaseResultOfListItemOf();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfListItemOf {
    id?: number;
    isOk?: boolean;
    result?: ListItem[] | undefined;
}

export class LinkCollection implements ILinkCollection {
    id!: string;
    accountId!: number;
    name!: string;
    description?: string | undefined;
    customCss?: string | undefined;
    backgroundImage?: string | undefined;
    backgroundImageName?: string | undefined;
    links?: Link[] | undefined;

    constructor(data?: ILinkCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.customCss = _data["customCss"];
            this.backgroundImage = _data["backgroundImage"];
            this.backgroundImageName = _data["backgroundImageName"];
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(Link.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LinkCollection {
        data = typeof data === 'object' ? data : {};
        let result = new LinkCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["customCss"] = this.customCss;
        data["backgroundImage"] = this.backgroundImage;
        data["backgroundImageName"] = this.backgroundImageName;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): LinkCollection {
        const json = this.toJSON();
        let result = new LinkCollection();
        result.init(json);
        return result;
    }
}

export interface ILinkCollection {
    id: string;
    accountId: number;
    name: string;
    description?: string | undefined;
    customCss?: string | undefined;
    backgroundImage?: string | undefined;
    backgroundImageName?: string | undefined;
    links?: Link[] | undefined;
}

export class Link implements ILink {
    id!: string;
    name!: string;
    description?: string | undefined;
    url!: string;
    order!: number;
    newTab!: boolean;
    linkCollectionId!: string;

    constructor(data?: ILink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.order = _data["order"];
            this.newTab = _data["newTab"];
            this.linkCollectionId = _data["linkCollectionId"];
        }
    }

    static fromJS(data: any): Link {
        data = typeof data === 'object' ? data : {};
        let result = new Link();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["url"] = this.url;
        data["order"] = this.order;
        data["newTab"] = this.newTab;
        data["linkCollectionId"] = this.linkCollectionId;
        return data;
    }

    clone(): Link {
        const json = this.toJSON();
        let result = new Link();
        result.init(json);
        return result;
    }
}

export interface ILink {
    id: string;
    name: string;
    description?: string | undefined;
    url: string;
    order: number;
    newTab: boolean;
    linkCollectionId: string;
}

export class CollectionQrRequest implements ICollectionQrRequest {
    collectionIds!: string[];
    columns!: number;

    constructor(data?: ICollectionQrRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.collectionIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["collectionIds"])) {
                this.collectionIds = [] as any;
                for (let item of _data["collectionIds"])
                    this.collectionIds!.push(item);
            }
            this.columns = _data["columns"];
        }
    }

    static fromJS(data: any): CollectionQrRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionQrRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.collectionIds)) {
            data["collectionIds"] = [];
            for (let item of this.collectionIds)
                data["collectionIds"].push(item);
        }
        data["columns"] = this.columns;
        return data;
    }

    clone(): CollectionQrRequest {
        const json = this.toJSON();
        let result = new CollectionQrRequest();
        result.init(json);
        return result;
    }
}

export interface ICollectionQrRequest {
    collectionIds: string[];
    columns: number;
}

export class VMLabelNode implements IVMLabelNode {
    name?: string | undefined;
    id?: number;
    parentId?: number;
    parent?: VMLabelNode | undefined;
    nodes?: VMLabelNode[] | undefined;
    events?: VMEvent[] | undefined;

    constructor(data?: IVMLabelNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.parent = _data["parent"] ? VMLabelNode.fromJS(_data["parent"]) : undefined as any;
            if (Array.isArray(_data["nodes"])) {
                this.nodes = [] as any;
                for (let item of _data["nodes"])
                    this.nodes!.push(VMLabelNode.fromJS(item));
            }
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(VMEvent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VMLabelNode {
        data = typeof data === 'object' ? data : {};
        let result = new VMLabelNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        if (Array.isArray(this.nodes)) {
            data["nodes"] = [];
            for (let item of this.nodes)
                data["nodes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): VMLabelNode {
        const json = this.toJSON();
        let result = new VMLabelNode();
        result.init(json);
        return result;
    }
}

export interface IVMLabelNode {
    name?: string | undefined;
    id?: number;
    parentId?: number;
    parent?: VMLabelNode | undefined;
    nodes?: VMLabelNode[] | undefined;
    events?: VMEvent[] | undefined;
}

export class VMEvent implements IVMEvent {
    labelId?: number;
    labelName?: string | undefined;
    buttonNo?: number;
    id?: number;
    name?: string | undefined;
    type?: EventType;
    eventCell?: Cell | undefined;
    userID?: string | undefined;

    constructor(data?: IVMEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labelId = _data["labelId"];
            this.labelName = _data["labelName"];
            this.buttonNo = _data["buttonNo"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.eventCell = _data["eventCell"] ? Cell.fromJS(_data["eventCell"]) : undefined as any;
            this.userID = _data["userID"];
        }
    }

    static fromJS(data: any): VMEvent {
        data = typeof data === 'object' ? data : {};
        let result = new VMEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labelId"] = this.labelId;
        data["labelName"] = this.labelName;
        data["buttonNo"] = this.buttonNo;
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["eventCell"] = this.eventCell ? this.eventCell.toJSON() : undefined as any;
        data["userID"] = this.userID;
        return data;
    }

    clone(): VMEvent {
        const json = this.toJSON();
        let result = new VMEvent();
        result.init(json);
        return result;
    }
}

export interface IVMEvent {
    labelId?: number;
    labelName?: string | undefined;
    buttonNo?: number;
    id?: number;
    name?: string | undefined;
    type?: EventType;
    eventCell?: Cell | undefined;
    userID?: string | undefined;
}

export enum EventType {
    IntendedEvent = 1,
    ShortEvent = 2,
    StopEvent = 4,
    ShortOrStopEvent = 6,
}

export class Cell extends BaseEntityOfInteger implements ICell {
    name?: string | undefined;
    qrActivityId?: number;
    lineId?: number;
    line?: Line | undefined;
    fkAccountId?: number;
    description?: string | undefined;
    supplier?: string | undefined;
    ident?: string | undefined;
    ident2?: string | undefined;
    costCenter?: string | undefined;
    engineHours?: string | undefined;
    engineHoursUnit?: string | undefined;
    comment?: string | undefined;
    ratePerHour?: number;
    baseLineMinutes?: number;
    isCreateIfNoActivity?: boolean;
    commentLastUpdate?: Date;
    address?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    label?: string | undefined;
    misc?: string | undefined;
    color?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    isFireProtection?: boolean;
    risk?: number;
    yearOfManufacture?: number | undefined;
    files?: Media2[] | undefined;
    costs?: CostDto[] | undefined;

    constructor(data?: ICell) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.qrActivityId = _data["qrActivityId"];
            this.lineId = _data["lineId"];
            this.line = _data["line"] ? Line.fromJS(_data["line"]) : undefined as any;
            this.fkAccountId = _data["fkAccountId"];
            this.description = _data["description"];
            this.supplier = _data["supplier"];
            this.ident = _data["ident"];
            this.ident2 = _data["ident2"];
            this.costCenter = _data["costCenter"];
            this.engineHours = _data["engineHours"];
            this.engineHoursUnit = _data["engineHoursUnit"];
            this.comment = _data["comment"];
            this.ratePerHour = _data["ratePerHour"];
            this.baseLineMinutes = _data["baseLineMinutes"];
            this.isCreateIfNoActivity = _data["isCreateIfNoActivity"];
            this.commentLastUpdate = _data["commentLastUpdate"] ? new Date(_data["commentLastUpdate"].toString()) : undefined as any;
            this.address = _data["address"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.label = _data["label"];
            this.misc = _data["misc"];
            this.color = _data["color"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.isFireProtection = _data["isFireProtection"];
            this.risk = _data["risk"];
            this.yearOfManufacture = _data["yearOfManufacture"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(Media2.fromJS(item));
            }
            if (Array.isArray(_data["costs"])) {
                this.costs = [] as any;
                for (let item of _data["costs"])
                    this.costs!.push(CostDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Cell {
        data = typeof data === 'object' ? data : {};
        let result = new Cell();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["qrActivityId"] = this.qrActivityId;
        data["lineId"] = this.lineId;
        data["line"] = this.line ? this.line.toJSON() : undefined as any;
        data["fkAccountId"] = this.fkAccountId;
        data["description"] = this.description;
        data["supplier"] = this.supplier;
        data["ident"] = this.ident;
        data["ident2"] = this.ident2;
        data["costCenter"] = this.costCenter;
        data["engineHours"] = this.engineHours;
        data["engineHoursUnit"] = this.engineHoursUnit;
        data["comment"] = this.comment;
        data["ratePerHour"] = this.ratePerHour;
        data["baseLineMinutes"] = this.baseLineMinutes;
        data["isCreateIfNoActivity"] = this.isCreateIfNoActivity;
        data["commentLastUpdate"] = this.commentLastUpdate ? this.commentLastUpdate.toISOString() : undefined as any;
        data["address"] = this.address;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["country"] = this.country;
        data["label"] = this.label;
        data["misc"] = this.misc;
        data["color"] = this.color;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["isFireProtection"] = this.isFireProtection;
        data["risk"] = this.risk;
        data["yearOfManufacture"] = this.yearOfManufacture;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.costs)) {
            data["costs"] = [];
            for (let item of this.costs)
                data["costs"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Cell {
        const json = this.toJSON();
        let result = new Cell();
        result.init(json);
        return result;
    }
}

export interface ICell extends IBaseEntityOfInteger {
    name?: string | undefined;
    qrActivityId?: number;
    lineId?: number;
    line?: Line | undefined;
    fkAccountId?: number;
    description?: string | undefined;
    supplier?: string | undefined;
    ident?: string | undefined;
    ident2?: string | undefined;
    costCenter?: string | undefined;
    engineHours?: string | undefined;
    engineHoursUnit?: string | undefined;
    comment?: string | undefined;
    ratePerHour?: number;
    baseLineMinutes?: number;
    isCreateIfNoActivity?: boolean;
    commentLastUpdate?: Date;
    address?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    label?: string | undefined;
    misc?: string | undefined;
    color?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    isFireProtection?: boolean;
    risk?: number;
    yearOfManufacture?: number | undefined;
    files?: Media2[] | undefined;
    costs?: CostDto[] | undefined;
}

export class Line implements ILine {
    id?: number;
    name?: string | undefined;
    cells?: Cell[] | undefined;
    siteId?: number;
    site?: Site | undefined;
    fkAccountId?: number;

    constructor(data?: ILine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["cells"])) {
                this.cells = [] as any;
                for (let item of _data["cells"])
                    this.cells!.push(Cell.fromJS(item));
            }
            this.siteId = _data["siteId"];
            this.site = _data["site"] ? Site.fromJS(_data["site"]) : undefined as any;
            this.fkAccountId = _data["fkAccountId"];
        }
    }

    static fromJS(data: any): Line {
        data = typeof data === 'object' ? data : {};
        let result = new Line();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.cells)) {
            data["cells"] = [];
            for (let item of this.cells)
                data["cells"].push(item ? item.toJSON() : undefined as any);
        }
        data["siteId"] = this.siteId;
        data["site"] = this.site ? this.site.toJSON() : undefined as any;
        data["fkAccountId"] = this.fkAccountId;
        return data;
    }

    clone(): Line {
        const json = this.toJSON();
        let result = new Line();
        result.init(json);
        return result;
    }
}

export interface ILine {
    id?: number;
    name?: string | undefined;
    cells?: Cell[] | undefined;
    siteId?: number;
    site?: Site | undefined;
    fkAccountId?: number;
}

export class Site implements ISite {
    id?: number;
    fkAccountId?: number;
    name?: string | undefined;
    lines?: Line[] | undefined;

    constructor(data?: ISite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkAccountId = _data["fkAccountId"];
            this.name = _data["name"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(Line.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Site {
        data = typeof data === 'object' ? data : {};
        let result = new Site();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkAccountId"] = this.fkAccountId;
        data["name"] = this.name;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): Site {
        const json = this.toJSON();
        let result = new Site();
        result.init(json);
        return result;
    }
}

export interface ISite {
    id?: number;
    fkAccountId?: number;
    name?: string | undefined;
    lines?: Line[] | undefined;
}

export class Media2 extends MediaBase implements IMedia2 {
    properties?: string | undefined;
    folder?: MediaFolderDto | undefined;
    versions?: MediaVersion2[] | undefined;

    constructor(data?: IMedia2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.properties = _data["properties"];
            this.folder = _data["folder"] ? MediaFolderDto.fromJS(_data["folder"]) : undefined as any;
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(MediaVersion2.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Media2 {
        data = typeof data === 'object' ? data : {};
        let result = new Media2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["properties"] = this.properties;
        data["folder"] = this.folder ? this.folder.toJSON() : undefined as any;
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Media2 {
        const json = this.toJSON();
        let result = new Media2();
        result.init(json);
        return result;
    }
}

export interface IMedia2 extends IMediaBase {
    properties?: string | undefined;
    folder?: MediaFolderDto | undefined;
    versions?: MediaVersion2[] | undefined;
}

export class MediaFolder implements IMediaFolder {
    id?: string;
    parentId?: string | undefined;
    creatorId?: string;
    fkAccountId?: number | undefined;
    name!: string;
    created?: Date;

    constructor(data?: IMediaFolder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.creatorId = _data["creatorId"];
            this.fkAccountId = _data["fkAccountId"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): MediaFolder {
        data = typeof data === 'object' ? data : {};
        let result = new MediaFolder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["creatorId"] = this.creatorId;
        data["fkAccountId"] = this.fkAccountId;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        return data;
    }

    clone(): MediaFolder {
        const json = this.toJSON();
        let result = new MediaFolder();
        result.init(json);
        return result;
    }
}

export interface IMediaFolder {
    id?: string;
    parentId?: string | undefined;
    creatorId?: string;
    fkAccountId?: number | undefined;
    name: string;
    created?: Date;
}

export class MediaFolderDto extends MediaFolder implements IMediaFolderDto {
    media?: Media2[] | undefined;

    constructor(data?: IMediaFolderDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["media"])) {
                this.media = [] as any;
                for (let item of _data["media"])
                    this.media!.push(Media2.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): MediaFolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new MediaFolderDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.media)) {
            data["media"] = [];
            for (let item of this.media)
                data["media"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): MediaFolderDto {
        const json = this.toJSON();
        let result = new MediaFolderDto();
        result.init(json);
        return result;
    }
}

export interface IMediaFolderDto extends IMediaFolder {
    media?: Media2[] | undefined;
}

export class MediaVersion2 extends MediaVersion implements IMediaVersion2 {
    mediaId?: string;

    constructor(data?: IMediaVersion2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mediaId = _data["mediaId"];
        }
    }

    static override fromJS(data: any): MediaVersion2 {
        data = typeof data === 'object' ? data : {};
        let result = new MediaVersion2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mediaId"] = this.mediaId;
        super.toJSON(data);
        return data;
    }

    clone(): MediaVersion2 {
        const json = this.toJSON();
        let result = new MediaVersion2();
        result.init(json);
        return result;
    }
}

export interface IMediaVersion2 extends IMediaVersion {
    mediaId?: string;
}

export class CostDto implements ICostDto {
    id!: string;
    fkAccountId!: number;
    startTime!: Date;
    endTime!: Date;
    amount!: number;
    quantity!: number;
    value4Type1!: number;
    subCategory!: string;
    costUnit!: string;
    costUnitIdent!: string;
    costCenter!: string;
    transactionComment!: string;
    category?: TrackedCostCategory | undefined;
    fkCellId?: number | undefined;
    userId!: string;

    constructor(data?: ICostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkAccountId = _data["fkAccountId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.amount = _data["amount"];
            this.quantity = _data["quantity"];
            this.value4Type1 = _data["value4Type1"];
            this.subCategory = _data["subCategory"];
            this.costUnit = _data["costUnit"];
            this.costUnitIdent = _data["costUnitIdent"];
            this.costCenter = _data["costCenter"];
            this.transactionComment = _data["transactionComment"];
            this.category = _data["category"] ? TrackedCostCategory.fromJS(_data["category"]) : undefined as any;
            this.fkCellId = _data["fkCellId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): CostDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkAccountId"] = this.fkAccountId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["amount"] = this.amount;
        data["quantity"] = this.quantity;
        data["value4Type1"] = this.value4Type1;
        data["subCategory"] = this.subCategory;
        data["costUnit"] = this.costUnit;
        data["costUnitIdent"] = this.costUnitIdent;
        data["costCenter"] = this.costCenter;
        data["transactionComment"] = this.transactionComment;
        data["category"] = this.category ? this.category.toJSON() : undefined as any;
        data["fkCellId"] = this.fkCellId;
        data["userId"] = this.userId;
        return data;
    }

    clone(): CostDto {
        const json = this.toJSON();
        let result = new CostDto();
        result.init(json);
        return result;
    }
}

export interface ICostDto {
    id: string;
    fkAccountId: number;
    startTime: Date;
    endTime: Date;
    amount: number;
    quantity: number;
    value4Type1: number;
    subCategory: string;
    costUnit: string;
    costUnitIdent: string;
    costCenter: string;
    transactionComment: string;
    category?: TrackedCostCategory | undefined;
    fkCellId?: number | undefined;
    userId: string;
}

export class TrackedCostCategory implements ITrackedCostCategory {
    id?: number;
    fkAccountId!: number;
    name!: string;
    ratePerHour!: number;

    constructor(data?: ITrackedCostCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkAccountId = _data["fkAccountId"];
            this.name = _data["name"];
            this.ratePerHour = _data["ratePerHour"];
        }
    }

    static fromJS(data: any): TrackedCostCategory {
        data = typeof data === 'object' ? data : {};
        let result = new TrackedCostCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkAccountId"] = this.fkAccountId;
        data["name"] = this.name;
        data["ratePerHour"] = this.ratePerHour;
        return data;
    }

    clone(): TrackedCostCategory {
        const json = this.toJSON();
        let result = new TrackedCostCategory();
        result.init(json);
        return result;
    }
}

export interface ITrackedCostCategory {
    id?: number;
    fkAccountId: number;
    name: string;
    ratePerHour: number;
}

export class LabelNode implements ILabelNode {
    state?: StateStruct2;
    dbId?: number;
    text?: string | undefined;
    nodes?: LabelNode[] | undefined;

    constructor(data?: ILabelNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"] ? StateStruct2.fromJS(_data["state"]) : undefined as any;
            this.dbId = _data["dbId"];
            this.text = _data["text"];
            if (Array.isArray(_data["nodes"])) {
                this.nodes = [] as any;
                for (let item of _data["nodes"])
                    this.nodes!.push(LabelNode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LabelNode {
        data = typeof data === 'object' ? data : {};
        let result = new LabelNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state ? this.state.toJSON() : undefined as any;
        data["dbId"] = this.dbId;
        data["text"] = this.text;
        if (Array.isArray(this.nodes)) {
            data["nodes"] = [];
            for (let item of this.nodes)
                data["nodes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): LabelNode {
        const json = this.toJSON();
        let result = new LabelNode();
        result.init(json);
        return result;
    }
}

export interface ILabelNode {
    state?: StateStruct2;
    dbId?: number;
    text?: string | undefined;
    nodes?: LabelNode[] | undefined;
}

export class StateStruct2 implements IStateStruct2 {

    constructor(data?: IStateStruct2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): StateStruct2 {
        data = typeof data === 'object' ? data : {};
        let result = new StateStruct2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): StateStruct2 {
        const json = this.toJSON();
        let result = new StateStruct2();
        result.init(json);
        return result;
    }
}

export interface IStateStruct2 {
}

export class CellList extends Cell implements ICellList {
    level?: number;
    nameWithLevel?: string | undefined;

    constructor(data?: ICellList) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.level = _data["level"];
            this.nameWithLevel = _data["nameWithLevel"];
        }
    }

    static override fromJS(data: any): CellList {
        data = typeof data === 'object' ? data : {};
        let result = new CellList();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["nameWithLevel"] = this.nameWithLevel;
        super.toJSON(data);
        return data;
    }

    clone(): CellList {
        const json = this.toJSON();
        let result = new CellList();
        result.init(json);
        return result;
    }
}

export interface ICellList extends ICell {
    level?: number;
    nameWithLevel?: string | undefined;
}

export class TreeNodeCell implements ITreeNodeCell {
    state?: StateStruct3;
    dbId?: number;
    text?: string | undefined;
    path?: string | undefined;
    tags?: string[] | undefined;
    nodes?: TreeNodeCell[] | undefined;
    cell?: Cell | undefined;

    constructor(data?: ITreeNodeCell) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"] ? StateStruct3.fromJS(_data["state"]) : undefined as any;
            this.dbId = _data["dbId"];
            this.text = _data["text"];
            this.path = _data["path"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["nodes"])) {
                this.nodes = [] as any;
                for (let item of _data["nodes"])
                    this.nodes!.push(TreeNodeCell.fromJS(item));
            }
            this.cell = _data["cell"] ? Cell.fromJS(_data["cell"]) : undefined as any;
        }
    }

    static fromJS(data: any): TreeNodeCell {
        data = typeof data === 'object' ? data : {};
        let result = new TreeNodeCell();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state ? this.state.toJSON() : undefined as any;
        data["dbId"] = this.dbId;
        data["text"] = this.text;
        data["path"] = this.path;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.nodes)) {
            data["nodes"] = [];
            for (let item of this.nodes)
                data["nodes"].push(item ? item.toJSON() : undefined as any);
        }
        data["cell"] = this.cell ? this.cell.toJSON() : undefined as any;
        return data;
    }

    clone(): TreeNodeCell {
        const json = this.toJSON();
        let result = new TreeNodeCell();
        result.init(json);
        return result;
    }
}

export interface ITreeNodeCell {
    state?: StateStruct3;
    dbId?: number;
    text?: string | undefined;
    path?: string | undefined;
    tags?: string[] | undefined;
    nodes?: TreeNodeCell[] | undefined;
    cell?: Cell | undefined;
}

export class StateStruct3 implements IStateStruct3 {

    constructor(data?: IStateStruct3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): StateStruct3 {
        data = typeof data === 'object' ? data : {};
        let result = new StateStruct3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): StateStruct3 {
        const json = this.toJSON();
        let result = new StateStruct3();
        result.init(json);
        return result;
    }
}

export interface IStateStruct3 {
}

export class VMCellEdit implements IVMCellEdit {
    cell?: Cell | undefined;
    parentNodeId?: number;

    constructor(data?: IVMCellEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cell = _data["cell"] ? Cell.fromJS(_data["cell"]) : undefined as any;
            this.parentNodeId = _data["parentNodeId"];
        }
    }

    static fromJS(data: any): VMCellEdit {
        data = typeof data === 'object' ? data : {};
        let result = new VMCellEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cell"] = this.cell ? this.cell.toJSON() : undefined as any;
        data["parentNodeId"] = this.parentNodeId;
        return data;
    }

    clone(): VMCellEdit {
        const json = this.toJSON();
        let result = new VMCellEdit();
        result.init(json);
        return result;
    }
}

export interface IVMCellEdit {
    cell?: Cell | undefined;
    parentNodeId?: number;
}

export enum CellQrLabelOption {
    Name = 0,
    Description = 1,
    Supplier = 2,
    Ident = 3,
    Label = 4,
}

export class NfcWrite implements INfcWrite {
    id?: number;
    typeNameFormat?: number;
    type?: number[] | undefined;
    identifier?: number[] | undefined;
    payload?: number[] | undefined;

    constructor(data?: INfcWrite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeNameFormat = _data["typeNameFormat"];
            if (Array.isArray(_data["type"])) {
                this.type = [] as any;
                for (let item of _data["type"])
                    this.type!.push(item);
            }
            if (Array.isArray(_data["identifier"])) {
                this.identifier = [] as any;
                for (let item of _data["identifier"])
                    this.identifier!.push(item);
            }
            if (Array.isArray(_data["payload"])) {
                this.payload = [] as any;
                for (let item of _data["payload"])
                    this.payload!.push(item);
            }
        }
    }

    static fromJS(data: any): NfcWrite {
        data = typeof data === 'object' ? data : {};
        let result = new NfcWrite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeNameFormat"] = this.typeNameFormat;
        if (Array.isArray(this.type)) {
            data["type"] = [];
            for (let item of this.type)
                data["type"].push(item);
        }
        if (Array.isArray(this.identifier)) {
            data["identifier"] = [];
            for (let item of this.identifier)
                data["identifier"].push(item);
        }
        if (Array.isArray(this.payload)) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item);
        }
        return data;
    }

    clone(): NfcWrite {
        const json = this.toJSON();
        let result = new NfcWrite();
        result.init(json);
        return result;
    }
}

export interface INfcWrite {
    id?: number;
    typeNameFormat?: number;
    type?: number[] | undefined;
    identifier?: number[] | undefined;
    payload?: number[] | undefined;
}

export class SetMediaForCellRequestModel implements ISetMediaForCellRequestModel {
    mediaId?: string;
    cellId?: number;

    constructor(data?: ISetMediaForCellRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mediaId = _data["mediaId"];
            this.cellId = _data["cellId"];
        }
    }

    static fromJS(data: any): SetMediaForCellRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetMediaForCellRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mediaId"] = this.mediaId;
        data["cellId"] = this.cellId;
        return data;
    }

    clone(): SetMediaForCellRequestModel {
        const json = this.toJSON();
        let result = new SetMediaForCellRequestModel();
        result.init(json);
        return result;
    }
}

export interface ISetMediaForCellRequestModel {
    mediaId?: string;
    cellId?: number;
}

export class BaseResultOfListOfVMEventRecordPareto implements IBaseResultOfListOfVMEventRecordPareto {
    id?: number;
    isOk?: boolean;
    result?: VMEventRecordPareto[] | undefined;

    constructor(data?: IBaseResultOfListOfVMEventRecordPareto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(VMEventRecordPareto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfListOfVMEventRecordPareto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfListOfVMEventRecordPareto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfListOfVMEventRecordPareto {
        const json = this.toJSON();
        let result = new BaseResultOfListOfVMEventRecordPareto();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfListOfVMEventRecordPareto {
    id?: number;
    isOk?: boolean;
    result?: VMEventRecordPareto[] | undefined;
}

export class VMEventRecordPareto implements IVMEventRecordPareto {
    eventName?: string | undefined;
    count?: number;

    constructor(data?: IVMEventRecordPareto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventName = _data["eventName"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): VMEventRecordPareto {
        data = typeof data === 'object' ? data : {};
        let result = new VMEventRecordPareto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventName"] = this.eventName;
        data["count"] = this.count;
        return data;
    }

    clone(): VMEventRecordPareto {
        const json = this.toJSON();
        let result = new VMEventRecordPareto();
        result.init(json);
        return result;
    }
}

export interface IVMEventRecordPareto {
    eventName?: string | undefined;
    count?: number;
}

export class BaseResultOfICostSumup implements IBaseResultOfICostSumup {
    id?: number;
    isOk?: boolean;
    result?: ICostSumup | undefined;

    constructor(data?: IBaseResultOfICostSumup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? ICostSumup.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfICostSumup {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfICostSumup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfICostSumup {
        const json = this.toJSON();
        let result = new BaseResultOfICostSumup();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfICostSumup {
    id?: number;
    isOk?: boolean;
    result?: ICostSumup | undefined;
}

export abstract class ICostSumup implements IICostSumup {
    totalAmount!: number;
    totalTime?: string;
    subCategory!: string;
    lastCost?: ICostDto | undefined;

    constructor(data?: IICostSumup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalAmount = _data["totalAmount"];
            this.totalTime = _data["totalTime"];
            this.subCategory = _data["subCategory"];
            this.lastCost = _data["lastCost"] ? ICostDto.fromJS(_data["lastCost"]) : undefined as any;
        }
    }

    static fromJS(data: any): ICostSumup {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ICostSumup' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAmount"] = this.totalAmount;
        data["totalTime"] = this.totalTime;
        data["subCategory"] = this.subCategory;
        data["lastCost"] = this.lastCost ? this.lastCost.toJSON() : undefined as any;
        return data;
    }

    clone(): ICostSumup {
        throw new Error("The abstract class 'ICostSumup' cannot be instantiated.");
    }
}

export interface IICostSumup {
    totalAmount: number;
    totalTime?: string;
    subCategory: string;
    lastCost?: ICostDto | undefined;
}

export abstract class ICostDto implements IICostDto {
    id!: string;
    fkAccountId!: number;
    startTime!: Date;
    endTime!: Date;
    amount!: number;
    subCategory!: string;
    costUnit!: string;
    costUnitIdent!: string;
    costCenter!: string;
    category?: TrackedCostCategory | undefined;

    constructor(data?: IICostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkAccountId = _data["fkAccountId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.amount = _data["amount"];
            this.subCategory = _data["subCategory"];
            this.costUnit = _data["costUnit"];
            this.costUnitIdent = _data["costUnitIdent"];
            this.costCenter = _data["costCenter"];
            this.category = _data["category"] ? TrackedCostCategory.fromJS(_data["category"]) : undefined as any;
        }
    }

    static fromJS(data: any): ICostDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ICostDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkAccountId"] = this.fkAccountId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["amount"] = this.amount;
        data["subCategory"] = this.subCategory;
        data["costUnit"] = this.costUnit;
        data["costUnitIdent"] = this.costUnitIdent;
        data["costCenter"] = this.costCenter;
        data["category"] = this.category ? this.category.toJSON() : undefined as any;
        return data;
    }

    clone(): ICostDto {
        throw new Error("The abstract class 'ICostDto' cannot be instantiated.");
    }
}

export interface IICostDto {
    id: string;
    fkAccountId: number;
    startTime: Date;
    endTime: Date;
    amount: number;
    subCategory: string;
    costUnit: string;
    costUnitIdent: string;
    costCenter: string;
    category?: TrackedCostCategory | undefined;
}

export class BaseResultOfActivityLogOf implements IBaseResultOfActivityLogOf {
    id?: number;
    isOk?: boolean;
    result?: ActivityLog[] | undefined;

    constructor(data?: IBaseResultOfActivityLogOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(ActivityLog.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfActivityLogOf {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfActivityLogOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfActivityLogOf {
        const json = this.toJSON();
        let result = new BaseResultOfActivityLogOf();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfActivityLogOf {
    id?: number;
    isOk?: boolean;
    result?: ActivityLog[] | undefined;
}

export abstract class IActivity implements IIActivity {
    id?: number;
    fkUserIdResponsible?: string | undefined;
    fkUserIdCreatedBy?: string;
    fkUserResponsibleName?: string | undefined;
    fkUserIdDone?: string | undefined;
    username?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    domainObjectName?: string | undefined;
    isUserResponsible?: boolean;
    dutyDate?: Date | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    cellId?: number | undefined;
    cellName?: string | undefined;
    cellRisk?: number;
    status?: EnumStatus;
    currentDate?: Date | undefined;
    comment?: string | undefined;
    jsonVMChecklist?: string | undefined;
    duty?: Duty | undefined;
    file?: Media2[] | undefined;
    priority?: ActivityPriority | undefined;
    reference?: string | undefined;
    techArea?: string | undefined;
    dueSeconds?: number;
    totalMinutes?: number;
    wasOverDue?: boolean;
    label?: string | undefined;
    isPlaned?: boolean;
    cellIdent?: string | undefined;
    dutyIdent?: string | undefined;
    dutyTitle?: string | undefined;
    isFireProtection?: boolean;
    cellParents?: string[] | undefined;

    constructor(data?: IIActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkUserIdResponsible = _data["fkUserIdResponsible"];
            this.fkUserIdCreatedBy = _data["fkUserIdCreatedBy"];
            this.fkUserResponsibleName = _data["fkUserResponsibleName"];
            this.fkUserIdDone = _data["fkUserIdDone"];
            this.username = _data["username"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.domainObjectName = _data["domainObjectName"];
            this.isUserResponsible = _data["isUserResponsible"];
            this.dutyDate = _data["dutyDate"] ? new Date(_data["dutyDate"].toString()) : undefined as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.cellId = _data["cellId"];
            this.cellName = _data["cellName"];
            this.cellRisk = _data["cellRisk"];
            this.status = _data["status"];
            this.currentDate = _data["currentDate"] ? new Date(_data["currentDate"].toString()) : undefined as any;
            this.comment = _data["comment"];
            this.jsonVMChecklist = _data["jsonVMChecklist"];
            this.duty = _data["duty"] ? Duty.fromJS(_data["duty"]) : undefined as any;
            if (Array.isArray(_data["file"])) {
                this.file = [] as any;
                for (let item of _data["file"])
                    this.file!.push(Media2.fromJS(item));
            }
            this.priority = _data["priority"] ? ActivityPriority.fromJS(_data["priority"]) : undefined as any;
            this.reference = _data["reference"];
            this.techArea = _data["techArea"];
            this.dueSeconds = _data["dueSeconds"];
            this.totalMinutes = _data["totalMinutes"];
            this.wasOverDue = _data["wasOverDue"];
            this.label = _data["label"];
            this.isPlaned = _data["isPlaned"];
            this.cellIdent = _data["cellIdent"];
            this.dutyIdent = _data["dutyIdent"];
            this.dutyTitle = _data["dutyTitle"];
            this.isFireProtection = _data["isFireProtection"];
            if (Array.isArray(_data["cellParents"])) {
                this.cellParents = [] as any;
                for (let item of _data["cellParents"])
                    this.cellParents!.push(item);
            }
        }
    }

    static fromJS(data: any): IActivity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IActivity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkUserIdResponsible"] = this.fkUserIdResponsible;
        data["fkUserIdCreatedBy"] = this.fkUserIdCreatedBy;
        data["fkUserResponsibleName"] = this.fkUserResponsibleName;
        data["fkUserIdDone"] = this.fkUserIdDone;
        data["username"] = this.username;
        data["title"] = this.title;
        data["description"] = this.description;
        data["domainObjectName"] = this.domainObjectName;
        data["isUserResponsible"] = this.isUserResponsible;
        data["dutyDate"] = this.dutyDate ? this.dutyDate.toISOString() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["cellId"] = this.cellId;
        data["cellName"] = this.cellName;
        data["cellRisk"] = this.cellRisk;
        data["status"] = this.status;
        data["currentDate"] = this.currentDate ? formatDate(this.currentDate) : undefined as any;
        data["comment"] = this.comment;
        data["jsonVMChecklist"] = this.jsonVMChecklist;
        data["duty"] = this.duty ? this.duty.toJSON() : undefined as any;
        if (Array.isArray(this.file)) {
            data["file"] = [];
            for (let item of this.file)
                data["file"].push(item ? item.toJSON() : undefined as any);
        }
        data["priority"] = this.priority ? this.priority.toJSON() : undefined as any;
        data["reference"] = this.reference;
        data["techArea"] = this.techArea;
        data["dueSeconds"] = this.dueSeconds;
        data["totalMinutes"] = this.totalMinutes;
        data["wasOverDue"] = this.wasOverDue;
        data["label"] = this.label;
        data["isPlaned"] = this.isPlaned;
        data["cellIdent"] = this.cellIdent;
        data["dutyIdent"] = this.dutyIdent;
        data["dutyTitle"] = this.dutyTitle;
        data["isFireProtection"] = this.isFireProtection;
        if (Array.isArray(this.cellParents)) {
            data["cellParents"] = [];
            for (let item of this.cellParents)
                data["cellParents"].push(item);
        }
        return data;
    }

    clone(): IActivity {
        throw new Error("The abstract class 'IActivity' cannot be instantiated.");
    }
}

export interface IIActivity {
    id?: number;
    fkUserIdResponsible?: string | undefined;
    fkUserIdCreatedBy?: string;
    fkUserResponsibleName?: string | undefined;
    fkUserIdDone?: string | undefined;
    username?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    domainObjectName?: string | undefined;
    isUserResponsible?: boolean;
    dutyDate?: Date | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    cellId?: number | undefined;
    cellName?: string | undefined;
    cellRisk?: number;
    status?: EnumStatus;
    currentDate?: Date | undefined;
    comment?: string | undefined;
    jsonVMChecklist?: string | undefined;
    duty?: Duty | undefined;
    file?: Media2[] | undefined;
    priority?: ActivityPriority | undefined;
    reference?: string | undefined;
    techArea?: string | undefined;
    dueSeconds?: number;
    totalMinutes?: number;
    wasOverDue?: boolean;
    label?: string | undefined;
    isPlaned?: boolean;
    cellIdent?: string | undefined;
    dutyIdent?: string | undefined;
    dutyTitle?: string | undefined;
    isFireProtection?: boolean;
    cellParents?: string[] | undefined;
}

export class ActivityLog extends IActivity implements IActivityLog {
    medias?: ActivityLogMedia[] | undefined;
    file?: Media2[] | undefined;

    constructor(data?: IActivityLog) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["medias"])) {
                this.medias = [] as any;
                for (let item of _data["medias"])
                    this.medias!.push(ActivityLogMedia.fromJS(item));
            }
            if (Array.isArray(_data["file"])) {
                this.file = [] as any;
                for (let item of _data["file"])
                    this.file!.push(Media2.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ActivityLog {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLog();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.medias)) {
            data["medias"] = [];
            for (let item of this.medias)
                data["medias"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.file)) {
            data["file"] = [];
            for (let item of this.file)
                data["file"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ActivityLog {
        const json = this.toJSON();
        let result = new ActivityLog();
        result.init(json);
        return result;
    }
}

export interface IActivityLog extends IIActivity {
    medias?: ActivityLogMedia[] | undefined;
    file?: Media2[] | undefined;
}

export class ActivityLogMedia implements IActivityLogMedia {
    id!: string;
    activityLogId!: number;
    mediaId!: string;
    media!: Media2;

    constructor(data?: IActivityLogMedia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.media = new Media2();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityLogId = _data["activityLogId"];
            this.mediaId = _data["mediaId"];
            this.media = _data["media"] ? Media2.fromJS(_data["media"]) : new Media2();
        }
    }

    static fromJS(data: any): ActivityLogMedia {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogMedia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityLogId"] = this.activityLogId;
        data["mediaId"] = this.mediaId;
        data["media"] = this.media ? this.media.toJSON() : undefined as any;
        return data;
    }

    clone(): ActivityLogMedia {
        const json = this.toJSON();
        let result = new ActivityLogMedia();
        result.init(json);
        return result;
    }
}

export interface IActivityLogMedia {
    id: string;
    activityLogId: number;
    mediaId: string;
    media: Media2;
}

export enum EnumStatus {
    Created = 0,
    Triggered = 1,
    Postponed = 2,
    Changed = 4,
    Workflow = 8,
    Document = 16,
    SignedOff = 32,
    Done = 126,
}

export class Duty implements IDuty {
    dutyId?: number;
    fkDomainObjectNodeId?: number;
    fkUserId?: string | undefined;
    dates?: DutyDate[];
    files?: Media2[];
    activities?: Activity[];
    checklists?: TodoItemDb[];
    notifications?: Notification[];
    dutyTriggers?: DutyTrigger[];
    cells?: DutyCellsMapping[];
    identString?: string | undefined;
    desc?: string | undefined;
    area?: string | undefined;
    subArea?: string | undefined;
    techArea?: string | undefined;
    costCenter?: string | undefined;
    conditions?: Condition;
    bgColor?: string | undefined;
    linkedEventId?: number;
    desiredMin?: number;
    isChecklist?: boolean;
    datePattern?: DatePatternType;
    firstDate?: DutyDate;
    reccuringDates?: Date[];
    title!: string;
    cell?: string | undefined;
    label?: string | undefined;
    skipNextAutoTrigger!: boolean;
    modified?: Date;
    isDisabled!: boolean;
    advancedReminderHours!: number;
    dueSeconds!: number;
    ratePerHour!: number;
    preventAutoTriggeredActivityDuplicates!: boolean;
    cbmAnonymousEnabled!: boolean;
    cbmAnonymousId?: string | undefined;
    cbmInsertIntoWorkflowEnabled!: boolean;
    cbmInsertIntoWorkflowFlow?: string | undefined;
    cbmAutoCloseActivity!: boolean;
    cbmMailAnswerEnabled!: boolean;
    cbmAuthedId?: string | undefined;
    titleRegex?: string | undefined;
    ignoreRegex?: string | undefined;
    autoCloseAfterDays?: number | undefined;

    constructor(data?: IDuty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dutyId = _data["dutyId"];
            this.fkDomainObjectNodeId = _data["fkDomainObjectNodeId"];
            this.fkUserId = _data["fkUserId"];
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates!.push(DutyDate.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(Media2.fromJS(item));
            }
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(Activity.fromJS(item));
            }
            if (Array.isArray(_data["checklists"])) {
                this.checklists = [] as any;
                for (let item of _data["checklists"])
                    this.checklists!.push(TodoItemDb.fromJS(item));
            }
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(Notification.fromJS(item));
            }
            if (Array.isArray(_data["dutyTriggers"])) {
                this.dutyTriggers = [] as any;
                for (let item of _data["dutyTriggers"])
                    this.dutyTriggers!.push(DutyTrigger.fromJS(item));
            }
            if (Array.isArray(_data["cells"])) {
                this.cells = [] as any;
                for (let item of _data["cells"])
                    this.cells!.push(DutyCellsMapping.fromJS(item));
            }
            this.identString = _data["identString"];
            this.desc = _data["desc"];
            this.area = _data["area"];
            this.subArea = _data["subArea"];
            this.techArea = _data["techArea"];
            this.costCenter = _data["costCenter"];
            this.conditions = _data["conditions"];
            this.bgColor = _data["bgColor"];
            this.linkedEventId = _data["linkedEventId"];
            this.desiredMin = _data["desiredMin"];
            this.isChecklist = _data["isChecklist"];
            this.datePattern = _data["datePattern"];
            this.firstDate = _data["firstDate"] ? DutyDate.fromJS(_data["firstDate"]) : undefined as any;
            if (Array.isArray(_data["reccuringDates"])) {
                this.reccuringDates = [] as any;
                for (let item of _data["reccuringDates"])
                    this.reccuringDates!.push(new Date(item));
            }
            this.title = _data["title"];
            this.cell = _data["cell"];
            this.label = _data["label"];
            this.skipNextAutoTrigger = _data["skipNextAutoTrigger"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.isDisabled = _data["isDisabled"];
            this.advancedReminderHours = _data["advancedReminderHours"];
            this.dueSeconds = _data["dueSeconds"];
            this.ratePerHour = _data["ratePerHour"];
            this.preventAutoTriggeredActivityDuplicates = _data["preventAutoTriggeredActivityDuplicates"];
            this.cbmAnonymousEnabled = _data["cbmAnonymousEnabled"];
            this.cbmAnonymousId = _data["cbmAnonymousId"];
            this.cbmInsertIntoWorkflowEnabled = _data["cbmInsertIntoWorkflowEnabled"];
            this.cbmInsertIntoWorkflowFlow = _data["cbmInsertIntoWorkflowFlow"];
            this.cbmAutoCloseActivity = _data["cbmAutoCloseActivity"];
            this.cbmMailAnswerEnabled = _data["cbmMailAnswerEnabled"];
            this.cbmAuthedId = _data["cbmAuthedId"];
            this.titleRegex = _data["titleRegex"];
            this.ignoreRegex = _data["ignoreRegex"];
            this.autoCloseAfterDays = _data["autoCloseAfterDays"];
        }
    }

    static fromJS(data: any): Duty {
        data = typeof data === 'object' ? data : {};
        let result = new Duty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dutyId"] = this.dutyId;
        data["fkDomainObjectNodeId"] = this.fkDomainObjectNodeId;
        data["fkUserId"] = this.fkUserId;
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.checklists)) {
            data["checklists"] = [];
            for (let item of this.checklists)
                data["checklists"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dutyTriggers)) {
            data["dutyTriggers"] = [];
            for (let item of this.dutyTriggers)
                data["dutyTriggers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cells)) {
            data["cells"] = [];
            for (let item of this.cells)
                data["cells"].push(item ? item.toJSON() : undefined as any);
        }
        data["identString"] = this.identString;
        data["desc"] = this.desc;
        data["area"] = this.area;
        data["subArea"] = this.subArea;
        data["techArea"] = this.techArea;
        data["costCenter"] = this.costCenter;
        data["conditions"] = this.conditions;
        data["bgColor"] = this.bgColor;
        data["linkedEventId"] = this.linkedEventId;
        data["desiredMin"] = this.desiredMin;
        data["isChecklist"] = this.isChecklist;
        data["datePattern"] = this.datePattern;
        data["firstDate"] = this.firstDate ? this.firstDate.toJSON() : undefined as any;
        if (Array.isArray(this.reccuringDates)) {
            data["reccuringDates"] = [];
            for (let item of this.reccuringDates)
                data["reccuringDates"].push(item.toISOString());
        }
        data["title"] = this.title;
        data["cell"] = this.cell;
        data["label"] = this.label;
        data["skipNextAutoTrigger"] = this.skipNextAutoTrigger;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["isDisabled"] = this.isDisabled;
        data["advancedReminderHours"] = this.advancedReminderHours;
        data["dueSeconds"] = this.dueSeconds;
        data["ratePerHour"] = this.ratePerHour;
        data["preventAutoTriggeredActivityDuplicates"] = this.preventAutoTriggeredActivityDuplicates;
        data["cbmAnonymousEnabled"] = this.cbmAnonymousEnabled;
        data["cbmAnonymousId"] = this.cbmAnonymousId;
        data["cbmInsertIntoWorkflowEnabled"] = this.cbmInsertIntoWorkflowEnabled;
        data["cbmInsertIntoWorkflowFlow"] = this.cbmInsertIntoWorkflowFlow;
        data["cbmAutoCloseActivity"] = this.cbmAutoCloseActivity;
        data["cbmMailAnswerEnabled"] = this.cbmMailAnswerEnabled;
        data["cbmAuthedId"] = this.cbmAuthedId;
        data["titleRegex"] = this.titleRegex;
        data["ignoreRegex"] = this.ignoreRegex;
        data["autoCloseAfterDays"] = this.autoCloseAfterDays;
        return data;
    }

    clone(): Duty {
        const json = this.toJSON();
        let result = new Duty();
        result.init(json);
        return result;
    }
}

export interface IDuty {
    dutyId?: number;
    fkDomainObjectNodeId?: number;
    fkUserId?: string | undefined;
    dates?: DutyDate[];
    files?: Media2[];
    activities?: Activity[];
    checklists?: TodoItemDb[];
    notifications?: Notification[];
    dutyTriggers?: DutyTrigger[];
    cells?: DutyCellsMapping[];
    identString?: string | undefined;
    desc?: string | undefined;
    area?: string | undefined;
    subArea?: string | undefined;
    techArea?: string | undefined;
    costCenter?: string | undefined;
    conditions?: Condition;
    bgColor?: string | undefined;
    linkedEventId?: number;
    desiredMin?: number;
    isChecklist?: boolean;
    datePattern?: DatePatternType;
    firstDate?: DutyDate;
    reccuringDates?: Date[];
    title: string;
    cell?: string | undefined;
    label?: string | undefined;
    skipNextAutoTrigger: boolean;
    modified?: Date;
    isDisabled: boolean;
    advancedReminderHours: number;
    dueSeconds: number;
    ratePerHour: number;
    preventAutoTriggeredActivityDuplicates: boolean;
    cbmAnonymousEnabled: boolean;
    cbmAnonymousId?: string | undefined;
    cbmInsertIntoWorkflowEnabled: boolean;
    cbmInsertIntoWorkflowFlow?: string | undefined;
    cbmAutoCloseActivity: boolean;
    cbmMailAnswerEnabled: boolean;
    cbmAuthedId?: string | undefined;
    titleRegex?: string | undefined;
    ignoreRegex?: string | undefined;
    autoCloseAfterDays?: number | undefined;
}

export class DutyDate implements IDutyDate {
    dutyDateId?: number;
    freqType?: Type;
    start?: Date | undefined;
    end?: Date | undefined;
    repeatStart?: Date | undefined;
    repeatInterval?: string | undefined;
    repeatYear?: string | undefined;
    repeatMonth?: string | undefined;
    repeatDay?: string | undefined;
    repeatWeek?: string | undefined;
    repeatWeekday?: string | undefined;
    repeatWeekOfMonth?: string | undefined;
    repeatHour?: number;
    datePattern?: DatePatternType;

    constructor(data?: IDutyDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dutyDateId = _data["dutyDateId"];
            this.freqType = _data["freqType"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined as any;
            this.repeatStart = _data["repeatStart"] ? new Date(_data["repeatStart"].toString()) : undefined as any;
            this.repeatInterval = _data["repeatInterval"];
            this.repeatYear = _data["repeatYear"];
            this.repeatMonth = _data["repeatMonth"];
            this.repeatDay = _data["repeatDay"];
            this.repeatWeek = _data["repeatWeek"];
            this.repeatWeekday = _data["repeatWeekday"];
            this.repeatWeekOfMonth = _data["repeatWeekOfMonth"];
            this.repeatHour = _data["repeatHour"];
            this.datePattern = _data["datePattern"];
        }
    }

    static fromJS(data: any): DutyDate {
        data = typeof data === 'object' ? data : {};
        let result = new DutyDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dutyDateId"] = this.dutyDateId;
        data["freqType"] = this.freqType;
        data["start"] = this.start ? formatDate(this.start) : undefined as any;
        data["end"] = this.end ? formatDate(this.end) : undefined as any;
        data["repeatStart"] = this.repeatStart ? this.repeatStart.toISOString() : undefined as any;
        data["repeatInterval"] = this.repeatInterval;
        data["repeatYear"] = this.repeatYear;
        data["repeatMonth"] = this.repeatMonth;
        data["repeatDay"] = this.repeatDay;
        data["repeatWeek"] = this.repeatWeek;
        data["repeatWeekday"] = this.repeatWeekday;
        data["repeatWeekOfMonth"] = this.repeatWeekOfMonth;
        data["repeatHour"] = this.repeatHour;
        data["datePattern"] = this.datePattern;
        return data;
    }

    clone(): DutyDate {
        const json = this.toJSON();
        let result = new DutyDate();
        result.init(json);
        return result;
    }
}

export interface IDutyDate {
    dutyDateId?: number;
    freqType?: Type;
    start?: Date | undefined;
    end?: Date | undefined;
    repeatStart?: Date | undefined;
    repeatInterval?: string | undefined;
    repeatYear?: string | undefined;
    repeatMonth?: string | undefined;
    repeatDay?: string | undefined;
    repeatWeek?: string | undefined;
    repeatWeekday?: string | undefined;
    repeatWeekOfMonth?: string | undefined;
    repeatHour?: number;
    datePattern?: DatePatternType;
}

export enum Type {
    Single = 1,
    Recurring = 4,
}

export enum DatePatternType {
    Interval = 0,
    YearMonthDay = 1,
    YearMonthWeekWeekday = 2,
    YearMonthWeekOfMonthWeekday = 4,
    Single = 16,
}

export class Activity extends IActivity implements IActivity {

    constructor(data?: IActivity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): Activity {
        data = typeof data === 'object' ? data : {};
        let result = new Activity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): Activity {
        const json = this.toJSON();
        let result = new Activity();
        result.init(json);
        return result;
    }
}

export interface IActivity extends IIActivity {
}

export class TodoItemDb implements ITodoItemDb {
    id?: number;
    name?: string | undefined;
    json?: string | undefined;
    dutyId?: number | undefined;

    constructor(data?: ITodoItemDb) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.json = _data["json"];
            this.dutyId = _data["dutyId"];
        }
    }

    static fromJS(data: any): TodoItemDb {
        data = typeof data === 'object' ? data : {};
        let result = new TodoItemDb();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["json"] = this.json;
        data["dutyId"] = this.dutyId;
        return data;
    }

    clone(): TodoItemDb {
        const json = this.toJSON();
        let result = new TodoItemDb();
        result.init(json);
        return result;
    }
}

export interface ITodoItemDb {
    id?: number;
    name?: string | undefined;
    json?: string | undefined;
    dutyId?: number | undefined;
}

export class Notification implements INotification {
    id?: number;
    notifyId?: string;

    constructor(data?: INotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.notifyId = _data["notifyId"];
        }
    }

    static fromJS(data: any): Notification {
        data = typeof data === 'object' ? data : {};
        let result = new Notification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["notifyId"] = this.notifyId;
        return data;
    }

    clone(): Notification {
        const json = this.toJSON();
        let result = new Notification();
        result.init(json);
        return result;
    }
}

export interface INotification {
    id?: number;
    notifyId?: string;
}

export class DutyTrigger implements IDutyTrigger {
    id?: number;
    fkDutyId?: number | undefined;
    isActive?: boolean;
    name?: string | undefined;
    lastValue?: number;
    condition?: string | undefined;
    triggerValue?: number;
    lastRun?: Date;
    ignServer?: string | undefined;
    ignUser?: string | undefined;
    ignPwd?: string | undefined;
    ignIndex?: string | undefined;
    ignDb?: string | undefined;
    ignTable?: string | undefined;
    ignFieldTimestmp?: string | undefined;
    ignFieldValue?: string | undefined;
    ignFieldError?: string | undefined;
    ignFieldCell?: string | undefined;

    constructor(data?: IDutyTrigger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkDutyId = _data["fkDutyId"];
            this.isActive = _data["isActive"];
            this.name = _data["name"];
            this.lastValue = _data["lastValue"];
            this.condition = _data["condition"];
            this.triggerValue = _data["triggerValue"];
            this.lastRun = _data["lastRun"] ? new Date(_data["lastRun"].toString()) : undefined as any;
            this.ignServer = _data["ignServer"];
            this.ignUser = _data["ignUser"];
            this.ignPwd = _data["ignPwd"];
            this.ignIndex = _data["ignIndex"];
            this.ignDb = _data["ignDb"];
            this.ignTable = _data["ignTable"];
            this.ignFieldTimestmp = _data["ignFieldTimestmp"];
            this.ignFieldValue = _data["ignFieldValue"];
            this.ignFieldError = _data["ignFieldError"];
            this.ignFieldCell = _data["ignFieldCell"];
        }
    }

    static fromJS(data: any): DutyTrigger {
        data = typeof data === 'object' ? data : {};
        let result = new DutyTrigger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkDutyId"] = this.fkDutyId;
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["lastValue"] = this.lastValue;
        data["condition"] = this.condition;
        data["triggerValue"] = this.triggerValue;
        data["lastRun"] = this.lastRun ? this.lastRun.toISOString() : undefined as any;
        data["ignServer"] = this.ignServer;
        data["ignUser"] = this.ignUser;
        data["ignPwd"] = this.ignPwd;
        data["ignIndex"] = this.ignIndex;
        data["ignDb"] = this.ignDb;
        data["ignTable"] = this.ignTable;
        data["ignFieldTimestmp"] = this.ignFieldTimestmp;
        data["ignFieldValue"] = this.ignFieldValue;
        data["ignFieldError"] = this.ignFieldError;
        data["ignFieldCell"] = this.ignFieldCell;
        return data;
    }

    clone(): DutyTrigger {
        const json = this.toJSON();
        let result = new DutyTrigger();
        result.init(json);
        return result;
    }
}

export interface IDutyTrigger {
    id?: number;
    fkDutyId?: number | undefined;
    isActive?: boolean;
    name?: string | undefined;
    lastValue?: number;
    condition?: string | undefined;
    triggerValue?: number;
    lastRun?: Date;
    ignServer?: string | undefined;
    ignUser?: string | undefined;
    ignPwd?: string | undefined;
    ignIndex?: string | undefined;
    ignDb?: string | undefined;
    ignTable?: string | undefined;
    ignFieldTimestmp?: string | undefined;
    ignFieldValue?: string | undefined;
    ignFieldError?: string | undefined;
    ignFieldCell?: string | undefined;
}

export class DutyCellsMapping implements IDutyCellsMapping {
    id?: number;
    cellId?: number | undefined;

    constructor(data?: IDutyCellsMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cellId = _data["cellId"];
        }
    }

    static fromJS(data: any): DutyCellsMapping {
        data = typeof data === 'object' ? data : {};
        let result = new DutyCellsMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cellId"] = this.cellId;
        return data;
    }

    clone(): DutyCellsMapping {
        const json = this.toJSON();
        let result = new DutyCellsMapping();
        result.init(json);
        return result;
    }
}

export interface IDutyCellsMapping {
    id?: number;
    cellId?: number | undefined;
}

export enum Condition {
    Off = 0,
    On = 1,
}

export class ActivityPriority implements IActivityPriority {
    id?: number;
    fkAccountId?: number;
    name?: string | undefined;
    colorTag?: string | undefined;

    constructor(data?: IActivityPriority) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkAccountId = _data["fkAccountId"];
            this.name = _data["name"];
            this.colorTag = _data["colorTag"];
        }
    }

    static fromJS(data: any): ActivityPriority {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityPriority();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkAccountId"] = this.fkAccountId;
        data["name"] = this.name;
        data["colorTag"] = this.colorTag;
        return data;
    }

    clone(): ActivityPriority {
        const json = this.toJSON();
        let result = new ActivityPriority();
        result.init(json);
        return result;
    }
}

export interface IActivityPriority {
    id?: number;
    fkAccountId?: number;
    name?: string | undefined;
    colorTag?: string | undefined;
}

export class BaseResultOfGpsPosDto implements IBaseResultOfGpsPosDto {
    id?: number;
    isOk?: boolean;
    result?: GpsPosDto | undefined;

    constructor(data?: IBaseResultOfGpsPosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? GpsPosDto.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfGpsPosDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfGpsPosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfGpsPosDto {
        const json = this.toJSON();
        let result = new BaseResultOfGpsPosDto();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfGpsPosDto {
    id?: number;
    isOk?: boolean;
    result?: GpsPosDto | undefined;
}

export class GpsPosDto implements IGpsPosDto {
    id!: number;
    fkAccountId!: number;
    fkCellId?: number | undefined;
    fkTrackerId?: number | undefined;
    fkUserId?: string | undefined;
    fkInventoryId?: number | undefined;
    lng!: number;
    lat!: number;
    alt!: number;
    timestamp!: Date;

    constructor(data?: IGpsPosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkAccountId = _data["fkAccountId"];
            this.fkCellId = _data["fkCellId"];
            this.fkTrackerId = _data["fkTrackerId"];
            this.fkUserId = _data["fkUserId"];
            this.fkInventoryId = _data["fkInventoryId"];
            this.lng = _data["lng"];
            this.lat = _data["lat"];
            this.alt = _data["alt"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GpsPosDto {
        data = typeof data === 'object' ? data : {};
        let result = new GpsPosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkAccountId"] = this.fkAccountId;
        data["fkCellId"] = this.fkCellId;
        data["fkTrackerId"] = this.fkTrackerId;
        data["fkUserId"] = this.fkUserId;
        data["fkInventoryId"] = this.fkInventoryId;
        data["lng"] = this.lng;
        data["lat"] = this.lat;
        data["alt"] = this.alt;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined as any;
        return data;
    }

    clone(): GpsPosDto {
        const json = this.toJSON();
        let result = new GpsPosDto();
        result.init(json);
        return result;
    }
}

export interface IGpsPosDto {
    id: number;
    fkAccountId: number;
    fkCellId?: number | undefined;
    fkTrackerId?: number | undefined;
    fkUserId?: string | undefined;
    fkInventoryId?: number | undefined;
    lng: number;
    lat: number;
    alt: number;
    timestamp: Date;
}

export class BaseResultOfInventoryOf implements IBaseResultOfInventoryOf {
    id?: number;
    isOk?: boolean;
    result?: Inventory[] | undefined;

    constructor(data?: IBaseResultOfInventoryOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(Inventory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfInventoryOf {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfInventoryOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfInventoryOf {
        const json = this.toJSON();
        let result = new BaseResultOfInventoryOf();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfInventoryOf {
    id?: number;
    isOk?: boolean;
    result?: Inventory[] | undefined;
}

export class Inventory implements IInventory {
    id?: number;
    fkAccountId?: number;
    key?: string | undefined;
    name?: string | undefined;
    ident?: string | undefined;
    generalInfo?: string | undefined;
    supplier?: string | undefined;
    comment?: string | undefined;
    entryDate?: Date;
    updatedAt?: Date;
    price?: number;
    location?: string | undefined;
    itemsOnStock?: number;
    lowStockSetpoint?: number;
    nominalStock?: number;
    defaultActionAmount?: number;
    costCenter?: string | undefined;
    riskInfo?: string | undefined;
    locationAisle?: string | undefined;
    locationRow?: string | undefined;
    locationPin?: string | undefined;
    techArea?: string | undefined;
    lastTransactionComment?: string | undefined;
    unit?: string | undefined;
    gtin?: string | undefined;
    weight?: string | undefined;
    volume?: string | undefined;
    size?: string | undefined;
    package?: string | undefined;
    origin?: string | undefined;
    hsCode?: string | undefined;
    quality?: string | undefined;
    quality2?: string | undefined;
    partNumber?: string | undefined;
    web?: string | undefined;
    supplierContact?: string | undefined;
    supplierNumber?: string | undefined;
    beaconId?: string | undefined;
    isNegativStockAllowed?: boolean;
    inboundPrice!: number;
    outboundPrice!: number;
    storagePrice!: number;
    packagesCount!: number;
    isShowPackageCount!: boolean;
    isShowPictureInLine!: boolean;
    inventoryCell?: InventoryCell[] | undefined;
    medias?: InventoryMedia[] | undefined;
    bins?: InventoryBinMapping[] | undefined;
    contacts?: InventoryContactMapping[] | undefined;

    constructor(data?: IInventory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkAccountId = _data["fkAccountId"];
            this.key = _data["key"];
            this.name = _data["name"];
            this.ident = _data["ident"];
            this.generalInfo = _data["generalInfo"];
            this.supplier = _data["supplier"];
            this.comment = _data["comment"];
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.price = _data["price"];
            this.location = _data["location"];
            this.itemsOnStock = _data["itemsOnStock"];
            this.lowStockSetpoint = _data["lowStockSetpoint"];
            this.nominalStock = _data["nominalStock"];
            this.defaultActionAmount = _data["defaultActionAmount"];
            this.costCenter = _data["costCenter"];
            this.riskInfo = _data["riskInfo"];
            this.locationAisle = _data["locationAisle"];
            this.locationRow = _data["locationRow"];
            this.locationPin = _data["locationPin"];
            this.techArea = _data["techArea"];
            this.lastTransactionComment = _data["lastTransactionComment"];
            this.unit = _data["unit"];
            this.gtin = _data["gtin"];
            this.weight = _data["weight"];
            this.volume = _data["volume"];
            this.size = _data["size"];
            this.package = _data["package"];
            this.origin = _data["origin"];
            this.hsCode = _data["hsCode"];
            this.quality = _data["quality"];
            this.quality2 = _data["quality2"];
            this.partNumber = _data["partNumber"];
            this.web = _data["web"];
            this.supplierContact = _data["supplierContact"];
            this.supplierNumber = _data["supplierNumber"];
            this.beaconId = _data["beaconId"];
            this.isNegativStockAllowed = _data["isNegativStockAllowed"];
            this.inboundPrice = _data["inboundPrice"];
            this.outboundPrice = _data["outboundPrice"];
            this.storagePrice = _data["storagePrice"];
            this.packagesCount = _data["packagesCount"];
            this.isShowPackageCount = _data["isShowPackageCount"];
            this.isShowPictureInLine = _data["isShowPictureInLine"];
            if (Array.isArray(_data["inventoryCell"])) {
                this.inventoryCell = [] as any;
                for (let item of _data["inventoryCell"])
                    this.inventoryCell!.push(InventoryCell.fromJS(item));
            }
            if (Array.isArray(_data["medias"])) {
                this.medias = [] as any;
                for (let item of _data["medias"])
                    this.medias!.push(InventoryMedia.fromJS(item));
            }
            if (Array.isArray(_data["bins"])) {
                this.bins = [] as any;
                for (let item of _data["bins"])
                    this.bins!.push(InventoryBinMapping.fromJS(item));
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(InventoryContactMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Inventory {
        data = typeof data === 'object' ? data : {};
        let result = new Inventory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkAccountId"] = this.fkAccountId;
        data["key"] = this.key;
        data["name"] = this.name;
        data["ident"] = this.ident;
        data["generalInfo"] = this.generalInfo;
        data["supplier"] = this.supplier;
        data["comment"] = this.comment;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["price"] = this.price;
        data["location"] = this.location;
        data["itemsOnStock"] = this.itemsOnStock;
        data["lowStockSetpoint"] = this.lowStockSetpoint;
        data["nominalStock"] = this.nominalStock;
        data["defaultActionAmount"] = this.defaultActionAmount;
        data["costCenter"] = this.costCenter;
        data["riskInfo"] = this.riskInfo;
        data["locationAisle"] = this.locationAisle;
        data["locationRow"] = this.locationRow;
        data["locationPin"] = this.locationPin;
        data["techArea"] = this.techArea;
        data["lastTransactionComment"] = this.lastTransactionComment;
        data["unit"] = this.unit;
        data["gtin"] = this.gtin;
        data["weight"] = this.weight;
        data["volume"] = this.volume;
        data["size"] = this.size;
        data["package"] = this.package;
        data["origin"] = this.origin;
        data["hsCode"] = this.hsCode;
        data["quality"] = this.quality;
        data["quality2"] = this.quality2;
        data["partNumber"] = this.partNumber;
        data["web"] = this.web;
        data["supplierContact"] = this.supplierContact;
        data["supplierNumber"] = this.supplierNumber;
        data["beaconId"] = this.beaconId;
        data["isNegativStockAllowed"] = this.isNegativStockAllowed;
        data["inboundPrice"] = this.inboundPrice;
        data["outboundPrice"] = this.outboundPrice;
        data["storagePrice"] = this.storagePrice;
        data["packagesCount"] = this.packagesCount;
        data["isShowPackageCount"] = this.isShowPackageCount;
        data["isShowPictureInLine"] = this.isShowPictureInLine;
        if (Array.isArray(this.inventoryCell)) {
            data["inventoryCell"] = [];
            for (let item of this.inventoryCell)
                data["inventoryCell"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.medias)) {
            data["medias"] = [];
            for (let item of this.medias)
                data["medias"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.bins)) {
            data["bins"] = [];
            for (let item of this.bins)
                data["bins"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): Inventory {
        const json = this.toJSON();
        let result = new Inventory();
        result.init(json);
        return result;
    }
}

export interface IInventory {
    id?: number;
    fkAccountId?: number;
    key?: string | undefined;
    name?: string | undefined;
    ident?: string | undefined;
    generalInfo?: string | undefined;
    supplier?: string | undefined;
    comment?: string | undefined;
    entryDate?: Date;
    updatedAt?: Date;
    price?: number;
    location?: string | undefined;
    itemsOnStock?: number;
    lowStockSetpoint?: number;
    nominalStock?: number;
    defaultActionAmount?: number;
    costCenter?: string | undefined;
    riskInfo?: string | undefined;
    locationAisle?: string | undefined;
    locationRow?: string | undefined;
    locationPin?: string | undefined;
    techArea?: string | undefined;
    lastTransactionComment?: string | undefined;
    unit?: string | undefined;
    gtin?: string | undefined;
    weight?: string | undefined;
    volume?: string | undefined;
    size?: string | undefined;
    package?: string | undefined;
    origin?: string | undefined;
    hsCode?: string | undefined;
    quality?: string | undefined;
    quality2?: string | undefined;
    partNumber?: string | undefined;
    web?: string | undefined;
    supplierContact?: string | undefined;
    supplierNumber?: string | undefined;
    beaconId?: string | undefined;
    isNegativStockAllowed?: boolean;
    inboundPrice: number;
    outboundPrice: number;
    storagePrice: number;
    packagesCount: number;
    isShowPackageCount: boolean;
    isShowPictureInLine: boolean;
    inventoryCell?: InventoryCell[] | undefined;
    medias?: InventoryMedia[] | undefined;
    bins?: InventoryBinMapping[] | undefined;
    contacts?: InventoryContactMapping[] | undefined;
}

export class InventoryCell implements IInventoryCell {
    id?: number;
    cellId?: number | undefined;
    fkAccountId?: number;

    constructor(data?: IInventoryCell) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cellId = _data["cellId"];
            this.fkAccountId = _data["fkAccountId"];
        }
    }

    static fromJS(data: any): InventoryCell {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryCell();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cellId"] = this.cellId;
        data["fkAccountId"] = this.fkAccountId;
        return data;
    }

    clone(): InventoryCell {
        const json = this.toJSON();
        let result = new InventoryCell();
        result.init(json);
        return result;
    }
}

export interface IInventoryCell {
    id?: number;
    cellId?: number | undefined;
    fkAccountId?: number;
}

export class InventoryMedia implements IInventoryMedia {
    id!: string;
    inventoryId!: number;
    mediaId!: string;

    constructor(data?: IInventoryMedia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inventoryId = _data["inventoryId"];
            this.mediaId = _data["mediaId"];
        }
    }

    static fromJS(data: any): InventoryMedia {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryMedia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inventoryId"] = this.inventoryId;
        data["mediaId"] = this.mediaId;
        return data;
    }

    clone(): InventoryMedia {
        const json = this.toJSON();
        let result = new InventoryMedia();
        result.init(json);
        return result;
    }
}

export interface IInventoryMedia {
    id: string;
    inventoryId: number;
    mediaId: string;
}

export class InventoryBinMapping implements IInventoryBinMapping {
    id!: string;
    createdAt!: Date;
    createdBy!: string;
    inventoryId!: number;
    binId!: string;

    constructor(data?: IInventoryBinMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.inventoryId = _data["inventoryId"];
            this.binId = _data["binId"];
        }
    }

    static fromJS(data: any): InventoryBinMapping {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryBinMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["inventoryId"] = this.inventoryId;
        data["binId"] = this.binId;
        return data;
    }

    clone(): InventoryBinMapping {
        const json = this.toJSON();
        let result = new InventoryBinMapping();
        result.init(json);
        return result;
    }
}

export interface IInventoryBinMapping {
    id: string;
    createdAt: Date;
    createdBy: string;
    inventoryId: number;
    binId: string;
}

export class InventoryContactMapping implements IInventoryContactMapping {
    id!: string;
    createdAt!: Date;
    createdBy!: string;
    inventoryId!: number;
    contactId!: string;

    constructor(data?: IInventoryContactMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.inventoryId = _data["inventoryId"];
            this.contactId = _data["contactId"];
        }
    }

    static fromJS(data: any): InventoryContactMapping {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryContactMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["inventoryId"] = this.inventoryId;
        data["contactId"] = this.contactId;
        return data;
    }

    clone(): InventoryContactMapping {
        const json = this.toJSON();
        let result = new InventoryContactMapping();
        result.init(json);
        return result;
    }
}

export interface IInventoryContactMapping {
    id: string;
    createdAt: Date;
    createdBy: string;
    inventoryId: number;
    contactId: string;
}

export class SetCellInventoriesRequest implements ISetCellInventoriesRequest {
    cellId!: number;
    inventoryIds!: number[];

    constructor(data?: ISetCellInventoriesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.inventoryIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cellId = _data["cellId"];
            if (Array.isArray(_data["inventoryIds"])) {
                this.inventoryIds = [] as any;
                for (let item of _data["inventoryIds"])
                    this.inventoryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SetCellInventoriesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetCellInventoriesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cellId"] = this.cellId;
        if (Array.isArray(this.inventoryIds)) {
            data["inventoryIds"] = [];
            for (let item of this.inventoryIds)
                data["inventoryIds"].push(item);
        }
        return data;
    }

    clone(): SetCellInventoriesRequest {
        const json = this.toJSON();
        let result = new SetCellInventoriesRequest();
        result.init(json);
        return result;
    }
}

export interface ISetCellInventoriesRequest {
    cellId: number;
    inventoryIds: number[];
}

export class QrResponseAsEncodedJson implements IQrResponseAsEncodedJson {
    title!: string;
    allowedPrinters?: AllowedPrinterInfo | undefined;
    printerCommand!: string;

    constructor(data?: IQrResponseAsEncodedJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.allowedPrinters = _data["allowedPrinters"] ? AllowedPrinterInfo.fromJS(_data["allowedPrinters"]) : undefined as any;
            this.printerCommand = _data["printerCommand"];
        }
    }

    static fromJS(data: any): QrResponseAsEncodedJson {
        data = typeof data === 'object' ? data : {};
        let result = new QrResponseAsEncodedJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["allowedPrinters"] = this.allowedPrinters ? this.allowedPrinters.toJSON() : undefined as any;
        data["printerCommand"] = this.printerCommand;
        return data;
    }

    clone(): QrResponseAsEncodedJson {
        const json = this.toJSON();
        let result = new QrResponseAsEncodedJson();
        result.init(json);
        return result;
    }
}

export interface IQrResponseAsEncodedJson {
    title: string;
    allowedPrinters?: AllowedPrinterInfo | undefined;
    printerCommand: string;
}

export class ExtraModelsClass implements IExtraModelsClass {
    costsumup?: CostSumup | undefined;
    costdto?: CostDto | undefined;

    constructor(data?: IExtraModelsClass) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costsumup = _data["costsumup"] ? CostSumup.fromJS(_data["costsumup"]) : undefined as any;
            this.costdto = _data["costdto"] ? CostDto.fromJS(_data["costdto"]) : undefined as any;
        }
    }

    static fromJS(data: any): ExtraModelsClass {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraModelsClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costsumup"] = this.costsumup ? this.costsumup.toJSON() : undefined as any;
        data["costdto"] = this.costdto ? this.costdto.toJSON() : undefined as any;
        return data;
    }

    clone(): ExtraModelsClass {
        const json = this.toJSON();
        let result = new ExtraModelsClass();
        result.init(json);
        return result;
    }
}

export interface IExtraModelsClass {
    costsumup?: CostSumup | undefined;
    costdto?: CostDto | undefined;
}

export class CostSumup implements ICostSumup {
    totalAmount!: number;
    totalTime?: string;
    subCategory!: string;
    lastCost?: ICostDto | undefined;

    constructor(data?: ICostSumup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalAmount = _data["totalAmount"];
            this.totalTime = _data["totalTime"];
            this.subCategory = _data["subCategory"];
            this.lastCost = _data["lastCost"] ? ICostDto.fromJS(_data["lastCost"]) : undefined as any;
        }
    }

    static fromJS(data: any): CostSumup {
        data = typeof data === 'object' ? data : {};
        let result = new CostSumup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAmount"] = this.totalAmount;
        data["totalTime"] = this.totalTime;
        data["subCategory"] = this.subCategory;
        data["lastCost"] = this.lastCost ? this.lastCost.toJSON() : undefined as any;
        return data;
    }

    clone(): CostSumup {
        const json = this.toJSON();
        let result = new CostSumup();
        result.init(json);
        return result;
    }
}

export interface ICostSumup {
    totalAmount: number;
    totalTime?: string;
    subCategory: string;
    lastCost?: ICostDto | undefined;
}

export class ARequestVM implements IARequestVM {
    route?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    offsetMin?: number;
    filters?: AFilter[] | undefined;
    isRealTimeCalculationEnabled?: boolean;

    constructor(data?: IARequestVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.route = _data["route"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.offsetMin = _data["offsetMin"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(AFilter.fromJS(item));
            }
            this.isRealTimeCalculationEnabled = _data["isRealTimeCalculationEnabled"];
        }
    }

    static fromJS(data: any): ARequestVM {
        data = typeof data === 'object' ? data : {};
        let result = new ARequestVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["route"] = this.route;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["offsetMin"] = this.offsetMin;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        data["isRealTimeCalculationEnabled"] = this.isRealTimeCalculationEnabled;
        return data;
    }

    clone(): ARequestVM {
        const json = this.toJSON();
        let result = new ARequestVM();
        result.init(json);
        return result;
    }
}

export interface IARequestVM {
    route?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    offsetMin?: number;
    filters?: AFilter[] | undefined;
    isRealTimeCalculationEnabled?: boolean;
}

export class AFilter implements IAFilter {
    searchString?: string | undefined;

    constructor(data?: IAFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchString = _data["searchString"];
        }
    }

    static fromJS(data: any): AFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchString"] = this.searchString;
        return data;
    }

    clone(): AFilter {
        const json = this.toJSON();
        let result = new AFilter();
        result.init(json);
        return result;
    }
}

export interface IAFilter {
    searchString?: string | undefined;
}

export class DTOEvent implements IDTOEvent {
    name?: string | undefined;

    constructor(data?: IDTOEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DTOEvent {
        data = typeof data === 'object' ? data : {};
        let result = new DTOEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }

    clone(): DTOEvent {
        const json = this.toJSON();
        let result = new DTOEvent();
        result.init(json);
        return result;
    }
}

export interface IDTOEvent {
    name?: string | undefined;
}

export class Event implements IEvent {
    id?: number;
    fkAccountId?: number;
    name?: string | undefined;
    labelEvents?: LabelEvent[] | undefined;
    cell?: Cell | undefined;

    constructor(data?: IEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkAccountId = _data["fkAccountId"];
            this.name = _data["name"];
            if (Array.isArray(_data["labelEvents"])) {
                this.labelEvents = [] as any;
                for (let item of _data["labelEvents"])
                    this.labelEvents!.push(LabelEvent.fromJS(item));
            }
            this.cell = _data["cell"] ? Cell.fromJS(_data["cell"]) : undefined as any;
        }
    }

    static fromJS(data: any): Event {
        data = typeof data === 'object' ? data : {};
        let result = new Event();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkAccountId"] = this.fkAccountId;
        data["name"] = this.name;
        if (Array.isArray(this.labelEvents)) {
            data["labelEvents"] = [];
            for (let item of this.labelEvents)
                data["labelEvents"].push(item ? item.toJSON() : undefined as any);
        }
        data["cell"] = this.cell ? this.cell.toJSON() : undefined as any;
        return data;
    }

    clone(): Event {
        const json = this.toJSON();
        let result = new Event();
        result.init(json);
        return result;
    }
}

export interface IEvent {
    id?: number;
    fkAccountId?: number;
    name?: string | undefined;
    labelEvents?: LabelEvent[] | undefined;
    cell?: Cell | undefined;
}

export class LabelEvent implements ILabelEvent {
    labelId?: number;
    labelNode?: LabelNode | undefined;
    eventId?: number;
    event?: Event | undefined;

    constructor(data?: ILabelEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labelId = _data["labelId"];
            this.labelNode = _data["labelNode"] ? LabelNode.fromJS(_data["labelNode"]) : undefined as any;
            this.eventId = _data["eventId"];
            this.event = _data["event"] ? Event.fromJS(_data["event"]) : undefined as any;
        }
    }

    static fromJS(data: any): LabelEvent {
        data = typeof data === 'object' ? data : {};
        let result = new LabelEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labelId"] = this.labelId;
        data["labelNode"] = this.labelNode ? this.labelNode.toJSON() : undefined as any;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : undefined as any;
        return data;
    }

    clone(): LabelEvent {
        const json = this.toJSON();
        let result = new LabelEvent();
        result.init(json);
        return result;
    }
}

export interface ILabelEvent {
    labelId?: number;
    labelNode?: LabelNode | undefined;
    eventId?: number;
    event?: Event | undefined;
}

export class VMDutiesIndex implements IVMDutiesIndex {
    duties!: Duty[];
    selectedDomainObjectId!: number;
    users!: ListItem[];
    triggers!: ListDutyTriggerItem[];

    constructor(data?: IVMDutiesIndex) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.duties = [];
            this.users = [];
            this.triggers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["duties"])) {
                this.duties = [] as any;
                for (let item of _data["duties"])
                    this.duties!.push(Duty.fromJS(item));
            }
            this.selectedDomainObjectId = _data["selectedDomainObjectId"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(ListItem.fromJS(item));
            }
            if (Array.isArray(_data["triggers"])) {
                this.triggers = [] as any;
                for (let item of _data["triggers"])
                    this.triggers!.push(ListDutyTriggerItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VMDutiesIndex {
        data = typeof data === 'object' ? data : {};
        let result = new VMDutiesIndex();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.duties)) {
            data["duties"] = [];
            for (let item of this.duties)
                data["duties"].push(item ? item.toJSON() : undefined as any);
        }
        data["selectedDomainObjectId"] = this.selectedDomainObjectId;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.triggers)) {
            data["triggers"] = [];
            for (let item of this.triggers)
                data["triggers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): VMDutiesIndex {
        const json = this.toJSON();
        let result = new VMDutiesIndex();
        result.init(json);
        return result;
    }
}

export interface IVMDutiesIndex {
    duties: Duty[];
    selectedDomainObjectId: number;
    users: ListItem[];
    triggers: ListDutyTriggerItem[];
}

export class ListDutyTriggerItem implements IListDutyTriggerItem {
    id?: number;
    name?: string | undefined;
    triggerValue?: string | undefined;
    ignDb?: string | undefined;
    ignTable?: string | undefined;
    ignFieldValue?: string | undefined;
    ignFieldError?: string | undefined;

    constructor(data?: IListDutyTriggerItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.triggerValue = _data["triggerValue"];
            this.ignDb = _data["ignDb"];
            this.ignTable = _data["ignTable"];
            this.ignFieldValue = _data["ignFieldValue"];
            this.ignFieldError = _data["ignFieldError"];
        }
    }

    static fromJS(data: any): ListDutyTriggerItem {
        data = typeof data === 'object' ? data : {};
        let result = new ListDutyTriggerItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["triggerValue"] = this.triggerValue;
        data["ignDb"] = this.ignDb;
        data["ignTable"] = this.ignTable;
        data["ignFieldValue"] = this.ignFieldValue;
        data["ignFieldError"] = this.ignFieldError;
        return data;
    }

    clone(): ListDutyTriggerItem {
        const json = this.toJSON();
        let result = new ListDutyTriggerItem();
        result.init(json);
        return result;
    }
}

export interface IListDutyTriggerItem {
    id?: number;
    name?: string | undefined;
    triggerValue?: string | undefined;
    ignDb?: string | undefined;
    ignTable?: string | undefined;
    ignFieldValue?: string | undefined;
    ignFieldError?: string | undefined;
}

export class BaseResultOfDutyNameWithCellIdsOf implements IBaseResultOfDutyNameWithCellIdsOf {
    id?: number;
    isOk?: boolean;
    result?: DutyNameWithCellIds[] | undefined;

    constructor(data?: IBaseResultOfDutyNameWithCellIdsOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(DutyNameWithCellIds.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfDutyNameWithCellIdsOf {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfDutyNameWithCellIdsOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfDutyNameWithCellIdsOf {
        const json = this.toJSON();
        let result = new BaseResultOfDutyNameWithCellIdsOf();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfDutyNameWithCellIdsOf {
    id?: number;
    isOk?: boolean;
    result?: DutyNameWithCellIds[] | undefined;
}

export class DutyNameWithCellIds implements IDutyNameWithCellIds {
    id!: number;
    title!: string;
    cellIds!: number[];

    constructor(data?: IDutyNameWithCellIds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.cellIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            if (Array.isArray(_data["cellIds"])) {
                this.cellIds = [] as any;
                for (let item of _data["cellIds"])
                    this.cellIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DutyNameWithCellIds {
        data = typeof data === 'object' ? data : {};
        let result = new DutyNameWithCellIds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        if (Array.isArray(this.cellIds)) {
            data["cellIds"] = [];
            for (let item of this.cellIds)
                data["cellIds"].push(item);
        }
        return data;
    }

    clone(): DutyNameWithCellIds {
        const json = this.toJSON();
        let result = new DutyNameWithCellIds();
        result.init(json);
        return result;
    }
}

export interface IDutyNameWithCellIds {
    id: number;
    title: string;
    cellIds: number[];
}

export class VMDuties implements IVMDuties {
    userListId?: string | undefined;
    duty!: Duty;

    constructor(data?: IVMDuties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.duty = new Duty();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userListId = _data["userListId"];
            this.duty = _data["duty"] ? Duty.fromJS(_data["duty"]) : new Duty();
        }
    }

    static fromJS(data: any): VMDuties {
        data = typeof data === 'object' ? data : {};
        let result = new VMDuties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userListId"] = this.userListId;
        data["duty"] = this.duty ? this.duty.toJSON() : undefined as any;
        return data;
    }

    clone(): VMDuties {
        const json = this.toJSON();
        let result = new VMDuties();
        result.init(json);
        return result;
    }
}

export interface IVMDuties {
    userListId?: string | undefined;
    duty: Duty;
}

export class VMDutyCreate extends VMDuties implements IVMDutyCreate {
    strJsonTodo?: string | undefined;
    idTodoList?: number;
    users?: ListItem[] | undefined;
    triggerSelected?: number;
    triggers?: ListDutyTriggerItem[] | undefined;
    cells?: ListItemCell[] | undefined;

    constructor(data?: IVMDutyCreate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.strJsonTodo = _data["strJsonTodo"];
            this.idTodoList = _data["idTodoList"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(ListItem.fromJS(item));
            }
            this.triggerSelected = _data["triggerSelected"];
            if (Array.isArray(_data["triggers"])) {
                this.triggers = [] as any;
                for (let item of _data["triggers"])
                    this.triggers!.push(ListDutyTriggerItem.fromJS(item));
            }
            if (Array.isArray(_data["cells"])) {
                this.cells = [] as any;
                for (let item of _data["cells"])
                    this.cells!.push(ListItemCell.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): VMDutyCreate {
        data = typeof data === 'object' ? data : {};
        let result = new VMDutyCreate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["strJsonTodo"] = this.strJsonTodo;
        data["idTodoList"] = this.idTodoList;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        data["triggerSelected"] = this.triggerSelected;
        if (Array.isArray(this.triggers)) {
            data["triggers"] = [];
            for (let item of this.triggers)
                data["triggers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cells)) {
            data["cells"] = [];
            for (let item of this.cells)
                data["cells"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): VMDutyCreate {
        const json = this.toJSON();
        let result = new VMDutyCreate();
        result.init(json);
        return result;
    }
}

export interface IVMDutyCreate extends IVMDuties {
    strJsonTodo?: string | undefined;
    idTodoList?: number;
    users?: ListItem[] | undefined;
    triggerSelected?: number;
    triggers?: ListDutyTriggerItem[] | undefined;
    cells?: ListItemCell[] | undefined;
}

export class ListItemCell implements IListItemCell {
    id?: number;
    name?: string | undefined;

    constructor(data?: IListItemCell) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ListItemCell {
        data = typeof data === 'object' ? data : {};
        let result = new ListItemCell();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): ListItemCell {
        const json = this.toJSON();
        let result = new ListItemCell();
        result.init(json);
        return result;
    }
}

export interface IListItemCell {
    id?: number;
    name?: string | undefined;
}

export class BaseResultOfActivity implements IBaseResultOfActivity {
    id?: number;
    isOk?: boolean;
    result?: Activity | undefined;

    constructor(data?: IBaseResultOfActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? Activity.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfActivity {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfActivity {
        const json = this.toJSON();
        let result = new BaseResultOfActivity();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfActivity {
    id?: number;
    isOk?: boolean;
    result?: Activity | undefined;
}

export class VMDutyEdit extends VMDuties implements IVMDutyEdit {
    strJsonTodo!: string;
    idTodoList!: number;
    users!: ListItem[];
    usersSelected!: ListItem[];
    triggers!: ListDutyTriggerItem[];
    cells!: ListItemCell[];
    cellsSelected!: ListItemCell[];

    constructor(data?: IVMDutyEdit) {
        super(data);
        if (!data) {
            this.users = [];
            this.usersSelected = [];
            this.triggers = [];
            this.cells = [];
            this.cellsSelected = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.strJsonTodo = _data["strJsonTodo"];
            this.idTodoList = _data["idTodoList"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(ListItem.fromJS(item));
            }
            if (Array.isArray(_data["usersSelected"])) {
                this.usersSelected = [] as any;
                for (let item of _data["usersSelected"])
                    this.usersSelected!.push(ListItem.fromJS(item));
            }
            if (Array.isArray(_data["triggers"])) {
                this.triggers = [] as any;
                for (let item of _data["triggers"])
                    this.triggers!.push(ListDutyTriggerItem.fromJS(item));
            }
            if (Array.isArray(_data["cells"])) {
                this.cells = [] as any;
                for (let item of _data["cells"])
                    this.cells!.push(ListItemCell.fromJS(item));
            }
            if (Array.isArray(_data["cellsSelected"])) {
                this.cellsSelected = [] as any;
                for (let item of _data["cellsSelected"])
                    this.cellsSelected!.push(ListItemCell.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): VMDutyEdit {
        data = typeof data === 'object' ? data : {};
        let result = new VMDutyEdit();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["strJsonTodo"] = this.strJsonTodo;
        data["idTodoList"] = this.idTodoList;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.usersSelected)) {
            data["usersSelected"] = [];
            for (let item of this.usersSelected)
                data["usersSelected"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.triggers)) {
            data["triggers"] = [];
            for (let item of this.triggers)
                data["triggers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cells)) {
            data["cells"] = [];
            for (let item of this.cells)
                data["cells"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cellsSelected)) {
            data["cellsSelected"] = [];
            for (let item of this.cellsSelected)
                data["cellsSelected"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): VMDutyEdit {
        const json = this.toJSON();
        let result = new VMDutyEdit();
        result.init(json);
        return result;
    }
}

export interface IVMDutyEdit extends IVMDuties {
    strJsonTodo: string;
    idTodoList: number;
    users: ListItem[];
    usersSelected: ListItem[];
    triggers: ListDutyTriggerItem[];
    cells: ListItemCell[];
    cellsSelected: ListItemCell[];
}

export class OptionItem implements IOptionItem {
    internalId?: string | undefined;
    name?: string | undefined;
    filename?: string | undefined;
    css?: string | undefined;
    policy?: string | undefined;

    constructor(data?: IOptionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalId = _data["internalId"];
            this.name = _data["name"];
            this.filename = _data["filename"];
            this.css = _data["css"];
            this.policy = _data["policy"];
        }
    }

    static fromJS(data: any): OptionItem {
        data = typeof data === 'object' ? data : {};
        let result = new OptionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalId"] = this.internalId;
        data["name"] = this.name;
        data["filename"] = this.filename;
        data["css"] = this.css;
        data["policy"] = this.policy;
        return data;
    }

    clone(): OptionItem {
        const json = this.toJSON();
        let result = new OptionItem();
        result.init(json);
        return result;
    }
}

export interface IOptionItem {
    internalId?: string | undefined;
    name?: string | undefined;
    filename?: string | undefined;
    css?: string | undefined;
    policy?: string | undefined;
}

export class TriggerCbmAnonymousDuty implements ITriggerCbmAnonymousDuty {
    cbmAnonymousId!: string;
    email!: string;
    comment?: string | undefined;

    constructor(data?: ITriggerCbmAnonymousDuty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cbmAnonymousId = _data["cbmAnonymousId"];
            this.email = _data["email"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): TriggerCbmAnonymousDuty {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerCbmAnonymousDuty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cbmAnonymousId"] = this.cbmAnonymousId;
        data["email"] = this.email;
        data["comment"] = this.comment;
        return data;
    }

    clone(): TriggerCbmAnonymousDuty {
        const json = this.toJSON();
        let result = new TriggerCbmAnonymousDuty();
        result.init(json);
        return result;
    }
}

export interface ITriggerCbmAnonymousDuty {
    cbmAnonymousId: string;
    email: string;
    comment?: string | undefined;
}

export class TriggerCbmDuty implements ITriggerCbmDuty {
    cbmId!: string;
    description?: string | undefined;
    mailSubject?: string | undefined;
    fromMail?: string | undefined;
    fromName?: string | undefined;
    dateTimeAt?: string | undefined;
    attachments?: CbmAttachmentDto[] | undefined;

    constructor(data?: ITriggerCbmDuty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cbmId = _data["cbmId"];
            this.description = _data["description"];
            this.mailSubject = _data["mailSubject"];
            this.fromMail = _data["fromMail"];
            this.fromName = _data["fromName"];
            this.dateTimeAt = _data["dateTimeAt"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(CbmAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TriggerCbmDuty {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerCbmDuty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cbmId"] = this.cbmId;
        data["description"] = this.description;
        data["mailSubject"] = this.mailSubject;
        data["fromMail"] = this.fromMail;
        data["fromName"] = this.fromName;
        data["dateTimeAt"] = this.dateTimeAt;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TriggerCbmDuty {
        const json = this.toJSON();
        let result = new TriggerCbmDuty();
        result.init(json);
        return result;
    }
}

export interface ITriggerCbmDuty {
    cbmId: string;
    description?: string | undefined;
    mailSubject?: string | undefined;
    fromMail?: string | undefined;
    fromName?: string | undefined;
    dateTimeAt?: string | undefined;
    attachments?: CbmAttachmentDto[] | undefined;
}

export class CbmAttachmentDto implements ICbmAttachmentDto {
    fileName?: string | undefined;
    contentType?: string | undefined;
    size?: number;
    contentBase64?: string | undefined;

    constructor(data?: ICbmAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.size = _data["size"];
            this.contentBase64 = _data["contentBase64"];
        }
    }

    static fromJS(data: any): CbmAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CbmAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["size"] = this.size;
        data["contentBase64"] = this.contentBase64;
        return data;
    }

    clone(): CbmAttachmentDto {
        const json = this.toJSON();
        let result = new CbmAttachmentDto();
        result.init(json);
        return result;
    }
}

export interface ICbmAttachmentDto {
    fileName?: string | undefined;
    contentType?: string | undefined;
    size?: number;
    contentBase64?: string | undefined;
}

export class GpsTrackerDto implements IGpsTrackerDto {
    id!: number;
    fkAccountId!: number;
    fkCellId?: number | undefined;
    imei!: string;
    phoneNumber!: string;
    type!: string;
    apn!: string;
    apnUser?: string | undefined;
    apnPwd?: string | undefined;
    mode!: string;
    networkMode!: string;
    band!: string;
    modeReportIntervalSec?: number;
    triggerDistanceTraveledDutyId?: number | undefined;
    triggerDistanceTraveledDutyMeters!: number;
    triggerDistanceTraveledDutySetPointSeconds!: number;

    constructor(data?: IGpsTrackerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkAccountId = _data["fkAccountId"];
            this.fkCellId = _data["fkCellId"];
            this.imei = _data["imei"];
            this.phoneNumber = _data["phoneNumber"];
            this.type = _data["type"];
            this.apn = _data["apn"];
            this.apnUser = _data["apnUser"];
            this.apnPwd = _data["apnPwd"];
            this.mode = _data["mode"];
            this.networkMode = _data["networkMode"];
            this.band = _data["band"];
            this.modeReportIntervalSec = _data["modeReportIntervalSec"];
            this.triggerDistanceTraveledDutyId = _data["triggerDistanceTraveledDutyId"];
            this.triggerDistanceTraveledDutyMeters = _data["triggerDistanceTraveledDutyMeters"];
            this.triggerDistanceTraveledDutySetPointSeconds = _data["triggerDistanceTraveledDutySetPointSeconds"];
        }
    }

    static fromJS(data: any): GpsTrackerDto {
        data = typeof data === 'object' ? data : {};
        let result = new GpsTrackerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkAccountId"] = this.fkAccountId;
        data["fkCellId"] = this.fkCellId;
        data["imei"] = this.imei;
        data["phoneNumber"] = this.phoneNumber;
        data["type"] = this.type;
        data["apn"] = this.apn;
        data["apnUser"] = this.apnUser;
        data["apnPwd"] = this.apnPwd;
        data["mode"] = this.mode;
        data["networkMode"] = this.networkMode;
        data["band"] = this.band;
        data["modeReportIntervalSec"] = this.modeReportIntervalSec;
        data["triggerDistanceTraveledDutyId"] = this.triggerDistanceTraveledDutyId;
        data["triggerDistanceTraveledDutyMeters"] = this.triggerDistanceTraveledDutyMeters;
        data["triggerDistanceTraveledDutySetPointSeconds"] = this.triggerDistanceTraveledDutySetPointSeconds;
        return data;
    }

    clone(): GpsTrackerDto {
        const json = this.toJSON();
        let result = new GpsTrackerDto();
        result.init(json);
        return result;
    }
}

export interface IGpsTrackerDto {
    id: number;
    fkAccountId: number;
    fkCellId?: number | undefined;
    imei: string;
    phoneNumber: string;
    type: string;
    apn: string;
    apnUser?: string | undefined;
    apnPwd?: string | undefined;
    mode: string;
    networkMode: string;
    band: string;
    modeReportIntervalSec?: number;
    triggerDistanceTraveledDutyId?: number | undefined;
    triggerDistanceTraveledDutyMeters: number;
    triggerDistanceTraveledDutySetPointSeconds: number;
}

export class GroupMaintenanceExtension implements IGroupMaintenanceExtension {
    id!: string;
    group!: Group;
    groupId!: string;
    cellScopeVisibilities!: GroupMaintenanceCellScopeVisibility[];

    constructor(data?: IGroupMaintenanceExtension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.group = new Group();
            this.cellScopeVisibilities = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.group = _data["group"] ? Group.fromJS(_data["group"]) : new Group();
            this.groupId = _data["groupId"];
            if (Array.isArray(_data["cellScopeVisibilities"])) {
                this.cellScopeVisibilities = [] as any;
                for (let item of _data["cellScopeVisibilities"])
                    this.cellScopeVisibilities!.push(GroupMaintenanceCellScopeVisibility.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupMaintenanceExtension {
        data = typeof data === 'object' ? data : {};
        let result = new GroupMaintenanceExtension();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["group"] = this.group ? this.group.toJSON() : undefined as any;
        data["groupId"] = this.groupId;
        if (Array.isArray(this.cellScopeVisibilities)) {
            data["cellScopeVisibilities"] = [];
            for (let item of this.cellScopeVisibilities)
                data["cellScopeVisibilities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): GroupMaintenanceExtension {
        const json = this.toJSON();
        let result = new GroupMaintenanceExtension();
        result.init(json);
        return result;
    }
}

export interface IGroupMaintenanceExtension {
    id: string;
    group: Group;
    groupId: string;
    cellScopeVisibilities: GroupMaintenanceCellScopeVisibility[];
}

export class GroupMaintenanceCellScopeVisibility implements IGroupMaintenanceCellScopeVisibility {
    id!: string;
    groupMaintenanceExtensionId!: string;
    cellId!: number;
    cellChildrenVisible!: boolean;

    constructor(data?: IGroupMaintenanceCellScopeVisibility) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupMaintenanceExtensionId = _data["groupMaintenanceExtensionId"];
            this.cellId = _data["cellId"];
            this.cellChildrenVisible = _data["cellChildrenVisible"];
        }
    }

    static fromJS(data: any): GroupMaintenanceCellScopeVisibility {
        data = typeof data === 'object' ? data : {};
        let result = new GroupMaintenanceCellScopeVisibility();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupMaintenanceExtensionId"] = this.groupMaintenanceExtensionId;
        data["cellId"] = this.cellId;
        data["cellChildrenVisible"] = this.cellChildrenVisible;
        return data;
    }

    clone(): GroupMaintenanceCellScopeVisibility {
        const json = this.toJSON();
        let result = new GroupMaintenanceCellScopeVisibility();
        result.init(json);
        return result;
    }
}

export interface IGroupMaintenanceCellScopeVisibility {
    id: string;
    groupMaintenanceExtensionId: string;
    cellId: number;
    cellChildrenVisible: boolean;
}

export class LinkMediaRequest implements ILinkMediaRequest {
    inventoryId!: number;
    mediaId?: string | undefined;
    mediaFileName?: string;
    mediaPublicUrl?: string;

    constructor(data?: ILinkMediaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inventoryId = _data["inventoryId"];
            this.mediaId = _data["mediaId"];
            this.mediaFileName = _data["mediaFileName"];
            this.mediaPublicUrl = _data["mediaPublicUrl"];
        }
    }

    static fromJS(data: any): LinkMediaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LinkMediaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inventoryId"] = this.inventoryId;
        data["mediaId"] = this.mediaId;
        data["mediaFileName"] = this.mediaFileName;
        data["mediaPublicUrl"] = this.mediaPublicUrl;
        return data;
    }

    clone(): LinkMediaRequest {
        const json = this.toJSON();
        let result = new LinkMediaRequest();
        result.init(json);
        return result;
    }
}

export interface ILinkMediaRequest {
    inventoryId: number;
    mediaId?: string | undefined;
    mediaFileName?: string;
    mediaPublicUrl?: string;
}

export class InventoryBin implements IInventoryBin {
    id!: string;
    fkAccountId!: number;
    name!: string;
    ident?: string | undefined;
    createdAt!: Date;
    createdBy!: string;
    updatedAt!: Date;
    updatedBy!: string;
    locationAisle?: string | undefined;
    locationRow?: string | undefined;
    locationPin?: string | undefined;
    gtin?: string | undefined;
    inventories?: InventoryBinMapping[] | undefined;

    constructor(data?: IInventoryBin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkAccountId = _data["fkAccountId"];
            this.name = _data["name"];
            this.ident = _data["ident"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.locationAisle = _data["locationAisle"];
            this.locationRow = _data["locationRow"];
            this.locationPin = _data["locationPin"];
            this.gtin = _data["gtin"];
            if (Array.isArray(_data["inventories"])) {
                this.inventories = [] as any;
                for (let item of _data["inventories"])
                    this.inventories!.push(InventoryBinMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InventoryBin {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryBin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkAccountId"] = this.fkAccountId;
        data["name"] = this.name;
        data["ident"] = this.ident;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        data["locationAisle"] = this.locationAisle;
        data["locationRow"] = this.locationRow;
        data["locationPin"] = this.locationPin;
        data["gtin"] = this.gtin;
        if (Array.isArray(this.inventories)) {
            data["inventories"] = [];
            for (let item of this.inventories)
                data["inventories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): InventoryBin {
        const json = this.toJSON();
        let result = new InventoryBin();
        result.init(json);
        return result;
    }
}

export interface IInventoryBin {
    id: string;
    fkAccountId: number;
    name: string;
    ident?: string | undefined;
    createdAt: Date;
    createdBy: string;
    updatedAt: Date;
    updatedBy: string;
    locationAisle?: string | undefined;
    locationRow?: string | undefined;
    locationPin?: string | undefined;
    gtin?: string | undefined;
    inventories?: InventoryBinMapping[] | undefined;
}

export class BinQrRequest implements IBinQrRequest {
    binIds!: string[];
    columns!: number;

    constructor(data?: IBinQrRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.binIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["binIds"])) {
                this.binIds = [] as any;
                for (let item of _data["binIds"])
                    this.binIds!.push(item);
            }
            this.columns = _data["columns"];
        }
    }

    static fromJS(data: any): BinQrRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BinQrRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.binIds)) {
            data["binIds"] = [];
            for (let item of this.binIds)
                data["binIds"].push(item);
        }
        data["columns"] = this.columns;
        return data;
    }

    clone(): BinQrRequest {
        const json = this.toJSON();
        let result = new BinQrRequest();
        result.init(json);
        return result;
    }
}

export interface IBinQrRequest {
    binIds: string[];
    columns: number;
}

export class SignOffInventoryRequest implements ISignOffInventoryRequest {
    gpsPos!: GpsPos;
    inventoryId!: number;

    constructor(data?: ISignOffInventoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.gpsPos = new GpsPos();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gpsPos = _data["gpsPos"] ? GpsPos.fromJS(_data["gpsPos"]) : new GpsPos();
            this.inventoryId = _data["inventoryId"];
        }
    }

    static fromJS(data: any): SignOffInventoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignOffInventoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gpsPos"] = this.gpsPos ? this.gpsPos.toJSON() : undefined as any;
        data["inventoryId"] = this.inventoryId;
        return data;
    }

    clone(): SignOffInventoryRequest {
        const json = this.toJSON();
        let result = new SignOffInventoryRequest();
        result.init(json);
        return result;
    }
}

export interface ISignOffInventoryRequest {
    gpsPos: GpsPos;
    inventoryId: number;
}

export class GpsPos implements IGpsPos {
    lng!: number;
    lat!: number;
    alt!: number;
    timestamp!: Date;

    constructor(data?: IGpsPos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lng = _data["lng"];
            this.lat = _data["lat"];
            this.alt = _data["alt"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GpsPos {
        data = typeof data === 'object' ? data : {};
        let result = new GpsPos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lng"] = this.lng;
        data["lat"] = this.lat;
        data["alt"] = this.alt;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined as any;
        return data;
    }

    clone(): GpsPos {
        const json = this.toJSON();
        let result = new GpsPos();
        result.init(json);
        return result;
    }
}

export interface IGpsPos {
    lng: number;
    lat: number;
    alt: number;
    timestamp: Date;
}

export class InventoryStockTaking implements IInventoryStockTaking {
    id!: string;
    createdAt!: Date;
    createdBy!: string;
    updatedAt!: Date;
    updatedBy!: string;
    name!: string;
    scheduledAt!: Date;
    completedAt?: Date | undefined;
    entries!: InventoryStockTakingEntry[];

    constructor(data?: IInventoryStockTaking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.entries = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.name = _data["name"];
            this.scheduledAt = _data["scheduledAt"] ? new Date(_data["scheduledAt"].toString()) : undefined as any;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : undefined as any;
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(InventoryStockTakingEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InventoryStockTaking {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryStockTaking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        data["name"] = this.name;
        data["scheduledAt"] = this.scheduledAt ? this.scheduledAt.toISOString() : undefined as any;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined as any;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): InventoryStockTaking {
        const json = this.toJSON();
        let result = new InventoryStockTaking();
        result.init(json);
        return result;
    }
}

export interface IInventoryStockTaking {
    id: string;
    createdAt: Date;
    createdBy: string;
    updatedAt: Date;
    updatedBy: string;
    name: string;
    scheduledAt: Date;
    completedAt?: Date | undefined;
    entries: InventoryStockTakingEntry[];
}

export class InventoryStockTakingEntry implements IInventoryStockTakingEntry {
    id!: string;
    createdAt!: Date;
    createdBy!: string;
    updatedAt!: Date;
    updatedBy!: string;
    inventoryId?: number | undefined;
    inventoryIdent?: string | undefined;
    inventoryName?: string | undefined;
    stockBefore?: number | undefined;
    stockAfter?: number | undefined;
    packageCountBefore?: number | undefined;
    packageCountAfter?: number | undefined;
    comment?: string | undefined;

    constructor(data?: IInventoryStockTakingEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.inventoryId = _data["inventoryId"];
            this.inventoryIdent = _data["inventoryIdent"];
            this.inventoryName = _data["inventoryName"];
            this.stockBefore = _data["stockBefore"];
            this.stockAfter = _data["stockAfter"];
            this.packageCountBefore = _data["packageCountBefore"];
            this.packageCountAfter = _data["packageCountAfter"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): InventoryStockTakingEntry {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryStockTakingEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        data["inventoryId"] = this.inventoryId;
        data["inventoryIdent"] = this.inventoryIdent;
        data["inventoryName"] = this.inventoryName;
        data["stockBefore"] = this.stockBefore;
        data["stockAfter"] = this.stockAfter;
        data["packageCountBefore"] = this.packageCountBefore;
        data["packageCountAfter"] = this.packageCountAfter;
        data["comment"] = this.comment;
        return data;
    }

    clone(): InventoryStockTakingEntry {
        const json = this.toJSON();
        let result = new InventoryStockTakingEntry();
        result.init(json);
        return result;
    }
}

export interface IInventoryStockTakingEntry {
    id: string;
    createdAt: Date;
    createdBy: string;
    updatedAt: Date;
    updatedBy: string;
    inventoryId?: number | undefined;
    inventoryIdent?: string | undefined;
    inventoryName?: string | undefined;
    stockBefore?: number | undefined;
    stockAfter?: number | undefined;
    packageCountBefore?: number | undefined;
    packageCountAfter?: number | undefined;
    comment?: string | undefined;
}

export class BaseResultOfLine implements IBaseResultOfLine {
    id?: number;
    isOk?: boolean;
    result?: Line | undefined;

    constructor(data?: IBaseResultOfLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? Line.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfLine {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfLine {
        const json = this.toJSON();
        let result = new BaseResultOfLine();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfLine {
    id?: number;
    isOk?: boolean;
    result?: Line | undefined;
}

export class LinkAreaCellEvent implements ILinkAreaCellEvent {
    id?: number;
    fkAccountId?: number;
    areaDbId?: number;
    cellDbId?: number;
    eventDbId?: number;

    constructor(data?: ILinkAreaCellEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkAccountId = _data["fkAccountId"];
            this.areaDbId = _data["areaDbId"];
            this.cellDbId = _data["cellDbId"];
            this.eventDbId = _data["eventDbId"];
        }
    }

    static fromJS(data: any): LinkAreaCellEvent {
        data = typeof data === 'object' ? data : {};
        let result = new LinkAreaCellEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkAccountId"] = this.fkAccountId;
        data["areaDbId"] = this.areaDbId;
        data["cellDbId"] = this.cellDbId;
        data["eventDbId"] = this.eventDbId;
        return data;
    }

    clone(): LinkAreaCellEvent {
        const json = this.toJSON();
        let result = new LinkAreaCellEvent();
        result.init(json);
        return result;
    }
}

export interface ILinkAreaCellEvent {
    id?: number;
    fkAccountId?: number;
    areaDbId?: number;
    cellDbId?: number;
    eventDbId?: number;
}

export class OeeSettings implements IOeeSettings {
    id?: number;
    fkAccountId?: number;
    fkCellId?: number;
    generalId?: string | undefined;
    cellName?: string | undefined;
    defaultQualityRatio?: number;
    defaultPlannedProductionTimeMin?: number;
    defaultAutomaticOverOffDuration?: number;
    isOee?: boolean;
    lastRun?: Date;
    ignServer?: string | undefined;
    ignDb?: string | undefined;
    ignUser?: string | undefined;
    ignPwd?: string | undefined;
    ignTable?: string | undefined;
    ignIndex?: string | undefined;
    ignFieldValue?: string | undefined;
    ignFieldTimestmp?: string | undefined;
    ignScanRate?: number;
    shortstopSeconds?: number;
    ignFieldCell?: string | undefined;
    status?: string | undefined;
    isDisabled?: boolean;

    constructor(data?: IOeeSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkAccountId = _data["fkAccountId"];
            this.fkCellId = _data["fkCellId"];
            this.generalId = _data["generalId"];
            this.cellName = _data["cellName"];
            this.defaultQualityRatio = _data["defaultQualityRatio"];
            this.defaultPlannedProductionTimeMin = _data["defaultPlannedProductionTimeMin"];
            this.defaultAutomaticOverOffDuration = _data["defaultAutomaticOverOffDuration"];
            this.isOee = _data["isOee"];
            this.lastRun = _data["lastRun"] ? new Date(_data["lastRun"].toString()) : undefined as any;
            this.ignServer = _data["ignServer"];
            this.ignDb = _data["ignDb"];
            this.ignUser = _data["ignUser"];
            this.ignPwd = _data["ignPwd"];
            this.ignTable = _data["ignTable"];
            this.ignIndex = _data["ignIndex"];
            this.ignFieldValue = _data["ignFieldValue"];
            this.ignFieldTimestmp = _data["ignFieldTimestmp"];
            this.ignScanRate = _data["ignScanRate"];
            this.shortstopSeconds = _data["shortstopSeconds"];
            this.ignFieldCell = _data["ignFieldCell"];
            this.status = _data["status"];
            this.isDisabled = _data["isDisabled"];
        }
    }

    static fromJS(data: any): OeeSettings {
        data = typeof data === 'object' ? data : {};
        let result = new OeeSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkAccountId"] = this.fkAccountId;
        data["fkCellId"] = this.fkCellId;
        data["generalId"] = this.generalId;
        data["cellName"] = this.cellName;
        data["defaultQualityRatio"] = this.defaultQualityRatio;
        data["defaultPlannedProductionTimeMin"] = this.defaultPlannedProductionTimeMin;
        data["defaultAutomaticOverOffDuration"] = this.defaultAutomaticOverOffDuration;
        data["isOee"] = this.isOee;
        data["lastRun"] = this.lastRun ? this.lastRun.toISOString() : undefined as any;
        data["ignServer"] = this.ignServer;
        data["ignDb"] = this.ignDb;
        data["ignUser"] = this.ignUser;
        data["ignPwd"] = this.ignPwd;
        data["ignTable"] = this.ignTable;
        data["ignIndex"] = this.ignIndex;
        data["ignFieldValue"] = this.ignFieldValue;
        data["ignFieldTimestmp"] = this.ignFieldTimestmp;
        data["ignScanRate"] = this.ignScanRate;
        data["shortstopSeconds"] = this.shortstopSeconds;
        data["ignFieldCell"] = this.ignFieldCell;
        data["status"] = this.status;
        data["isDisabled"] = this.isDisabled;
        return data;
    }

    clone(): OeeSettings {
        const json = this.toJSON();
        let result = new OeeSettings();
        result.init(json);
        return result;
    }
}

export interface IOeeSettings {
    id?: number;
    fkAccountId?: number;
    fkCellId?: number;
    generalId?: string | undefined;
    cellName?: string | undefined;
    defaultQualityRatio?: number;
    defaultPlannedProductionTimeMin?: number;
    defaultAutomaticOverOffDuration?: number;
    isOee?: boolean;
    lastRun?: Date;
    ignServer?: string | undefined;
    ignDb?: string | undefined;
    ignUser?: string | undefined;
    ignPwd?: string | undefined;
    ignTable?: string | undefined;
    ignIndex?: string | undefined;
    ignFieldValue?: string | undefined;
    ignFieldTimestmp?: string | undefined;
    ignScanRate?: number;
    shortstopSeconds?: number;
    ignFieldCell?: string | undefined;
    status?: string | undefined;
    isDisabled?: boolean;
}

export class ShiftTime implements IShiftTime {
    id?: number;
    fkAccountId?: number;
    name?: string | undefined;
    hour?: number;
    min?: number;
    defaultPlannedProductionTimeMin?: number;
    hour2?: number;
    min2?: number;
    defaultPlannedProductionTimeMin2?: number;
    hour3?: number;
    min3?: number;
    defaultPlannedProductionTimeMin3?: number;
    start?: Date;
    end?: Date;

    constructor(data?: IShiftTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkAccountId = _data["fkAccountId"];
            this.name = _data["name"];
            this.hour = _data["hour"];
            this.min = _data["min"];
            this.defaultPlannedProductionTimeMin = _data["defaultPlannedProductionTimeMin"];
            this.hour2 = _data["hour2"];
            this.min2 = _data["min2"];
            this.defaultPlannedProductionTimeMin2 = _data["defaultPlannedProductionTimeMin2"];
            this.hour3 = _data["hour3"];
            this.min3 = _data["min3"];
            this.defaultPlannedProductionTimeMin3 = _data["defaultPlannedProductionTimeMin3"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ShiftTime {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkAccountId"] = this.fkAccountId;
        data["name"] = this.name;
        data["hour"] = this.hour;
        data["min"] = this.min;
        data["defaultPlannedProductionTimeMin"] = this.defaultPlannedProductionTimeMin;
        data["hour2"] = this.hour2;
        data["min2"] = this.min2;
        data["defaultPlannedProductionTimeMin2"] = this.defaultPlannedProductionTimeMin2;
        data["hour3"] = this.hour3;
        data["min3"] = this.min3;
        data["defaultPlannedProductionTimeMin3"] = this.defaultPlannedProductionTimeMin3;
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["end"] = this.end ? this.end.toISOString() : undefined as any;
        return data;
    }

    clone(): ShiftTime {
        const json = this.toJSON();
        let result = new ShiftTime();
        result.init(json);
        return result;
    }
}

export interface IShiftTime {
    id?: number;
    fkAccountId?: number;
    name?: string | undefined;
    hour?: number;
    min?: number;
    defaultPlannedProductionTimeMin?: number;
    hour2?: number;
    min2?: number;
    defaultPlannedProductionTimeMin2?: number;
    hour3?: number;
    min3?: number;
    defaultPlannedProductionTimeMin3?: number;
    start?: Date;
    end?: Date;
}

export class VMActivitiesIndex implements IVMActivitiesIndex {
    activities?: VuetableListOfIPagedListOfActivityAndActivity | undefined;
    activitiesLog?: ActivityLog[] | undefined;
    selectedDomainObjectId?: number;

    constructor(data?: IVMActivitiesIndex) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activities = _data["activities"] ? VuetableListOfIPagedListOfActivityAndActivity.fromJS(_data["activities"]) : undefined as any;
            if (Array.isArray(_data["activitiesLog"])) {
                this.activitiesLog = [] as any;
                for (let item of _data["activitiesLog"])
                    this.activitiesLog!.push(ActivityLog.fromJS(item));
            }
            this.selectedDomainObjectId = _data["selectedDomainObjectId"];
        }
    }

    static fromJS(data: any): VMActivitiesIndex {
        data = typeof data === 'object' ? data : {};
        let result = new VMActivitiesIndex();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activities"] = this.activities ? this.activities.toJSON() : undefined as any;
        if (Array.isArray(this.activitiesLog)) {
            data["activitiesLog"] = [];
            for (let item of this.activitiesLog)
                data["activitiesLog"].push(item ? item.toJSON() : undefined as any);
        }
        data["selectedDomainObjectId"] = this.selectedDomainObjectId;
        return data;
    }

    clone(): VMActivitiesIndex {
        const json = this.toJSON();
        let result = new VMActivitiesIndex();
        result.init(json);
        return result;
    }
}

export interface IVMActivitiesIndex {
    activities?: VuetableListOfIPagedListOfActivityAndActivity | undefined;
    activitiesLog?: ActivityLog[] | undefined;
    selectedDomainObjectId?: number;
}

export class VuetableListOfIPagedListOfActivityAndActivity implements IVuetableListOfIPagedListOfActivityAndActivity {
    data?: Activity[] | undefined;
    current_page?: number;
    per_page?: number;
    total?: number;
    last_page?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
    from?: number;
    to?: number;
    next_page_url?: string | undefined;
    prev_page_url?: string | undefined;

    constructor(data?: IVuetableListOfIPagedListOfActivityAndActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Activity.fromJS(item));
            }
            this.current_page = _data["current_page"];
            this.per_page = _data["per_page"];
            this.total = _data["total"];
            this.last_page = _data["last_page"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.next_page_url = _data["next_page_url"];
            this.prev_page_url = _data["prev_page_url"];
        }
    }

    static fromJS(data: any): VuetableListOfIPagedListOfActivityAndActivity {
        data = typeof data === 'object' ? data : {};
        let result = new VuetableListOfIPagedListOfActivityAndActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["current_page"] = this.current_page;
        data["per_page"] = this.per_page;
        data["total"] = this.total;
        data["last_page"] = this.last_page;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        data["from"] = this.from;
        data["to"] = this.to;
        data["next_page_url"] = this.next_page_url;
        data["prev_page_url"] = this.prev_page_url;
        return data;
    }

    clone(): VuetableListOfIPagedListOfActivityAndActivity {
        const json = this.toJSON();
        let result = new VuetableListOfIPagedListOfActivityAndActivity();
        result.init(json);
        return result;
    }
}

export interface IVuetableListOfIPagedListOfActivityAndActivity {
    data?: Activity[] | undefined;
    current_page?: number;
    per_page?: number;
    total?: number;
    last_page?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
    from?: number;
    to?: number;
    next_page_url?: string | undefined;
    prev_page_url?: string | undefined;
}

export class SearchResult implements ISearchResult {
    pos?: number;
    lastModified?: Date;
    type?: string | undefined;
    link?: string | undefined;
    content?: string | undefined;

    constructor(data?: ISearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pos = _data["pos"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.type = _data["type"];
            this.link = _data["link"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): SearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pos"] = this.pos;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["type"] = this.type;
        data["link"] = this.link;
        data["content"] = this.content;
        return data;
    }

    clone(): SearchResult {
        const json = this.toJSON();
        let result = new SearchResult();
        result.init(json);
        return result;
    }
}

export interface ISearchResult {
    pos?: number;
    lastModified?: Date;
    type?: string | undefined;
    link?: string | undefined;
    content?: string | undefined;
}

export class SuperSearch implements ISuperSearch {
    filter?: string | undefined;

    constructor(data?: ISuperSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): SuperSearch {
        data = typeof data === 'object' ? data : {};
        let result = new SuperSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data;
    }

    clone(): SuperSearch {
        const json = this.toJSON();
        let result = new SuperSearch();
        result.init(json);
        return result;
    }
}

export interface ISuperSearch {
    filter?: string | undefined;
}

export class CreateFlow implements ICreateFlow {
    id?: number;
    name?: string | undefined;

    constructor(data?: ICreateFlow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateFlow {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFlow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): CreateFlow {
        const json = this.toJSON();
        let result = new CreateFlow();
        result.init(json);
        return result;
    }
}

export interface ICreateFlow {
    id?: number;
    name?: string | undefined;
}

export class BaseResultOfActivityPriorityOf implements IBaseResultOfActivityPriorityOf {
    id?: number;
    isOk?: boolean;
    result?: ActivityPriority[] | undefined;

    constructor(data?: IBaseResultOfActivityPriorityOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(ActivityPriority.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfActivityPriorityOf {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfActivityPriorityOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfActivityPriorityOf {
        const json = this.toJSON();
        let result = new BaseResultOfActivityPriorityOf();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfActivityPriorityOf {
    id?: number;
    isOk?: boolean;
    result?: ActivityPriority[] | undefined;
}

export class ActivityDistinctValues implements IActivityDistinctValues {
    references!: string[];
    techAreas!: string[];

    constructor(data?: IActivityDistinctValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.references = [];
            this.techAreas = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["references"])) {
                this.references = [] as any;
                for (let item of _data["references"])
                    this.references!.push(item);
            }
            if (Array.isArray(_data["techAreas"])) {
                this.techAreas = [] as any;
                for (let item of _data["techAreas"])
                    this.techAreas!.push(item);
            }
        }
    }

    static fromJS(data: any): ActivityDistinctValues {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDistinctValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.references)) {
            data["references"] = [];
            for (let item of this.references)
                data["references"].push(item);
        }
        if (Array.isArray(this.techAreas)) {
            data["techAreas"] = [];
            for (let item of this.techAreas)
                data["techAreas"].push(item);
        }
        return data;
    }

    clone(): ActivityDistinctValues {
        const json = this.toJSON();
        let result = new ActivityDistinctValues();
        result.init(json);
        return result;
    }
}

export interface IActivityDistinctValues {
    references: string[];
    techAreas: string[];
}

export class ActivityLogDistinctValues implements IActivityLogDistinctValues {
    descriptions!: string[];
    cellIdents!: string[];
    dutyIdents!: string[];
    dutyTitles!: string[];
    references!: string[];
    techAreas!: string[];

    constructor(data?: IActivityLogDistinctValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.descriptions = [];
            this.cellIdents = [];
            this.dutyIdents = [];
            this.dutyTitles = [];
            this.references = [];
            this.techAreas = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["descriptions"])) {
                this.descriptions = [] as any;
                for (let item of _data["descriptions"])
                    this.descriptions!.push(item);
            }
            if (Array.isArray(_data["cellIdents"])) {
                this.cellIdents = [] as any;
                for (let item of _data["cellIdents"])
                    this.cellIdents!.push(item);
            }
            if (Array.isArray(_data["dutyIdents"])) {
                this.dutyIdents = [] as any;
                for (let item of _data["dutyIdents"])
                    this.dutyIdents!.push(item);
            }
            if (Array.isArray(_data["dutyTitles"])) {
                this.dutyTitles = [] as any;
                for (let item of _data["dutyTitles"])
                    this.dutyTitles!.push(item);
            }
            if (Array.isArray(_data["references"])) {
                this.references = [] as any;
                for (let item of _data["references"])
                    this.references!.push(item);
            }
            if (Array.isArray(_data["techAreas"])) {
                this.techAreas = [] as any;
                for (let item of _data["techAreas"])
                    this.techAreas!.push(item);
            }
        }
    }

    static fromJS(data: any): ActivityLogDistinctValues {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogDistinctValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.descriptions)) {
            data["descriptions"] = [];
            for (let item of this.descriptions)
                data["descriptions"].push(item);
        }
        if (Array.isArray(this.cellIdents)) {
            data["cellIdents"] = [];
            for (let item of this.cellIdents)
                data["cellIdents"].push(item);
        }
        if (Array.isArray(this.dutyIdents)) {
            data["dutyIdents"] = [];
            for (let item of this.dutyIdents)
                data["dutyIdents"].push(item);
        }
        if (Array.isArray(this.dutyTitles)) {
            data["dutyTitles"] = [];
            for (let item of this.dutyTitles)
                data["dutyTitles"].push(item);
        }
        if (Array.isArray(this.references)) {
            data["references"] = [];
            for (let item of this.references)
                data["references"].push(item);
        }
        if (Array.isArray(this.techAreas)) {
            data["techAreas"] = [];
            for (let item of this.techAreas)
                data["techAreas"].push(item);
        }
        return data;
    }

    clone(): ActivityLogDistinctValues {
        const json = this.toJSON();
        let result = new ActivityLogDistinctValues();
        result.init(json);
        return result;
    }
}

export interface IActivityLogDistinctValues {
    descriptions: string[];
    cellIdents: string[];
    dutyIdents: string[];
    dutyTitles: string[];
    references: string[];
    techAreas: string[];
}

export class TextAboutActivity implements ITextAboutActivity {
    subject?: string | undefined;
    body?: string | undefined;

    constructor(data?: ITextAboutActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): TextAboutActivity {
        data = typeof data === 'object' ? data : {};
        let result = new TextAboutActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["body"] = this.body;
        return data;
    }

    clone(): TextAboutActivity {
        const json = this.toJSON();
        let result = new TextAboutActivity();
        result.init(json);
        return result;
    }
}

export interface ITextAboutActivity {
    subject?: string | undefined;
    body?: string | undefined;
}

export class ActivityLinkMediaRequest implements IActivityLinkMediaRequest {
    activityId!: number;
    url!: string;
    fileSize!: number;
    mediaId?: string | undefined;
    contentType?: string | undefined;

    constructor(data?: IActivityLinkMediaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.url = _data["url"];
            this.fileSize = _data["fileSize"];
            this.mediaId = _data["mediaId"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): ActivityLinkMediaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLinkMediaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["url"] = this.url;
        data["fileSize"] = this.fileSize;
        data["mediaId"] = this.mediaId;
        data["contentType"] = this.contentType;
        return data;
    }

    clone(): ActivityLinkMediaRequest {
        const json = this.toJSON();
        let result = new ActivityLinkMediaRequest();
        result.init(json);
        return result;
    }
}

export interface IActivityLinkMediaRequest {
    activityId: number;
    url: string;
    fileSize: number;
    mediaId?: string | undefined;
    contentType?: string | undefined;
}

export class BaseResultOfIListOfOeeOverShiftBreakdown implements IBaseResultOfIListOfOeeOverShiftBreakdown {
    id?: number;
    isOk?: boolean;
    result?: OeeOverShiftBreakdown[] | undefined;

    constructor(data?: IBaseResultOfIListOfOeeOverShiftBreakdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(OeeOverShiftBreakdown.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfIListOfOeeOverShiftBreakdown {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfIListOfOeeOverShiftBreakdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfIListOfOeeOverShiftBreakdown {
        const json = this.toJSON();
        let result = new BaseResultOfIListOfOeeOverShiftBreakdown();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfIListOfOeeOverShiftBreakdown {
    id?: number;
    isOk?: boolean;
    result?: OeeOverShiftBreakdown[] | undefined;
}

export class OeeOverShiftBreakdown implements IOeeOverShiftBreakdown {
    id?: number;
    fkAccountId?: number;
    start?: Date;
    end?: Date;
    fkOeeSettingsKey?: number;
    oeeSettings?: OeeSettings | undefined;
    endedByUserId?: string;

    constructor(data?: IOeeOverShiftBreakdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fkAccountId = _data["fkAccountId"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined as any;
            this.fkOeeSettingsKey = _data["fkOeeSettingsKey"];
            this.oeeSettings = _data["oeeSettings"] ? OeeSettings.fromJS(_data["oeeSettings"]) : undefined as any;
            this.endedByUserId = _data["endedByUserId"];
        }
    }

    static fromJS(data: any): OeeOverShiftBreakdown {
        data = typeof data === 'object' ? data : {};
        let result = new OeeOverShiftBreakdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fkAccountId"] = this.fkAccountId;
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["end"] = this.end ? this.end.toISOString() : undefined as any;
        data["fkOeeSettingsKey"] = this.fkOeeSettingsKey;
        data["oeeSettings"] = this.oeeSettings ? this.oeeSettings.toJSON() : undefined as any;
        data["endedByUserId"] = this.endedByUserId;
        return data;
    }

    clone(): OeeOverShiftBreakdown {
        const json = this.toJSON();
        let result = new OeeOverShiftBreakdown();
        result.init(json);
        return result;
    }
}

export interface IOeeOverShiftBreakdown {
    id?: number;
    fkAccountId?: number;
    start?: Date;
    end?: Date;
    fkOeeSettingsKey?: number;
    oeeSettings?: OeeSettings | undefined;
    endedByUserId?: string;
}

export class BaseResultOfListOfXY implements IBaseResultOfListOfXY {
    id?: number;
    isOk?: boolean;
    result?: XY[] | undefined;

    constructor(data?: IBaseResultOfListOfXY) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(XY.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfListOfXY {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfListOfXY();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfListOfXY {
        const json = this.toJSON();
        let result = new BaseResultOfListOfXY();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfListOfXY {
    id?: number;
    isOk?: boolean;
    result?: XY[] | undefined;
}

export class XY implements IXY {
    value?: number;
    date?: Date;

    constructor(data?: IXY) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): XY {
        data = typeof data === 'object' ? data : {};
        let result = new XY();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        return data;
    }

    clone(): XY {
        const json = this.toJSON();
        let result = new XY();
        result.init(json);
        return result;
    }
}

export interface IXY {
    value?: number;
    date?: Date;
}

export class BaseResultOfXYOf implements IBaseResultOfXYOf {
    id?: number;
    isOk?: boolean;
    result?: XY[] | undefined;

    constructor(data?: IBaseResultOfXYOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(XY.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfXYOf {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfXYOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfXYOf {
        const json = this.toJSON();
        let result = new BaseResultOfXYOf();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfXYOf {
    id?: number;
    isOk?: boolean;
    result?: XY[] | undefined;
}

export class PqtProduct implements IPqtProduct {
    id!: number;
    combinedIdentifier!: string;
    ident!: string;
    groupId!: number;
    groupName!: string;
    itemNo!: string;
    name!: string;
    entryDate?: Date;
    issueDate!: Date;
    responsible!: string;
    warningMail?: string | undefined;
    testSpecification!: string;
    errorMargin!: string;
    testProcedure!: string;
    note?: string | undefined;
    costCenter?: string | undefined;
    status?: string | undefined;
    archived!: boolean;
    archiveReason?: string | undefined;
    archiveRisk?: string | undefined;
    files!: Media2[];
    lastTestDate?: Date | undefined;
    lastTester?: string | undefined;
    measurementSpecifications?: PqtMeasurementSpecification[] | undefined;
    revision?: string | undefined;
    disabled!: boolean;
    customString1?: string | undefined;
    customString2?: string | undefined;
    customString3?: string | undefined;

    constructor(data?: IPqtProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.files = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.combinedIdentifier = _data["combinedIdentifier"];
            this.ident = _data["ident"];
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            this.itemNo = _data["itemNo"];
            this.name = _data["name"];
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : undefined as any;
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined as any;
            this.responsible = _data["responsible"];
            this.warningMail = _data["warningMail"];
            this.testSpecification = _data["testSpecification"];
            this.errorMargin = _data["errorMargin"];
            this.testProcedure = _data["testProcedure"];
            this.note = _data["note"];
            this.costCenter = _data["costCenter"];
            this.status = _data["status"];
            this.archived = _data["archived"];
            this.archiveReason = _data["archiveReason"];
            this.archiveRisk = _data["archiveRisk"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(Media2.fromJS(item));
            }
            this.lastTestDate = _data["lastTestDate"] ? new Date(_data["lastTestDate"].toString()) : undefined as any;
            this.lastTester = _data["lastTester"];
            if (Array.isArray(_data["measurementSpecifications"])) {
                this.measurementSpecifications = [] as any;
                for (let item of _data["measurementSpecifications"])
                    this.measurementSpecifications!.push(PqtMeasurementSpecification.fromJS(item));
            }
            this.revision = _data["revision"];
            this.disabled = _data["disabled"];
            this.customString1 = _data["customString1"];
            this.customString2 = _data["customString2"];
            this.customString3 = _data["customString3"];
        }
    }

    static fromJS(data: any): PqtProduct {
        data = typeof data === 'object' ? data : {};
        let result = new PqtProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["combinedIdentifier"] = this.combinedIdentifier;
        data["ident"] = this.ident;
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        data["itemNo"] = this.itemNo;
        data["name"] = this.name;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : undefined as any;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined as any;
        data["responsible"] = this.responsible;
        data["warningMail"] = this.warningMail;
        data["testSpecification"] = this.testSpecification;
        data["errorMargin"] = this.errorMargin;
        data["testProcedure"] = this.testProcedure;
        data["note"] = this.note;
        data["costCenter"] = this.costCenter;
        data["status"] = this.status;
        data["archived"] = this.archived;
        data["archiveReason"] = this.archiveReason;
        data["archiveRisk"] = this.archiveRisk;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        data["lastTestDate"] = this.lastTestDate ? this.lastTestDate.toISOString() : undefined as any;
        data["lastTester"] = this.lastTester;
        if (Array.isArray(this.measurementSpecifications)) {
            data["measurementSpecifications"] = [];
            for (let item of this.measurementSpecifications)
                data["measurementSpecifications"].push(item ? item.toJSON() : undefined as any);
        }
        data["revision"] = this.revision;
        data["disabled"] = this.disabled;
        data["customString1"] = this.customString1;
        data["customString2"] = this.customString2;
        data["customString3"] = this.customString3;
        return data;
    }

    clone(): PqtProduct {
        const json = this.toJSON();
        let result = new PqtProduct();
        result.init(json);
        return result;
    }
}

export interface IPqtProduct {
    id: number;
    combinedIdentifier: string;
    ident: string;
    groupId: number;
    groupName: string;
    itemNo: string;
    name: string;
    entryDate?: Date;
    issueDate: Date;
    responsible: string;
    warningMail?: string | undefined;
    testSpecification: string;
    errorMargin: string;
    testProcedure: string;
    note?: string | undefined;
    costCenter?: string | undefined;
    status?: string | undefined;
    archived: boolean;
    archiveReason?: string | undefined;
    archiveRisk?: string | undefined;
    files: Media2[];
    lastTestDate?: Date | undefined;
    lastTester?: string | undefined;
    measurementSpecifications?: PqtMeasurementSpecification[] | undefined;
    revision?: string | undefined;
    disabled: boolean;
    customString1?: string | undefined;
    customString2?: string | undefined;
    customString3?: string | undefined;
}

export class PqtMeasurementSpecification implements IPqtMeasurementSpecification {
    id!: string;
    name!: string;
    description?: string | undefined;
    type!: PqtMeasurementValueType;
    lowerBound!: string;
    nominalValue!: string;
    upperBound!: string;
    templateId?: string | undefined;
    templateName?: string | undefined;
    mediaIds?: string[] | undefined;
    optional?: boolean;
    allowSeparateTester?: boolean;

    constructor(data?: IPqtMeasurementSpecification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.lowerBound = _data["lowerBound"];
            this.nominalValue = _data["nominalValue"];
            this.upperBound = _data["upperBound"];
            this.templateId = _data["templateId"];
            this.templateName = _data["templateName"];
            if (Array.isArray(_data["mediaIds"])) {
                this.mediaIds = [] as any;
                for (let item of _data["mediaIds"])
                    this.mediaIds!.push(item);
            }
            this.optional = _data["optional"];
            this.allowSeparateTester = _data["allowSeparateTester"];
        }
    }

    static fromJS(data: any): PqtMeasurementSpecification {
        data = typeof data === 'object' ? data : {};
        let result = new PqtMeasurementSpecification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["type"] = this.type;
        data["lowerBound"] = this.lowerBound;
        data["nominalValue"] = this.nominalValue;
        data["upperBound"] = this.upperBound;
        data["templateId"] = this.templateId;
        data["templateName"] = this.templateName;
        if (Array.isArray(this.mediaIds)) {
            data["mediaIds"] = [];
            for (let item of this.mediaIds)
                data["mediaIds"].push(item);
        }
        data["optional"] = this.optional;
        data["allowSeparateTester"] = this.allowSeparateTester;
        return data;
    }

    clone(): PqtMeasurementSpecification {
        const json = this.toJSON();
        let result = new PqtMeasurementSpecification();
        result.init(json);
        return result;
    }
}

export interface IPqtMeasurementSpecification {
    id: string;
    name: string;
    description?: string | undefined;
    type: PqtMeasurementValueType;
    lowerBound: string;
    nominalValue: string;
    upperBound: string;
    templateId?: string | undefined;
    templateName?: string | undefined;
    mediaIds?: string[] | undefined;
    optional?: boolean;
    allowSeparateTester?: boolean;
}

export enum PqtMeasurementValueType {
    Float = 0,
    String = 1,
}

export class PqtArchiveRequest implements IPqtArchiveRequest {
    id!: number;
    reason!: string;
    risk!: string;

    constructor(data?: IPqtArchiveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reason = _data["reason"];
            this.risk = _data["risk"];
        }
    }

    static fromJS(data: any): PqtArchiveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PqtArchiveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reason"] = this.reason;
        data["risk"] = this.risk;
        return data;
    }

    clone(): PqtArchiveRequest {
        const json = this.toJSON();
        let result = new PqtArchiveRequest();
        result.init(json);
        return result;
    }
}

export interface IPqtArchiveRequest {
    id: number;
    reason: string;
    risk: string;
}

export class PqtProductTest implements IPqtProductTest {
    id!: number;
    productId!: number;
    protocolNumber!: string;
    testDate!: Date;
    testPerson!: string;
    testSpecification!: string;
    expectedError!: string;
    error!: string;
    grade!: string;
    note?: string | undefined;
    files!: Media2[];
    measurementSpecifications?: PqtMeasurementSpecification[] | undefined;
    measurements?: PqtMeasurement[] | undefined;
    weight?: number;
    weightUnit?: string | undefined;
    batchNumber?: string | undefined;

    constructor(data?: IPqtProductTest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.files = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.protocolNumber = _data["protocolNumber"];
            this.testDate = _data["testDate"] ? new Date(_data["testDate"].toString()) : undefined as any;
            this.testPerson = _data["testPerson"];
            this.testSpecification = _data["testSpecification"];
            this.expectedError = _data["expectedError"];
            this.error = _data["error"];
            this.grade = _data["grade"];
            this.note = _data["note"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(Media2.fromJS(item));
            }
            if (Array.isArray(_data["measurementSpecifications"])) {
                this.measurementSpecifications = [] as any;
                for (let item of _data["measurementSpecifications"])
                    this.measurementSpecifications!.push(PqtMeasurementSpecification.fromJS(item));
            }
            if (Array.isArray(_data["measurements"])) {
                this.measurements = [] as any;
                for (let item of _data["measurements"])
                    this.measurements!.push(PqtMeasurement.fromJS(item));
            }
            this.weight = _data["weight"];
            this.weightUnit = _data["weightUnit"];
            this.batchNumber = _data["batchNumber"];
        }
    }

    static fromJS(data: any): PqtProductTest {
        data = typeof data === 'object' ? data : {};
        let result = new PqtProductTest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["protocolNumber"] = this.protocolNumber;
        data["testDate"] = this.testDate ? this.testDate.toISOString() : undefined as any;
        data["testPerson"] = this.testPerson;
        data["testSpecification"] = this.testSpecification;
        data["expectedError"] = this.expectedError;
        data["error"] = this.error;
        data["grade"] = this.grade;
        data["note"] = this.note;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.measurementSpecifications)) {
            data["measurementSpecifications"] = [];
            for (let item of this.measurementSpecifications)
                data["measurementSpecifications"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.measurements)) {
            data["measurements"] = [];
            for (let item of this.measurements)
                data["measurements"].push(item ? item.toJSON() : undefined as any);
        }
        data["weight"] = this.weight;
        data["weightUnit"] = this.weightUnit;
        data["batchNumber"] = this.batchNumber;
        return data;
    }

    clone(): PqtProductTest {
        const json = this.toJSON();
        let result = new PqtProductTest();
        result.init(json);
        return result;
    }
}

export interface IPqtProductTest {
    id: number;
    productId: number;
    protocolNumber: string;
    testDate: Date;
    testPerson: string;
    testSpecification: string;
    expectedError: string;
    error: string;
    grade: string;
    note?: string | undefined;
    files: Media2[];
    measurementSpecifications?: PqtMeasurementSpecification[] | undefined;
    measurements?: PqtMeasurement[] | undefined;
    weight?: number;
    weightUnit?: string | undefined;
    batchNumber?: string | undefined;
}

export class PqtMeasurement implements IPqtMeasurement {
    specificationId!: string;
    value?: string | undefined;
    testerName?: string | undefined;
    testDate?: Date | undefined;
    testComment?: string | undefined;

    constructor(data?: IPqtMeasurement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specificationId = _data["specificationId"];
            this.value = _data["value"];
            this.testerName = _data["testerName"];
            this.testDate = _data["testDate"] ? new Date(_data["testDate"].toString()) : undefined as any;
            this.testComment = _data["testComment"];
        }
    }

    static fromJS(data: any): PqtMeasurement {
        data = typeof data === 'object' ? data : {};
        let result = new PqtMeasurement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specificationId"] = this.specificationId;
        data["value"] = this.value;
        data["testerName"] = this.testerName;
        data["testDate"] = this.testDate ? this.testDate.toISOString() : undefined as any;
        data["testComment"] = this.testComment;
        return data;
    }

    clone(): PqtMeasurement {
        const json = this.toJSON();
        let result = new PqtMeasurement();
        result.init(json);
        return result;
    }
}

export interface IPqtMeasurement {
    specificationId: string;
    value?: string | undefined;
    testerName?: string | undefined;
    testDate?: Date | undefined;
    testComment?: string | undefined;
}

export class PqtMeasurementSpecificationTemplate implements IPqtMeasurementSpecificationTemplate {
    id!: string;
    name!: string;
    createdAt!: Date;
    createdBy!: string;
    createdByUser?: UserBase | undefined;
    updatedAt!: Date;
    updatedBy!: string;
    updatedByUser?: UserBase | undefined;
    measurementSpecifications?: PqtMeasurementSpecification[] | undefined;
    medias?: PqtMeasurementSpecificationTemplateMedia[] | undefined;

    constructor(data?: IPqtMeasurementSpecificationTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.createdByUser = _data["createdByUser"] ? UserBase.fromJS(_data["createdByUser"]) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.updatedByUser = _data["updatedByUser"] ? UserBase.fromJS(_data["updatedByUser"]) : undefined as any;
            if (Array.isArray(_data["measurementSpecifications"])) {
                this.measurementSpecifications = [] as any;
                for (let item of _data["measurementSpecifications"])
                    this.measurementSpecifications!.push(PqtMeasurementSpecification.fromJS(item));
            }
            if (Array.isArray(_data["medias"])) {
                this.medias = [] as any;
                for (let item of _data["medias"])
                    this.medias!.push(PqtMeasurementSpecificationTemplateMedia.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PqtMeasurementSpecificationTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new PqtMeasurementSpecificationTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        data["updatedByUser"] = this.updatedByUser ? this.updatedByUser.toJSON() : undefined as any;
        if (Array.isArray(this.measurementSpecifications)) {
            data["measurementSpecifications"] = [];
            for (let item of this.measurementSpecifications)
                data["measurementSpecifications"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.medias)) {
            data["medias"] = [];
            for (let item of this.medias)
                data["medias"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PqtMeasurementSpecificationTemplate {
        const json = this.toJSON();
        let result = new PqtMeasurementSpecificationTemplate();
        result.init(json);
        return result;
    }
}

export interface IPqtMeasurementSpecificationTemplate {
    id: string;
    name: string;
    createdAt: Date;
    createdBy: string;
    createdByUser?: UserBase | undefined;
    updatedAt: Date;
    updatedBy: string;
    updatedByUser?: UserBase | undefined;
    measurementSpecifications?: PqtMeasurementSpecification[] | undefined;
    medias?: PqtMeasurementSpecificationTemplateMedia[] | undefined;
}

export class PqtMeasurementSpecificationTemplateMedia implements IPqtMeasurementSpecificationTemplateMedia {
    id!: string;
    createdAt!: Date;
    createdBy!: string;
    templateId!: string;
    mediaId!: string;

    constructor(data?: IPqtMeasurementSpecificationTemplateMedia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.templateId = _data["templateId"];
            this.mediaId = _data["mediaId"];
        }
    }

    static fromJS(data: any): PqtMeasurementSpecificationTemplateMedia {
        data = typeof data === 'object' ? data : {};
        let result = new PqtMeasurementSpecificationTemplateMedia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["templateId"] = this.templateId;
        data["mediaId"] = this.mediaId;
        return data;
    }

    clone(): PqtMeasurementSpecificationTemplateMedia {
        const json = this.toJSON();
        let result = new PqtMeasurementSpecificationTemplateMedia();
        result.init(json);
        return result;
    }
}

export interface IPqtMeasurementSpecificationTemplateMedia {
    id: string;
    createdAt: Date;
    createdBy: string;
    templateId: string;
    mediaId: string;
}

export class PqtGroupType implements IPqtGroupType {
    id!: number;
    name!: string;

    constructor(data?: IPqtGroupType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PqtGroupType {
        data = typeof data === 'object' ? data : {};
        let result = new PqtGroupType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): PqtGroupType {
        const json = this.toJSON();
        let result = new PqtGroupType();
        result.init(json);
        return result;
    }
}

export interface IPqtGroupType {
    id: number;
    name: string;
}

export class SensorData implements ISensorData {
    siteId!: string;
    sensorId!: string;
    sensorType!: string;
    timestamp!: Date;
    measurements!: Measurement[];
    tags?: string[];

    constructor(data?: ISensorData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.measurements = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.sensorId = _data["sensorId"];
            this.sensorType = _data["sensorType"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : undefined as any;
            if (Array.isArray(_data["measurements"])) {
                this.measurements = [] as any;
                for (let item of _data["measurements"])
                    this.measurements!.push(Measurement.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): SensorData {
        data = typeof data === 'object' ? data : {};
        let result = new SensorData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["sensorId"] = this.sensorId;
        data["sensorType"] = this.sensorType;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined as any;
        if (Array.isArray(this.measurements)) {
            data["measurements"] = [];
            for (let item of this.measurements)
                data["measurements"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }

    clone(): SensorData {
        const json = this.toJSON();
        let result = new SensorData();
        result.init(json);
        return result;
    }
}

export interface ISensorData {
    siteId: string;
    sensorId: string;
    sensorType: string;
    timestamp: Date;
    measurements: Measurement[];
    tags?: string[];
}

export class Measurement implements IMeasurement {
    identifier!: string;
    value!: any;
    unit?: string | undefined;

    constructor(data?: IMeasurement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.value = _data["value"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): Measurement {
        data = typeof data === 'object' ? data : {};
        let result = new Measurement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["value"] = this.value;
        data["unit"] = this.unit;
        return data;
    }

    clone(): Measurement {
        const json = this.toJSON();
        let result = new Measurement();
        result.init(json);
        return result;
    }
}

export interface IMeasurement {
    identifier: string;
    value: any;
    unit?: string | undefined;
}

export class TestEquipmentDevice implements ITestEquipmentDevice {
    id!: number;
    combinedIdentifier!: string;
    ident!: string;
    placeOfUseShortId!: number;
    placeOfUseShortName!: string;
    groupId!: number;
    groupName!: string;
    kindId!: number;
    kindName!: string;
    itemNo!: string;
    name!: string;
    entryDate?: Date;
    issueDate!: Date;
    intervalValue!: number;
    intervalUnitId!: number;
    intervalUnitName!: string;
    warningValue!: number;
    warningUnitId!: number;
    warningUnitName!: string;
    placeOfUse!: string;
    responsible!: string;
    warningMail?: string | undefined;
    deviceManufacturer!: string;
    deviceType!: string;
    deviceSerialNumber!: string;
    testSpecification!: string;
    errorMargin!: string;
    testProcedure!: string;
    note?: string | undefined;
    costCenter?: string | undefined;
    status?: string | undefined;
    archived!: boolean;
    archiveReason?: string | undefined;
    archiveRisk?: string | undefined;
    files!: Media2[];
    lastTestDate?: Date | undefined;
    lastTester?: string | undefined;
    nextTestDate?: Date | undefined;
    nextTestWarningDate?: Date | undefined;
    daysOpen?: number | undefined;
    measurementSpecifications?: MeasurementSpecification[] | undefined;

    constructor(data?: ITestEquipmentDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.files = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.combinedIdentifier = _data["combinedIdentifier"];
            this.ident = _data["ident"];
            this.placeOfUseShortId = _data["placeOfUseShortId"];
            this.placeOfUseShortName = _data["placeOfUseShortName"];
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            this.kindId = _data["kindId"];
            this.kindName = _data["kindName"];
            this.itemNo = _data["itemNo"];
            this.name = _data["name"];
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : undefined as any;
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined as any;
            this.intervalValue = _data["intervalValue"];
            this.intervalUnitId = _data["intervalUnitId"];
            this.intervalUnitName = _data["intervalUnitName"];
            this.warningValue = _data["warningValue"];
            this.warningUnitId = _data["warningUnitId"];
            this.warningUnitName = _data["warningUnitName"];
            this.placeOfUse = _data["placeOfUse"];
            this.responsible = _data["responsible"];
            this.warningMail = _data["warningMail"];
            this.deviceManufacturer = _data["deviceManufacturer"];
            this.deviceType = _data["deviceType"];
            this.deviceSerialNumber = _data["deviceSerialNumber"];
            this.testSpecification = _data["testSpecification"];
            this.errorMargin = _data["errorMargin"];
            this.testProcedure = _data["testProcedure"];
            this.note = _data["note"];
            this.costCenter = _data["costCenter"];
            this.status = _data["status"];
            this.archived = _data["archived"];
            this.archiveReason = _data["archiveReason"];
            this.archiveRisk = _data["archiveRisk"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(Media2.fromJS(item));
            }
            this.lastTestDate = _data["lastTestDate"] ? new Date(_data["lastTestDate"].toString()) : undefined as any;
            this.lastTester = _data["lastTester"];
            this.nextTestDate = _data["nextTestDate"] ? new Date(_data["nextTestDate"].toString()) : undefined as any;
            this.nextTestWarningDate = _data["nextTestWarningDate"] ? new Date(_data["nextTestWarningDate"].toString()) : undefined as any;
            this.daysOpen = _data["daysOpen"];
            if (Array.isArray(_data["measurementSpecifications"])) {
                this.measurementSpecifications = [] as any;
                for (let item of _data["measurementSpecifications"])
                    this.measurementSpecifications!.push(MeasurementSpecification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TestEquipmentDevice {
        data = typeof data === 'object' ? data : {};
        let result = new TestEquipmentDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["combinedIdentifier"] = this.combinedIdentifier;
        data["ident"] = this.ident;
        data["placeOfUseShortId"] = this.placeOfUseShortId;
        data["placeOfUseShortName"] = this.placeOfUseShortName;
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        data["kindId"] = this.kindId;
        data["kindName"] = this.kindName;
        data["itemNo"] = this.itemNo;
        data["name"] = this.name;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : undefined as any;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined as any;
        data["intervalValue"] = this.intervalValue;
        data["intervalUnitId"] = this.intervalUnitId;
        data["intervalUnitName"] = this.intervalUnitName;
        data["warningValue"] = this.warningValue;
        data["warningUnitId"] = this.warningUnitId;
        data["warningUnitName"] = this.warningUnitName;
        data["placeOfUse"] = this.placeOfUse;
        data["responsible"] = this.responsible;
        data["warningMail"] = this.warningMail;
        data["deviceManufacturer"] = this.deviceManufacturer;
        data["deviceType"] = this.deviceType;
        data["deviceSerialNumber"] = this.deviceSerialNumber;
        data["testSpecification"] = this.testSpecification;
        data["errorMargin"] = this.errorMargin;
        data["testProcedure"] = this.testProcedure;
        data["note"] = this.note;
        data["costCenter"] = this.costCenter;
        data["status"] = this.status;
        data["archived"] = this.archived;
        data["archiveReason"] = this.archiveReason;
        data["archiveRisk"] = this.archiveRisk;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        data["lastTestDate"] = this.lastTestDate ? this.lastTestDate.toISOString() : undefined as any;
        data["lastTester"] = this.lastTester;
        data["nextTestDate"] = this.nextTestDate ? this.nextTestDate.toISOString() : undefined as any;
        data["nextTestWarningDate"] = this.nextTestWarningDate ? this.nextTestWarningDate.toISOString() : undefined as any;
        data["daysOpen"] = this.daysOpen;
        if (Array.isArray(this.measurementSpecifications)) {
            data["measurementSpecifications"] = [];
            for (let item of this.measurementSpecifications)
                data["measurementSpecifications"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TestEquipmentDevice {
        const json = this.toJSON();
        let result = new TestEquipmentDevice();
        result.init(json);
        return result;
    }
}

export interface ITestEquipmentDevice {
    id: number;
    combinedIdentifier: string;
    ident: string;
    placeOfUseShortId: number;
    placeOfUseShortName: string;
    groupId: number;
    groupName: string;
    kindId: number;
    kindName: string;
    itemNo: string;
    name: string;
    entryDate?: Date;
    issueDate: Date;
    intervalValue: number;
    intervalUnitId: number;
    intervalUnitName: string;
    warningValue: number;
    warningUnitId: number;
    warningUnitName: string;
    placeOfUse: string;
    responsible: string;
    warningMail?: string | undefined;
    deviceManufacturer: string;
    deviceType: string;
    deviceSerialNumber: string;
    testSpecification: string;
    errorMargin: string;
    testProcedure: string;
    note?: string | undefined;
    costCenter?: string | undefined;
    status?: string | undefined;
    archived: boolean;
    archiveReason?: string | undefined;
    archiveRisk?: string | undefined;
    files: Media2[];
    lastTestDate?: Date | undefined;
    lastTester?: string | undefined;
    nextTestDate?: Date | undefined;
    nextTestWarningDate?: Date | undefined;
    daysOpen?: number | undefined;
    measurementSpecifications?: MeasurementSpecification[] | undefined;
}

export class MeasurementSpecification implements IMeasurementSpecification {
    id!: string;
    name!: string;
    description?: string | undefined;
    type!: MeasurementValueType;
    lowerBound!: string;
    nominalValue!: string;
    upperBound!: string;
    templateId?: string | undefined;
    templateName?: string | undefined;
    mediaIds?: string[] | undefined;
    optional?: boolean;
    allowSeparateTester?: boolean;

    constructor(data?: IMeasurementSpecification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.lowerBound = _data["lowerBound"];
            this.nominalValue = _data["nominalValue"];
            this.upperBound = _data["upperBound"];
            this.templateId = _data["templateId"];
            this.templateName = _data["templateName"];
            if (Array.isArray(_data["mediaIds"])) {
                this.mediaIds = [] as any;
                for (let item of _data["mediaIds"])
                    this.mediaIds!.push(item);
            }
            this.optional = _data["optional"];
            this.allowSeparateTester = _data["allowSeparateTester"];
        }
    }

    static fromJS(data: any): MeasurementSpecification {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementSpecification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["type"] = this.type;
        data["lowerBound"] = this.lowerBound;
        data["nominalValue"] = this.nominalValue;
        data["upperBound"] = this.upperBound;
        data["templateId"] = this.templateId;
        data["templateName"] = this.templateName;
        if (Array.isArray(this.mediaIds)) {
            data["mediaIds"] = [];
            for (let item of this.mediaIds)
                data["mediaIds"].push(item);
        }
        data["optional"] = this.optional;
        data["allowSeparateTester"] = this.allowSeparateTester;
        return data;
    }

    clone(): MeasurementSpecification {
        const json = this.toJSON();
        let result = new MeasurementSpecification();
        result.init(json);
        return result;
    }
}

export interface IMeasurementSpecification {
    id: string;
    name: string;
    description?: string | undefined;
    type: MeasurementValueType;
    lowerBound: string;
    nominalValue: string;
    upperBound: string;
    templateId?: string | undefined;
    templateName?: string | undefined;
    mediaIds?: string[] | undefined;
    optional?: boolean;
    allowSeparateTester?: boolean;
}

export enum MeasurementValueType {
    Float = 0,
    String = 1,
}

export class ArchiveRequest implements IArchiveRequest {
    id!: number;
    reason!: string;
    risk!: string;

    constructor(data?: IArchiveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reason = _data["reason"];
            this.risk = _data["risk"];
        }
    }

    static fromJS(data: any): ArchiveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ArchiveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reason"] = this.reason;
        data["risk"] = this.risk;
        return data;
    }

    clone(): ArchiveRequest {
        const json = this.toJSON();
        let result = new ArchiveRequest();
        result.init(json);
        return result;
    }
}

export interface IArchiveRequest {
    id: number;
    reason: string;
    risk: string;
}

export class TestEquipmentTest implements ITestEquipmentTest {
    id!: number;
    testEquipmentId!: number;
    protocolNumber!: string;
    testDate!: Date;
    testPerson!: string;
    testSpecification!: string;
    expectedError!: string;
    error!: string;
    grade!: string;
    note?: string | undefined;
    files!: Media2[];
    measurementSpecifications?: MeasurementSpecification[] | undefined;
    measurements?: TeMeasurement[] | undefined;

    constructor(data?: ITestEquipmentTest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.files = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.testEquipmentId = _data["testEquipmentId"];
            this.protocolNumber = _data["protocolNumber"];
            this.testDate = _data["testDate"] ? new Date(_data["testDate"].toString()) : undefined as any;
            this.testPerson = _data["testPerson"];
            this.testSpecification = _data["testSpecification"];
            this.expectedError = _data["expectedError"];
            this.error = _data["error"];
            this.grade = _data["grade"];
            this.note = _data["note"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(Media2.fromJS(item));
            }
            if (Array.isArray(_data["measurementSpecifications"])) {
                this.measurementSpecifications = [] as any;
                for (let item of _data["measurementSpecifications"])
                    this.measurementSpecifications!.push(MeasurementSpecification.fromJS(item));
            }
            if (Array.isArray(_data["measurements"])) {
                this.measurements = [] as any;
                for (let item of _data["measurements"])
                    this.measurements!.push(TeMeasurement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TestEquipmentTest {
        data = typeof data === 'object' ? data : {};
        let result = new TestEquipmentTest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["testEquipmentId"] = this.testEquipmentId;
        data["protocolNumber"] = this.protocolNumber;
        data["testDate"] = this.testDate ? this.testDate.toISOString() : undefined as any;
        data["testPerson"] = this.testPerson;
        data["testSpecification"] = this.testSpecification;
        data["expectedError"] = this.expectedError;
        data["error"] = this.error;
        data["grade"] = this.grade;
        data["note"] = this.note;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.measurementSpecifications)) {
            data["measurementSpecifications"] = [];
            for (let item of this.measurementSpecifications)
                data["measurementSpecifications"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.measurements)) {
            data["measurements"] = [];
            for (let item of this.measurements)
                data["measurements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TestEquipmentTest {
        const json = this.toJSON();
        let result = new TestEquipmentTest();
        result.init(json);
        return result;
    }
}

export interface ITestEquipmentTest {
    id: number;
    testEquipmentId: number;
    protocolNumber: string;
    testDate: Date;
    testPerson: string;
    testSpecification: string;
    expectedError: string;
    error: string;
    grade: string;
    note?: string | undefined;
    files: Media2[];
    measurementSpecifications?: MeasurementSpecification[] | undefined;
    measurements?: TeMeasurement[] | undefined;
}

export class TeMeasurement implements ITeMeasurement {
    specificationId!: string;
    value?: string | undefined;
    testerName?: string | undefined;
    testDate?: Date | undefined;

    constructor(data?: ITeMeasurement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specificationId = _data["specificationId"];
            this.value = _data["value"];
            this.testerName = _data["testerName"];
            this.testDate = _data["testDate"] ? new Date(_data["testDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TeMeasurement {
        data = typeof data === 'object' ? data : {};
        let result = new TeMeasurement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specificationId"] = this.specificationId;
        data["value"] = this.value;
        data["testerName"] = this.testerName;
        data["testDate"] = this.testDate ? this.testDate.toISOString() : undefined as any;
        return data;
    }

    clone(): TeMeasurement {
        const json = this.toJSON();
        let result = new TeMeasurement();
        result.init(json);
        return result;
    }
}

export interface ITeMeasurement {
    specificationId: string;
    value?: string | undefined;
    testerName?: string | undefined;
    testDate?: Date | undefined;
}

export class MeasurementSpecificationTemplate implements IMeasurementSpecificationTemplate {
    id!: string;
    name!: string;
    createdAt!: Date;
    createdBy!: string;
    createdByUser?: UserBase | undefined;
    updatedAt!: Date;
    updatedBy!: string;
    updatedByUser?: UserBase | undefined;
    measurementSpecifications?: MeasurementSpecification[] | undefined;
    medias?: MeasurementSpecificationTemplateMedia[] | undefined;

    constructor(data?: IMeasurementSpecificationTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.createdByUser = _data["createdByUser"] ? UserBase.fromJS(_data["createdByUser"]) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.updatedByUser = _data["updatedByUser"] ? UserBase.fromJS(_data["updatedByUser"]) : undefined as any;
            if (Array.isArray(_data["measurementSpecifications"])) {
                this.measurementSpecifications = [] as any;
                for (let item of _data["measurementSpecifications"])
                    this.measurementSpecifications!.push(MeasurementSpecification.fromJS(item));
            }
            if (Array.isArray(_data["medias"])) {
                this.medias = [] as any;
                for (let item of _data["medias"])
                    this.medias!.push(MeasurementSpecificationTemplateMedia.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeasurementSpecificationTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementSpecificationTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        data["updatedByUser"] = this.updatedByUser ? this.updatedByUser.toJSON() : undefined as any;
        if (Array.isArray(this.measurementSpecifications)) {
            data["measurementSpecifications"] = [];
            for (let item of this.measurementSpecifications)
                data["measurementSpecifications"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.medias)) {
            data["medias"] = [];
            for (let item of this.medias)
                data["medias"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): MeasurementSpecificationTemplate {
        const json = this.toJSON();
        let result = new MeasurementSpecificationTemplate();
        result.init(json);
        return result;
    }
}

export interface IMeasurementSpecificationTemplate {
    id: string;
    name: string;
    createdAt: Date;
    createdBy: string;
    createdByUser?: UserBase | undefined;
    updatedAt: Date;
    updatedBy: string;
    updatedByUser?: UserBase | undefined;
    measurementSpecifications?: MeasurementSpecification[] | undefined;
    medias?: MeasurementSpecificationTemplateMedia[] | undefined;
}

export class MeasurementSpecificationTemplateMedia implements IMeasurementSpecificationTemplateMedia {
    id!: string;
    createdAt!: Date;
    createdBy!: string;
    templateId!: string;
    mediaId!: string;

    constructor(data?: IMeasurementSpecificationTemplateMedia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.templateId = _data["templateId"];
            this.mediaId = _data["mediaId"];
        }
    }

    static fromJS(data: any): MeasurementSpecificationTemplateMedia {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementSpecificationTemplateMedia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["templateId"] = this.templateId;
        data["mediaId"] = this.mediaId;
        return data;
    }

    clone(): MeasurementSpecificationTemplateMedia {
        const json = this.toJSON();
        let result = new MeasurementSpecificationTemplateMedia();
        result.init(json);
        return result;
    }
}

export interface IMeasurementSpecificationTemplateMedia {
    id: string;
    createdAt: Date;
    createdBy: string;
    templateId: string;
    mediaId: string;
}

export class GroupType implements IGroupType {
    id!: number;
    name!: string;

    constructor(data?: IGroupType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GroupType {
        data = typeof data === 'object' ? data : {};
        let result = new GroupType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): GroupType {
        const json = this.toJSON();
        let result = new GroupType();
        result.init(json);
        return result;
    }
}

export interface IGroupType {
    id: number;
    name: string;
}

export class KindType implements IKindType {
    id!: number;
    name!: string;

    constructor(data?: IKindType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): KindType {
        data = typeof data === 'object' ? data : {};
        let result = new KindType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): KindType {
        const json = this.toJSON();
        let result = new KindType();
        result.init(json);
        return result;
    }
}

export interface IKindType {
    id: number;
    name: string;
}

export class PlaceOfUseType implements IPlaceOfUseType {
    id!: number;
    name!: string;

    constructor(data?: IPlaceOfUseType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PlaceOfUseType {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceOfUseType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): PlaceOfUseType {
        const json = this.toJSON();
        let result = new PlaceOfUseType();
        result.init(json);
        return result;
    }
}

export interface IPlaceOfUseType {
    id: number;
    name: string;
}

export class TimeUnit implements ITimeUnit {
    id!: number;
    name!: string;

    constructor(data?: ITimeUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TimeUnit {
        data = typeof data === 'object' ? data : {};
        let result = new TimeUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): TimeUnit {
        const json = this.toJSON();
        let result = new TimeUnit();
        result.init(json);
        return result;
    }
}

export interface ITimeUnit {
    id: number;
    name: string;
}

export class BaseResultOfListOfTntBatch implements IBaseResultOfListOfTntBatch {
    id?: number;
    isOk?: boolean;
    result?: TntBatch[] | undefined;

    constructor(data?: IBaseResultOfListOfTntBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(TntBatch.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfListOfTntBatch {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfListOfTntBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfListOfTntBatch {
        const json = this.toJSON();
        let result = new BaseResultOfListOfTntBatch();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfListOfTntBatch {
    id?: number;
    isOk?: boolean;
    result?: TntBatch[] | undefined;
}

export class TntBatch implements ITntBatch {
    id!: string;
    accountId!: number;
    identifier!: string;

    constructor(data?: ITntBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): TntBatch {
        data = typeof data === 'object' ? data : {};
        let result = new TntBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["identifier"] = this.identifier;
        return data;
    }

    clone(): TntBatch {
        const json = this.toJSON();
        let result = new TntBatch();
        result.init(json);
        return result;
    }
}

export interface ITntBatch {
    id: string;
    accountId: number;
    identifier: string;
}

export class BaseResultOfTntBatch implements IBaseResultOfTntBatch {
    id?: number;
    isOk?: boolean;
    result?: TntBatch | undefined;

    constructor(data?: IBaseResultOfTntBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? TntBatch.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfTntBatch {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfTntBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfTntBatch {
        const json = this.toJSON();
        let result = new BaseResultOfTntBatch();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfTntBatch {
    id?: number;
    isOk?: boolean;
    result?: TntBatch | undefined;
}

export class TntQrRequest implements ITntQrRequest {
    ids!: string[];
    layout!: string;
    options?: string[] | undefined;

    constructor(data?: ITntQrRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.layout = _data["layout"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
        }
    }

    static fromJS(data: any): TntQrRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TntQrRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["layout"] = this.layout;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        return data;
    }

    clone(): TntQrRequest {
        const json = this.toJSON();
        let result = new TntQrRequest();
        result.init(json);
        return result;
    }
}

export interface ITntQrRequest {
    ids: string[];
    layout: string;
    options?: string[] | undefined;
}

export class TntConsumeResult implements ITntConsumeResult {
    order!: TntOrder;

    constructor(data?: ITntConsumeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.order = new TntOrder();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? TntOrder.fromJS(_data["order"]) : new TntOrder();
        }
    }

    static fromJS(data: any): TntConsumeResult {
        data = typeof data === 'object' ? data : {};
        let result = new TntConsumeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : undefined as any;
        return data;
    }

    clone(): TntConsumeResult {
        const json = this.toJSON();
        let result = new TntConsumeResult();
        result.init(json);
        return result;
    }
}

export interface ITntConsumeResult {
    order: TntOrder;
}

export class TntOrder implements ITntOrder {
    id!: string;
    accountId!: number;
    date!: Date;
    type!: TntOrderType;
    userId!: string;
    transactions?: TntTransaction[] | undefined;

    constructor(data?: ITntOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.type = _data["type"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions!.push(TntTransaction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TntOrder {
        data = typeof data === 'object' ? data : {};
        let result = new TntOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["type"] = this.type;
        data["userId"] = this.userId;
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TntOrder {
        const json = this.toJSON();
        let result = new TntOrder();
        result.init(json);
        return result;
    }
}

export interface ITntOrder {
    id: string;
    accountId: number;
    date: Date;
    type: TntOrderType;
    userId: string;
    transactions?: TntTransaction[] | undefined;
}

export enum TntOrderType {
    Translocation = 0,
    Transformation = 1,
    Produce = 2,
    Consume = 3,
}

export class TntTransaction implements ITntTransaction {
    id!: string;
    accountId!: number;
    orderId!: string;
    sourceLocationId!: string;
    targetLocationId!: string;
    sourceItemLocationId?: string;
    targetItemLocationId?: string;
    sourceItemId!: string;
    sourceItemStockBefore!: number;
    sourceItemStockAfter!: number;
    sourceItemLocationStockBefore!: number;
    sourceItemLocationStockAfter!: number;
    targetItemId!: string;
    targetItemStockBefore!: number;
    targetItemStockAfter!: number;
    targetItemLocationStockBefore!: number;
    targetItemLocationStockAfter!: number;
    quantity!: number;

    constructor(data?: ITntTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.orderId = _data["orderId"];
            this.sourceLocationId = _data["sourceLocationId"];
            this.targetLocationId = _data["targetLocationId"];
            this.sourceItemLocationId = _data["sourceItemLocationId"];
            this.targetItemLocationId = _data["targetItemLocationId"];
            this.sourceItemId = _data["sourceItemId"];
            this.sourceItemStockBefore = _data["sourceItemStockBefore"];
            this.sourceItemStockAfter = _data["sourceItemStockAfter"];
            this.sourceItemLocationStockBefore = _data["sourceItemLocationStockBefore"];
            this.sourceItemLocationStockAfter = _data["sourceItemLocationStockAfter"];
            this.targetItemId = _data["targetItemId"];
            this.targetItemStockBefore = _data["targetItemStockBefore"];
            this.targetItemStockAfter = _data["targetItemStockAfter"];
            this.targetItemLocationStockBefore = _data["targetItemLocationStockBefore"];
            this.targetItemLocationStockAfter = _data["targetItemLocationStockAfter"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): TntTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new TntTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["orderId"] = this.orderId;
        data["sourceLocationId"] = this.sourceLocationId;
        data["targetLocationId"] = this.targetLocationId;
        data["sourceItemLocationId"] = this.sourceItemLocationId;
        data["targetItemLocationId"] = this.targetItemLocationId;
        data["sourceItemId"] = this.sourceItemId;
        data["sourceItemStockBefore"] = this.sourceItemStockBefore;
        data["sourceItemStockAfter"] = this.sourceItemStockAfter;
        data["sourceItemLocationStockBefore"] = this.sourceItemLocationStockBefore;
        data["sourceItemLocationStockAfter"] = this.sourceItemLocationStockAfter;
        data["targetItemId"] = this.targetItemId;
        data["targetItemStockBefore"] = this.targetItemStockBefore;
        data["targetItemStockAfter"] = this.targetItemStockAfter;
        data["targetItemLocationStockBefore"] = this.targetItemLocationStockBefore;
        data["targetItemLocationStockAfter"] = this.targetItemLocationStockAfter;
        data["quantity"] = this.quantity;
        return data;
    }

    clone(): TntTransaction {
        const json = this.toJSON();
        let result = new TntTransaction();
        result.init(json);
        return result;
    }
}

export interface ITntTransaction {
    id: string;
    accountId: number;
    orderId: string;
    sourceLocationId: string;
    targetLocationId: string;
    sourceItemLocationId?: string;
    targetItemLocationId?: string;
    sourceItemId: string;
    sourceItemStockBefore: number;
    sourceItemStockAfter: number;
    sourceItemLocationStockBefore: number;
    sourceItemLocationStockAfter: number;
    targetItemId: string;
    targetItemStockBefore: number;
    targetItemStockAfter: number;
    targetItemLocationStockBefore: number;
    targetItemLocationStockAfter: number;
    quantity: number;
}

export class TntBookingConsumeRequest implements ITntBookingConsumeRequest {
    locationId!: string;
    productId!: string;
    supplierId?: string | undefined;
    quantity!: number;

    constructor(data?: ITntBookingConsumeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.productId = _data["productId"];
            this.supplierId = _data["supplierId"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): TntBookingConsumeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TntBookingConsumeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["productId"] = this.productId;
        data["supplierId"] = this.supplierId;
        data["quantity"] = this.quantity;
        return data;
    }

    clone(): TntBookingConsumeRequest {
        const json = this.toJSON();
        let result = new TntBookingConsumeRequest();
        result.init(json);
        return result;
    }
}

export interface ITntBookingConsumeRequest {
    locationId: string;
    productId: string;
    supplierId?: string | undefined;
    quantity: number;
}

export class TntBookingTransferUntilEnoughInTargetRequest implements ITntBookingTransferUntilEnoughInTargetRequest {
    sourceLocationId!: string;
    targetLocationId!: string;
    itemFilter!: TntItemFilter;
    quantity!: number;

    constructor(data?: ITntBookingTransferUntilEnoughInTargetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.itemFilter = new TntItemFilter();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceLocationId = _data["sourceLocationId"];
            this.targetLocationId = _data["targetLocationId"];
            this.itemFilter = _data["itemFilter"] ? TntItemFilter.fromJS(_data["itemFilter"]) : new TntItemFilter();
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): TntBookingTransferUntilEnoughInTargetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TntBookingTransferUntilEnoughInTargetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceLocationId"] = this.sourceLocationId;
        data["targetLocationId"] = this.targetLocationId;
        data["itemFilter"] = this.itemFilter ? this.itemFilter.toJSON() : undefined as any;
        data["quantity"] = this.quantity;
        return data;
    }

    clone(): TntBookingTransferUntilEnoughInTargetRequest {
        const json = this.toJSON();
        let result = new TntBookingTransferUntilEnoughInTargetRequest();
        result.init(json);
        return result;
    }
}

export interface ITntBookingTransferUntilEnoughInTargetRequest {
    sourceLocationId: string;
    targetLocationId: string;
    itemFilter: TntItemFilter;
    quantity: number;
}

export class TntItemFilter implements ITntItemFilter {
    ids?: string[] | undefined;
    batchIds?: string[] | undefined;
    productIds?: string[] | undefined;
    supplierIds?: (string | undefined)[] | undefined;

    constructor(data?: ITntItemFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            if (Array.isArray(_data["batchIds"])) {
                this.batchIds = [] as any;
                for (let item of _data["batchIds"])
                    this.batchIds!.push(item);
            }
            if (Array.isArray(_data["productIds"])) {
                this.productIds = [] as any;
                for (let item of _data["productIds"])
                    this.productIds!.push(item);
            }
            if (Array.isArray(_data["supplierIds"])) {
                this.supplierIds = [] as any;
                for (let item of _data["supplierIds"])
                    this.supplierIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TntItemFilter {
        data = typeof data === 'object' ? data : {};
        let result = new TntItemFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        if (Array.isArray(this.batchIds)) {
            data["batchIds"] = [];
            for (let item of this.batchIds)
                data["batchIds"].push(item);
        }
        if (Array.isArray(this.productIds)) {
            data["productIds"] = [];
            for (let item of this.productIds)
                data["productIds"].push(item);
        }
        if (Array.isArray(this.supplierIds)) {
            data["supplierIds"] = [];
            for (let item of this.supplierIds)
                data["supplierIds"].push(item);
        }
        return data;
    }

    clone(): TntItemFilter {
        const json = this.toJSON();
        let result = new TntItemFilter();
        result.init(json);
        return result;
    }
}

export interface ITntItemFilter {
    ids?: string[] | undefined;
    batchIds?: string[] | undefined;
    productIds?: string[] | undefined;
    supplierIds?: (string | undefined)[] | undefined;
}

export class BaseResultOfListOfTntItemAttributeDefinition implements IBaseResultOfListOfTntItemAttributeDefinition {
    id?: number;
    isOk?: boolean;
    result?: TntItemAttributeDefinition[] | undefined;

    constructor(data?: IBaseResultOfListOfTntItemAttributeDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(TntItemAttributeDefinition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfListOfTntItemAttributeDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfListOfTntItemAttributeDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfListOfTntItemAttributeDefinition {
        const json = this.toJSON();
        let result = new BaseResultOfListOfTntItemAttributeDefinition();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfListOfTntItemAttributeDefinition {
    id?: number;
    isOk?: boolean;
    result?: TntItemAttributeDefinition[] | undefined;
}

export class TntItemAttributeDefinition implements ITntItemAttributeDefinition {
    id!: string;
    accountId!: number;
    name!: string;
    type!: TntAttributeDefinitionType;
    order!: number;

    constructor(data?: ITntItemAttributeDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): TntItemAttributeDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new TntItemAttributeDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["order"] = this.order;
        return data;
    }

    clone(): TntItemAttributeDefinition {
        const json = this.toJSON();
        let result = new TntItemAttributeDefinition();
        result.init(json);
        return result;
    }
}

export interface ITntItemAttributeDefinition {
    id: string;
    accountId: number;
    name: string;
    type: TntAttributeDefinitionType;
    order: number;
}

export enum TntAttributeDefinitionType {
    String = 0,
    Integer = 1,
    Datetime = 2,
    Link = 3,
    Double = 4,
    Object = 20,
    Signature = 30,
    GPS = 31,
}

export class BaseResultOfTntItemAttributeDefinition implements IBaseResultOfTntItemAttributeDefinition {
    id?: number;
    isOk?: boolean;
    result?: TntItemAttributeDefinition | undefined;

    constructor(data?: IBaseResultOfTntItemAttributeDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? TntItemAttributeDefinition.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfTntItemAttributeDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfTntItemAttributeDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfTntItemAttributeDefinition {
        const json = this.toJSON();
        let result = new BaseResultOfTntItemAttributeDefinition();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfTntItemAttributeDefinition {
    id?: number;
    isOk?: boolean;
    result?: TntItemAttributeDefinition | undefined;
}

export class BaseResultOfListOfTntItem implements IBaseResultOfListOfTntItem {
    id?: number;
    isOk?: boolean;
    result?: TntItem[] | undefined;

    constructor(data?: IBaseResultOfListOfTntItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(TntItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfListOfTntItem {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfListOfTntItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfListOfTntItem {
        const json = this.toJSON();
        let result = new BaseResultOfListOfTntItem();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfListOfTntItem {
    id?: number;
    isOk?: boolean;
    result?: TntItem[] | undefined;
}

export class TntItem implements ITntItem {
    id!: string;
    accountId!: number;
    batchId!: string;
    lotNumber!: string;
    stock!: number;
    unitId!: string;
    productId!: string;
    supplierId?: string | undefined;
    netPrice?: number | undefined;
    taxPercent?: number | undefined;
    attributes?: TntItemAttribute[] | undefined;

    constructor(data?: ITntItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.batchId = _data["batchId"];
            this.lotNumber = _data["lotNumber"];
            this.stock = _data["stock"];
            this.unitId = _data["unitId"];
            this.productId = _data["productId"];
            this.supplierId = _data["supplierId"];
            this.netPrice = _data["netPrice"];
            this.taxPercent = _data["taxPercent"];
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(TntItemAttribute.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TntItem {
        data = typeof data === 'object' ? data : {};
        let result = new TntItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["batchId"] = this.batchId;
        data["lotNumber"] = this.lotNumber;
        data["stock"] = this.stock;
        data["unitId"] = this.unitId;
        data["productId"] = this.productId;
        data["supplierId"] = this.supplierId;
        data["netPrice"] = this.netPrice;
        data["taxPercent"] = this.taxPercent;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TntItem {
        const json = this.toJSON();
        let result = new TntItem();
        result.init(json);
        return result;
    }
}

export interface ITntItem {
    id: string;
    accountId: number;
    batchId: string;
    lotNumber: string;
    stock: number;
    unitId: string;
    productId: string;
    supplierId?: string | undefined;
    netPrice?: number | undefined;
    taxPercent?: number | undefined;
    attributes?: TntItemAttribute[] | undefined;
}

export class TntItemAttribute implements ITntItemAttribute {
    id!: string;
    accountId!: number;
    itemId!: string;
    definitionId!: string;
    value?: string | undefined;

    constructor(data?: ITntItemAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.itemId = _data["itemId"];
            this.definitionId = _data["definitionId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TntItemAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new TntItemAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["itemId"] = this.itemId;
        data["definitionId"] = this.definitionId;
        data["value"] = this.value;
        return data;
    }

    clone(): TntItemAttribute {
        const json = this.toJSON();
        let result = new TntItemAttribute();
        result.init(json);
        return result;
    }
}

export interface ITntItemAttribute {
    id: string;
    accountId: number;
    itemId: string;
    definitionId: string;
    value?: string | undefined;
}

export class BaseResultOfTntItem implements IBaseResultOfTntItem {
    id?: number;
    isOk?: boolean;
    result?: TntItem | undefined;

    constructor(data?: IBaseResultOfTntItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? TntItem.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfTntItem {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfTntItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfTntItem {
        const json = this.toJSON();
        let result = new BaseResultOfTntItem();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfTntItem {
    id?: number;
    isOk?: boolean;
    result?: TntItem | undefined;
}

export class TntItemPatchRequest implements ITntItemPatchRequest {
    patch!: JsonPatchDocumentOfTntItem;
    ids!: string[];

    constructor(data?: ITntItemPatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.patch = new JsonPatchDocumentOfTntItem();
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patch = _data["patch"] ? JsonPatchDocumentOfTntItem.fromJS(_data["patch"]) : new JsonPatchDocumentOfTntItem();
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): TntItemPatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TntItemPatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patch"] = this.patch ? this.patch.toJSON() : undefined as any;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }

    clone(): TntItemPatchRequest {
        const json = this.toJSON();
        let result = new TntItemPatchRequest();
        result.init(json);
        return result;
    }
}

export interface ITntItemPatchRequest {
    patch: JsonPatchDocumentOfTntItem;
    ids: string[];
}

export class JsonPatchDocumentOfTntItem implements IJsonPatchDocumentOfTntItem {
    operations?: OperationOfTntItem[] | undefined;

    constructor(data?: IJsonPatchDocumentOfTntItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(OperationOfTntItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JsonPatchDocumentOfTntItem {
        data = typeof data === 'object' ? data : {};
        let result = new JsonPatchDocumentOfTntItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): JsonPatchDocumentOfTntItem {
        const json = this.toJSON();
        let result = new JsonPatchDocumentOfTntItem();
        result.init(json);
        return result;
    }
}

export interface IJsonPatchDocumentOfTntItem {
    operations?: OperationOfTntItem[] | undefined;
}

export class OperationOfTntItem extends Operation implements IOperationOfTntItem {

    constructor(data?: IOperationOfTntItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OperationOfTntItem {
        data = typeof data === 'object' ? data : {};
        let result = new OperationOfTntItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): OperationOfTntItem {
        const json = this.toJSON();
        let result = new OperationOfTntItem();
        result.init(json);
        return result;
    }
}

export interface IOperationOfTntItem extends IOperation {
}

export class BaseResultOfListOfTntItemLocation implements IBaseResultOfListOfTntItemLocation {
    id?: number;
    isOk?: boolean;
    result?: TntItemLocation[] | undefined;

    constructor(data?: IBaseResultOfListOfTntItemLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(TntItemLocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfListOfTntItemLocation {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfListOfTntItemLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfListOfTntItemLocation {
        const json = this.toJSON();
        let result = new BaseResultOfListOfTntItemLocation();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfListOfTntItemLocation {
    id?: number;
    isOk?: boolean;
    result?: TntItemLocation[] | undefined;
}

export class TntItemLocation implements ITntItemLocation {
    id!: string;
    accountId!: number;
    locationId!: string;
    itemId!: string;
    stock!: number;

    constructor(data?: ITntItemLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.locationId = _data["locationId"];
            this.itemId = _data["itemId"];
            this.stock = _data["stock"];
        }
    }

    static fromJS(data: any): TntItemLocation {
        data = typeof data === 'object' ? data : {};
        let result = new TntItemLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["locationId"] = this.locationId;
        data["itemId"] = this.itemId;
        data["stock"] = this.stock;
        return data;
    }

    clone(): TntItemLocation {
        const json = this.toJSON();
        let result = new TntItemLocation();
        result.init(json);
        return result;
    }
}

export interface ITntItemLocation {
    id: string;
    accountId: number;
    locationId: string;
    itemId: string;
    stock: number;
}

export class BaseResultOfTntItemLocation implements IBaseResultOfTntItemLocation {
    id?: number;
    isOk?: boolean;
    result?: TntItemLocation | undefined;

    constructor(data?: IBaseResultOfTntItemLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? TntItemLocation.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfTntItemLocation {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfTntItemLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfTntItemLocation {
        const json = this.toJSON();
        let result = new BaseResultOfTntItemLocation();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfTntItemLocation {
    id?: number;
    isOk?: boolean;
    result?: TntItemLocation | undefined;
}

export class TntItemLocationFilter implements ITntItemLocationFilter {
    ids?: string[] | undefined;
    itemIds?: string[] | undefined;
    locationIds?: string[] | undefined;

    constructor(data?: ITntItemLocationFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            if (Array.isArray(_data["itemIds"])) {
                this.itemIds = [] as any;
                for (let item of _data["itemIds"])
                    this.itemIds!.push(item);
            }
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TntItemLocationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new TntItemLocationFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        if (Array.isArray(this.itemIds)) {
            data["itemIds"] = [];
            for (let item of this.itemIds)
                data["itemIds"].push(item);
        }
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        return data;
    }

    clone(): TntItemLocationFilter {
        const json = this.toJSON();
        let result = new TntItemLocationFilter();
        result.init(json);
        return result;
    }
}

export interface ITntItemLocationFilter {
    ids?: string[] | undefined;
    itemIds?: string[] | undefined;
    locationIds?: string[] | undefined;
}

export class BaseResultOfListOfTntLocation implements IBaseResultOfListOfTntLocation {
    id?: number;
    isOk?: boolean;
    result?: TntLocation[] | undefined;

    constructor(data?: IBaseResultOfListOfTntLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(TntLocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfListOfTntLocation {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfListOfTntLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfListOfTntLocation {
        const json = this.toJSON();
        let result = new BaseResultOfListOfTntLocation();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfListOfTntLocation {
    id?: number;
    isOk?: boolean;
    result?: TntLocation[] | undefined;
}

export class TntLocation implements ITntLocation {
    id!: string;
    accountId!: number;
    identifier!: string;
    deleted!: boolean;
    doNotCombineItemLocationsOnTransfer!: boolean;

    constructor(data?: ITntLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.identifier = _data["identifier"];
            this.deleted = _data["deleted"];
            this.doNotCombineItemLocationsOnTransfer = _data["doNotCombineItemLocationsOnTransfer"];
        }
    }

    static fromJS(data: any): TntLocation {
        data = typeof data === 'object' ? data : {};
        let result = new TntLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["identifier"] = this.identifier;
        data["deleted"] = this.deleted;
        data["doNotCombineItemLocationsOnTransfer"] = this.doNotCombineItemLocationsOnTransfer;
        return data;
    }

    clone(): TntLocation {
        const json = this.toJSON();
        let result = new TntLocation();
        result.init(json);
        return result;
    }
}

export interface ITntLocation {
    id: string;
    accountId: number;
    identifier: string;
    deleted: boolean;
    doNotCombineItemLocationsOnTransfer: boolean;
}

export class BaseResultOfTntLocation implements IBaseResultOfTntLocation {
    id?: number;
    isOk?: boolean;
    result?: TntLocation | undefined;

    constructor(data?: IBaseResultOfTntLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? TntLocation.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfTntLocation {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfTntLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfTntLocation {
        const json = this.toJSON();
        let result = new BaseResultOfTntLocation();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfTntLocation {
    id?: number;
    isOk?: boolean;
    result?: TntLocation | undefined;
}

export class TntLocationFilter implements ITntLocationFilter {
    ids?: string[] | undefined;
    identifiers?: string[] | undefined;

    constructor(data?: ITntLocationFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(item);
            }
        }
    }

    static fromJS(data: any): TntLocationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new TntLocationFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item);
        }
        return data;
    }

    clone(): TntLocationFilter {
        const json = this.toJSON();
        let result = new TntLocationFilter();
        result.init(json);
        return result;
    }
}

export interface ITntLocationFilter {
    ids?: string[] | undefined;
    identifiers?: string[] | undefined;
}

export class BaseResultOfTntProduceResult implements IBaseResultOfTntProduceResult {
    id?: number;
    isOk?: boolean;
    result?: TntProduceResult | undefined;

    constructor(data?: IBaseResultOfTntProduceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? TntProduceResult.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfTntProduceResult {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfTntProduceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfTntProduceResult {
        const json = this.toJSON();
        let result = new BaseResultOfTntProduceResult();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfTntProduceResult {
    id?: number;
    isOk?: boolean;
    result?: TntProduceResult | undefined;
}

export class TntProduceResult implements ITntProduceResult {
    order!: TntOrder;
    producedItemLocations!: TntItemLocation[];

    constructor(data?: ITntProduceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.order = new TntOrder();
            this.producedItemLocations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? TntOrder.fromJS(_data["order"]) : new TntOrder();
            if (Array.isArray(_data["producedItemLocations"])) {
                this.producedItemLocations = [] as any;
                for (let item of _data["producedItemLocations"])
                    this.producedItemLocations!.push(TntItemLocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TntProduceResult {
        data = typeof data === 'object' ? data : {};
        let result = new TntProduceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : undefined as any;
        if (Array.isArray(this.producedItemLocations)) {
            data["producedItemLocations"] = [];
            for (let item of this.producedItemLocations)
                data["producedItemLocations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TntProduceResult {
        const json = this.toJSON();
        let result = new TntProduceResult();
        result.init(json);
        return result;
    }
}

export interface ITntProduceResult {
    order: TntOrder;
    producedItemLocations: TntItemLocation[];
}

export class TntProduceRequest implements ITntProduceRequest {
    items!: TntItem[];
    targetLocationId!: string;

    constructor(data?: ITntProduceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TntItem.fromJS(item));
            }
            this.targetLocationId = _data["targetLocationId"];
        }
    }

    static fromJS(data: any): TntProduceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TntProduceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["targetLocationId"] = this.targetLocationId;
        return data;
    }

    clone(): TntProduceRequest {
        const json = this.toJSON();
        let result = new TntProduceRequest();
        result.init(json);
        return result;
    }
}

export interface ITntProduceRequest {
    items: TntItem[];
    targetLocationId: string;
}

export class BaseResultOfTntConsumeResult implements IBaseResultOfTntConsumeResult {
    id?: number;
    isOk?: boolean;
    result?: TntConsumeResult | undefined;

    constructor(data?: IBaseResultOfTntConsumeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? TntConsumeResult.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfTntConsumeResult {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfTntConsumeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfTntConsumeResult {
        const json = this.toJSON();
        let result = new BaseResultOfTntConsumeResult();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfTntConsumeResult {
    id?: number;
    isOk?: boolean;
    result?: TntConsumeResult | undefined;
}

export class TntConsumeRequest implements ITntConsumeRequest {
    sourceItemLocationIds!: string[];

    constructor(data?: ITntConsumeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.sourceItemLocationIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sourceItemLocationIds"])) {
                this.sourceItemLocationIds = [] as any;
                for (let item of _data["sourceItemLocationIds"])
                    this.sourceItemLocationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TntConsumeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TntConsumeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sourceItemLocationIds)) {
            data["sourceItemLocationIds"] = [];
            for (let item of this.sourceItemLocationIds)
                data["sourceItemLocationIds"].push(item);
        }
        return data;
    }

    clone(): TntConsumeRequest {
        const json = this.toJSON();
        let result = new TntConsumeRequest();
        result.init(json);
        return result;
    }
}

export interface ITntConsumeRequest {
    sourceItemLocationIds: string[];
}

export class BaseResultOfTntTransferResult implements IBaseResultOfTntTransferResult {
    id?: number;
    isOk?: boolean;
    result?: TntTransferResult | undefined;

    constructor(data?: IBaseResultOfTntTransferResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? TntTransferResult.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfTntTransferResult {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfTntTransferResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfTntTransferResult {
        const json = this.toJSON();
        let result = new BaseResultOfTntTransferResult();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfTntTransferResult {
    id?: number;
    isOk?: boolean;
    result?: TntTransferResult | undefined;
}

export class TntTransferResult implements ITntTransferResult {
    order!: TntOrder;
    transferredItems!: TntItemLocation[];
    remainingItems!: TntItemLocation[];

    constructor(data?: ITntTransferResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.order = new TntOrder();
            this.transferredItems = [];
            this.remainingItems = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? TntOrder.fromJS(_data["order"]) : new TntOrder();
            if (Array.isArray(_data["transferredItems"])) {
                this.transferredItems = [] as any;
                for (let item of _data["transferredItems"])
                    this.transferredItems!.push(TntItemLocation.fromJS(item));
            }
            if (Array.isArray(_data["remainingItems"])) {
                this.remainingItems = [] as any;
                for (let item of _data["remainingItems"])
                    this.remainingItems!.push(TntItemLocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TntTransferResult {
        data = typeof data === 'object' ? data : {};
        let result = new TntTransferResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : undefined as any;
        if (Array.isArray(this.transferredItems)) {
            data["transferredItems"] = [];
            for (let item of this.transferredItems)
                data["transferredItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.remainingItems)) {
            data["remainingItems"] = [];
            for (let item of this.remainingItems)
                data["remainingItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TntTransferResult {
        const json = this.toJSON();
        let result = new TntTransferResult();
        result.init(json);
        return result;
    }
}

export interface ITntTransferResult {
    order: TntOrder;
    transferredItems: TntItemLocation[];
    remainingItems: TntItemLocation[];
}

export class TntTransferRequest implements ITntTransferRequest {
    sourceItemLocationId!: string;
    targetLocationId!: string;
    quantity!: number;
    forceNoCombine?: boolean;
    forceCombine?: boolean;

    constructor(data?: ITntTransferRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceItemLocationId = _data["sourceItemLocationId"];
            this.targetLocationId = _data["targetLocationId"];
            this.quantity = _data["quantity"];
            this.forceNoCombine = _data["forceNoCombine"];
            this.forceCombine = _data["forceCombine"];
        }
    }

    static fromJS(data: any): TntTransferRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TntTransferRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceItemLocationId"] = this.sourceItemLocationId;
        data["targetLocationId"] = this.targetLocationId;
        data["quantity"] = this.quantity;
        data["forceNoCombine"] = this.forceNoCombine;
        data["forceCombine"] = this.forceCombine;
        return data;
    }

    clone(): TntTransferRequest {
        const json = this.toJSON();
        let result = new TntTransferRequest();
        result.init(json);
        return result;
    }
}

export interface ITntTransferRequest {
    sourceItemLocationId: string;
    targetLocationId: string;
    quantity: number;
    forceNoCombine?: boolean;
    forceCombine?: boolean;
}

export class BaseResultOfTntTransformResult implements IBaseResultOfTntTransformResult {
    id?: number;
    isOk?: boolean;
    result?: TntTransformResult | undefined;

    constructor(data?: IBaseResultOfTntTransformResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? TntTransformResult.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfTntTransformResult {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfTntTransformResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfTntTransformResult {
        const json = this.toJSON();
        let result = new BaseResultOfTntTransformResult();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfTntTransformResult {
    id?: number;
    isOk?: boolean;
    result?: TntTransformResult | undefined;
}

export class TntTransformResult implements ITntTransformResult {
    order!: TntOrder;
    transformedItemLocations!: TntItemLocation[];

    constructor(data?: ITntTransformResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.order = new TntOrder();
            this.transformedItemLocations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? TntOrder.fromJS(_data["order"]) : new TntOrder();
            if (Array.isArray(_data["transformedItemLocations"])) {
                this.transformedItemLocations = [] as any;
                for (let item of _data["transformedItemLocations"])
                    this.transformedItemLocations!.push(TntItemLocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TntTransformResult {
        data = typeof data === 'object' ? data : {};
        let result = new TntTransformResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : undefined as any;
        if (Array.isArray(this.transformedItemLocations)) {
            data["transformedItemLocations"] = [];
            for (let item of this.transformedItemLocations)
                data["transformedItemLocations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TntTransformResult {
        const json = this.toJSON();
        let result = new TntTransformResult();
        result.init(json);
        return result;
    }
}

export interface ITntTransformResult {
    order: TntOrder;
    transformedItemLocations: TntItemLocation[];
}

export class TntTransformRequest implements ITntTransformRequest {
    sourceItemLocationIds!: string[];
    targetItems!: TntItem[];
    locationId!: string;

    constructor(data?: ITntTransformRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.sourceItemLocationIds = [];
            this.targetItems = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sourceItemLocationIds"])) {
                this.sourceItemLocationIds = [] as any;
                for (let item of _data["sourceItemLocationIds"])
                    this.sourceItemLocationIds!.push(item);
            }
            if (Array.isArray(_data["targetItems"])) {
                this.targetItems = [] as any;
                for (let item of _data["targetItems"])
                    this.targetItems!.push(TntItem.fromJS(item));
            }
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): TntTransformRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TntTransformRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sourceItemLocationIds)) {
            data["sourceItemLocationIds"] = [];
            for (let item of this.sourceItemLocationIds)
                data["sourceItemLocationIds"].push(item);
        }
        if (Array.isArray(this.targetItems)) {
            data["targetItems"] = [];
            for (let item of this.targetItems)
                data["targetItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["locationId"] = this.locationId;
        return data;
    }

    clone(): TntTransformRequest {
        const json = this.toJSON();
        let result = new TntTransformRequest();
        result.init(json);
        return result;
    }
}

export interface ITntTransformRequest {
    sourceItemLocationIds: string[];
    targetItems: TntItem[];
    locationId: string;
}

export class BaseResultOfListOfTntProduct implements IBaseResultOfListOfTntProduct {
    id?: number;
    isOk?: boolean;
    result?: TntProduct[] | undefined;

    constructor(data?: IBaseResultOfListOfTntProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(TntProduct.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfListOfTntProduct {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfListOfTntProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfListOfTntProduct {
        const json = this.toJSON();
        let result = new BaseResultOfListOfTntProduct();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfListOfTntProduct {
    id?: number;
    isOk?: boolean;
    result?: TntProduct[] | undefined;
}

export class TntProduct implements ITntProduct {
    id!: string;
    accountId!: number;
    identifier!: string;
    name!: string;
    description?: string | undefined;
    netPrice?: number | undefined;
    taxPercent?: number | undefined;

    constructor(data?: ITntProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.netPrice = _data["netPrice"];
            this.taxPercent = _data["taxPercent"];
        }
    }

    static fromJS(data: any): TntProduct {
        data = typeof data === 'object' ? data : {};
        let result = new TntProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["description"] = this.description;
        data["netPrice"] = this.netPrice;
        data["taxPercent"] = this.taxPercent;
        return data;
    }

    clone(): TntProduct {
        const json = this.toJSON();
        let result = new TntProduct();
        result.init(json);
        return result;
    }
}

export interface ITntProduct {
    id: string;
    accountId: number;
    identifier: string;
    name: string;
    description?: string | undefined;
    netPrice?: number | undefined;
    taxPercent?: number | undefined;
}

export class BaseResultOfTntProduct implements IBaseResultOfTntProduct {
    id?: number;
    isOk?: boolean;
    result?: TntProduct | undefined;

    constructor(data?: IBaseResultOfTntProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? TntProduct.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfTntProduct {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfTntProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfTntProduct {
        const json = this.toJSON();
        let result = new BaseResultOfTntProduct();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfTntProduct {
    id?: number;
    isOk?: boolean;
    result?: TntProduct | undefined;
}

export class BaseResultOfListOfTntSupplier implements IBaseResultOfListOfTntSupplier {
    id?: number;
    isOk?: boolean;
    result?: TntSupplier[] | undefined;

    constructor(data?: IBaseResultOfListOfTntSupplier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(TntSupplier.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfListOfTntSupplier {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfListOfTntSupplier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfListOfTntSupplier {
        const json = this.toJSON();
        let result = new BaseResultOfListOfTntSupplier();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfListOfTntSupplier {
    id?: number;
    isOk?: boolean;
    result?: TntSupplier[] | undefined;
}

export class TntSupplier implements ITntSupplier {
    id!: string;
    accountId!: number;
    name!: string;
    identifier?: string | undefined;
    country?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    buildingNumber?: string | undefined;
    floor?: string | undefined;
    door?: string | undefined;

    constructor(data?: ITntSupplier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.country = _data["country"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.buildingNumber = _data["buildingNumber"];
            this.floor = _data["floor"];
            this.door = _data["door"];
        }
    }

    static fromJS(data: any): TntSupplier {
        data = typeof data === 'object' ? data : {};
        let result = new TntSupplier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["country"] = this.country;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["street"] = this.street;
        data["buildingNumber"] = this.buildingNumber;
        data["floor"] = this.floor;
        data["door"] = this.door;
        return data;
    }

    clone(): TntSupplier {
        const json = this.toJSON();
        let result = new TntSupplier();
        result.init(json);
        return result;
    }
}

export interface ITntSupplier {
    id: string;
    accountId: number;
    name: string;
    identifier?: string | undefined;
    country?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    buildingNumber?: string | undefined;
    floor?: string | undefined;
    door?: string | undefined;
}

export class BaseResultOfTntSupplier implements IBaseResultOfTntSupplier {
    id?: number;
    isOk?: boolean;
    result?: TntSupplier | undefined;

    constructor(data?: IBaseResultOfTntSupplier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? TntSupplier.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfTntSupplier {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfTntSupplier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfTntSupplier {
        const json = this.toJSON();
        let result = new BaseResultOfTntSupplier();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfTntSupplier {
    id?: number;
    isOk?: boolean;
    result?: TntSupplier | undefined;
}

export class BaseResultOfTntTransaction implements IBaseResultOfTntTransaction {
    id?: number;
    isOk?: boolean;
    result?: TntTransaction | undefined;

    constructor(data?: IBaseResultOfTntTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? TntTransaction.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfTntTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfTntTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfTntTransaction {
        const json = this.toJSON();
        let result = new BaseResultOfTntTransaction();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfTntTransaction {
    id?: number;
    isOk?: boolean;
    result?: TntTransaction | undefined;
}

export class BaseResultOfListOfTntTransaction implements IBaseResultOfListOfTntTransaction {
    id?: number;
    isOk?: boolean;
    result?: TntTransaction[] | undefined;

    constructor(data?: IBaseResultOfListOfTntTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(TntTransaction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfListOfTntTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfListOfTntTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfListOfTntTransaction {
        const json = this.toJSON();
        let result = new BaseResultOfListOfTntTransaction();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfListOfTntTransaction {
    id?: number;
    isOk?: boolean;
    result?: TntTransaction[] | undefined;
}

export class TntTransactionFilter implements ITntTransactionFilter {
    ids?: string[] | undefined;
    orderIds?: string[] | undefined;
    orderTypes?: TntOrderType[] | undefined;
    sourceLocationIds?: string[] | undefined;
    sourceItemLocationIds?: string[] | undefined;
    sourceItemIds?: string[] | undefined;
    sourceBatchIds?: string[] | undefined;
    sourceProductIds?: string[] | undefined;
    sourceSupplierIds?: (string | undefined)[] | undefined;
    targetLocationIds?: string[] | undefined;
    targetItemLocationIds?: string[] | undefined;
    targetItemIds?: string[] | undefined;
    targetBatchIds?: string[] | undefined;
    targetProductIds?: string[] | undefined;
    targetSupplierIds?: (string | undefined)[] | undefined;

    constructor(data?: ITntTransactionFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds!.push(item);
            }
            if (Array.isArray(_data["orderTypes"])) {
                this.orderTypes = [] as any;
                for (let item of _data["orderTypes"])
                    this.orderTypes!.push(item);
            }
            if (Array.isArray(_data["sourceLocationIds"])) {
                this.sourceLocationIds = [] as any;
                for (let item of _data["sourceLocationIds"])
                    this.sourceLocationIds!.push(item);
            }
            if (Array.isArray(_data["sourceItemLocationIds"])) {
                this.sourceItemLocationIds = [] as any;
                for (let item of _data["sourceItemLocationIds"])
                    this.sourceItemLocationIds!.push(item);
            }
            if (Array.isArray(_data["sourceItemIds"])) {
                this.sourceItemIds = [] as any;
                for (let item of _data["sourceItemIds"])
                    this.sourceItemIds!.push(item);
            }
            if (Array.isArray(_data["sourceBatchIds"])) {
                this.sourceBatchIds = [] as any;
                for (let item of _data["sourceBatchIds"])
                    this.sourceBatchIds!.push(item);
            }
            if (Array.isArray(_data["sourceProductIds"])) {
                this.sourceProductIds = [] as any;
                for (let item of _data["sourceProductIds"])
                    this.sourceProductIds!.push(item);
            }
            if (Array.isArray(_data["sourceSupplierIds"])) {
                this.sourceSupplierIds = [] as any;
                for (let item of _data["sourceSupplierIds"])
                    this.sourceSupplierIds!.push(item);
            }
            if (Array.isArray(_data["targetLocationIds"])) {
                this.targetLocationIds = [] as any;
                for (let item of _data["targetLocationIds"])
                    this.targetLocationIds!.push(item);
            }
            if (Array.isArray(_data["targetItemLocationIds"])) {
                this.targetItemLocationIds = [] as any;
                for (let item of _data["targetItemLocationIds"])
                    this.targetItemLocationIds!.push(item);
            }
            if (Array.isArray(_data["targetItemIds"])) {
                this.targetItemIds = [] as any;
                for (let item of _data["targetItemIds"])
                    this.targetItemIds!.push(item);
            }
            if (Array.isArray(_data["targetBatchIds"])) {
                this.targetBatchIds = [] as any;
                for (let item of _data["targetBatchIds"])
                    this.targetBatchIds!.push(item);
            }
            if (Array.isArray(_data["targetProductIds"])) {
                this.targetProductIds = [] as any;
                for (let item of _data["targetProductIds"])
                    this.targetProductIds!.push(item);
            }
            if (Array.isArray(_data["targetSupplierIds"])) {
                this.targetSupplierIds = [] as any;
                for (let item of _data["targetSupplierIds"])
                    this.targetSupplierIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TntTransactionFilter {
        data = typeof data === 'object' ? data : {};
        let result = new TntTransactionFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        if (Array.isArray(this.orderTypes)) {
            data["orderTypes"] = [];
            for (let item of this.orderTypes)
                data["orderTypes"].push(item);
        }
        if (Array.isArray(this.sourceLocationIds)) {
            data["sourceLocationIds"] = [];
            for (let item of this.sourceLocationIds)
                data["sourceLocationIds"].push(item);
        }
        if (Array.isArray(this.sourceItemLocationIds)) {
            data["sourceItemLocationIds"] = [];
            for (let item of this.sourceItemLocationIds)
                data["sourceItemLocationIds"].push(item);
        }
        if (Array.isArray(this.sourceItemIds)) {
            data["sourceItemIds"] = [];
            for (let item of this.sourceItemIds)
                data["sourceItemIds"].push(item);
        }
        if (Array.isArray(this.sourceBatchIds)) {
            data["sourceBatchIds"] = [];
            for (let item of this.sourceBatchIds)
                data["sourceBatchIds"].push(item);
        }
        if (Array.isArray(this.sourceProductIds)) {
            data["sourceProductIds"] = [];
            for (let item of this.sourceProductIds)
                data["sourceProductIds"].push(item);
        }
        if (Array.isArray(this.sourceSupplierIds)) {
            data["sourceSupplierIds"] = [];
            for (let item of this.sourceSupplierIds)
                data["sourceSupplierIds"].push(item);
        }
        if (Array.isArray(this.targetLocationIds)) {
            data["targetLocationIds"] = [];
            for (let item of this.targetLocationIds)
                data["targetLocationIds"].push(item);
        }
        if (Array.isArray(this.targetItemLocationIds)) {
            data["targetItemLocationIds"] = [];
            for (let item of this.targetItemLocationIds)
                data["targetItemLocationIds"].push(item);
        }
        if (Array.isArray(this.targetItemIds)) {
            data["targetItemIds"] = [];
            for (let item of this.targetItemIds)
                data["targetItemIds"].push(item);
        }
        if (Array.isArray(this.targetBatchIds)) {
            data["targetBatchIds"] = [];
            for (let item of this.targetBatchIds)
                data["targetBatchIds"].push(item);
        }
        if (Array.isArray(this.targetProductIds)) {
            data["targetProductIds"] = [];
            for (let item of this.targetProductIds)
                data["targetProductIds"].push(item);
        }
        if (Array.isArray(this.targetSupplierIds)) {
            data["targetSupplierIds"] = [];
            for (let item of this.targetSupplierIds)
                data["targetSupplierIds"].push(item);
        }
        return data;
    }

    clone(): TntTransactionFilter {
        const json = this.toJSON();
        let result = new TntTransactionFilter();
        result.init(json);
        return result;
    }
}

export interface ITntTransactionFilter {
    ids?: string[] | undefined;
    orderIds?: string[] | undefined;
    orderTypes?: TntOrderType[] | undefined;
    sourceLocationIds?: string[] | undefined;
    sourceItemLocationIds?: string[] | undefined;
    sourceItemIds?: string[] | undefined;
    sourceBatchIds?: string[] | undefined;
    sourceProductIds?: string[] | undefined;
    sourceSupplierIds?: (string | undefined)[] | undefined;
    targetLocationIds?: string[] | undefined;
    targetItemLocationIds?: string[] | undefined;
    targetItemIds?: string[] | undefined;
    targetBatchIds?: string[] | undefined;
    targetProductIds?: string[] | undefined;
    targetSupplierIds?: (string | undefined)[] | undefined;
}

export class BaseResultOfListOfTntUnit implements IBaseResultOfListOfTntUnit {
    id?: number;
    isOk?: boolean;
    result?: TntUnit[] | undefined;

    constructor(data?: IBaseResultOfListOfTntUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(TntUnit.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResultOfListOfTntUnit {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfListOfTntUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BaseResultOfListOfTntUnit {
        const json = this.toJSON();
        let result = new BaseResultOfListOfTntUnit();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfListOfTntUnit {
    id?: number;
    isOk?: boolean;
    result?: TntUnit[] | undefined;
}

export class TntUnit implements ITntUnit {
    id!: string;
    accountId!: number;
    name!: string;

    constructor(data?: ITntUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TntUnit {
        data = typeof data === 'object' ? data : {};
        let result = new TntUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["name"] = this.name;
        return data;
    }

    clone(): TntUnit {
        const json = this.toJSON();
        let result = new TntUnit();
        result.init(json);
        return result;
    }
}

export interface ITntUnit {
    id: string;
    accountId: number;
    name: string;
}

export class BaseResultOfTntUnit implements IBaseResultOfTntUnit {
    id?: number;
    isOk?: boolean;
    result?: TntUnit | undefined;

    constructor(data?: IBaseResultOfTntUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? TntUnit.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfTntUnit {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfTntUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfTntUnit {
        const json = this.toJSON();
        let result = new BaseResultOfTntUnit();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfTntUnit {
    id?: number;
    isOk?: boolean;
    result?: TntUnit | undefined;
}

export class BaseResultOfTntFindResult implements IBaseResultOfTntFindResult {
    id?: number;
    isOk?: boolean;
    result?: TntFindResult | undefined;

    constructor(data?: IBaseResultOfTntFindResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? TntFindResult.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfTntFindResult {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfTntFindResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfTntFindResult {
        const json = this.toJSON();
        let result = new BaseResultOfTntFindResult();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfTntFindResult {
    id?: number;
    isOk?: boolean;
    result?: TntFindResult | undefined;
}

export class TntFindResult implements ITntFindResult {
    batches!: TntBatch[];
    items!: TntItem[];
    itemLocations!: TntItemLocation[];
    locations!: TntLocation[];
    products!: TntProduct[];
    suppliers!: TntSupplier[];
    orders!: TntOrder[];
    transactions!: TntTransaction[];
    units!: TntUnit[];

    constructor(data?: ITntFindResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.batches = [];
            this.items = [];
            this.itemLocations = [];
            this.locations = [];
            this.products = [];
            this.suppliers = [];
            this.orders = [];
            this.transactions = [];
            this.units = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["batches"])) {
                this.batches = [] as any;
                for (let item of _data["batches"])
                    this.batches!.push(TntBatch.fromJS(item));
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TntItem.fromJS(item));
            }
            if (Array.isArray(_data["itemLocations"])) {
                this.itemLocations = [] as any;
                for (let item of _data["itemLocations"])
                    this.itemLocations!.push(TntItemLocation.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(TntLocation.fromJS(item));
            }
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(TntProduct.fromJS(item));
            }
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(TntSupplier.fromJS(item));
            }
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(TntOrder.fromJS(item));
            }
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions!.push(TntTransaction.fromJS(item));
            }
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(TntUnit.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TntFindResult {
        data = typeof data === 'object' ? data : {};
        let result = new TntFindResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.batches)) {
            data["batches"] = [];
            for (let item of this.batches)
                data["batches"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.itemLocations)) {
            data["itemLocations"] = [];
            for (let item of this.itemLocations)
                data["itemLocations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TntFindResult {
        const json = this.toJSON();
        let result = new TntFindResult();
        result.init(json);
        return result;
    }
}

export interface ITntFindResult {
    batches: TntBatch[];
    items: TntItem[];
    itemLocations: TntItemLocation[];
    locations: TntLocation[];
    products: TntProduct[];
    suppliers: TntSupplier[];
    orders: TntOrder[];
    transactions: TntTransaction[];
    units: TntUnit[];
}

export class BaseResultOfTntInputResult implements IBaseResultOfTntInputResult {
    id?: number;
    isOk?: boolean;
    result?: TntInputResult | undefined;

    constructor(data?: IBaseResultOfTntInputResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOk = _data["isOk"];
            this.result = _data["result"] ? TntInputResult.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseResultOfTntInputResult {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResultOfTntInputResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOk"] = this.isOk;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): BaseResultOfTntInputResult {
        const json = this.toJSON();
        let result = new BaseResultOfTntInputResult();
        result.init(json);
        return result;
    }
}

export interface IBaseResultOfTntInputResult {
    id?: number;
    isOk?: boolean;
    result?: TntInputResult | undefined;
}

export class TntInputResult implements ITntInputResult {
    token!: string;
    result!: string;

    constructor(data?: ITntInputResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): TntInputResult {
        data = typeof data === 'object' ? data : {};
        let result = new TntInputResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["result"] = this.result;
        return data;
    }

    clone(): TntInputResult {
        const json = this.toJSON();
        let result = new TntInputResult();
        result.init(json);
        return result;
    }
}

export interface ITntInputResult {
    token: string;
    result: string;
}

export class TntGenericQrRequest implements ITntGenericQrRequest {
    content!: string[];
    layout!: string;
    options?: string[] | undefined;

    constructor(data?: ITntGenericQrRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.content = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["content"])) {
                this.content = [] as any;
                for (let item of _data["content"])
                    this.content!.push(item);
            }
            this.layout = _data["layout"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
        }
    }

    static fromJS(data: any): TntGenericQrRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TntGenericQrRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.content)) {
            data["content"] = [];
            for (let item of this.content)
                data["content"].push(item);
        }
        data["layout"] = this.layout;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        return data;
    }

    clone(): TntGenericQrRequest {
        const json = this.toJSON();
        let result = new TntGenericQrRequest();
        result.init(json);
        return result;
    }
}

export interface ITntGenericQrRequest {
    content: string[];
    layout: string;
    options?: string[] | undefined;
}

export class Structure implements IStructure {

    [key: string]: any;

    constructor(data?: IStructure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Structure {
        data = typeof data === 'object' ? data : {};
        let result = new Structure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }

    clone(): Structure {
        const json = this.toJSON();
        let result = new Structure();
        result.init(json);
        return result;
    }
}

export interface IStructure {

    [key: string]: any;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}